// 35   -- increment me if you need a marker for seeing if an update went through

// //////////////////////////////
// swfobject.js
// //////////////////////////////
(function () {
/*	SWFObject v2.2 <http://code.google.com/p/swfobject/> 
	is released under the MIT License <http://www.opensource.org/licenses/mit-license.php> 
*/
  var swfobject = function () {
    var D = 'undefined', r = 'object', S = 'Shockwave Flash', W = 'ShockwaveFlash.ShockwaveFlash', q = 'application/x-shockwave-flash', R = 'SWFObjectExprInst', x = 'onreadystatechange', O = window, j = document, t = navigator, T = false, U = [h], o = [], N = [], I = [], l, Q, E, B, J = false, a = false, n, G, m = true, M = function () {
        var aa = typeof j.getElementById != D && typeof j.getElementsByTagName != D && typeof j.createElement != D, ah = t.userAgent.toLowerCase(), Y = t.platform.toLowerCase(), ae = Y ? /win/.test(Y) : /win/.test(ah), ac = Y ? /mac/.test(Y) : /mac/.test(ah), af = /webkit/.test(ah) ? parseFloat(ah.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, '$1')) : false, X = !+'\v1', ag = [0, 0, 0], ab = null;

 if (typeof t.plugins != D && typeof t.plugins[S] == r) {
          ab = t.plugins[S].description; if (ab && !(typeof t.mimeTypes != D && t.mimeTypes[q] && !t.mimeTypes[q].enabledPlugin)) {
            T = true; X = false; ab = ab.replace(/^.*\s+(\S+\s+\S+$)/, '$1'); ag[0] = parseInt(ab.replace(/^(.*)\..*$/, '$1'), 10); ag[1] = parseInt(ab.replace(/^.*\.(.*)\s.*$/, '$1'), 10); ag[2] = /[a-zA-Z]/.test(ab) ? parseInt(ab.replace(/^.*[a-zA-Z]+(.*)$/, '$1'), 10) : 0;
          }
        } else {
          if (typeof O.ActiveXObject != D) {
            try {
              var ad = new ActiveXObject(W);

 if (ad) {
                ab = ad.GetVariable('$version'); if (ab) {
                  X = true; ab = ab.split(' ')[1].split(','); ag = [parseInt(ab[0], 10), parseInt(ab[1], 10), parseInt(ab[2], 10)];
                }
              }
            } catch (Z) {}
          }
        }

 return {
w3: aa,
pv: ag,
wk: af,
ie: X,
win: ae,
mac: ac
};
      }(), k = function () {
        if (!M.w3) {
          return;
        } if ((typeof j.readyState != D && j.readyState == 'complete') || (typeof j.readyState == D && (j.getElementsByTagName('body')[0] || j.body))) {
          f();
        } if (!J) {
          if (typeof j.addEventListener != D) {
            j.addEventListener('DOMContentLoaded', f, false);
          } if (M.ie && M.win) {
            j.attachEvent(x, function () {
              if (j.readyState == 'complete') {
                j.detachEvent(x, arguments.callee); f();
              }
            }); if (O == top) {
              (function () {
                if (J) {
                  return;
                } try {
                  j.documentElement.doScroll('left');
                } catch (X) {
                  setTimeout(arguments.callee, 0);

 return;
                }f();
              })();
            }
          } if (M.wk) {
            (function () {
              if (J) {
                return;
              } if (!/loaded|complete/.test(j.readyState)) {
                setTimeout(arguments.callee, 0);

 return;
              }f();
            })();
          }s(f);
        }
      }();

 function f() {
      if (J) {
        return;
      } try {
        var Z = j.getElementsByTagName('body')[0].appendChild(C('span'));

 Z.parentNode.removeChild(Z);
      } catch (aa) {
        return;
      }J = true; var X = U.length;

 for (var Y = 0; Y < X; Y++) {
        U[Y]();
      }
    } function K(X) {
      if (J) {
        X();
      } else {
        U[U.length] = X;
      }
    } function s(Y) {
      if (typeof O.addEventListener != D) {
        O.addEventListener('load', Y, false);
      } else {
        if (typeof j.addEventListener != D) {
          j.addEventListener('load', Y, false);
        } else {
          if (typeof O.attachEvent != D) {
            i(O, 'onload', Y);
          } else {
            if (typeof O.onload == 'function') {
              var X = O.onload;

 O.onload = function () {
                X(); Y();
              };
            } else {
              O.onload = Y;
            }
          }
        }
      }
    } function h() {
      if (T) {
        V();
      } else {
        H();
      }
    } function V() {
      var X = j.getElementsByTagName('body')[0]; var aa = C(r);

 aa.setAttribute('type', q); var Z = X.appendChild(aa);

 if (Z) {
        var Y = 0;

 (function () {
          if (typeof Z.GetVariable != D) {
            var ab = Z.GetVariable('$version');

 if (ab) {
              ab = ab.split(' ')[1].split(','); M.pv = [parseInt(ab[0], 10), parseInt(ab[1], 10), parseInt(ab[2], 10)];
            }
          } else {
            if (Y < 10) {
              Y++; setTimeout(arguments.callee, 10);

 return;
            }
          }X.removeChild(aa); Z = null; H();
        })();
      } else {
        H();
      }
    } function H() {
      var ag = o.length;

 if (ag > 0) {
        for (var af = 0; af < ag; af++) {
          var Y = o[af].id; var ab = o[af].callbackFn; var aa = { success: false,
id: Y };

 if (M.pv[0] > 0) {
            var ae = c(Y);

 if (ae) {
              if (F(o[af].swfVersion) && !(M.wk && M.wk < 312)) {
                w(Y, true); if (ab) {
                  aa.success = true; aa.ref = z(Y); ab(aa);
                }
              } else {
                if (o[af].expressInstall && A()) {
                  var ai = {};

 ai.data = o[af].expressInstall; ai.width = ae.getAttribute('width') || '0'; ai.height = ae.getAttribute('height') || '0'; if (ae.getAttribute('class')) {
                    ai.styleclass = ae.getAttribute('class');
                  } if (ae.getAttribute('align')) {
                    ai.align = ae.getAttribute('align');
                  } var ah = {}; var X = ae.getElementsByTagName('param'); var ac = X.length;

 for (var ad = 0; ad < ac; ad++) {
                    if (X[ad].getAttribute('name').toLowerCase() != 'movie') {
                      ah[X[ad].getAttribute('name')] = X[ad].getAttribute('value');
                    }
                  }P(ai, ah, Y, ab);
                } else {
                  p(ae); if (ab) {
                    ab(aa);
                  }
                }
              }
            }
          } else {
            w(Y, true); if (ab) {
              var Z = z(Y);

 if (Z && typeof Z.SetVariable != D) {
                aa.success = true; aa.ref = Z;
              }ab(aa);
            }
          }
        }
      }
    } function z(aa) {
      var X = null; var Y = c(aa);

 if (Y && Y.nodeName == 'OBJECT') {
        if (typeof Y.SetVariable != D) {
          X = Y;
        } else {
          var Z = Y.getElementsByTagName(r)[0];

 if (Z) {
            X = Z;
          }
        }
      }

 return X;
    } function A() {
      return !a && F('6.0.65') && (M.win || M.mac) && !(M.wk && M.wk < 312);
    } function P(aa, ab, X, Z) {
      a = true; E = Z || null; B = { success: false,
id: X }; var ae = c(X);

 if (ae) {
        if (ae.nodeName == 'OBJECT') {
          l = g(ae); Q = null;
        } else {
          l = ae; Q = X;
        }aa.id = R; if (typeof aa.width == D || (!/%$/.test(aa.width) && parseInt(aa.width, 10) < 310)) {
          aa.width = '310';
        } if (typeof aa.height == D || (!/%$/.test(aa.height) && parseInt(aa.height, 10) < 137)) {
          aa.height = '137';
        }j.title = j.title.slice(0, 47) + ' - Flash Player Installation'; var ad = M.ie && M.win ? 'ActiveX' : 'PlugIn', ac = 'MMredirectURL=' + O.location.toString().replace(/&/g, '%26') + '&MMplayerType=' + ad + '&MMdoctitle=' + j.title;

 if (typeof ab.flashvars != D) {
          ab.flashvars += '&' + ac;
        } else {
          ab.flashvars = ac;
        } if (M.ie && M.win && ae.readyState != 4) {
          var Y = C('div');

 X += 'SWFObjectNew'; Y.setAttribute('id', X); ae.parentNode.insertBefore(Y, ae); ae.style.display = 'none'; (function () {
            if (ae.readyState == 4) {
              ae.parentNode.removeChild(ae);
            } else {
              setTimeout(arguments.callee, 10);
            }
          })();
        }u(aa, ab, X);
      }
    } function p(Y) {
      if (M.ie && M.win && Y.readyState != 4) {
        var X = C('div');

 Y.parentNode.insertBefore(X, Y); X.parentNode.replaceChild(g(Y), X); Y.style.display = 'none'; (function () {
          if (Y.readyState == 4) {
            Y.parentNode.removeChild(Y);
          } else {
            setTimeout(arguments.callee, 10);
          }
        })();
      } else {
        Y.parentNode.replaceChild(g(Y), Y);
      }
    } function g(ab) {
      var aa = C('div');

 if (M.win && M.ie) {
        aa.innerHTML = ab.innerHTML;
      } else {
        var Y = ab.getElementsByTagName(r)[0];

 if (Y) {
          var ad = Y.childNodes;

 if (ad) {
            var X = ad.length;

 for (var Z = 0; Z < X; Z++) {
              if (!(ad[Z].nodeType == 1 && ad[Z].nodeName == 'PARAM') && !(ad[Z].nodeType == 8)) {
                aa.appendChild(ad[Z].cloneNode(true));
              }
            }
          }
        }
      }

 return aa;
    } function u(ai, ag, Y) {
      var X, aa = c(Y);

 if (M.wk && M.wk < 312) {
        return X;
      } if (aa) {
        if (typeof ai.id == D) {
          ai.id = Y;
        } if (M.ie && M.win) {
          var ah = '';

 for (var ae in ai) {
            if (ai[ae] != Object.prototype[ae]) {
              if (ae.toLowerCase() == 'data') {
                ag.movie = ai[ae];
              } else {
                if (ae.toLowerCase() == 'styleclass') {
                  ah += ' class="' + ai[ae] + '"';
                } else {
                  if (ae.toLowerCase() != 'classid') {
                    ah += ' ' + ae + '="' + ai[ae] + '"';
                  }
                }
              }
            }
          } var af = '';

 for (var ad in ag) {
            if (ag[ad] != Object.prototype[ad]) {
              af += '<param name="' + ad + '" value="' + ag[ad] + '" />';
            }
          }aa.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + ah + '>' + af + '</object>'; N[N.length] = ai.id; X = c(ai.id);
        } else {
          var Z = C(r);

 Z.setAttribute('type', q); for (var ac in ai) {
            if (ai[ac] != Object.prototype[ac]) {
              if (ac.toLowerCase() == 'styleclass') {
                Z.setAttribute('class', ai[ac]);
              } else {
                if (ac.toLowerCase() != 'classid') {
                  Z.setAttribute(ac, ai[ac]);
                }
              }
            }
          } for (var ab in ag) {
            if (ag[ab] != Object.prototype[ab] && ab.toLowerCase() != 'movie') {
              e(Z, ab, ag[ab]);
            }
          }aa.parentNode.replaceChild(Z, aa); X = Z;
        }
      }

 return X;
    } function e(Z, X, Y) {
      var aa = C('param');

 aa.setAttribute('name', X); aa.setAttribute('value', Y); Z.appendChild(aa);
    } function y(Y) {
      var X = c(Y);

 if (X && X.nodeName == 'OBJECT') {
        if (M.ie && M.win) {
          X.style.display = 'none'; (function () {
            if (X.readyState == 4) {
              b(Y);
            } else {
              setTimeout(arguments.callee, 10);
            }
          })();
        } else {
          X.parentNode.removeChild(X);
        }
      }
    } function b(Z) {
      var Y = c(Z);

 if (Y) {
        for (var X in Y) {
          if (typeof Y[X] == 'function') {
            Y[X] = null;
          }
        }Y.parentNode.removeChild(Y);
      }
    } function c(Z) {
      var X = null;

 try {
        X = j.getElementById(Z);
      } catch (Y) {}

 return X;
    } function C(X) {
      return j.createElement(X);
    } function i(Z, X, Y) {
      Z.attachEvent(X, Y); I[I.length] = [Z, X, Y];
    } function F(Z) {
      var Y = M.pv, X = Z.split('.');

 X[0] = parseInt(X[0], 10); X[1] = parseInt(X[1], 10) || 0; X[2] = parseInt(X[2], 10) || 0;

 return Y[0] > X[0] || (Y[0] == X[0] && Y[1] > X[1]) || (Y[0] == X[0] && Y[1] == X[1] && Y[2] >= X[2]) ? true : false;
    } function v(ac, Y, ad, ab) {
      if (M.ie && M.mac) {
        return;
      } var aa = j.getElementsByTagName('head')[0];

 if (!aa) {
        return;
      } var X = ad && typeof ad == 'string' ? ad : 'screen';

 if (ab) {
        n = null; G = null;
      } if (!n || G != X) {
        var Z = C('style');

 Z.setAttribute('type', 'text/css'); Z.setAttribute('media', X); n = aa.appendChild(Z); if (M.ie && M.win && typeof j.styleSheets != D && j.styleSheets.length > 0) {
          n = j.styleSheets[j.styleSheets.length - 1];
        }G = X;
      } if (M.ie && M.win) {
        if (n && typeof n.addRule == r) {
          n.addRule(ac, Y);
        }
      } else {
        if (n && typeof j.createTextNode != D) {
          n.appendChild(j.createTextNode(ac + ' {' + Y + '}'));
        }
      }
    } function w(Z, X) {
      if (!m) {
        return;
      } var Y = X ? 'visible' : 'hidden';

 if (J && c(Z)) {
        c(Z).style.visibility = Y;
      } else {
        v('#' + Z, 'visibility:' + Y);
      }
    } function L(Y) {
      var Z = /[\\\"<>\.;]/; var X = Z.exec(Y) != null;

 return X && typeof encodeURIComponent != D ? encodeURIComponent(Y) : Y;
    } var d = function () {
      if (M.ie && M.win) {
        window.attachEvent('onunload', function () {
          var ac = I.length;

 for (var ab = 0; ab < ac; ab++) {
            I[ab][0].detachEvent(I[ab][1], I[ab][2]);
          } var Z = N.length;

 for (var aa = 0; aa < Z; aa++) {
            y(N[aa]);
          } for (var Y in M) {
            M[Y] = null;
          }M = null; for (var X in swfobject) {
            swfobject[X] = null;
          }swfobject = null;
        });
      }
    }();

 return {
registerObject: function (ab, X, aa, Z) {
      if (M.w3 && ab && X) {
        var Y = {};

 Y.id = ab; Y.swfVersion = X; Y.expressInstall = aa; Y.callbackFn = Z; o[o.length] = Y; w(ab, false);
      } else {
        if (Z) {
          Z({ success: false,
id: ab });
        }
      }
    },
getObjectById: function (X) {
      if (M.w3) {
        return z(X);
      }
    },
embedSWF: function (ab, ah, ae, ag, Y, aa, Z, ad, af, ac) {
      var X = { success: false,
id: ah };

 if (M.w3 && !(M.wk && M.wk < 312) && ab && ah && ae && ag && Y) {
        w(ah, false); K(function () {
          ae += ''; ag += ''; var aj = {};

 if (af && typeof af === r) {
            for (var al in af) {
              aj[al] = af[al];
            }
          }aj.data = ab; aj.width = ae; aj.height = ag; var am = {};

 if (ad && typeof ad === r) {
            for (var ak in ad) {
              am[ak] = ad[ak];
            }
          } if (Z && typeof Z === r) {
            for (var ai in Z) {
              if (typeof am.flashvars != D) {
                am.flashvars += '&' + ai + '=' + Z[ai];
              } else {
                am.flashvars = ai + '=' + Z[ai];
              }
            }
          } if (F(Y)) {
            var an = u(aj, am, ah);

 if (aj.id == ah) {
              w(ah, true);
            }X.success = true; X.ref = an;
          } else {
            if (aa && A()) {
              aj.data = aa; P(aj, am, ah, ac);

 return;
            } else {
              w(ah, true);
            }
          } if (ac) {
            ac(X);
          }
        });
      } else {
        if (ac) {
          ac(X);
        }
      }
    },
switchOffAutoHideShow: function () {
      m = false;
    },
ua: M,
getFlashPlayerVersion: function () {
      return { major: M.pv[0],
minor: M.pv[1],
release: M.pv[2] };
    },
hasFlashPlayerVersion: F,
createSWF: function (Z, Y, X) {
      if (M.w3) {
        return u(Z, Y, X);
      } else {
        return undefined;
      }
    },
showExpressInstall: function (Z, aa, X, Y) {
      if (M.w3 && A()) {
        P(Z, aa, X, Y);
      }
    },
removeSWF: function (X) {
      if (M.w3) {
        y(X);
      }
    },
createCSS: function (aa, Z, Y, X) {
      if (M.w3) {
        v(aa, Z, Y, X);
      }
    },
addDomLoadEvent: K,
addLoadEvent: s,
getQueryParamValue: function (aa) {
      var Z = j.location.search || j.location.hash;

 if (Z) {
        if (/\?/.test(Z)) {
          Z = Z.split('?')[1];
        } if (aa == null) {
          return L(Z);
        } var Y = Z.split('&');

 for (var X = 0; X < Y.length; X++) {
          if (Y[X].substring(0, Y[X].indexOf('=')) == aa) {
            return L(Y[X].substring(Y[X].indexOf('=') + 1));
          }
        }
      }

 return '';
    },
expressInstallCallback: function () {
      if (a) {
        var X = c(R);

 if (X && l) {
          X.parentNode.replaceChild(l, X); if (Q) {
            w(Q, true); if (M.ie && M.win) {
              l.style.display = 'block';
            }
          } if (E) {
            E(B);
          }
        }a = false;
      }
    }
};
  }();
})();
// //////////////////////////////

// //////////////////////////////
// TweenMax.min.js
// //////////////////////////////
(function () {
/* !
 * VERSION: 1.17.0
 * DATE: 2015-05-27
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2015, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
  var _gsScope = typeof module != 'undefined' && module.exports && typeof global != 'undefined' ? global : this || window;

 (_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    'use strict';

 _gsScope._gsDefine('TweenMax', ['core.Animation', 'core.SimpleTimeline', 'TweenLite'], function (t, e, i) {
      var s = function (t) {
          var e, i = [], s = t.length;

 for (e = 0; e !== s; i.push(t[e++])) {

          }

 return i;
        }, r = function (t, e, s) {
          i.call(this, t, e, s), this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._dirty = !0, this.render = r.prototype.render;
        }, n = 1e-10, a = i._internals, o = a.isSelector, h = a.isArray, l = r.prototype = i.to({}, .1, {}), _ = [];

 r.version = '1.17.0', l.constructor = r, l.kill()._gc = !1, r.killTweensOf = r.killDelayedCallsTo = i.killTweensOf, r.getTweensOf = i.getTweensOf, r.lagSmoothing = i.lagSmoothing, r.ticker = i.ticker, r.render = i.render, l.invalidate = function () {
        return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), i.prototype.invalidate.call(this);
      }, l.updateTo = function (t, e) {
        var s, r = this.ratio, n = this.vars.immediateRender || t.immediateRender;

 e && this._startTime < this._timeline._time && (this._startTime = this._timeline._time, this._uncache(!1), this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay)); for (s in t) {
          this.vars[s] = t[s];
        } if (this._initted || n) {
          if (e) {
            this._initted = !1, n && this.render(0, !0, !0);
          } else if (this._gc && this._enabled(!0, !1), this._notifyPluginsOfEnabled && this._firstPT && i._onPluginEvent('_onDisable', this), this._time / this._duration > .998) {
            var a = this._time;

 this.render(0, !0, !1), this._initted = !1, this.render(a, !0, !1);
          } else if (this._time > 0 || n) {
            this._initted = !1, this._init(); for (var o, h = 1 / (1 - r), l = this._firstPT; l;) {
              o = l.s + l.c, l.c *= h, l.s = o - l.c, l = l._next;
            }
          }
        }

 return this;
      }, l.render = function (t, e, i) {
        this._initted || this._duration === 0 && this.vars.repeat && this.invalidate(); var s, r, o, h, l, _, u, c, f = this._dirty ? this.totalDuration() : this._totalDuration, p = this._time, m = this._totalTime, d = this._cycle, g = this._duration, v = this._rawPrevTime;

 if (t >= f ? (this._totalTime = f, this._cycle = this._repeat, this._yoyo && (1 & this._cycle) !== 0 ? (this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0) : (this._time = g, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1), this._reversed || (s = !0, r = 'onComplete', i = i || this._timeline.autoRemoveChildren), g === 0 && (this._initted || !this.vars.lazy || i) && (this._startTime === this._timeline._duration && (t = 0), (t === 0 || v < 0 || v === n) && v !== t && (i = !0, v > n && (r = 'onReverseComplete')), this._rawPrevTime = c = !e || t || v === t ? t : n)) : t < 1e-7 ? (this._totalTime = this._time = this._cycle = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (m !== 0 || g === 0 && v > 0) && (r = 'onReverseComplete', s = this._reversed), t < 0 && (this._active = !1, g === 0 && (this._initted || !this.vars.lazy || i) && (v >= 0 && (i = !0), this._rawPrevTime = c = !e || t || v === t ? t : n)), this._initted || (i = !0)) : (this._totalTime = this._time = t, this._repeat !== 0 && (h = g + this._repeatDelay, this._cycle = this._totalTime / h >> 0, this._cycle !== 0 && this._cycle === this._totalTime / h && this._cycle--, this._time = this._totalTime - this._cycle * h, this._yoyo && (1 & this._cycle) !== 0 && (this._time = g - this._time), this._time > g ? this._time = g : this._time < 0 && (this._time = 0)), this._easeType ? (l = this._time / g, _ = this._easeType, u = this._easePower, (_ === 1 || _ === 3 && l >= .5) && (l = 1 - l), _ === 3 && (l *= 2), u === 1 ? l *= l : u === 2 ? l *= l * l : u === 3 ? l *= l * l * l : u === 4 && (l *= l * l * l * l), this.ratio = _ === 1 ? 1 - l : _ === 2 ? l : this._time / g < .5 ? l / 2 : 1 - l / 2) : this.ratio = this._ease.getRatio(this._time / g)), p === this._time && !i && d === this._cycle) {
          return m !== this._totalTime && this._onUpdate && (e || this._callback('onUpdate')), void 0;
        } if (!this._initted) {
          if (this._init(), !this._initted || this._gc) {
            return;
          } if (!i && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) {
            return this._time = p, this._totalTime = m, this._rawPrevTime = v, this._cycle = d, a.lazyTweens.push(this), this._lazy = [t, e], void 0;
          } this._time && !s ? this.ratio = this._ease.getRatio(this._time / g) : s && this._ease._calcEnd && (this.ratio = this._ease.getRatio(this._time === 0 ? 0 : 1));
        } for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== p && t >= 0 && (this._active = !0), m === 0 && (this._initted === 2 && t > 0 && this._init(), this._startAt && (t >= 0 ? this._startAt.render(t, e, i) : r || (r = '_dummyGS')), this.vars.onStart && (this._totalTime !== 0 || g === 0) && (e || this._callback('onStart'))), o = this._firstPT; o;) {
          o.f ? o.t[o.p](o.c * this.ratio + o.s) : o.t[o.p] = o.c * this.ratio + o.s, o = o._next;
        } this._onUpdate && (t < 0 && this._startAt && this._startTime && this._startAt.render(t, e, i), e || (this._totalTime !== m || s) && this._callback('onUpdate')), this._cycle !== d && (e || this._gc || this.vars.onRepeat && this._callback('onRepeat')), r && (!this._gc || i) && (t < 0 && this._startAt && !this._onUpdate && this._startTime && this._startAt.render(t, e, i), s && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[r] && this._callback(r), g === 0 && this._rawPrevTime === n && c !== n && (this._rawPrevTime = 0));
      }, r.to = function (t, e, i) {
        return new r(t, e, i);
      }, r.from = function (t, e, i) {
        return i.runBackwards = !0, i.immediateRender = i.immediateRender != 0, new r(t, e, i);
      }, r.fromTo = function (t, e, i, s) {
        return s.startAt = i, s.immediateRender = s.immediateRender != 0 && i.immediateRender != 0, new r(t, e, s);
      }, r.staggerTo = r.allTo = function (t, e, n, a, l, u, c) {
        a = a || 0; var f, p, m, d, g = n.delay || 0, v = [], y = function () {
          n.onComplete && n.onComplete.apply(n.onCompleteScope || this, arguments), l.apply(c || n.callbackScope || this, u || _);
        };

 for (h(t) || (typeof t == 'string' && (t = i.selector(t) || t), o(t) && (t = s(t))), t = t || [], a < 0 && (t = s(t), t.reverse(), a *= -1), f = t.length - 1, m = 0; f >= m; m++) {
          p = {}; for (d in n) {
            p[d] = n[d];
          }p.delay = g, m === f && l && (p.onComplete = y), v[m] = new r(t[m], e, p), g += a;
        }

 return v;
      }, r.staggerFrom = r.allFrom = function (t, e, i, s, n, a, o) {
        return i.runBackwards = !0, i.immediateRender = i.immediateRender != 0, r.staggerTo(t, e, i, s, n, a, o);
      }, r.staggerFromTo = r.allFromTo = function (t, e, i, s, n, a, o, h) {
        return s.startAt = i, s.immediateRender = s.immediateRender != 0 && i.immediateRender != 0, r.staggerTo(t, e, s, n, a, o, h);
      }, r.delayedCall = function (t, e, i, s, n) {
        return new r(e, 0, {
delay: t,
onComplete: e,
onCompleteParams: i,
callbackScope: s,
onReverseComplete: e,
onReverseCompleteParams: i,
immediateRender: !1,
useFrames: n,
overwrite: 0
});
      }, r.set = function (t, e) {
        return new r(t, 0, e);
      }, r.isTweening = function (t) {
        return i.getTweensOf(t, !0).length > 0;
      }; var u = function (t, e) {
          for (var s = [], r = 0, n = t._first; n;) {
            n instanceof i ? s[r++] = n : (e && (s[r++] = n), s = s.concat(u(n, e)), r = s.length), n = n._next;
          }

 return s;
        }, c = r.getAllTweens = function (e) {
          return u(t._rootTimeline, e).concat(u(t._rootFramesTimeline, e));
        };

 r.killAll = function (t, i, s, r) {
        i == null && (i = !0), s == null && (s = !0); var n, a, o, h = c(r != 0), l = h.length, _ = i && s && r;

 for (o = 0; l > o; o++) {
          a = h[o], (_ || a instanceof e || (n = a.target === a.vars.onComplete) && s || i && !n) && (t ? a.totalTime(a._reversed ? 0 : a.totalDuration()) : a._enabled(!1, !1));
        }
      }, r.killChildTweensOf = function (t, e) {
        if (t != null) {
          var n, l, _, u, c, f = a.tweenLookup;

 if (typeof t == 'string' && (t = i.selector(t) || t), o(t) && (t = s(t)), h(t)) {
            for (u = t.length; --u > -1;) {
              r.killChildTweensOf(t[u], e);
            }
          } else {
            n = []; for (_ in f) {
              for (l = f[_].target.parentNode; l;) {
                l === t && (n = n.concat(f[_].tweens)), l = l.parentNode;
              }
            } for (c = n.length, u = 0; c > u; u++) {
              e && n[u].totalTime(n[u].totalDuration()), n[u]._enabled(!1, !1);
            }
          }
        }
      }; var f = function (t, i, s, r) {
        i = i !== !1, s = s !== !1, r = r !== !1; for (var n, a, o = c(r), h = i && s && r, l = o.length; --l > -1;) {
          a = o[l], (h || a instanceof e || (n = a.target === a.vars.onComplete) && s || i && !n) && a.paused(t);
        }
      };

 return r.pauseAll = function (t, e, i) {
        f(!0, t, e, i);
      }, r.resumeAll = function (t, e, i) {
        f(!1, t, e, i);
      }, r.globalTimeScale = function (e) {
        var s = t._rootTimeline, r = i.ticker.time;

 return arguments.length ? (e = e || n, s._startTime = r - (r - s._startTime) * s._timeScale / e, s = t._rootFramesTimeline, r = i.ticker.frame, s._startTime = r - (r - s._startTime) * s._timeScale / e, s._timeScale = t._rootTimeline._timeScale = e, e) : s._timeScale;
      }, l.progress = function (t) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && (1 & this._cycle) !== 0 ? 1 - t : t) + this._cycle * (this._duration + this._repeatDelay), !1) : this._time / this.duration();
      }, l.totalProgress = function (t) {
        return arguments.length ? this.totalTime(this.totalDuration() * t, !1) : this._totalTime / this.totalDuration();
      }, l.time = function (t, e) {
        return arguments.length ? (this._dirty && this.totalDuration(), t > this._duration && (t = this._duration), this._yoyo && (1 & this._cycle) !== 0 ? t = this._duration - t + this._cycle * (this._duration + this._repeatDelay) : this._repeat !== 0 && (t += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(t, e)) : this._time;
      }, l.duration = function (e) {
        return arguments.length ? t.prototype.duration.call(this, e) : this._duration;
      }, l.totalDuration = function (t) {
        return arguments.length ? this._repeat === -1 ? this : this.duration((t - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = this._repeat === -1 ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat, this._dirty = !1), this._totalDuration);
      }, l.repeat = function (t) {
        return arguments.length ? (this._repeat = t, this._uncache(!0)) : this._repeat;
      }, l.repeatDelay = function (t) {
        return arguments.length ? (this._repeatDelay = t, this._uncache(!0)) : this._repeatDelay;
      }, l.yoyo = function (t) {
        return arguments.length ? (this._yoyo = t, this) : this._yoyo;
      }, r;
    }, !0), _gsScope._gsDefine('TimelineLite', ['core.Animation', 'core.SimpleTimeline', 'TweenLite'], function (t, e, i) {
      var s = function (t) {
          e.call(this, t), this._labels = {}, this.autoRemoveChildren = this.vars.autoRemoveChildren === !0, this.smoothChildTiming = this.vars.smoothChildTiming === !0, this._sortChildren = !0, this._onUpdate = this.vars.onUpdate; var i, s, r = this.vars;

 for (s in r) {
            i = r[s], h(i) && i.join('').indexOf('{self}') !== -1 && (r[s] = this._swapSelfInParams(i));
          }h(r.tweens) && this.add(r.tweens, 0, r.align, r.stagger);
        }, r = 1e-10, n = i._internals, a = s._internals = {}, o = n.isSelector, h = n.isArray, l = n.lazyTweens, _ = n.lazyRender, u = [], c = _gsScope._gsDefine.globals, f = function (t) {
          var e, i = {};

 for (e in t) {
            i[e] = t[e];
          }

 return i;
        }, p = a.pauseCallback = function (t, e, i, s) {
          var n, a = t._timeline, o = a._totalTime, h = t._startTime, l = t._rawPrevTime < 0 || t._rawPrevTime === 0 && a._reversed, _ = l ? 0 : r, c = l ? r : 0;

 if (e || !this._forcingPlayhead) {
            for (a.pause(h), n = t._prev; n && n._startTime === h;) {
              n._rawPrevTime = c, n = n._prev;
            } for (n = t._next; n && n._startTime === h;) {
              n._rawPrevTime = _, n = n._next;
            }e && e.apply(s || a.vars.callbackScope || a, i || u), (this._forcingPlayhead || !a._paused) && a.seek(o);
          }
        }, m = function (t) {
          var e, i = [], s = t.length;

 for (e = 0; e !== s; i.push(t[e++])) {

          }

 return i;
        }, d = s.prototype = new e;

 return s.version = '1.17.0', d.constructor = s, d.kill()._gc = d._forcingPlayhead = !1, d.to = function (t, e, s, r) {
        var n = s.repeat && c.TweenMax || i;

 return e ? this.add(new n(t, e, s), r) : this.set(t, s, r);
      }, d.from = function (t, e, s, r) {
        return this.add((s.repeat && c.TweenMax || i).from(t, e, s), r);
      }, d.fromTo = function (t, e, s, r, n) {
        var a = r.repeat && c.TweenMax || i;

 return e ? this.add(a.fromTo(t, e, s, r), n) : this.set(t, r, n);
      }, d.staggerTo = function (t, e, r, n, a, h, l, _) {
        var u, c = new s({
onComplete: h,
onCompleteParams: l,
callbackScope: _,
smoothChildTiming: this.smoothChildTiming
});

 for (typeof t == 'string' && (t = i.selector(t) || t), t = t || [], o(t) && (t = m(t)), n = n || 0, n < 0 && (t = m(t), t.reverse(), n *= -1), u = 0; t.length > u; u++) {
          r.startAt && (r.startAt = f(r.startAt)), c.to(t[u], e, f(r), u * n);
        }

 return this.add(c, a);
      }, d.staggerFrom = function (t, e, i, s, r, n, a, o) {
        return i.immediateRender = i.immediateRender != 0, i.runBackwards = !0, this.staggerTo(t, e, i, s, r, n, a, o);
      }, d.staggerFromTo = function (t, e, i, s, r, n, a, o, h) {
        return s.startAt = i, s.immediateRender = s.immediateRender != 0 && i.immediateRender != 0, this.staggerTo(t, e, s, r, n, a, o, h);
      }, d.call = function (t, e, s, r) {
        return this.add(i.delayedCall(0, t, e, s), r);
      }, d.set = function (t, e, s) {
        return s = this._parseTimeOrLabel(s, 0, !0), e.immediateRender == null && (e.immediateRender = s === this._time && !this._paused), this.add(new i(t, 0, e), s);
      }, s.exportRoot = function (t, e) {
        t = t || {}, t.smoothChildTiming == null && (t.smoothChildTiming = !0); var r, n, a = new s(t), o = a._timeline;

 for (e == null && (e = !0), o._remove(a, !0), a._startTime = 0, a._rawPrevTime = a._time = a._totalTime = o._time, r = o._first; r;) {
          n = r._next, e && r instanceof i && r.target === r.vars.onComplete || a.add(r, r._startTime - r._delay), r = n;
        }

 return o.add(a, 0), a;
      }, d.add = function (r, n, a, o) {
        var l, _, u, c, f, p;

 if (typeof n != 'number' && (n = this._parseTimeOrLabel(n, 0, !0, r)), !(r instanceof t)) {
          if (r instanceof Array || r && r.push && h(r)) {
            for (a = a || 'normal', o = o || 0, l = n, _ = r.length, u = 0; _ > u; u++) {
              h(c = r[u]) && (c = new s({ tweens: c })), this.add(c, l), typeof c != 'string' && typeof c != 'function' && (a === 'sequence' ? l = c._startTime + c.totalDuration() / c._timeScale : a === 'start' && (c._startTime -= c.delay())), l += o;
            }

 return this._uncache(!0);
          } if (typeof r == 'string') {
            return this.addLabel(r, n);
          } if (typeof r != 'function') {
            throw 'Cannot add ' + r + ' into the timeline; it is not a tween, timeline, function, or string.';
          } r = i.delayedCall(0, r);
        } if (e.prototype.add.call(this, r, n), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration()) {
          for (f = this, p = f.rawTime() > r._startTime; f._timeline;) {
            p && f._timeline.smoothChildTiming ? f.totalTime(f._totalTime, !0) : f._gc && f._enabled(!0, !1), f = f._timeline;
          }
        }

 return this;
      }, d.remove = function (e) {
        if (e instanceof t) {
          return this._remove(e, !1);
        } if (e instanceof Array || e && e.push && h(e)) {
          for (var i = e.length; --i > -1;) {
            this.remove(e[i]);
          }

 return this;
        }

 return typeof e == 'string' ? this.removeLabel(e) : this.kill(null, e);
      }, d._remove = function (t, i) {
        e.prototype._remove.call(this, t, i); var s = this._last;

 return s ? this._time > s._startTime + s._totalDuration / s._timeScale && (this._time = this.duration(), this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0, this;
      }, d.append = function (t, e) {
        return this.add(t, this._parseTimeOrLabel(null, e, !0, t));
      }, d.insert = d.insertMultiple = function (t, e, i, s) {
        return this.add(t, e || 0, i, s);
      }, d.appendMultiple = function (t, e, i, s) {
        return this.add(t, this._parseTimeOrLabel(null, e, !0, t), i, s);
      }, d.addLabel = function (t, e) {
        return this._labels[t] = this._parseTimeOrLabel(e), this;
      }, d.addPause = function (t, e, s, r) {
        var n = i.delayedCall(0, p, ['{self}', e, s, r], this);

 return n.data = 'isPause', this.add(n, t);
      }, d.removeLabel = function (t) {
        return delete this._labels[t], this;
      }, d.getLabelTime = function (t) {
        return this._labels[t] != null ? this._labels[t] : -1;
      }, d._parseTimeOrLabel = function (e, i, s, r) {
        var n;

 if (r instanceof t && r.timeline === this) {
          this.remove(r);
        } else if (r && (r instanceof Array || r.push && h(r))) {
          for (n = r.length; --n > -1;) {
            r[n] instanceof t && r[n].timeline === this && this.remove(r[n]);
          }
        } if (typeof i == 'string') {
          return this._parseTimeOrLabel(i, s && typeof e == 'number' && this._labels[i] == null ? e - this.duration() : 0, s);
        } if (i = i || 0, typeof e != 'string' || !isNaN(e) && this._labels[e] == null) {
          e == null && (e = this.duration());
        } else {
          if (n = e.indexOf('='), n === -1) {
            return this._labels[e] == null ? s ? this._labels[e] = this.duration() + i : i : this._labels[e] + i;
          } i = parseInt(e.charAt(n - 1) + '1', 10) * Number(e.substr(n + 1)), e = n > 1 ? this._parseTimeOrLabel(e.substr(0, n - 1), 0, s) : this.duration();
        }

 return Number(e) + i;
      }, d.seek = function (t, e) {
        return this.totalTime(typeof t == 'number' ? t : this._parseTimeOrLabel(t), e !== !1);
      }, d.stop = function () {
        return this.paused(!0);
      }, d.gotoAndPlay = function (t, e) {
        return this.play(t, e);
      }, d.gotoAndStop = function (t, e) {
        return this.pause(t, e);
      }, d.render = function (t, e, i) {
        this._gc && this._enabled(!0, !1); var s, n, a, o, h, u = this._dirty ? this.totalDuration() : this._totalDuration, c = this._time, f = this._startTime, p = this._timeScale, m = this._paused;

 if (t >= u) {
          this._totalTime = this._time = u, this._reversed || this._hasPausedChild() || (n = !0, o = 'onComplete', h = !!this._timeline.autoRemoveChildren, this._duration === 0 && (t === 0 || this._rawPrevTime < 0 || this._rawPrevTime === r) && this._rawPrevTime !== t && this._first && (h = !0, this._rawPrevTime > r && (o = 'onReverseComplete'))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : r, t = u + 1e-4;
        } else if (t < 1e-7) {
          if (this._totalTime = this._time = 0, (c !== 0 || this._duration === 0 && this._rawPrevTime !== r && (this._rawPrevTime > 0 || t < 0 && this._rawPrevTime >= 0)) && (o = 'onReverseComplete', n = this._reversed), t < 0) {
            this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (h = n = !0, o = 'onReverseComplete') : this._rawPrevTime >= 0 && this._first && (h = !0), this._rawPrevTime = t;
          } else {
            if (this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : r, t === 0 && n) {
              for (s = this._first; s && s._startTime === 0;) {
                s._duration || (n = !1), s = s._next;
              }
            }t = 0, this._initted || (h = !0);
          }
        } else {
          this._totalTime = this._time = this._rawPrevTime = t;
        } if (this._time !== c && this._first || i || h) {
          if (this._initted || (this._initted = !0), this._active || !this._paused && this._time !== c && t > 0 && (this._active = !0), c === 0 && this.vars.onStart && this._time !== 0 && (e || this._callback('onStart')), this._time >= c) {
            for (s = this._first; s && (a = s._next, !this._paused || m);) {
              (s._active || s._startTime <= this._time && !s._paused && !s._gc) && (s._reversed ? s.render((s._dirty ? s.totalDuration() : s._totalDuration) - (t - s._startTime) * s._timeScale, e, i) : s.render((t - s._startTime) * s._timeScale, e, i)), s = a;
            }
          } else {
            for (s = this._last; s && (a = s._prev, !this._paused || m);) {
              (s._active || c >= s._startTime && !s._paused && !s._gc) && (s._reversed ? s.render((s._dirty ? s.totalDuration() : s._totalDuration) - (t - s._startTime) * s._timeScale, e, i) : s.render((t - s._startTime) * s._timeScale, e, i)), s = a;
            }
          } this._onUpdate && (e || (l.length && _(), this._callback('onUpdate'))), o && (this._gc || (f === this._startTime || p !== this._timeScale) && (this._time === 0 || u >= this.totalDuration()) && (n && (l.length && _(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[o] && this._callback(o)));
        }
      }, d._hasPausedChild = function () {
        for (var t = this._first; t;) {
          if (t._paused || t instanceof s && t._hasPausedChild()) {
            return !0;
          } t = t._next;
        }

 return !1;
      }, d.getChildren = function (t, e, s, r) {
        r = r || -9999999999; for (var n = [], a = this._first, o = 0; a;) {
          r > a._startTime || (a instanceof i ? e !== !1 && (n[o++] = a) : (s !== !1 && (n[o++] = a), t !== !1 && (n = n.concat(a.getChildren(!0, e, s)), o = n.length))), a = a._next;
        }

 return n;
      }, d.getTweensOf = function (t, e) {
        var s, r, n = this._gc, a = [], o = 0;

 for (n && this._enabled(!0, !0), s = i.getTweensOf(t), r = s.length; --r > -1;) {
          (s[r].timeline === this || e && this._contains(s[r])) && (a[o++] = s[r]);
        }

 return n && this._enabled(!1, !0), a;
      }, d.recent = function () {
        return this._recent;
      }, d._contains = function (t) {
        for (var e = t.timeline; e;) {
          if (e === this) {
            return !0;
          } e = e.timeline;
        }

 return !1;
      }, d.shiftChildren = function (t, e, i) {
        i = i || 0; for (var s, r = this._first, n = this._labels; r;) {
          r._startTime >= i && (r._startTime += t), r = r._next;
        } if (e) {
          for (s in n) {
            n[s] >= i && (n[s] += t);
          }
        }

 return this._uncache(!0);
      }, d._kill = function (t, e) {
        if (!t && !e) {
          return this._enabled(!1, !1);
        } for (var i = e ? this.getTweensOf(e) : this.getChildren(!0, !0, !1), s = i.length, r = !1; --s > -1;) {
          i[s]._kill(t, e) && (r = !0);
        }

 return r;
      }, d.clear = function (t) {
        var e = this.getChildren(!1, !0, !0), i = e.length;

 for (this._time = this._totalTime = 0; --i > -1;) {
          e[i]._enabled(!1, !1);
        }

 return t !== !1 && (this._labels = {}), this._uncache(!0);
      }, d.invalidate = function () {
        for (var e = this._first; e;) {
          e.invalidate(), e = e._next;
        }

 return t.prototype.invalidate.call(this);
      }, d._enabled = function (t, i) {
        if (t === this._gc) {
          for (var s = this._first; s;) {
            s._enabled(t, !0), s = s._next;
          }
        }

 return e.prototype._enabled.call(this, t, i);
      }, d.totalTime = function () {
        this._forcingPlayhead = !0; var e = t.prototype.totalTime.apply(this, arguments);

 return this._forcingPlayhead = !1, e;
      }, d.duration = function (t) {
        return arguments.length ? (this.duration() !== 0 && t !== 0 && this.timeScale(this._duration / t), this) : (this._dirty && this.totalDuration(), this._duration);
      }, d.totalDuration = function (t) {
        if (!arguments.length) {
          if (this._dirty) {
            for (var e, i, s = 0, r = this._last, n = 999999999999; r;) {
              e = r._prev, r._dirty && r.totalDuration(), r._startTime > n && this._sortChildren && !r._paused ? this.add(r, r._startTime - r._delay) : n = r._startTime, r._startTime < 0 && !r._paused && (s -= r._startTime, this._timeline.smoothChildTiming && (this._startTime += r._startTime / this._timeScale), this.shiftChildren(-r._startTime, !1, -9999999999), n = 0), i = r._startTime + r._totalDuration / r._timeScale, i > s && (s = i), r = e;
            } this._duration = this._totalDuration = s, this._dirty = !1;
          }

 return this._totalDuration;
        }

 return this.totalDuration() !== 0 && t !== 0 && this.timeScale(this._totalDuration / t), this;
      }, d.paused = function (e) {
        if (!e) {
          for (var i = this._first, s = this._time; i;) {
            i._startTime === s && i.data === 'isPause' && (i._rawPrevTime = 0), i = i._next;
          }
        }

 return t.prototype.paused.apply(this, arguments);
      }, d.usesFrames = function () {
        for (var e = this._timeline; e._timeline;) {
          e = e._timeline;
        }

 return e === t._rootFramesTimeline;
      }, d.rawTime = function () {
        return this._paused ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale;
      }, s;
    }, !0), _gsScope._gsDefine('TimelineMax', ['TimelineLite', 'TweenLite', 'easing.Ease'], function (t, e, i) {
      var s = function (e) {
          t.call(this, e), this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._dirty = !0;
        }, r = 1e-10, n = e._internals, a = n.lazyTweens, o = n.lazyRender, h = new i(null, null, 1, 0), l = s.prototype = new t;

 return l.constructor = s, l.kill()._gc = !1, s.version = '1.17.0', l.invalidate = function () {
        return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), t.prototype.invalidate.call(this);
      }, l.addCallback = function (t, i, s, r) {
        return this.add(e.delayedCall(0, t, s, r), i);
      }, l.removeCallback = function (t, e) {
        if (t) {
          if (e == null) {
            this._kill(null, t);
          } else {
            for (var i = this.getTweensOf(t, !1), s = i.length, r = this._parseTimeOrLabel(e); --s > -1;) {
              i[s]._startTime === r && i[s]._enabled(!1, !1);
            }
          }
        }

 return this;
      }, l.removePause = function (e) {
        return this.removeCallback(t._internals.pauseCallback, e);
      }, l.tweenTo = function (t, i) {
        i = i || {}; var s, r, n, a = { ease: h,
useFrames: this.usesFrames(),
immediateRender: !1 };

 for (r in i) {
          a[r] = i[r];
        }

 return a.time = this._parseTimeOrLabel(t), s = Math.abs(Number(a.time) - this._time) / this._timeScale || .001, n = new e(this, s, a), a.onStart = function () {
          n.target.paused(!0), n.vars.time !== n.target.time() && s === n.duration() && n.duration(Math.abs(n.vars.time - n.target.time()) / n.target._timeScale), i.onStart && n._callback('onStart');
        }, n;
      }, l.tweenFromTo = function (t, e, i) {
        i = i || {}, t = this._parseTimeOrLabel(t), i.startAt = { onComplete: this.seek,
onCompleteParams: [t],
callbackScope: this }, i.immediateRender = i.immediateRender !== !1; var s = this.tweenTo(e, i);

 return s.duration(Math.abs(s.vars.time - t) / this._timeScale || .001);
      }, l.render = function (t, e, i) {
        this._gc && this._enabled(!0, !1); var s, n, h, l, _, u, c = this._dirty ? this.totalDuration() : this._totalDuration, f = this._duration, p = this._time, m = this._totalTime, d = this._startTime, g = this._timeScale, v = this._rawPrevTime, y = this._paused, T = this._cycle;

 if (t >= c) {
          this._locked || (this._totalTime = c, this._cycle = this._repeat), this._reversed || this._hasPausedChild() || (n = !0, l = 'onComplete', _ = !!this._timeline.autoRemoveChildren, this._duration === 0 && (t === 0 || v < 0 || v === r) && v !== t && this._first && (_ = !0, v > r && (l = 'onReverseComplete'))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : r, this._yoyo && (1 & this._cycle) !== 0 ? this._time = t = 0 : (this._time = f, t = f + 1e-4);
        } else if (t < 1e-7) {
          if (this._locked || (this._totalTime = this._cycle = 0), this._time = 0, (p !== 0 || f === 0 && v !== r && (v > 0 || t < 0 && v >= 0) && !this._locked) && (l = 'onReverseComplete', n = this._reversed), t < 0) {
            this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (_ = n = !0, l = 'onReverseComplete') : v >= 0 && this._first && (_ = !0), this._rawPrevTime = t;
          } else {
            if (this._rawPrevTime = f || !e || t || this._rawPrevTime === t ? t : r, t === 0 && n) {
              for (s = this._first; s && s._startTime === 0;) {
                s._duration || (n = !1), s = s._next;
              }
            }t = 0, this._initted || (_ = !0);
          }
        } else {
          f === 0 && v < 0 && (_ = !0), this._time = this._rawPrevTime = t, this._locked || (this._totalTime = t, this._repeat !== 0 && (u = f + this._repeatDelay, this._cycle = this._totalTime / u >> 0, this._cycle !== 0 && this._cycle === this._totalTime / u && this._cycle--, this._time = this._totalTime - this._cycle * u, this._yoyo && (1 & this._cycle) !== 0 && (this._time = f - this._time), this._time > f ? (this._time = f, t = f + 1e-4) : this._time < 0 ? this._time = t = 0 : t = this._time));
        } if (this._cycle !== T && !this._locked) {
          var x = this._yoyo && (1 & T) !== 0, w = x === (this._yoyo && (1 & this._cycle) !== 0), b = this._totalTime, P = this._cycle, k = this._rawPrevTime, S = this._time;

 if (this._totalTime = T * f, T > this._cycle ? x = !x : this._totalTime += f, this._time = p, this._rawPrevTime = f === 0 ? v - 1e-4 : v, this._cycle = T, this._locked = !0, p = x ? 0 : f, this.render(p, e, f === 0), e || this._gc || this.vars.onRepeat && this._callback('onRepeat'), w && (p = x ? f + 1e-4 : -1e-4, this.render(p, !0, !1)), this._locked = !1, this._paused && !y) {
            return;
          } this._time = S, this._totalTime = b, this._cycle = P, this._rawPrevTime = k;
        } if (!(this._time !== p && this._first || i || _)) {
          return m !== this._totalTime && this._onUpdate && (e || this._callback('onUpdate')), void 0;
        } if (this._initted || (this._initted = !0), this._active || !this._paused && this._totalTime !== m && t > 0 && (this._active = !0), m === 0 && this.vars.onStart && this._totalTime !== 0 && (e || this._callback('onStart')), this._time >= p) {
          for (s = this._first; s && (h = s._next, !this._paused || y);) {
            (s._active || s._startTime <= this._time && !s._paused && !s._gc) && (s._reversed ? s.render((s._dirty ? s.totalDuration() : s._totalDuration) - (t - s._startTime) * s._timeScale, e, i) : s.render((t - s._startTime) * s._timeScale, e, i)), s = h;
          }
        } else {
          for (s = this._last; s && (h = s._prev, !this._paused || y);) {
            (s._active || p >= s._startTime && !s._paused && !s._gc) && (s._reversed ? s.render((s._dirty ? s.totalDuration() : s._totalDuration) - (t - s._startTime) * s._timeScale, e, i) : s.render((t - s._startTime) * s._timeScale, e, i)), s = h;
          }
        } this._onUpdate && (e || (a.length && o(), this._callback('onUpdate'))), l && (this._locked || this._gc || (d === this._startTime || g !== this._timeScale) && (this._time === 0 || c >= this.totalDuration()) && (n && (a.length && o(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[l] && this._callback(l)));
      }, l.getActive = function (t, e, i) {
        t == null && (t = !0), e == null && (e = !0), i == null && (i = !1); var s, r, n = [], a = this.getChildren(t, e, i), o = 0, h = a.length;

 for (s = 0; h > s; s++) {
          r = a[s], r.isActive() && (n[o++] = r);
        }

 return n;
      }, l.getLabelAfter = function (t) {
        t || t !== 0 && (t = this._time); var e, i = this.getLabelsArray(), s = i.length;

 for (e = 0; s > e; e++) {
          if (i[e].time > t) {
            return i[e].name;
          }
        }

 return null;
      }, l.getLabelBefore = function (t) {
        t == null && (t = this._time); for (var e = this.getLabelsArray(), i = e.length; --i > -1;) {
          if (t > e[i].time) {
            return e[i].name;
          }
        }

 return null;
      }, l.getLabelsArray = function () {
        var t, e = [], i = 0;

 for (t in this._labels) {
          e[i++] = { time: this._labels[t],
name: t };
        }

 return e.sort(function (t, e) {
          return t.time - e.time;
        }), e;
      }, l.progress = function (t, e) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && (1 & this._cycle) !== 0 ? 1 - t : t) + this._cycle * (this._duration + this._repeatDelay), e) : this._time / this.duration();
      }, l.totalProgress = function (t, e) {
        return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this._totalTime / this.totalDuration();
      }, l.totalDuration = function (e) {
        return arguments.length ? this._repeat === -1 ? this : this.duration((e - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (t.prototype.totalDuration.call(this), this._totalDuration = this._repeat === -1 ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), this._totalDuration);
      }, l.time = function (t, e) {
        return arguments.length ? (this._dirty && this.totalDuration(), t > this._duration && (t = this._duration), this._yoyo && (1 & this._cycle) !== 0 ? t = this._duration - t + this._cycle * (this._duration + this._repeatDelay) : this._repeat !== 0 && (t += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(t, e)) : this._time;
      }, l.repeat = function (t) {
        return arguments.length ? (this._repeat = t, this._uncache(!0)) : this._repeat;
      }, l.repeatDelay = function (t) {
        return arguments.length ? (this._repeatDelay = t, this._uncache(!0)) : this._repeatDelay;
      }, l.yoyo = function (t) {
        return arguments.length ? (this._yoyo = t, this) : this._yoyo;
      }, l.currentLabel = function (t) {
        return arguments.length ? this.seek(t, !0) : this.getLabelBefore(this._time + 1e-8);
      }, s;
    }, !0), function () {
      var t = 180 / Math.PI, e = [], i = [], s = [], r = {}, n = _gsScope._gsDefine.globals, a = function (t, e, i, s) {
          this.a = t, this.b = e, this.c = i, this.d = s, this.da = s - t, this.ca = i - t, this.ba = e - t;
        }, o = ',x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,', h = function (t, e, i, s) {
          var r = { a: t }, n = {}, a = {}, o = { c: s }, h = (t + e) / 2, l = (e + i) / 2, _ = (i + s) / 2, u = (h + l) / 2, c = (l + _) / 2, f = (c - u) / 8;

 return r.b = h + (t - h) / 4, n.b = u + f, r.c = n.a = (r.b + n.b) / 2, n.c = a.a = (u + c) / 2, a.b = c - f, o.b = _ + (s - _) / 4, a.c = o.a = (a.b + o.b) / 2, [r, n, a, o];
        }, l = function (t, r, n, a, o) {
          var l, _, u, c, f, p, m, d, g, v, y, T, x, w = t.length - 1, b = 0, P = t[0].a;

 for (l = 0; w > l; l++) {
            f = t[b], _ = f.a, u = f.d, c = t[b + 1].d, o ? (y = e[l], T = i[l], x = .25 * (T + y) * r / (a ? .5 : s[l] || .5), p = u - (u - _) * (a ? .5 * r : y !== 0 ? x / y : 0), m = u + (c - u) * (a ? .5 * r : T !== 0 ? x / T : 0), d = u - (p + ((m - p) * (3 * y / (y + T) + .5) / 4 || 0))) : (p = u - .5 * (u - _) * r, m = u + .5 * (c - u) * r, d = u - (p + m) / 2), p += d, m += d, f.c = g = p, f.b = l !== 0 ? P : P = f.a + .6 * (f.c - f.a), f.da = u - _, f.ca = g - _, f.ba = P - _, n ? (v = h(_, P, g, u), t.splice(b, 1, v[0], v[1], v[2], v[3]), b += 4) : b++, P = m;
          }f = t[b], f.b = P, f.c = P + .4 * (f.d - P), f.da = f.d - f.a, f.ca = f.c - f.a, f.ba = P - f.a, n && (v = h(f.a, P, f.c, f.d), t.splice(b, 1, v[0], v[1], v[2], v[3]));
        }, _ = function (t, s, r, n) {
          var o, h, l, _, u, c, f = [];

 if (n) {
            for (t = [n].concat(t), h = t.length; --h > -1;) {
              typeof (c = t[h][s]) == 'string' && c.charAt(1) === '=' && (t[h][s] = n[s] + Number(c.charAt(0) + c.substr(2)));
            }
          } if (o = t.length - 2, o < 0) {
            return f[0] = new a(t[0][s], 0, 0, t[o < -1 ? 0 : 1][s]), f;
          } for (h = 0; o > h; h++) {
            l = t[h][s], _ = t[h + 1][s], f[h] = new a(l, 0, 0, _), r && (u = t[h + 2][s], e[h] = (e[h] || 0) + (_ - l) * (_ - l), i[h] = (i[h] || 0) + (u - _) * (u - _));
          }

 return f[h] = new a(t[h][s], 0, 0, t[h + 1][s]), f;
        }, u = function (t, n, a, h, u, c) {
          var f, p, m, d, g, v, y, T, x = {}, w = [], b = c || t[0];

 u = typeof u == 'string' ? ',' + u + ',' : o, n == null && (n = 1); for (p in t[0]) {
            w.push(p);
          } if (t.length > 1) {
            for (T = t[t.length - 1], y = !0, f = w.length; --f > -1;) {
              if (p = w[f], Math.abs(b[p] - T[p]) > .05) {
                y = !1; break;
              }
            }y && (t = t.concat(), c && t.unshift(c), t.push(t[1]), c = t[t.length - 3]);
          } for (e.length = i.length = s.length = 0, f = w.length; --f > -1;) {
            p = w[f], r[p] = u.indexOf(',' + p + ',') !== -1, x[p] = _(t, p, r[p], c);
          } for (f = e.length; --f > -1;) {
            e[f] = Math.sqrt(e[f]), i[f] = Math.sqrt(i[f]);
          } if (!h) {
            for (f = w.length; --f > -1;) {
              if (r[p]) {
                for (m = x[w[f]], v = m.length - 1, d = 0; v > d; d++) {
                  g = m[d + 1].da / i[d] + m[d].da / e[d], s[d] = (s[d] || 0) + g * g;
                }
              }
            } for (f = s.length; --f > -1;) {
              s[f] = Math.sqrt(s[f]);
            }
          } for (f = w.length, d = a ? 4 : 1; --f > -1;) {
            p = w[f], m = x[p], l(m, n, a, h, r[p]), y && (m.splice(0, d), m.splice(m.length - d, d));
          }

 return x;
        }, c = function (t, e, i) {
          e = e || 'soft'; var s, r, n, o, h, l, _, u, c, f, p, m = {}, d = e === 'cubic' ? 3 : 2, g = e === 'soft', v = [];

 if (g && i && (t = [i].concat(t)), t == null || d + 1 > t.length) {
            throw 'invalid Bezier data';
          } for (c in t[0]) {
            v.push(c);
          } for (l = v.length; --l > -1;) {
            for (c = v[l], m[c] = h = [], f = 0, u = t.length, _ = 0; u > _; _++) {
              s = i == null ? t[_][c] : typeof (p = t[_][c]) == 'string' && p.charAt(1) === '=' ? i[c] + Number(p.charAt(0) + p.substr(2)) : Number(p), g && _ > 1 && u - 1 > _ && (h[f++] = (s + h[f - 2]) / 2), h[f++] = s;
            } for (u = f - d + 1, f = 0, _ = 0; u > _; _ += d) {
              s = h[_], r = h[_ + 1], n = h[_ + 2], o = d === 2 ? 0 : h[_ + 3], h[f++] = p = d === 3 ? new a(s, r, n, o) : new a(s, (2 * r + s) / 3, (2 * r + n) / 3, n);
            }h.length = f;
          }

 return m;
        }, f = function (t, e, i) {
          for (var s, r, n, a, o, h, l, _, u, c, f, p = 1 / i, m = t.length; --m > -1;) {
            for (c = t[m], n = c.a, a = c.d - n, o = c.c - n, h = c.b - n, s = r = 0, _ = 1; i >= _; _++) {
              l = p * _, u = 1 - l, s = r - (r = (l * l * a + 3 * u * (l * o + u * h)) * l), f = m * i + _ - 1, e[f] = (e[f] || 0) + s * s;
            }
          }
        }, p = function (t, e) {
          e = e >> 0 || 6; var i, s, r, n, a = [], o = [], h = 0, l = 0, _ = e - 1, u = [], c = [];

 for (i in t) {
            f(t[i], a, e);
          } for (r = a.length, s = 0; r > s; s++) {
            h += Math.sqrt(a[s]), n = s % e, c[n] = h, n === _ && (l += h, n = s / e >> 0, u[n] = c, o[n] = l, h = 0, c = []);
          }

 return { length: l,
lengths: o,
segments: u };
        }, m = _gsScope._gsDefine.plugin({
propName: 'bezier',
priority: -1,
version: '1.3.4',
API: 2,
global: !0,
init: function (t, e, i) {
          this._target = t, e instanceof Array && (e = { values: e }), this._func = {}, this._round = {}, this._props = [], this._timeRes = e.timeResolution == null ? 6 : parseInt(e.timeResolution, 10); var s, r, n, a, o, h = e.values || [], l = {}, _ = h[0], f = e.autoRotate || i.vars.orientToBezier;

 this._autoRotate = f ? f instanceof Array ? f : [['x', 'y', 'rotation', f === !0 ? 0 : Number(f) || 0]] : null; for (s in _) {
            this._props.push(s);
          } for (n = this._props.length; --n > -1;) {
            s = this._props[n], this._overwriteProps.push(s), r = this._func[s] = typeof t[s] == 'function', l[s] = r ? t[s.indexOf('set') || typeof t['get' + s.substr(3)] != 'function' ? s : 'get' + s.substr(3)]() : parseFloat(t[s]), o || l[s] !== h[0][s] && (o = l);
          } if (this._beziers = e.type !== 'cubic' && e.type !== 'quadratic' && e.type !== 'soft' ? u(h, isNaN(e.curviness) ? 1 : e.curviness, !1, e.type === 'thruBasic', e.correlate, o) : c(h, e.type, l), this._segCount = this._beziers[s].length, this._timeRes) {
            var m = p(this._beziers, this._timeRes);

 this._length = m.length, this._lengths = m.lengths, this._segments = m.segments, this._l1 = this._li = this._s1 = this._si = 0, this._l2 = this._lengths[0], this._curSeg = this._segments[0], this._s2 = this._curSeg[0], this._prec = 1 / this._curSeg.length;
          } if (f = this._autoRotate) {
            for (this._initialRotations = [], f[0] instanceof Array || (this._autoRotate = f = [f]), n = f.length; --n > -1;) {
              for (a = 0; a < 3; a++) {
                s = f[n][a], this._func[s] = typeof t[s] == 'function' ? t[s.indexOf('set') || typeof t['get' + s.substr(3)] != 'function' ? s : 'get' + s.substr(3)] : !1;
              }s = f[n][2], this._initialRotations[n] = this._func[s] ? this._func[s].call(this._target) : this._target[s];
            }
          }

 return this._startRatio = i.vars.runBackwards ? 1 : 0, !0;
        },
set: function (e) {
          var i, s, r, n, a, o, h, l, _, u, c = this._segCount, f = this._func, p = this._target, m = e !== this._startRatio;

 if (this._timeRes) {
            if (_ = this._lengths, u = this._curSeg, e *= this._length, r = this._li, e > this._l2 && c - 1 > r) {
              for (l = c - 1; l > r && e >= (this._l2 = _[++r]);) {

              } this._l1 = _[r - 1], this._li = r, this._curSeg = u = this._segments[r], this._s2 = u[this._s1 = this._si = 0];
            } else if (this._l1 > e && r > 0) {
              for (;r > 0 && (this._l1 = _[--r]) >= e;) {

              }r === 0 && this._l1 > e ? this._l1 = 0 : r++, this._l2 = _[r], this._li = r, this._curSeg = u = this._segments[r], this._s1 = u[(this._si = u.length - 1) - 1] || 0, this._s2 = u[this._si];
              } if (i = r, e -= this._l1, r = this._si, e > this._s2 && u.length - 1 > r) {
              for (l = u.length - 1; l > r && e >= (this._s2 = u[++r]);) {

              } this._s1 = u[r - 1], this._si = r;
            } else if (this._s1 > e && r > 0) {
              for (;r > 0 && (this._s1 = u[--r]) >= e;) {

              }r === 0 && this._s1 > e ? this._s1 = 0 : r++, this._s2 = u[r], this._si = r;
            }o = (r + (e - this._s1) / (this._s2 - this._s1)) * this._prec;
          } else {
            i = e < 0 ? 0 : e >= 1 ? c - 1 : c * e >> 0, o = (e - i * (1 / c)) * c;
          } for (s = 1 - o, r = this._props.length; --r > -1;) {
            n = this._props[r], a = this._beziers[n][i], h = (o * o * a.da + 3 * s * (o * a.ca + s * a.ba)) * o + a.a, this._round[n] && (h = Math.round(h)), f[n] ? p[n](h) : p[n] = h;
          } if (this._autoRotate) {
            var d, g, v, y, T, x, w, b = this._autoRotate;

 for (r = b.length; --r > -1;) {
              n = b[r][2], x = b[r][3] || 0, w = b[r][4] === !0 ? 1 : t, a = this._beziers[b[r][0]], d = this._beziers[b[r][1]], a && d && (a = a[i], d = d[i], g = a.a + (a.b - a.a) * o, y = a.b + (a.c - a.b) * o, g += (y - g) * o, y += (a.c + (a.d - a.c) * o - y) * o, v = d.a + (d.b - d.a) * o, T = d.b + (d.c - d.b) * o, v += (T - v) * o, T += (d.c + (d.d - d.c) * o - T) * o, h = m ? Math.atan2(T - v, y - g) * w + x : this._initialRotations[r], f[n] ? p[n](h) : p[n] = h);
            }
          }
        }
}), d = m.prototype;

 m.bezierThrough = u, m.cubicToQuadratic = h, m._autoCSS = !0, m.quadraticToCubic = function (t, e, i) {
        return new a(t, (2 * e + t) / 3, (2 * e + i) / 3, i);
      }, m._cssRegister = function () {
        var t = n.CSSPlugin;

 if (t) {
          var e = t._internals, i = e._parseToProxy, s = e._setPluginRatio, r = e.CSSPropTween;

 e._registerComplexSpecialProp('bezier', {
parser: function (t, e, n, a, o, h) {
            e instanceof Array && (e = { values: e }), h = new m; var l, _, u, c = e.values, f = c.length - 1, p = [], d = {};

 if (f < 0) {
              return o;
            } for (l = 0; f >= l; l++) {
              u = i(t, c[l], a, o, h, f !== l), p[l] = u.end;
            } for (_ in e) {
              d[_] = e[_];
            }

 return d.values = p, o = new r(t, 'bezier', 0, 0, u.pt, 2), o.data = u, o.plugin = h, o.setRatio = s, d.autoRotate === 0 && (d.autoRotate = !0), !d.autoRotate || d.autoRotate instanceof Array || (l = d.autoRotate === !0 ? 0 : Number(d.autoRotate), d.autoRotate = u.end.left != null ? [['left', 'top', 'rotation', l, !1]] : u.end.x != null ? [['x', 'y', 'rotation', l, !1]] : !1), d.autoRotate && (a._transform || a._enableTransforms(!1), u.autoRotate = a._target._gsTransform), h._onInitTween(u.proxy, d, a._tween), o;
          }
});
        }
      }, d._roundProps = function (t, e) {
        for (var i = this._overwriteProps, s = i.length; --s > -1;) {
          (t[i[s]] || t.bezier || t.bezierThrough) && (this._round[i[s]] = e);
        }
      }, d._kill = function (t) {
        var e, i, s = this._props;

 for (e in this._beziers) {
          if (e in t) {
            for (delete this._beziers[e], delete this._func[e], i = s.length; --i > -1;) {
              s[i] === e && s.splice(i, 1);
            }
          }
        }

 return this._super._kill.call(this, t);
      };
    }(), _gsScope._gsDefine('plugins.CSSPlugin', ['plugins.TweenPlugin', 'TweenLite'], function (t, e) {
      var i, s, r, n, a = function () {
          t.call(this, 'css'), this._overwriteProps.length = 0, this.setRatio = a.prototype.setRatio;
        }, o = _gsScope._gsDefine.globals, h = {}, l = a.prototype = new t('css');

 l.constructor = a, a.version = '1.17.0', a.API = 2, a.defaultTransformPerspective = 0, a.defaultSkewType = 'compensated', a.defaultSmoothOrigin = !0, l = 'px', a.suffixMap = {
top: l,
right: l,
bottom: l,
left: l,
width: l,
height: l,
fontSize: l,
padding: l,
margin: l,
perspective: l,
lineHeight: ''
}; var _, u, c, f, p, m, d = /(?:\d|\-\d|\.\d|\-\.\d)+/g, g = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g, v = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, y = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, T = /(?:\d|\-|\+|=|#|\.)*/g, x = /opacity *= *([^)]*)/i, w = /opacity:([^;]*)/i, b = /alpha\(opacity *=.+?\)/i, P = /^(rgb|hsl)/, k = /([A-Z])/g, S = /-([a-z])/gi, R = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, O = function (t, e) {
          return e.toUpperCase();
        }, A = /(?:Left|Right|Width)/i, C = /(M11|M12|M21|M22)=[\d\-\.e]+/gi, D = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i, M = /,(?=[^\)]*(?:\(|$))/gi, z = Math.PI / 180, I = 180 / Math.PI, F = {}, N = document, E = function (t) {
          return N.createElementNS ? N.createElementNS('http://www.w3.org/1999/xhtml', t) : N.createElement(t);
        }, L = E('div'), X = E('img'), B = a._internals = { _specialProps: h }, Y = navigator.userAgent, j = function () {
          var t = Y.indexOf('Android'), e = E('a');

 return c = Y.indexOf('Safari') !== -1 && Y.indexOf('Chrome') === -1 && (t === -1 || Number(Y.substr(t + 8, 1)) > 3), p = c && Number(Y.substr(Y.indexOf('Version/') + 8, 1)) < 6, f = Y.indexOf('Firefox') !== -1, (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(Y) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(Y)) && (m = parseFloat(RegExp.$1)), e ? (e.style.cssText = 'top:1px;opacity:.55;', /^0.55/.test(e.style.opacity)) : !1;
        }(), U = function (t) {
          return x.test(typeof t == 'string' ? t : (t.currentStyle ? t.currentStyle.filter : t.style.filter) || '') ? parseFloat(RegExp.$1) / 100 : 1;
        }, q = function (t) {
          window.console && console.log(t);
        }, V = '', G = '', W = function (t, e) {
          e = e || L; var i, s, r = e.style;

 if (void 0 !== r[t]) {
            return t;
          } for (t = t.charAt(0).toUpperCase() + t.substr(1), i = ['O', 'Moz', 'ms', 'Ms', 'Webkit'], s = 5; --s > -1 && void 0 === r[i[s] + t];) {

          }

 return s >= 0 ? (G = s === 3 ? 'ms' : i[s], V = '-' + G.toLowerCase() + '-', G + t) : null;
        }, Z = N.defaultView ? N.defaultView.getComputedStyle : function () {}, Q = a.getStyle = function (t, e, i, s, r) {
          var n;

 return j || e !== 'opacity' ? (!s && t.style[e] ? n = t.style[e] : (i = i || Z(t)) ? n = i[e] || i.getPropertyValue(e) || i.getPropertyValue(e.replace(k, '-$1').toLowerCase()) : t.currentStyle && (n = t.currentStyle[e]), r == null || n && n !== 'none' && n !== 'auto' && n !== 'auto auto' ? n : r) : U(t);
        }, $ = B.convertToPixels = function (t, i, s, r, n) {
          if (r === 'px' || !r) {
            return s;
          } if (r === 'auto' || !s) {
            return 0;
          } var o, h, l, _ = A.test(i), u = t, c = L.style, f = s < 0;

 if (f && (s = -s), r === '%' && i.indexOf('border') !== -1) {
            o = s / 100 * (_ ? t.clientWidth : t.clientHeight);
          } else {
            if (c.cssText = 'border:0 solid red;position:' + Q(t, 'position') + ';line-height:0;', r !== '%' && u.appendChild) {
              c[_ ? 'borderLeftWidth' : 'borderTopWidth'] = s + r;
            } else {
              if (u = t.parentNode || N.body, h = u._gsCache, l = e.ticker.frame, h && _ && h.time === l) {
                return h.width * s / 100;
              } c[_ ? 'width' : 'height'] = s + r;
            }u.appendChild(L), o = parseFloat(L[_ ? 'offsetWidth' : 'offsetHeight']), u.removeChild(L), _ && r === '%' && a.cacheWidths !== !1 && (h = u._gsCache = u._gsCache || {}, h.time = l, h.width = 100 * (o / s)), o !== 0 || n || (o = $(t, i, s, r, !0));
          }

 return f ? -o : o;
        }, H = B.calculateOffset = function (t, e, i) {
          if (Q(t, 'position', i) !== 'absolute') {
            return 0;
          } var s = e === 'left' ? 'Left' : 'Top', r = Q(t, 'margin' + s, i);

 return t['offset' + s] - ($(t, e, parseFloat(r), r.replace(T, '')) || 0);
        }, K = function (t, e) {
          var i, s, r, n = {};

 if (e = e || Z(t, null)) {
            if (i = e.length) {
              for (;--i > -1;) {
                r = e[i], (r.indexOf('-transform') === -1 || Pe === r) && (n[r.replace(S, O)] = e.getPropertyValue(r));
              }
            } else {
              for (i in e) {
                (i.indexOf('Transform') === -1 || be === i) && (n[i] = e[i]);
              }
            }
          } else if (e = t.currentStyle || t.style) {
            for (i in e) {
              typeof i == 'string' && void 0 === n[i] && (n[i.replace(S, O)] = e[i]);
            }
          }

 return j || (n.opacity = U(t)), s = Ne(t, e, !1), n.rotation = s.rotation, n.skewX = s.skewX, n.scaleX = s.scaleX, n.scaleY = s.scaleY, n.x = s.x, n.y = s.y, Se && (n.z = s.z, n.rotationX = s.rotationX, n.rotationY = s.rotationY, n.scaleZ = s.scaleZ), n.filters && delete n.filters, n;
        }, J = function (t, e, i, s, r) {
          var n, a, o, h = {}, l = t.style;

 for (a in i) {
            a !== 'cssText' && a !== 'length' && isNaN(a) && (e[a] !== (n = i[a]) || r && r[a]) && a.indexOf('Origin') === -1 && (typeof n == 'number' || typeof n == 'string') && (h[a] = n !== 'auto' || a !== 'left' && a !== 'top' ? n !== '' && n !== 'auto' && n !== 'none' || typeof e[a] != 'string' || e[a].replace(y, '') === '' ? n : 0 : H(t, a), void 0 !== l[a] && (o = new fe(l, a, l[a], o)));
          } if (s) {
            for (a in s) {
              a !== 'className' && (h[a] = s[a]);
            }
          }

 return { difs: h,
firstMPT: o };
        }, te = { width: ['Left', 'Right'],
height: ['Top', 'Bottom'] }, ee = ['marginLeft', 'marginRight', 'marginTop', 'marginBottom'], ie = function (t, e, i) {
          var s = parseFloat(e === 'width' ? t.offsetWidth : t.offsetHeight), r = te[e], n = r.length;

 for (i = i || Z(t, null); --n > -1;) {
            s -= parseFloat(Q(t, 'padding' + r[n], i, !0)) || 0, s -= parseFloat(Q(t, 'border' + r[n] + 'Width', i, !0)) || 0;
          }

 return s;
        }, se = function (t, e) {
          (t == null || t === '' || t === 'auto' || t === 'auto auto') && (t = '0 0'); var i = t.split(' '), s = t.indexOf('left') !== -1 ? '0%' : t.indexOf('right') !== -1 ? '100%' : i[0], r = t.indexOf('top') !== -1 ? '0%' : t.indexOf('bottom') !== -1 ? '100%' : i[1];

 return r == null ? r = s === 'center' ? '50%' : '0' : r === 'center' && (r = '50%'), (s === 'center' || isNaN(parseFloat(s)) && (s + '').indexOf('=') === -1) && (s = '50%'), t = s + ' ' + r + (i.length > 2 ? ' ' + i[2] : ''), e && (e.oxp = s.indexOf('%') !== -1, e.oyp = r.indexOf('%') !== -1, e.oxr = s.charAt(1) === '=', e.oyr = r.charAt(1) === '=', e.ox = parseFloat(s.replace(y, '')), e.oy = parseFloat(r.replace(y, '')), e.v = t), e || t;
        }, re = function (t, e) {
          return typeof t == 'string' && t.charAt(1) === '=' ? parseInt(t.charAt(0) + '1', 10) * parseFloat(t.substr(2)) : parseFloat(t) - parseFloat(e);
        }, ne = function (t, e) {
          return t == null ? e : typeof t == 'string' && t.charAt(1) === '=' ? parseInt(t.charAt(0) + '1', 10) * parseFloat(t.substr(2)) + e : parseFloat(t);
        }, ae = function (t, e, i, s) {
          var r, n, a, o, h, l = 1e-6;

 return t == null ? o = e : typeof t == 'number' ? o = t : (r = 360, n = t.split('_'), h = t.charAt(1) === '=', a = (h ? parseInt(t.charAt(0) + '1', 10) * parseFloat(n[0].substr(2)) : parseFloat(n[0])) * (t.indexOf('rad') === -1 ? 1 : I) - (h ? 0 : e), n.length && (s && (s[i] = e + a), t.indexOf('short') !== -1 && (a %= r, a !== a % (r / 2) && (a = a < 0 ? a + r : a - r)), t.indexOf('_cw') !== -1 && a < 0 ? a = (a + 9999999999 * r) % r - (0 | a / r) * r : t.indexOf('ccw') !== -1 && a > 0 && (a = (a - 9999999999 * r) % r - (0 | a / r) * r)), o = e + a), l > o && o > -l && (o = 0), o;
        }, oe = {
aqua: [0, 255, 255],
lime: [0, 255, 0],
silver: [192, 192, 192],
black: [0, 0, 0],
maroon: [128, 0, 0],
teal: [0, 128, 128],
blue: [0, 0, 255],
navy: [0, 0, 128],
white: [255, 255, 255],
fuchsia: [255, 0, 255],
olive: [128, 128, 0],
yellow: [255, 255, 0],
orange: [255, 165, 0],
gray: [128, 128, 128],
purple: [128, 0, 128],
green: [0, 128, 0],
red: [255, 0, 0],
pink: [255, 192, 203],
cyan: [0, 255, 255],
transparent: [255, 255, 255, 0]
}, he = function (t, e, i) {
          return t = t < 0 ? t + 1 : t > 1 ? t - 1 : t, 0 | 255 * (6 * t < 1 ? e + 6 * (i - e) * t : t < .5 ? i : 3 * t < 2 ? e + 6 * (i - e) * (2 / 3 - t) : e) + .5;
        }, le = a.parseColor = function (t) {
          var e, i, s, r, n, a;

 return t && t !== '' ? typeof t == 'number' ? [t >> 16, 255 & t >> 8, 255 & t] : (t.charAt(t.length - 1) === ',' && (t = t.substr(0, t.length - 1)), oe[t] ? oe[t] : t.charAt(0) === '#' ? (t.length === 4 && (e = t.charAt(1), i = t.charAt(2), s = t.charAt(3), t = '#' + e + e + i + i + s + s), t = parseInt(t.substr(1), 16), [t >> 16, 255 & t >> 8, 255 & t]) : t.substr(0, 3) === 'hsl' ? (t = t.match(d), r = Number(t[0]) % 360 / 360, n = Number(t[1]) / 100, a = Number(t[2]) / 100, i = a <= .5 ? a * (n + 1) : a + n - a * n, e = 2 * a - i, t.length > 3 && (t[3] = Number(t[3])), t[0] = he(r + 1 / 3, e, i), t[1] = he(r, e, i), t[2] = he(r - 1 / 3, e, i), t) : (t = t.match(d) || oe.transparent, t[0] = Number(t[0]), t[1] = Number(t[1]), t[2] = Number(t[2]), t.length > 3 && (t[3] = Number(t[3])), t)) : oe.black;
        }, _e = '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#.+?\\b';

 for (l in oe) {
        _e += '|' + l + '\\b';
      }_e = RegExp(_e + ')', 'gi'); var ue = function (t, e, i, s) {
          if (t == null) {
            return function (t) {
              return t;
            };
          } var r, n = e ? (t.match(_e) || [''])[0] : '', a = t.split(n).join('').match(v) || [], o = t.substr(0, t.indexOf(a[0])), h = t.charAt(t.length - 1) === ')' ? ')' : '', l = t.indexOf(' ') !== -1 ? ' ' : ',', _ = a.length, u = _ > 0 ? a[0].replace(d, '') : '';

 return _ ? r = e ? function (t) {
            var e, c, f, p;

 if (typeof t == 'number') {
              t += u;
            } else if (s && M.test(t)) {
              for (p = t.replace(M, '|').split('|'), f = 0; p.length > f; f++) {
                p[f] = r(p[f]);
              }

 return p.join(',');
            } if (e = (t.match(_e) || [n])[0], c = t.split(e).join('').match(v) || [], f = c.length, _ > f--) {
              for (;_ > ++f;) {
                c[f] = i ? c[0 | (f - 1) / 2] : a[f];
              }
            }

 return o + c.join(l) + l + e + h + (t.indexOf('inset') !== -1 ? ' inset' : '');
          } : function (t) {
            var e, n, c;

 if (typeof t == 'number') {
              t += u;
            } else if (s && M.test(t)) {
              for (n = t.replace(M, '|').split('|'), c = 0; n.length > c; c++) {
                n[c] = r(n[c]);
              }

 return n.join(',');
            } if (e = t.match(v) || [], c = e.length, _ > c--) {
              for (;_ > ++c;) {
                e[c] = i ? e[0 | (c - 1) / 2] : a[c];
              }
            }

 return o + e.join(l) + h;
          } : function (t) {
            return t;
          };
        }, ce = function (t) {
          return t = t.split(','), function (e, i, s, r, n, a, o) {
            var h, l = (i + '').split(' ');

 for (o = {}, h = 0; h < 4; h++) {
              o[t[h]] = l[h] = l[h] || l[(h - 1) / 2 >> 0];
            }

 return r.parse(e, o, n, a);
          };
        }, fe = (B._setPluginRatio = function (t) {
          this.plugin.setRatio(t); for (var e, i, s, r, n = this.data, a = n.proxy, o = n.firstMPT, h = 1e-6; o;) {
            e = a[o.v], o.r ? e = Math.round(e) : h > e && e > -h && (e = 0), o.t[o.p] = e, o = o._next;
          } if (n.autoRotate && (n.autoRotate.rotation = a.rotation), t === 1) {
            for (o = n.firstMPT; o;) {
              if (i = o.t, i.type) {
                if (i.type === 1) {
                  for (r = i.xs0 + i.s + i.xs1, s = 1; i.l > s; s++) {
                    r += i['xn' + s] + i['xs' + (s + 1)];
                  }i.e = r;
                }
              } else {
                i.e = i.s + i.xs0;
              }o = o._next;
            }
          }
        }, function (t, e, i, s, r) {
          this.t = t, this.p = e, this.v = i, this.r = r, s && (s._prev = this, this._next = s);
        }), pe = (B._parseToProxy = function (t, e, i, s, r, n) {
          var a, o, h, l, _, u = s, c = {}, f = {}, p = i._transform, m = F;

 for (i._transform = null, F = e, s = _ = i.parse(t, e, s, r), F = m, n && (i._transform = p, u && (u._prev = null, u._prev && (u._prev._next = null))); s && s !== u;) {
            if (s.type <= 1 && (o = s.p, f[o] = s.s + s.c, c[o] = s.s, n || (l = new fe(s, 's', o, l, s.r), s.c = 0), s.type === 1)) {
              for (a = s.l; --a > 0;) {
                h = 'xn' + a, o = s.p + '_' + h, f[o] = s.data[h], c[o] = s[h], n || (l = new fe(s, h, o, l, s.rxp[h]));
              }
            }s = s._next;
          }

 return {
proxy: c,
end: f,
firstMPT: l,
pt: _
};
        }, B.CSSPropTween = function (t, e, s, r, a, o, h, l, _, u, c) {
          this.t = t, this.p = e, this.s = s, this.c = r, this.n = h || e, t instanceof pe || n.push(this.n), this.r = l, this.type = o || 0, _ && (this.pr = _, i = !0), this.b = void 0 === u ? s : u, this.e = void 0 === c ? s + r : c, a && (this._next = a, a._prev = this);
        }), me = function (t, e, i, s, r, n) {
          var a = new pe(t, e, i, s - i, r, -1, n);

 return a.b = i, a.e = a.xs0 = s, a;
        }, de = a.parseComplex = function (t, e, i, s, r, n, a, o, h, l) {
          i = i || n || '', a = new pe(t, e, 0, 0, a, l ? 2 : 1, null, !1, o, i, s), s += ''; var u, c, f, p, m, v, y, T, x, w, b, k, S = i.split(', ').join(',').split(' '), R = s.split(', ').join(',').split(' '), O = S.length, A = _ !== !1;

 for ((s.indexOf(',') !== -1 || i.indexOf(',') !== -1) && (S = S.join(' ').replace(M, ', ').split(' '), R = R.join(' ').replace(M, ', ').split(' '), O = S.length), O !== R.length && (S = (n || '').split(' '), O = S.length), a.plugin = h, a.setRatio = l, u = 0; O > u; u++) {
            if (p = S[u], m = R[u], T = parseFloat(p), T || T === 0) {
              a.appendXtra('', T, re(m, T), m.replace(g, ''), A && m.indexOf('px') !== -1, !0);
            } else if (r && (p.charAt(0) === '#' || oe[p] || P.test(p))) {
              k = m.charAt(m.length - 1) === ',' ? '),' : ')', p = le(p), m = le(m), x = p.length + m.length > 6, x && !j && m[3] === 0 ? (a['xs' + a.l] += a.l ? ' transparent' : 'transparent', a.e = a.e.split(R[u]).join('transparent')) : (j || (x = !1), a.appendXtra(x ? 'rgba(' : 'rgb(', p[0], m[0] - p[0], ',', !0, !0).appendXtra('', p[1], m[1] - p[1], ',', !0).appendXtra('', p[2], m[2] - p[2], x ? ',' : k, !0), x && (p = p.length < 4 ? 1 : p[3], a.appendXtra('', p, (m.length < 4 ? 1 : m[3]) - p, k, !1)));
            } else if (v = p.match(d)) {
              if (y = m.match(g), !y || y.length !== v.length) {
                return a;
              } for (f = 0, c = 0; v.length > c; c++) {
                b = v[c], w = p.indexOf(b, f), a.appendXtra(p.substr(f, w - f), Number(b), re(y[c], b), '', A && p.substr(w + b.length, 2) === 'px', c === 0), f = w + b.length;
              }a['xs' + a.l] += p.substr(f);
            } else {
              a['xs' + a.l] += a.l ? ' ' + p : p;
            }
          } if (s.indexOf('=') !== -1 && a.data) {
            for (k = a.xs0 + a.data.s, u = 1; a.l > u; u++) {
              k += a['xs' + u] + a.data['xn' + u];
            }a.e = k + a['xs' + u];
          }

 return a.l || (a.type = -1, a.xs0 = a.e), a.xfirst || a;
        }, ge = 9;

 for (l = pe.prototype, l.l = l.pr = 0; --ge > 0;) {
        l['xn' + ge] = 0, l['xs' + ge] = '';
      }l.xs0 = '', l._next = l._prev = l.xfirst = l.data = l.plugin = l.setRatio = l.rxp = null, l.appendXtra = function (t, e, i, s, r, n) {
        var a = this, o = a.l;

 return a['xs' + o] += n && o ? ' ' + t : t || '', i || o === 0 || a.plugin ? (a.l++, a.type = a.setRatio ? 2 : 1, a['xs' + a.l] = s || '', o > 0 ? (a.data['xn' + o] = e + i, a.rxp['xn' + o] = r, a['xn' + o] = e, a.plugin || (a.xfirst = new pe(a, 'xn' + o, e, i, a.xfirst || a, 0, a.n, r, a.pr), a.xfirst.xs0 = 0), a) : (a.data = { s: e + i }, a.rxp = {}, a.s = e, a.c = i, a.r = r, a)) : (a['xs' + o] += e + (s || ''), a);
      }; var ve = function (t, e) {
          e = e || {}, this.p = e.prefix ? W(t) || t : t, h[t] = h[this.p] = this, this.format = e.formatter || ue(e.defaultValue, e.color, e.collapsible, e.multi), e.parser && (this.parse = e.parser), this.clrs = e.color, this.multi = e.multi, this.keyword = e.keyword, this.dflt = e.defaultValue, this.pr = e.priority || 0;
        }, ye = B._registerComplexSpecialProp = function (t, e, i) {
          typeof e != 'object' && (e = { parser: i }); var s, r, n = t.split(','), a = e.defaultValue;

 for (i = i || [a], s = 0; n.length > s; s++) {
            e.prefix = s === 0 && e.prefix, e.defaultValue = i[s] || a, r = new ve(n[s], e);
          }
        }, Te = function (t) {
          if (!h[t]) {
            var e = t.charAt(0).toUpperCase() + t.substr(1) + 'Plugin';

 ye(t, {
parser: function (t, i, s, r, n, a, l) {
              var _ = o.com.greensock.plugins[e];

 return _ ? (_._cssRegister(), h[s].parse(t, i, s, r, n, a, l)) : (q('Error: ' + e + ' js file not loaded.'), n);
            }
});
          }
        };

 l = ve.prototype, l.parseComplex = function (t, e, i, s, r, n) {
        var a, o, h, l, _, u, c = this.keyword;

 if (this.multi && (M.test(i) || M.test(e) ? (o = e.replace(M, '|').split('|'), h = i.replace(M, '|').split('|')) : c && (o = [e], h = [i])), h) {
          for (l = h.length > o.length ? h.length : o.length, a = 0; l > a; a++) {
            e = o[a] = o[a] || this.dflt, i = h[a] = h[a] || this.dflt, c && (_ = e.indexOf(c), u = i.indexOf(c), _ !== u && (u === -1 ? o[a] = o[a].split(c).join('') : _ === -1 && (o[a] += ' ' + c)));
          }e = o.join(', '), i = h.join(', ');
        }

 return de(t, this.p, e, i, this.clrs, this.dflt, s, this.pr, r, n);
      }, l.parse = function (t, e, i, s, n, a) {
        return this.parseComplex(t.style, this.format(Q(t, this.p, r, !1, this.dflt)), this.format(e), n, a);
      }, a.registerSpecialProp = function (t, e, i) {
        ye(t, {
parser: function (t, s, r, n, a, o) {
          var h = new pe(t, r, 0, 0, a, 2, r, !1, i);

 return h.plugin = o, h.setRatio = e(t, s, n._tween, r), h;
        },
priority: i
});
      }, a.useSVGTransformAttr = c || f; var xe, we = 'scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent'.split(','), be = W('transform'), Pe = V + 'transform', ke = W('transformOrigin'), Se = W('perspective') !== null, Re = B.Transform = function () {
          this.perspective = parseFloat(a.defaultTransformPerspective) || 0, this.force3D = a.defaultForce3D !== !1 && Se ? a.defaultForce3D || 'auto' : !1;
        }, Oe = window.SVGElement, Ae = function (t, e, i) {
          var s, r = N.createElementNS('http://www.w3.org/2000/svg', t), n = /([a-z])([A-Z])/g;

 for (s in i) {
            r.setAttributeNS(null, s.replace(n, '$1-$2').toLowerCase(), i[s]);
          }

 return e.appendChild(r), r;
        }, Ce = N.documentElement, De = function () {
          var t, e, i, s = m || /Android/i.test(Y) && !window.chrome;

 return N.createElementNS && !s && (t = Ae('svg', Ce), e = Ae('rect', t, { width: 100,
height: 50,
x: 100 }), i = e.getBoundingClientRect().width, e.style[ke] = '50% 50%', e.style[be] = 'scaleX(0.5)', s = i === e.getBoundingClientRect().width && !(f && Se), Ce.removeChild(t)), s;
        }(), Me = function (t, e, i, s, r) {
          var n, o, h, l, _, u, c, f, p, m, d, g, v, y, T = t._gsTransform, x = Fe(t, !0);

 T && (v = T.xOrigin, y = T.yOrigin), (!s || (n = s.split(' ')).length < 2) && (c = t.getBBox(), e = se(e).split(' '), n = [(e[0].indexOf('%') !== -1 ? parseFloat(e[0]) / 100 * c.width : parseFloat(e[0])) + c.x, (e[1].indexOf('%') !== -1 ? parseFloat(e[1]) / 100 * c.height : parseFloat(e[1])) + c.y]), i.xOrigin = l = parseFloat(n[0]), i.yOrigin = _ = parseFloat(n[1]), s && x !== Ie && (u = x[0], c = x[1], f = x[2], p = x[3], m = x[4], d = x[5], g = u * p - c * f, o = l * (p / g) + _ * (-f / g) + (f * d - p * m) / g, h = l * (-c / g) + _ * (u / g) - (u * d - c * m) / g, l = i.xOrigin = n[0] = o, _ = i.yOrigin = n[1] = h), T && (r || r !== !1 && a.defaultSmoothOrigin !== !1 ? (o = l - v, h = _ - y, T.xOffset += o * x[0] + h * x[2] - o, T.yOffset += o * x[1] + h * x[3] - h) : T.xOffset = T.yOffset = 0), t.setAttribute('data-svg-origin', n.join(' '));
        }, ze = function (t) {
          return !!(Oe && typeof t.getBBox == 'function' && t.getCTM && (!t.parentNode || t.parentNode.getBBox && t.parentNode.getCTM));
        }, Ie = [1, 0, 0, 1, 0, 0], Fe = function (t, e) {
          var i, s, r, n, a, o = t._gsTransform || new Re, h = 1e5;

 if (be ? s = Q(t, Pe, null, !0) : t.currentStyle && (s = t.currentStyle.filter.match(C), s = s && s.length === 4 ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), o.x || 0, o.y || 0].join(',') : ''), i = !s || s === 'none' || s === 'matrix(1, 0, 0, 1, 0, 0)', (o.svg || t.getBBox && ze(t)) && (i && (t.style[be] + '').indexOf('matrix') !== -1 && (s = t.style[be], i = 0), r = t.getAttribute('transform'), i && r && (r.indexOf('matrix') !== -1 ? (s = r, i = 0) : r.indexOf('translate') !== -1 && (s = 'matrix(1,0,0,1,' + r.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(',') + ')', i = 0))), i) {
            return Ie;
          } for (r = (s || '').match(/(?:\-|\b)[\d\-\.e]+\b/gi) || [], ge = r.length; --ge > -1;) {
            n = Number(r[ge]), r[ge] = (a = n - (n |= 0)) ? (0 | a * h + (a < 0 ? -.5 : .5)) / h + n : n;
          }

 return e && r.length > 6 ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r;
        }, Ne = B.getTransform = function (t, i, s, n) {
          if (t._gsTransform && s && !n) {
            return t._gsTransform;
          } var o, h, l, _, u, c, f = s ? t._gsTransform || new Re : new Re, p = f.scaleX < 0, m = 2e-5, d = 1e5, g = Se ? parseFloat(Q(t, ke, i, !1, '0 0 0').split(' ')[2]) || f.zOrigin || 0 : 0, v = parseFloat(a.defaultTransformPerspective) || 0;

 if (f.svg = !(!t.getBBox || !ze(t)), f.svg && (Me(t, Q(t, ke, r, !1, '50% 50%') + '', f, t.getAttribute('data-svg-origin')), xe = a.useSVGTransformAttr || De), o = Fe(t), o !== Ie) {
            if (o.length === 16) {
              var y, T, x, w, b, P = o[0], k = o[1], S = o[2], R = o[3], O = o[4], A = o[5], C = o[6], D = o[7], M = o[8], z = o[9], F = o[10], N = o[12], E = o[13], L = o[14], X = o[11], B = Math.atan2(C, F);

 f.zOrigin && (L = -f.zOrigin, N = M * L - o[12], E = z * L - o[13], L = F * L + f.zOrigin - o[14]), f.rotationX = B * I, B && (w = Math.cos(-B), b = Math.sin(-B), y = O * w + M * b, T = A * w + z * b, x = C * w + F * b, M = O * -b + M * w, z = A * -b + z * w, F = C * -b + F * w, X = D * -b + X * w, O = y, A = T, C = x), B = Math.atan2(M, F), f.rotationY = B * I, B && (w = Math.cos(-B), b = Math.sin(-B), y = P * w - M * b, T = k * w - z * b, x = S * w - F * b, z = k * b + z * w, F = S * b + F * w, X = R * b + X * w, P = y, k = T, S = x), B = Math.atan2(k, P), f.rotation = B * I, B && (w = Math.cos(-B), b = Math.sin(-B), P = P * w + O * b, T = k * w + A * b, A = k * -b + A * w, C = S * -b + C * w, k = T), f.rotationX && Math.abs(f.rotationX) + Math.abs(f.rotation) > 359.9 && (f.rotationX = f.rotation = 0, f.rotationY += 180), f.scaleX = (0 | Math.sqrt(P * P + k * k) * d + .5) / d, f.scaleY = (0 | Math.sqrt(A * A + z * z) * d + .5) / d, f.scaleZ = (0 | Math.sqrt(C * C + F * F) * d + .5) / d, f.skewX = 0, f.perspective = X ? 1 / (X < 0 ? -X : X) : 0, f.x = N, f.y = E, f.z = L, f.svg && (f.x -= f.xOrigin - (f.xOrigin * P - f.yOrigin * O), f.y -= f.yOrigin - (f.yOrigin * k - f.xOrigin * A));
            } else if (!(Se && !n && o.length && f.x === o[4] && f.y === o[5] && (f.rotationX || f.rotationY) || void 0 !== f.x && Q(t, 'display', i) === 'none')) {
              var Y = o.length >= 6, j = Y ? o[0] : 1, U = o[1] || 0, q = o[2] || 0, V = Y ? o[3] : 1;

 f.x = o[4] || 0, f.y = o[5] || 0, l = Math.sqrt(j * j + U * U), _ = Math.sqrt(V * V + q * q), u = j || U ? Math.atan2(U, j) * I : f.rotation || 0, c = q || V ? Math.atan2(q, V) * I + u : f.skewX || 0, Math.abs(c) > 90 && Math.abs(c) < 270 && (p ? (l *= -1, c += u <= 0 ? 180 : -180, u += u <= 0 ? 180 : -180) : (_ *= -1, c += c <= 0 ? 180 : -180)), f.scaleX = l, f.scaleY = _, f.rotation = u, f.skewX = c, Se && (f.rotationX = f.rotationY = f.z = 0, f.perspective = v, f.scaleZ = 1), f.svg && (f.x -= f.xOrigin - (f.xOrigin * j + f.yOrigin * q), f.y -= f.yOrigin - (f.xOrigin * U + f.yOrigin * V));
            }f.zOrigin = g; for (h in f) {
              m > f[h] && f[h] > -m && (f[h] = 0);
            }
          }

 return s && (t._gsTransform = f, f.svg && (xe && t.style[be] ? e.delayedCall(.001, function () {
            Be(t.style, be);
          }) : !xe && t.getAttribute('transform') && e.delayedCall(.001, function () {
            t.removeAttribute('transform');
          }))), f;
        }, Ee = function (t) {
          var e, i, s = this.data, r = -s.rotation * z, n = r + s.skewX * z, a = 1e5, o = (0 | Math.cos(r) * s.scaleX * a) / a, h = (0 | Math.sin(r) * s.scaleX * a) / a, l = (0 | Math.sin(n) * -s.scaleY * a) / a, _ = (0 | Math.cos(n) * s.scaleY * a) / a, u = this.t.style, c = this.t.currentStyle;

 if (c) {
            i = h, h = -l, l = -i, e = c.filter, u.filter = ''; var f, p, d = this.t.offsetWidth, g = this.t.offsetHeight, v = c.position !== 'absolute', y = 'progid:DXImageTransform.Microsoft.Matrix(M11=' + o + ', M12=' + h + ', M21=' + l + ', M22=' + _, w = s.x + d * s.xPercent / 100, b = s.y + g * s.yPercent / 100;

 if (s.ox != null && (f = (s.oxp ? .01 * d * s.ox : s.ox) - d / 2, p = (s.oyp ? .01 * g * s.oy : s.oy) - g / 2, w += f - (f * o + p * h), b += p - (f * l + p * _)), v ? (f = d / 2, p = g / 2, y += ', Dx=' + (f - (f * o + p * h) + w) + ', Dy=' + (p - (f * l + p * _) + b) + ')') : y += ", sizingMethod='auto expand')", u.filter = e.indexOf('DXImageTransform.Microsoft.Matrix(') !== -1 ? e.replace(D, y) : y + ' ' + e, (t === 0 || t === 1) && o === 1 && h === 0 && l === 0 && _ === 1 && (v && y.indexOf('Dx=0, Dy=0') === -1 || x.test(e) && parseFloat(RegExp.$1) !== 100 || e.indexOf('gradient(' && e.indexOf('Alpha')) === -1 && u.removeAttribute('filter')), !v) {
              var P, k, S, R = m < 8 ? 1 : -1;

 for (f = s.ieOffsetX || 0, p = s.ieOffsetY || 0, s.ieOffsetX = Math.round((d - ((o < 0 ? -o : o) * d + (h < 0 ? -h : h) * g)) / 2 + w), s.ieOffsetY = Math.round((g - ((_ < 0 ? -_ : _) * g + (l < 0 ? -l : l) * d)) / 2 + b), ge = 0; ge < 4; ge++) {
                k = ee[ge], P = c[k], i = P.indexOf('px') !== -1 ? parseFloat(P) : $(this.t, k, parseFloat(P), P.replace(T, '')) || 0, S = i !== s[k] ? ge < 2 ? -s.ieOffsetX : -s.ieOffsetY : ge < 2 ? f - s.ieOffsetX : p - s.ieOffsetY, u[k] = (s[k] = Math.round(i - S * (ge === 0 || ge === 2 ? 1 : R))) + 'px';
              }
            }
          }
        }, Le = B.set3DTransformRatio = B.setTransformRatio = function (t) {
          var e, i, s, r, n, a, o, h, l, _, u, c, p, m, d, g, v, y, T, x, w, b, P, k = this.data, S = this.t.style, R = k.rotation, O = k.rotationX, A = k.rotationY, C = k.scaleX, D = k.scaleY, M = k.scaleZ, I = k.x, F = k.y, N = k.z, E = k.svg, L = k.perspective, X = k.force3D;

 if (!(((t !== 1 && t !== 0 || X !== 'auto' || this.tween._totalTime !== this.tween._totalDuration && this.tween._totalTime) && X || N || L || A || O) && (!xe || !E) && Se)) {
            return R || k.skewX || E ? (R *= z, b = k.skewX * z, P = 1e5, e = Math.cos(R) * C, r = Math.sin(R) * C, i = Math.sin(R - b) * -D, n = Math.cos(R - b) * D, b && k.skewType === 'simple' && (v = Math.tan(b), v = Math.sqrt(1 + v * v), i *= v, n *= v, k.skewY && (e *= v, r *= v)), E && (I += k.xOrigin - (k.xOrigin * e + k.yOrigin * i) + k.xOffset, F += k.yOrigin - (k.xOrigin * r + k.yOrigin * n) + k.yOffset, xe && (k.xPercent || k.yPercent) && (m = this.t.getBBox(), I += .01 * k.xPercent * m.width, F += .01 * k.yPercent * m.height), m = 1e-6, m > I && I > -m && (I = 0), m > F && F > -m && (F = 0)), T = (0 | e * P) / P + ',' + (0 | r * P) / P + ',' + (0 | i * P) / P + ',' + (0 | n * P) / P + ',' + I + ',' + F + ')', E && xe ? this.t.setAttribute('transform', 'matrix(' + T) : S[be] = (k.xPercent || k.yPercent ? 'translate(' + k.xPercent + '%,' + k.yPercent + '%) matrix(' : 'matrix(') + T) : S[be] = (k.xPercent || k.yPercent ? 'translate(' + k.xPercent + '%,' + k.yPercent + '%) matrix(' : 'matrix(') + C + ',0,0,' + D + ',' + I + ',' + F + ')', void 0;
          } if (f && (m = 1e-4, m > C && C > -m && (C = M = 2e-5), m > D && D > -m && (D = M = 2e-5), !L || k.z || k.rotationX || k.rotationY || (L = 0)), R || k.skewX) {
            R *= z, d = e = Math.cos(R), g = r = Math.sin(R), k.skewX && (R -= k.skewX * z, d = Math.cos(R), g = Math.sin(R), k.skewType === 'simple' && (v = Math.tan(k.skewX * z), v = Math.sqrt(1 + v * v), d *= v, g *= v, k.skewY && (e *= v, r *= v))), i = -g, n = d;
          } else {
            if (!(A || O || M !== 1 || L || E)) {
              return S[be] = (k.xPercent || k.yPercent ? 'translate(' + k.xPercent + '%,' + k.yPercent + '%) translate3d(' : 'translate3d(') + I + 'px,' + F + 'px,' + N + 'px)' + (C !== 1 || D !== 1 ? ' scale(' + C + ',' + D + ')' : ''), void 0;
            } e = n = 1, i = r = 0;
          }l = 1, s = a = o = h = _ = u = 0, c = L ? -1 / L : 0, p = k.zOrigin, m = 1e-6, x = ',', w = '0', R = A * z, R && (d = Math.cos(R), g = Math.sin(R), o = -g, _ = c * -g, s = e * g, a = r * g, l = d, c *= d, e *= d, r *= d), R = O * z, R && (d = Math.cos(R), g = Math.sin(R), v = i * d + s * g, y = n * d + a * g, h = l * g, u = c * g, s = i * -g + s * d, a = n * -g + a * d, l *= d, c *= d, i = v, n = y), M !== 1 && (s *= M, a *= M, l *= M, c *= M), D !== 1 && (i *= D, n *= D, h *= D, u *= D), C !== 1 && (e *= C, r *= C, o *= C, _ *= C), (p || E) && (p && (I += s * -p, F += a * -p, N += l * -p + p), E && (I += k.xOrigin - (k.xOrigin * e + k.yOrigin * i) + k.xOffset, F += k.yOrigin - (k.xOrigin * r + k.yOrigin * n) + k.yOffset), m > I && I > -m && (I = w), m > F && F > -m && (F = w), m > N && N > -m && (N = 0)), T = k.xPercent || k.yPercent ? 'translate(' + k.xPercent + '%,' + k.yPercent + '%) matrix3d(' : 'matrix3d(', T += (m > e && e > -m ? w : e) + x + (m > r && r > -m ? w : r) + x + (m > o && o > -m ? w : o), T += x + (m > _ && _ > -m ? w : _) + x + (m > i && i > -m ? w : i) + x + (m > n && n > -m ? w : n), O || A ? (T += x + (m > h && h > -m ? w : h) + x + (m > u && u > -m ? w : u) + x + (m > s && s > -m ? w : s), T += x + (m > a && a > -m ? w : a) + x + (m > l && l > -m ? w : l) + x + (m > c && c > -m ? w : c) + x) : T += ',0,0,0,0,1,0,', T += I + x + F + x + N + x + (L ? 1 + -N / L : 1) + ')', S[be] = T;
        };

 l = Re.prototype, l.x = l.y = l.z = l.skewX = l.skewY = l.rotation = l.rotationX = l.rotationY = l.zOrigin = l.xPercent = l.yPercent = l.xOffset = l.yOffset = 0, l.scaleX = l.scaleY = l.scaleZ = 1, ye('transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin', {
parser: function (t, e, i, s, n, o, h) {
        if (s._lastParsedTransform === h) {
          return n;
        } s._lastParsedTransform = h; var l, _, u, c, f, p, m, d, g, v = t._gsTransform, y = s._transform = Ne(t, r, !0, h.parseTransform), T = t.style, x = 1e-6, w = we.length, b = h, P = {}, k = 'transformOrigin';

 if (typeof b.transform == 'string' && be) {
          u = L.style, u[be] = b.transform, u.display = 'block', u.position = 'absolute', N.body.appendChild(L), l = Ne(L, null, !1), N.body.removeChild(L), b.xPercent != null && (l.xPercent = ne(b.xPercent, y.xPercent)), b.yPercent != null && (l.yPercent = ne(b.yPercent, y.yPercent));
        } else if (typeof b == 'object') {
          if (l = {
scaleX: ne(b.scaleX != null ? b.scaleX : b.scale, y.scaleX),
scaleY: ne(b.scaleY != null ? b.scaleY : b.scale, y.scaleY),
scaleZ: ne(b.scaleZ, y.scaleZ),
x: ne(b.x, y.x),
y: ne(b.y, y.y),
z: ne(b.z, y.z),
xPercent: ne(b.xPercent, y.xPercent),
yPercent: ne(b.yPercent, y.yPercent),
perspective: ne(b.transformPerspective, y.perspective)
}, m = b.directionalRotation, m != null) {
            if (typeof m == 'object') {
              for (u in m) {
                b[u] = m[u];
              }
            } else {
              b.rotation = m;
            }
          } typeof b.x == 'string' && b.x.indexOf('%') !== -1 && (l.x = 0, l.xPercent = ne(b.x, y.xPercent)), typeof b.y == 'string' && b.y.indexOf('%') !== -1 && (l.y = 0, l.yPercent = ne(b.y, y.yPercent)), l.rotation = ae('rotation' in b ? b.rotation : 'shortRotation' in b ? b.shortRotation + '_short' : 'rotationZ' in b ? b.rotationZ : y.rotation, y.rotation, 'rotation', P), Se && (l.rotationX = ae('rotationX' in b ? b.rotationX : 'shortRotationX' in b ? b.shortRotationX + '_short' : y.rotationX || 0, y.rotationX, 'rotationX', P), l.rotationY = ae('rotationY' in b ? b.rotationY : 'shortRotationY' in b ? b.shortRotationY + '_short' : y.rotationY || 0, y.rotationY, 'rotationY', P)), l.skewX = b.skewX == null ? y.skewX : ae(b.skewX, y.skewX), l.skewY = b.skewY == null ? y.skewY : ae(b.skewY, y.skewY), (_ = l.skewY - y.skewY) && (l.skewX += _, l.rotation += _);
        } for (Se && b.force3D != null && (y.force3D = b.force3D, p = !0), y.skewType = b.skewType || y.skewType || a.defaultSkewType, f = y.force3D || y.z || y.rotationX || y.rotationY || l.z || l.rotationX || l.rotationY || l.perspective, f || b.scale == null || (l.scaleZ = 1); --w > -1;) {
          i = we[w], c = l[i] - y[i], (c > x || -x > c || b[i] != null || F[i] != null) && (p = !0, n = new pe(y, i, y[i], c, n), i in P && (n.e = P[i]), n.xs0 = 0, n.plugin = o, s._overwriteProps.push(n.n));
        }

 return c = b.transformOrigin, y.svg && (c || b.svgOrigin) && (d = y.xOffset, g = y.yOffset, Me(t, se(c), l, b.svgOrigin, b.smoothOrigin), n = me(y, 'xOrigin', (v ? y : l).xOrigin, l.xOrigin, n, k), n = me(y, 'yOrigin', (v ? y : l).yOrigin, l.yOrigin, n, k), (d !== y.xOffset || g !== y.yOffset) && (n = me(y, 'xOffset', v ? d : y.xOffset, y.xOffset, n, k), n = me(y, 'yOffset', v ? g : y.yOffset, y.yOffset, n, k)), c = xe ? null : '0px 0px'), (c || Se && f && y.zOrigin) && (be ? (p = !0, i = ke, c = (c || Q(t, i, r, !1, '50% 50%')) + '', n = new pe(T, i, 0, 0, n, -1, k), n.b = T[i], n.plugin = o, Se ? (u = y.zOrigin, c = c.split(' '), y.zOrigin = (c.length > 2 && (u === 0 || c[2] !== '0px') ? parseFloat(c[2]) : u) || 0, n.xs0 = n.e = c[0] + ' ' + (c[1] || '50%') + ' 0px', n = new pe(y, 'zOrigin', 0, 0, n, -1, n.n), n.b = u, n.xs0 = n.e = y.zOrigin) : n.xs0 = n.e = c) : se(c + '', y)), p && (s._transformType = y.svg && xe || !f && this._transformType !== 3 ? 2 : 3), n;
      },
prefix: !0
}), ye('boxShadow', {
defaultValue: '0px 0px 0px 0px #999',
prefix: !0,
color: !0,
multi: !0,
keyword: 'inset'
}), ye('borderRadius', {
defaultValue: '0px',
parser: function (t, e, i, n, a) {
        e = this.format(e); var o, h, l, _, u, c, f, p, m, d, g, v, y, T, x, w, b = ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'], P = t.style;

 for (m = parseFloat(t.offsetWidth), d = parseFloat(t.offsetHeight), o = e.split(' '), h = 0; b.length > h; h++) {
          this.p.indexOf('border') && (b[h] = W(b[h])), u = _ = Q(t, b[h], r, !1, '0px'), u.indexOf(' ') !== -1 && (_ = u.split(' '), u = _[0], _ = _[1]), c = l = o[h], f = parseFloat(u), v = u.substr((f + '').length), y = c.charAt(1) === '=', y ? (p = parseInt(c.charAt(0) + '1', 10), c = c.substr(2), p *= parseFloat(c), g = c.substr((p + '').length - (p < 0 ? 1 : 0)) || '') : (p = parseFloat(c), g = c.substr((p + '').length)), g === '' && (g = s[i] || v), g !== v && (T = $(t, 'borderLeft', f, v), x = $(t, 'borderTop', f, v), g === '%' ? (u = 100 * (T / m) + '%', _ = 100 * (x / d) + '%') : g === 'em' ? (w = $(t, 'borderLeft', 1, 'em'), u = T / w + 'em', _ = x / w + 'em') : (u = T + 'px', _ = x + 'px'), y && (c = parseFloat(u) + p + g, l = parseFloat(_) + p + g)), a = de(P, b[h], u + ' ' + _, c + ' ' + l, !1, '0px', a);
        }

 return a;
      },
prefix: !0,
formatter: ue('0px 0px 0px 0px', !1, !0)
}), ye('backgroundPosition', {
defaultValue: '0 0',
parser: function (t, e, i, s, n, a) {
        var o, h, l, _, u, c, f = 'background-position', p = r || Z(t, null), d = this.format((p ? m ? p.getPropertyValue(f + '-x') + ' ' + p.getPropertyValue(f + '-y') : p.getPropertyValue(f) : t.currentStyle.backgroundPositionX + ' ' + t.currentStyle.backgroundPositionY) || '0 0'), g = this.format(e);

 if (d.indexOf('%') !== -1 != (g.indexOf('%') !== -1) && (c = Q(t, 'backgroundImage').replace(R, ''), c && c !== 'none')) {
          for (o = d.split(' '), h = g.split(' '), X.setAttribute('src', c), l = 2; --l > -1;) {
            d = o[l], _ = d.indexOf('%') !== -1, _ !== (h[l].indexOf('%') !== -1) && (u = l === 0 ? t.offsetWidth - X.width : t.offsetHeight - X.height, o[l] = _ ? parseFloat(d) / 100 * u + 'px' : 100 * (parseFloat(d) / u) + '%');
          }d = o.join(' ');
        }

 return this.parseComplex(t.style, d, g, n, a);
      },
formatter: se
}), ye('backgroundSize', { defaultValue: '0 0',
formatter: se }), ye('perspective', { defaultValue: '0px',
prefix: !0 }), ye('perspectiveOrigin', { defaultValue: '50% 50%',
prefix: !0 }), ye('transformStyle', { prefix: !0 }), ye('backfaceVisibility', { prefix: !0 }), ye('userSelect', { prefix: !0 }), ye('margin', { parser: ce('marginTop,marginRight,marginBottom,marginLeft') }), ye('padding', { parser: ce('paddingTop,paddingRight,paddingBottom,paddingLeft') }), ye('clip', {
defaultValue: 'rect(0px,0px,0px,0px)',
parser: function (t, e, i, s, n, a) {
        var o, h, l;

 return m < 9 ? (h = t.currentStyle, l = m < 8 ? ' ' : ',', o = 'rect(' + h.clipTop + l + h.clipRight + l + h.clipBottom + l + h.clipLeft + ')', e = this.format(e).split(',').join(l)) : (o = this.format(Q(t, this.p, r, !1, this.dflt)), e = this.format(e)), this.parseComplex(t.style, o, e, n, a);
      }
}), ye('textShadow', { defaultValue: '0px 0px 0px #999',
color: !0,
multi: !0 }), ye('autoRound,strictUnits', {
parser: function (t, e, i, s, r) {
        return r;
      }
}), ye('border', {
defaultValue: '0px solid #000',
parser: function (t, e, i, s, n, a) {
        return this.parseComplex(t.style, this.format(Q(t, 'borderTopWidth', r, !1, '0px') + ' ' + Q(t, 'borderTopStyle', r, !1, 'solid') + ' ' + Q(t, 'borderTopColor', r, !1, '#000')), this.format(e), n, a);
      },
color: !0,
formatter: function (t) {
        var e = t.split(' ');

 return e[0] + ' ' + (e[1] || 'solid') + ' ' + (t.match(_e) || ['#000'])[0];
      }
}), ye('borderWidth', { parser: ce('borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth') }), ye('float,cssFloat,styleFloat', {
parser: function (t, e, i, s, r) {
        var n = t.style, a = 'cssFloat' in n ? 'cssFloat' : 'styleFloat';

 return new pe(n, a, 0, 0, r, -1, i, !1, 0, n[a], e);
      }
}); var Xe = function (t) {
        var e, i = this.t, s = i.filter || Q(this.data, 'filter') || '', r = 0 | this.s + this.c * t;

 r === 100 && (s.indexOf('atrix(') === -1 && s.indexOf('radient(') === -1 && s.indexOf('oader(') === -1 ? (i.removeAttribute('filter'), e = !Q(this.data, 'filter')) : (i.filter = s.replace(b, ''), e = !0)), e || (this.xn1 && (i.filter = s = s || 'alpha(opacity=' + r + ')'), s.indexOf('pacity') === -1 ? r === 0 && this.xn1 || (i.filter = s + ' alpha(opacity=' + r + ')') : i.filter = s.replace(x, 'opacity=' + r));
      };

 ye('opacity,alpha,autoAlpha', {
defaultValue: '1',
parser: function (t, e, i, s, n, a) {
        var o = parseFloat(Q(t, 'opacity', r, !1, '1')), h = t.style, l = i === 'autoAlpha';

 return typeof e == 'string' && e.charAt(1) === '=' && (e = (e.charAt(0) === '-' ? -1 : 1) * parseFloat(e.substr(2)) + o), l && o === 1 && Q(t, 'visibility', r) === 'hidden' && e !== 0 && (o = 0), j ? n = new pe(h, 'opacity', o, e - o, n) : (n = new pe(h, 'opacity', 100 * o, 100 * (e - o), n), n.xn1 = l ? 1 : 0, h.zoom = 1, n.type = 2, n.b = 'alpha(opacity=' + n.s + ')', n.e = 'alpha(opacity=' + (n.s + n.c) + ')', n.data = t, n.plugin = a, n.setRatio = Xe), l && (n = new pe(h, 'visibility', 0, 0, n, -1, null, !1, 0, o !== 0 ? 'inherit' : 'hidden', e === 0 ? 'hidden' : 'inherit'), n.xs0 = 'inherit', s._overwriteProps.push(n.n), s._overwriteProps.push(i)), n;
      }
}); var Be = function (t, e) {
          e && (t.removeProperty ? ((e.substr(0, 2) === 'ms' || e.substr(0, 6) === 'webkit') && (e = '-' + e), t.removeProperty(e.replace(k, '-$1').toLowerCase())) : t.removeAttribute(e));
        }, Ye = function (t) {
          if (this.t._gsClassPT = this, t === 1 || t === 0) {
            this.t.setAttribute('class', t === 0 ? this.b : this.e); for (var e = this.data, i = this.t.style; e;) {
              e.v ? i[e.p] = e.v : Be(i, e.p), e = e._next;
            }t === 1 && this.t._gsClassPT === this && (this.t._gsClassPT = null);
          } else {
            this.t.getAttribute('class') !== this.e && this.t.setAttribute('class', this.e);
          }
        };

 ye('className', {
parser: function (t, e, s, n, a, o, h) {
        var l, _, u, c, f, p = t.getAttribute('class') || '', m = t.style.cssText;

 if (a = n._classNamePT = new pe(t, s, 0, 0, a, 2), a.setRatio = Ye, a.pr = -11, i = !0, a.b = p, _ = K(t, r), u = t._gsClassPT) {
          for (c = {}, f = u.data; f;) {
            c[f.p] = 1, f = f._next;
          }u.setRatio(1);
        }

 return t._gsClassPT = a, a.e = e.charAt(1) !== '=' ? e : p.replace(RegExp('\\s*\\b' + e.substr(2) + '\\b'), '') + (e.charAt(0) === '+' ? ' ' + e.substr(2) : ''), t.setAttribute('class', a.e), l = J(t, _, K(t), h, c), t.setAttribute('class', p), a.data = l.firstMPT, t.style.cssText = m, a = a.xfirst = n.parse(t, l.difs, a, o);
      }
}); var je = function (t) {
        if ((t === 1 || t === 0) && this.data._totalTime === this.data._totalDuration && this.data.data !== 'isFromStart') {
          var e, i, s, r, n, a = this.t.style, o = h.transform.parse;

 if (this.e === 'all') {
            a.cssText = '', r = !0;
          } else {
            for (e = this.e.split(' ').join('').split(','), s = e.length; --s > -1;) {
              i = e[s], h[i] && (h[i].parse === o ? r = !0 : i = i === 'transformOrigin' ? ke : h[i].p), Be(a, i);
            }
          }r && (Be(a, be), n = this.t._gsTransform, n && (n.svg && this.t.removeAttribute('data-svg-origin'), delete this.t._gsTransform));
        }
      };

 for (ye('clearProps', {
parser: function (t, e, s, r, n) {
        return n = new pe(t, s, 0, 0, n, 2), n.setRatio = je, n.e = e, n.pr = -10, n.data = r._tween, i = !0, n;
      }
}), l = 'bezier,throwProps,physicsProps,physics2D'.split(','), ge = l.length; ge--;) {
        Te(l[ge]);
      }l = a.prototype, l._firstPT = l._lastParsedTransform = l._transform = null, l._onInitTween = function (t, e, o) {
        if (!t.nodeType) {
          return !1;
        } this._target = t, this._tween = o, this._vars = e, _ = e.autoRound, i = !1, s = e.suffixMap || a.suffixMap, r = Z(t, ''), n = this._overwriteProps; var l, f, m, d, g, v, y, T, x, b = t.style;

 if (u && b.zIndex === '' && (l = Q(t, 'zIndex', r), (l === 'auto' || l === '') && this._addLazySet(b, 'zIndex', 0)), typeof e == 'string' && (d = b.cssText, l = K(t, r), b.cssText = d + ';' + e, l = J(t, l, K(t)).difs, !j && w.test(e) && (l.opacity = parseFloat(RegExp.$1)), e = l, b.cssText = d), this._firstPT = f = e.className ? h.className.parse(t, e.className, 'className', this, null, null, e) : this.parse(t, e, null), this._transformType) {
          for (x = this._transformType === 3, be ? c && (u = !0, b.zIndex === '' && (y = Q(t, 'zIndex', r), (y === 'auto' || y === '') && this._addLazySet(b, 'zIndex', 0)), p && this._addLazySet(b, 'WebkitBackfaceVisibility', this._vars.WebkitBackfaceVisibility || (x ? 'visible' : 'hidden'))) : b.zoom = 1, m = f; m && m._next;) {
            m = m._next;
          }T = new pe(t, 'transform', 0, 0, null, 2), this._linkCSSP(T, null, m), T.setRatio = be ? Le : Ee, T.data = this._transform || Ne(t, r, !0), T.tween = o, T.pr = -1, n.pop();
        } if (i) {
          for (;f;) {
            for (v = f._next, m = d; m && m.pr > f.pr;) {
              m = m._next;
            }(f._prev = m ? m._prev : g) ? f._prev._next = f : d = f, (f._next = m) ? m._prev = f : g = f, f = v;
          } this._firstPT = d;
        }

 return !0;
      }, l.parse = function (t, e, i, n) {
        var a, o, l, u, c, f, p, m, d, g, v = t.style;

 for (a in e) {
          f = e[a], o = h[a], o ? i = o.parse(t, f, a, this, i, n, e) : (c = Q(t, a, r) + '', d = typeof f == 'string', a === 'color' || a === 'fill' || a === 'stroke' || a.indexOf('Color') !== -1 || d && P.test(f) ? (d || (f = le(f), f = (f.length > 3 ? 'rgba(' : 'rgb(') + f.join(',') + ')'), i = de(v, a, c, f, !0, 'transparent', i, 0, n)) : !d || f.indexOf(' ') === -1 && f.indexOf(',') === -1 ? (l = parseFloat(c), p = l || l === 0 ? c.substr((l + '').length) : '', (c === '' || c === 'auto') && (a === 'width' || a === 'height' ? (l = ie(t, a, r), p = 'px') : a === 'left' || a === 'top' ? (l = H(t, a, r), p = 'px') : (l = a !== 'opacity' ? 0 : 1, p = '')), g = d && f.charAt(1) === '=', g ? (u = parseInt(f.charAt(0) + '1', 10), f = f.substr(2), u *= parseFloat(f), m = f.replace(T, '')) : (u = parseFloat(f), m = d ? f.replace(T, '') : ''), m === '' && (m = a in s ? s[a] : p), f = u || u === 0 ? (g ? u + l : u) + m : e[a], p !== m && m !== '' && (u || u === 0) && l && (l = $(t, a, l, p), m === '%' ? (l /= $(t, a, 100, '%') / 100, e.strictUnits !== !0 && (c = l + '%')) : m === 'em' ? l /= $(t, a, 1, 'em') : m !== 'px' && (u = $(t, a, u, m), m = 'px'), g && (u || u === 0) && (f = u + l + m)), g && (u += l), !l && l !== 0 || !u && u !== 0 ? void 0 !== v[a] && (f || f + '' != 'NaN' && f != null) ? (i = new pe(v, a, u || l || 0, 0, i, -1, a, !1, 0, c, f), i.xs0 = f !== 'none' || a !== 'display' && a.indexOf('Style') === -1 ? f : c) : q('invalid ' + a + ' tween value: ' + e[a]) : (i = new pe(v, a, l, u - l, i, 0, a, _ !== !1 && (m === 'px' || a === 'zIndex'), 0, c, f), i.xs0 = m)) : i = de(v, a, c, f, !0, null, i, 0, n)), n && i && !i.plugin && (i.plugin = n);
        }

 return i;
      }, l.setRatio = function (t) {
        var e, i, s, r = this._firstPT, n = 1e-6;

 if (t !== 1 || this._tween._time !== this._tween._duration && this._tween._time !== 0) {
          if (t || this._tween._time !== this._tween._duration && this._tween._time !== 0 || this._tween._rawPrevTime === -1e-6) {
            for (;r;) {
              if (e = r.c * t + r.s, r.r ? e = Math.round(e) : n > e && e > -n && (e = 0), r.type) {
                if (r.type === 1) {
                  if (s = r.l, s === 2) {
                    r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2;
                  } else if (s === 3) {
                    r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3;
                  } else if (s === 4) {
                    r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4;
                  } else if (s === 5) {
                    r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4 + r.xn4 + r.xs5;
                  } else {
                    for (i = r.xs0 + e + r.xs1, s = 1; r.l > s; s++) {
                      i += r['xn' + s] + r['xs' + (s + 1)];
                    }r.t[r.p] = i;
                  }
                } else {
                  r.type === -1 ? r.t[r.p] = r.xs0 : r.setRatio && r.setRatio(t);
                }
              } else {
                r.t[r.p] = e + r.xs0;
              }r = r._next;
            }
          } else {
            for (;r;) {
              r.type !== 2 ? r.t[r.p] = r.b : r.setRatio(t), r = r._next;
            }
          }
        } else {
          for (;r;) {
            if (r.type !== 2) {
              if (r.r && r.type !== -1) {
                if (e = Math.round(r.s + r.c), r.type) {
                  if (r.type === 1) {
                    for (s = r.l, i = r.xs0 + e + r.xs1, s = 1; r.l > s; s++) {
                      i += r['xn' + s] + r['xs' + (s + 1)];
                    }r.t[r.p] = i;
                  }
                } else {
                  r.t[r.p] = e + r.xs0;
                }
              } else {
                r.t[r.p] = r.e;
              }
            } else {
              r.setRatio(t);
            }r = r._next;
          }
        }
      }, l._enableTransforms = function (t) {
        this._transform = this._transform || Ne(this._target, r, !0), this._transformType = this._transform.svg && xe || !t && this._transformType !== 3 ? 2 : 3;
      }; var Ue = function () {
        this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0);
      };

 l._addLazySet = function (t, e, i) {
        var s = this._firstPT = new pe(t, e, 0, 0, this._firstPT, 2);

 s.e = i, s.setRatio = Ue, s.data = this;
      }, l._linkCSSP = function (t, e, i, s) {
        return t && (e && (e._prev = t), t._next && (t._next._prev = t._prev), t._prev ? t._prev._next = t._next : this._firstPT === t && (this._firstPT = t._next, s = !0), i ? i._next = t : s || this._firstPT !== null || (this._firstPT = t), t._next = e, t._prev = i), t;
      }, l._kill = function (e) {
        var i, s, r, n = e;

 if (e.autoAlpha || e.alpha) {
          n = {}; for (s in e) {
            n[s] = e[s];
          }n.opacity = 1, n.autoAlpha && (n.visibility = 1);
        }

 return e.className && (i = this._classNamePT) && (r = i.xfirst, r && r._prev ? this._linkCSSP(r._prev, i._next, r._prev._prev) : r === this._firstPT && (this._firstPT = i._next), i._next && this._linkCSSP(i._next, i._next._next, r._prev), this._classNamePT = null), t.prototype._kill.call(this, n);
      }; var qe = function (t, e, i) {
        var s, r, n, a;

 if (t.slice) {
          for (r = t.length; --r > -1;) {
            qe(t[r], e, i);
          }
        } else {
          for (s = t.childNodes, r = s.length; --r > -1;) {
            n = s[r], a = n.type, n.style && (e.push(K(n)), i && i.push(n)), a !== 1 && a !== 9 && a !== 11 || !n.childNodes.length || qe(n, e, i);
          }
        }
      };

 return a.cascadeTo = function (t, i, s) {
        var r, n, a, o, h = e.to(t, i, s), l = [h], _ = [], u = [], c = [], f = e._internals.reservedProps;

 for (t = h._targets || h.target, qe(t, _, c), h.render(i, !0, !0), qe(t, u), h.render(0, !0, !0), h._enabled(!0), r = c.length; --r > -1;) {
          if (n = J(c[r], _[r], u[r]), n.firstMPT) {
            n = n.difs; for (a in s) {
              f[a] && (n[a] = s[a]);
            }o = {}; for (a in n) {
              o[a] = _[r][a];
            }l.push(e.fromTo(c[r], i, o, n));
          }
        }

 return l;
      }, t.activate([a]), a;
    }, !0), function () {
      var t = _gsScope._gsDefine.plugin({
propName: 'roundProps',
priority: -1,
API: 2,
init: function (t, e, i) {
          return this._tween = i, !0;
        }
}), e = t.prototype;

 e._onInitAllProps = function () {
        for (var t, e, i, s = this._tween, r = s.vars.roundProps instanceof Array ? s.vars.roundProps : s.vars.roundProps.split(','), n = r.length, a = {}, o = s._propLookup.roundProps; --n > -1;) {
          a[r[n]] = 1;
        } for (n = r.length; --n > -1;) {
          for (t = r[n], e = s._firstPT; e;) {
            i = e._next, e.pg ? e.t._roundProps(a, !0) : e.n === t && (this._add(e.t, t, e.s, e.c), i && (i._prev = e._prev), e._prev ? e._prev._next = i : s._firstPT === e && (s._firstPT = i), e._next = e._prev = null, s._propLookup[t] = o), e = i;
          }
        }

 return !1;
      }, e._add = function (t, e, i, s) {
        this._addTween(t, e, i, i + s, e, !0), this._overwriteProps.push(e);
      };
    }(), function () {
      var t = /(?:\d|\-|\+|=|#|\.)*/g, e = /[A-Za-z%]/g;

 _gsScope._gsDefine.plugin({
propName: 'attr',
API: 2,
version: '0.4.0',
init: function (i, s) {
        var r, n, a, o, h;

 if (typeof i.setAttribute != 'function') {
          return !1;
        } this._target = i, this._proxy = {}, this._start = {}, this._end = {}, this._suffix = {}; for (r in s) {
          this._start[r] = this._proxy[r] = n = i.getAttribute(r) + '', this._end[r] = a = s[r] + '', this._suffix[r] = o = e.test(a) ? a.replace(t, '') : e.test(n) ? n.replace(t, '') : '', o && (h = a.indexOf(o), h !== -1 && (a = a.substr(0, h))), this._addTween(this._proxy, r, parseFloat(n), a, r) || (this._suffix[r] = ''), a.charAt(1) === '=' && (this._end[r] = this._firstPT.s + this._firstPT.c + o), this._overwriteProps.push(r);
        }

 return !0;
      },
set: function (t) {
        this._super.setRatio.call(this, t); for (var e, i = this._overwriteProps, s = i.length, r = t === 1 ? this._end : t ? this._proxy : this._start, n = r === this._proxy; --s > -1;) {
          e = i[s], this._target.setAttribute(e, r[e] + (n ? this._suffix[e] : ''));
        }
      }
});
    }(), _gsScope._gsDefine.plugin({
propName: 'directionalRotation',
version: '0.2.1',
API: 2,
init: function (t, e) {
      typeof e != 'object' && (e = { rotation: e }), this.finals = {}; var i, s, r, n, a, o, h = e.useRadians === !0 ? 2 * Math.PI : 360, l = 1e-6;

 for (i in e) {
        i !== 'useRadians' && (o = (e[i] + '').split('_'), s = o[0], r = parseFloat(typeof t[i] != 'function' ? t[i] : t[i.indexOf('set') || typeof t['get' + i.substr(3)] != 'function' ? i : 'get' + i.substr(3)]()), n = this.finals[i] = typeof s == 'string' && s.charAt(1) === '=' ? r + parseInt(s.charAt(0) + '1', 10) * Number(s.substr(2)) : Number(s) || 0, a = n - r, o.length && (s = o.join('_'), s.indexOf('short') !== -1 && (a %= h, a !== a % (h / 2) && (a = a < 0 ? a + h : a - h)), s.indexOf('_cw') !== -1 && a < 0 ? a = (a + 9999999999 * h) % h - (0 | a / h) * h : s.indexOf('ccw') !== -1 && a > 0 && (a = (a - 9999999999 * h) % h - (0 | a / h) * h)), (a > l || -l > a) && (this._addTween(t, i, r, r + a, i), this._overwriteProps.push(i)));
      }

 return !0;
    },
set: function (t) {
      var e;

 if (t !== 1) {
        this._super.setRatio.call(this, t);
      } else {
        for (e = this._firstPT; e;) {
          e.f ? e.t[e.p](this.finals[e.p]) : e.t[e.p] = this.finals[e.p], e = e._next;
        }
      }
    }
})._autoCSS = !0, _gsScope._gsDefine('easing.Back', ['easing.Ease'], function (t) {
      var e, i, s, r = _gsScope.GreenSockGlobals || _gsScope, n = r.com.greensock, a = 2 * Math.PI, o = Math.PI / 2, h = n._class, l = function (e, i) {
          var s = h('easing.' + e, function () {}, !0), r = s.prototype = new t;

 return r.constructor = s, r.getRatio = i, s;
        }, _ = t.register || function () {}, u = function (t, e, i, s) {
          var r = h('easing.' + t, { easeOut: new e,
easeIn: new i,
easeInOut: new s }, !0);

 return _(r, t), r;
        }, c = function (t, e, i) {
          this.t = t, this.v = e, i && (this.next = i, i.prev = this, this.c = i.v - e, this.gap = i.t - t);
        }, f = function (e, i) {
          var s = h('easing.' + e, function (t) {
              this._p1 = t || t === 0 ? t : 1.70158, this._p2 = 1.525 * this._p1;
            }, !0), r = s.prototype = new t;

 return r.constructor = s, r.getRatio = i, r.config = function (t) {
            return new s(t);
          }, s;
        }, p = u('Back', f('BackOut', function (t) {
          return (t -= 1) * t * ((this._p1 + 1) * t + this._p1) + 1;
        }), f('BackIn', function (t) {
          return t * t * ((this._p1 + 1) * t - this._p1);
        }), f('BackInOut', function (t) {
          return (t *= 2) < 1 ? .5 * t * t * ((this._p2 + 1) * t - this._p2) : .5 * ((t -= 2) * t * ((this._p2 + 1) * t + this._p2) + 2);
        })), m = h('easing.SlowMo', function (t, e, i) {
          e = e || e === 0 ? e : .7, t == null ? t = .7 : t > 1 && (t = 1), this._p = t !== 1 ? e : 0, this._p1 = (1 - t) / 2, this._p2 = t, this._p3 = this._p1 + this._p2, this._calcEnd = i === !0;
        }, !0), d = m.prototype = new t;

 return d.constructor = m, d.getRatio = function (t) {
        var e = t + (.5 - t) * this._p;

 return this._p1 > t ? this._calcEnd ? 1 - (t = 1 - t / this._p1) * t : e - (t = 1 - t / this._p1) * t * t * t * e : t > this._p3 ? this._calcEnd ? 1 - (t = (t - this._p3) / this._p1) * t : e + (t - e) * (t = (t - this._p3) / this._p1) * t * t * t : this._calcEnd ? 1 : e;
      }, m.ease = new m(.7, .7), d.config = m.config = function (t, e, i) {
        return new m(t, e, i);
      }, e = h('easing.SteppedEase', function (t) {
        t = t || 1, this._p1 = 1 / t, this._p2 = t + 1;
      }, !0), d = e.prototype = new t, d.constructor = e, d.getRatio = function (t) {
        return t < 0 ? t = 0 : t >= 1 && (t = .999999999), (this._p2 * t >> 0) * this._p1;
      }, d.config = e.config = function (t) {
        return new e(t);
      }, i = h('easing.RoughEase', function (e) {
        e = e || {}; for (var i, s, r, n, a, o, h = e.taper || 'none', l = [], _ = 0, u = 0 | (e.points || 20), f = u, p = e.randomize !== !1, m = e.clamp === !0, d = e.template instanceof t ? e.template : null, g = typeof e.strength == 'number' ? .4 * e.strength : .4; --f > -1;) {
          i = p ? Math.random() : 1 / u * f, s = d ? d.getRatio(i) : i, h === 'none' ? r = g : h === 'out' ? (n = 1 - i, r = n * n * g) : h === 'in' ? r = i * i * g : i < .5 ? (n = 2 * i, r = .5 * n * n * g) : (n = 2 * (1 - i), r = .5 * n * n * g), p ? s += Math.random() * r - .5 * r : f % 2 ? s += .5 * r : s -= .5 * r, m && (s > 1 ? s = 1 : s < 0 && (s = 0)), l[_++] = { x: i,
y: s };
        } for (l.sort(function (t, e) {
          return t.x - e.x;
        }), o = new c(1, 1, null), f = u; --f > -1;) {
          a = l[f], o = new c(a.x, a.y, o);
        } this._prev = new c(0, 0, o.t !== 0 ? o : o.next);
      }, !0), d = i.prototype = new t, d.constructor = i, d.getRatio = function (t) {
        var e = this._prev;

 if (t > e.t) {
          for (;e.next && t >= e.t;) {
            e = e.next;
          }e = e.prev;
        } else {
          for (;e.prev && e.t >= t;) {
            e = e.prev;
          }
        }

 return this._prev = e, e.v + (t - e.t) / e.gap * e.c;
      }, d.config = function (t) {
        return new i(t);
      }, i.ease = new i, u('Bounce', l('BounceOut', function (t) {
        return 1 / 2.75 > t ? 7.5625 * t * t : 2 / 2.75 > t ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : 2.5 / 2.75 > t ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
      }), l('BounceIn', function (t) {
        return 1 / 2.75 > (t = 1 - t) ? 1 - 7.5625 * t * t : 2 / 2.75 > t ? 1 - (7.5625 * (t -= 1.5 / 2.75) * t + .75) : 2.5 / 2.75 > t ? 1 - (7.5625 * (t -= 2.25 / 2.75) * t + .9375) : 1 - (7.5625 * (t -= 2.625 / 2.75) * t + .984375);
      }), l('BounceInOut', function (t) {
        var e = t < .5;

 return t = e ? 1 - 2 * t : 2 * t - 1, t = 1 / 2.75 > t ? 7.5625 * t * t : 2 / 2.75 > t ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : 2.5 / 2.75 > t ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375, e ? .5 * (1 - t) : .5 * t + .5;
      })), u('Circ', l('CircOut', function (t) {
        return Math.sqrt(1 - (t -= 1) * t);
      }), l('CircIn', function (t) {
        return -(Math.sqrt(1 - t * t) - 1);
      }), l('CircInOut', function (t) {
        return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
      })), s = function (e, i, s) {
        var r = h('easing.' + e, function (t, e) {
            this._p1 = t >= 1 ? t : 1, this._p2 = (e || s) / (t < 1 ? t : 1), this._p3 = this._p2 / a * (Math.asin(1 / this._p1) || 0), this._p2 = a / this._p2;
          }, !0), n = r.prototype = new t;

 return n.constructor = r, n.getRatio = i, n.config = function (t, e) {
          return new r(t, e);
        }, r;
      }, u('Elastic', s('ElasticOut', function (t) {
        return this._p1 * 2**(-10 * t) * Math.sin((t - this._p3) * this._p2) + 1;
      }, .3), s('ElasticIn', function (t) {
        return -(this._p1 * 2**(10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2));
      }, .3), s('ElasticInOut', function (t) {
        return (t *= 2) < 1 ? -.5 * this._p1 * 2**(10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2) : .5 * this._p1 * 2**(-10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2) + 1;
      }, .45)), u('Expo', l('ExpoOut', function (t) {
        return 1 - 2**(-10 * t);
      }), l('ExpoIn', function (t) {
        return 2**(10 * (t - 1)) - .001;
      }), l('ExpoInOut', function (t) {
        return (t *= 2) < 1 ? .5 * 2**(10 * (t - 1)) : .5 * (2 - 2**(-10 * (t - 1)));
      })), u('Sine', l('SineOut', function (t) {
        return Math.sin(t * o);
      }), l('SineIn', function (t) {
        return -Math.cos(t * o) + 1;
      }), l('SineInOut', function (t) {
        return -.5 * (Math.cos(Math.PI * t) - 1);
      })), h('easing.EaseLookup', {
find: function (e) {
        return t.map[e];
      }
}, !0), _(r.SlowMo, 'SlowMo', 'ease,'), _(i, 'RoughEase', 'ease,'), _(e, 'SteppedEase', 'ease,'), p;
    }, !0);
  }), _gsScope._gsDefine && _gsScope._gsQueue.pop()(), function (t, e) {
    'use strict';

 var i = t.GreenSockGlobals = t.GreenSockGlobals || t;

 if (!i.TweenLite) {
      var s, r, n, a, o, h = function (t) {
          var e, s = t.split('.'), r = i;

 for (e = 0; s.length > e; e++) {
            r[s[e]] = r = r[s[e]] || {};
          }

 return r;
        }, l = h('com.greensock'), _ = 1e-10, u = function (t) {
          var e, i = [], s = t.length;

 for (e = 0; e !== s; i.push(t[e++])) {

          }

 return i;
        }, c = function () {}, f = function () {
          var t = Object.prototype.toString, e = t.call([]);

 return function (i) {
            return i != null && (i instanceof Array || typeof i == 'object' && !!i.push && t.call(i) === e);
          };
        }(), p = {}, m = function (s, r, n, a) {
          this.sc = p[s] ? p[s].sc : [], p[s] = this, this.gsClass = null, this.func = n; var o = [];

 this.check = function (l) {
            for (var _, u, c, f, d = r.length, g = d; --d > -1;) {
              (_ = p[r[d]] || new m(r[d], [])).gsClass ? (o[d] = _.gsClass, g--) : l && _.sc.push(this);
            } if (g === 0 && n) {
              for (u = ('com.greensock.' + s).split('.'), c = u.pop(), f = h(u.join('.'))[c] = this.gsClass = n.apply(n, o), a && (i[c] = f, typeof define == 'function' && define.amd ? define((t.GreenSockAMDPath ? t.GreenSockAMDPath + '/' : '') + s.split('.').pop(), [], function () {
                return f;
              }) : s === e && typeof module != 'undefined' && module.exports && (module.exports = f)), d = 0; this.sc.length > d; d++) {
                this.sc[d].check();
              }
            }
          }, this.check(!0);
        }, d = t._gsDefine = function (t, e, i, s) {
          return new m(t, e, i, s);
        }, g = l._class = function (t, e, i) {
          return e = e || function () {}, d(t, [], function () {
            return e;
          }, i), e;
        };

 d.globals = i; var v = [0, 0, 1, 1], y = [], T = g('easing.Ease', function (t, e, i, s) {
          this._func = t, this._type = i || 0, this._power = s || 0, this._params = e ? v.concat(e) : v;
        }, !0), x = T.map = {}, w = T.register = function (t, e, i, s) {
          for (var r, n, a, o, h = e.split(','), _ = h.length, u = (i || 'easeIn,easeOut,easeInOut').split(','); --_ > -1;) {
            for (n = h[_], r = s ? g('easing.' + n, null, !0) : l.easing[n] || {}, a = u.length; --a > -1;) {
              o = u[a], x[n + '.' + o] = x[o + n] = r[o] = t.getRatio ? t : t[o] || new t;
            }
          }
        };

 for (n = T.prototype, n._calcEnd = !1, n.getRatio = function (t) {
        if (this._func) {
          return this._params[0] = t, this._func.apply(null, this._params);
        } var e = this._type, i = this._power, s = e === 1 ? 1 - t : e === 2 ? t : t < .5 ? 2 * t : 2 * (1 - t);

 return i === 1 ? s *= s : i === 2 ? s *= s * s : i === 3 ? s *= s * s * s : i === 4 && (s *= s * s * s * s), e === 1 ? 1 - s : e === 2 ? s : t < .5 ? s / 2 : 1 - s / 2;
      }, s = ['Linear', 'Quad', 'Cubic', 'Quart', 'Quint,Strong'], r = s.length; --r > -1;) {
        n = s[r] + ',Power' + r, w(new T(null, null, 1, r), n, 'easeOut', !0), w(new T(null, null, 2, r), n, 'easeIn' + (r === 0 ? ',easeNone' : '')), w(new T(null, null, 3, r), n, 'easeInOut');
      }x.linear = l.easing.Linear.easeIn, x.swing = l.easing.Quad.easeInOut; var b = g('events.EventDispatcher', function (t) {
        this._listeners = {}, this._eventTarget = t || this;
      });

 n = b.prototype, n.addEventListener = function (t, e, i, s, r) {
        r = r || 0; var n, h, l = this._listeners[t], _ = 0;

 for (l == null && (this._listeners[t] = l = []), h = l.length; --h > -1;) {
          n = l[h], n.c === e && n.s === i ? l.splice(h, 1) : _ === 0 && r > n.pr && (_ = h + 1);
        }l.splice(_, 0, {
c: e,
s: i,
up: s,
pr: r
}), this !== a || o || a.wake();
      }, n.removeEventListener = function (t, e) {
        var i, s = this._listeners[t];

 if (s) {
          for (i = s.length; --i > -1;) {
            if (s[i].c === e) {
              return s.splice(i, 1), void 0;
            }
          }
        }
      }, n.dispatchEvent = function (t) {
        var e, i, s, r = this._listeners[t];

 if (r) {
          for (e = r.length, i = this._eventTarget; --e > -1;) {
            s = r[e], s && (s.up ? s.c.call(s.s || i, { type: t,
target: i }) : s.c.call(s.s || i));
          }
        }
      }; var P = t.requestAnimationFrame, k = t.cancelAnimationFrame, S = Date.now || function () {
          return (new Date).getTime();
        }, R = S();

 for (s = ['ms', 'moz', 'webkit', 'o'], r = s.length; --r > -1 && !P;) {
        P = t[s[r] + 'RequestAnimationFrame'], k = t[s[r] + 'CancelAnimationFrame'] || t[s[r] + 'CancelRequestAnimationFrame'];
      }g('Ticker', function (t, e) {
        var i, s, r, n, h, l = this, u = S(), f = e !== !1 && P, p = 500, m = 33, d = 'tick', g = function (t) {
          var e, a, o = S() - R;

 o > p && (u += o - m), R += o, l.time = (R - u) / 1e3, e = l.time - h, (!i || e > 0 || t === !0) && (l.frame++, h += e + (e >= n ? .004 : n - e), a = !0), t !== !0 && (r = s(g)), a && l.dispatchEvent(d);
        };

 b.call(l), l.time = l.frame = 0, l.tick = function () {
          g(!0);
        }, l.lagSmoothing = function (t, e) {
          p = t || 1 / _, m = Math.min(e, p, 0);
        }, l.sleep = function () {
          r != null && (f && k ? k(r) : clearTimeout(r), s = c, r = null, l === a && (o = !1));
        }, l.wake = function () {
          r !== null ? l.sleep() : l.frame > 10 && (R = S() - p + 5), s = i === 0 ? c : f && P ? P : function (t) {
            return setTimeout(t, 0 | 1e3 * (h - l.time) + 1);
          }, l === a && (o = !0), g(2);
        }, l.fps = function (t) {
          return arguments.length ? (i = t, n = 1 / (i || 60), h = this.time + n, l.wake(), void 0) : i;
        }, l.useRAF = function (t) {
          return arguments.length ? (l.sleep(), f = t, l.fps(i), void 0) : f;
        }, l.fps(t), setTimeout(function () {
          f && l.frame < 5 && l.useRAF(!1);
        }, 1500);
      }), n = l.Ticker.prototype = new l.events.EventDispatcher, n.constructor = l.Ticker; var O = g('core.Animation', function (t, e) {
        if (this.vars = e = e || {}, this._duration = this._totalDuration = t || 0, this._delay = Number(e.delay) || 0, this._timeScale = 1, this._active = e.immediateRender === !0, this.data = e.data, this._reversed = e.reversed === !0, U) {
          o || a.wake(); var i = this.vars.useFrames ? j : U;

 i.add(this, i._time), this.vars.paused && this.paused(!0);
        }
      });

 a = O.ticker = new l.Ticker, n = O.prototype, n._dirty = n._gc = n._initted = n._paused = !1, n._totalTime = n._time = 0, n._rawPrevTime = -1, n._next = n._last = n._onUpdate = n._timeline = n.timeline = null, n._paused = !1; var A = function () {
        o && S() - R > 2e3 && a.wake(), setTimeout(A, 2e3);
      };

 A(), n.play = function (t, e) {
        return t != null && this.seek(t, e), this.reversed(!1).paused(!1);
      }, n.pause = function (t, e) {
        return t != null && this.seek(t, e), this.paused(!0);
      }, n.resume = function (t, e) {
        return t != null && this.seek(t, e), this.paused(!1);
      }, n.seek = function (t, e) {
        return this.totalTime(Number(t), e !== !1);
      }, n.restart = function (t, e) {
        return this.reversed(!1).paused(!1).totalTime(t ? -this._delay : 0, e !== !1, !0);
      }, n.reverse = function (t, e) {
        return t != null && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
      }, n.render = function () {}, n.invalidate = function () {
        return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, (this._gc || !this.timeline) && this._enabled(!0), this;
      }, n.isActive = function () {
        var t, e = this._timeline, i = this._startTime;

 return !e || !this._gc && !this._paused && e.isActive() && (t = e.rawTime()) >= i && i + this.totalDuration() / this._timeScale > t;
      }, n._enabled = function (t, e) {
        return o || a.wake(), this._gc = !t, this._active = this.isActive(), e !== !0 && (t && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !t && this.timeline && this._timeline._remove(this, !0)), !1;
      }, n._kill = function () {
        return this._enabled(!1, !1);
      }, n.kill = function (t, e) {
        return this._kill(t, e), this;
      }, n._uncache = function (t) {
        for (var e = t ? this : this.timeline; e;) {
          e._dirty = !0, e = e.timeline;
        }

 return this;
      }, n._swapSelfInParams = function (t) {
        for (var e = t.length, i = t.concat(); --e > -1;) {
          t[e] === '{self}' && (i[e] = this);
        }

 return i;
      }, n._callback = function (t) {
        var e = this.vars;

 e[t].apply(e[t + 'Scope'] || e.callbackScope || this, e[t + 'Params'] || y);
      }, n.eventCallback = function (t, e, i, s) {
        if ((t || '').substr(0, 2) === 'on') {
          var r = this.vars;

 if (arguments.length === 1) {
            return r[t];
          } e == null ? delete r[t] : (r[t] = e, r[t + 'Params'] = f(i) && i.join('').indexOf('{self}') !== -1 ? this._swapSelfInParams(i) : i, r[t + 'Scope'] = s), t === 'onUpdate' && (this._onUpdate = e);
        }

 return this;
      }, n.delay = function (t) {
        return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + t - this._delay), this._delay = t, this) : this._delay;
      }, n.duration = function (t) {
        return arguments.length ? (this._duration = this._totalDuration = t, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && t !== 0 && this.totalTime(this._totalTime * (t / this._duration), !0), this) : (this._dirty = !1, this._duration);
      }, n.totalDuration = function (t) {
        return this._dirty = !1, arguments.length ? this.duration(t) : this._totalDuration;
      }, n.time = function (t, e) {
        return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(t > this._duration ? this._duration : t, e)) : this._time;
      }, n.totalTime = function (t, e, i) {
        if (o || a.wake(), !arguments.length) {
          return this._totalTime;
        } if (this._timeline) {
          if (t < 0 && !i && (t += this.totalDuration()), this._timeline.smoothChildTiming) {
            this._dirty && this.totalDuration(); var s = this._totalDuration, r = this._timeline;

 if (t > s && !i && (t = s), this._startTime = (this._paused ? this._pauseTime : r._time) - (this._reversed ? s - t : t) / this._timeScale, r._dirty || this._uncache(!1), r._timeline) {
              for (;r._timeline;) {
                r._timeline._time !== (r._startTime + r._totalTime) / r._timeScale && r.totalTime(r._totalTime, !0), r = r._timeline;
              }
            }
          } this._gc && this._enabled(!0, !1), (this._totalTime !== t || this._duration === 0) && (this.render(t, e, !1), I.length && V());
        }

 return this;
      }, n.progress = n.totalProgress = function (t, e) {
        return arguments.length ? this.totalTime(this.duration() * t, e) : this._time / this.duration();
      }, n.startTime = function (t) {
        return arguments.length ? (t !== this._startTime && (this._startTime = t, this.timeline && this.timeline._sortChildren && this.timeline.add(this, t - this._delay)), this) : this._startTime;
      }, n.endTime = function (t) {
        return this._startTime + (t != 0 ? this.totalDuration() : this.duration()) / this._timeScale;
      }, n.timeScale = function (t) {
        if (!arguments.length) {
          return this._timeScale;
        } if (t = t || _, this._timeline && this._timeline.smoothChildTiming) {
          var e = this._pauseTime, i = e || e === 0 ? e : this._timeline.totalTime();

 this._startTime = i - (i - this._startTime) * this._timeScale / t;
        }

 return this._timeScale = t, this._uncache(!1);
      }, n.reversed = function (t) {
        return arguments.length ? (t != this._reversed && (this._reversed = t, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed;
      }, n.paused = function (t) {
        if (!arguments.length) {
          return this._paused;
        } var e, i, s = this._timeline;

 return t != this._paused && s && (o || t || a.wake(), e = s.rawTime(), i = e - this._pauseTime, !t && s.smoothChildTiming && (this._startTime += i, this._uncache(!1)), this._pauseTime = t ? e : null, this._paused = t, this._active = this.isActive(), !t && i !== 0 && this._initted && this.duration() && this.render(s.smoothChildTiming ? this._totalTime : (e - this._startTime) / this._timeScale, !0, !0)), this._gc && !t && this._enabled(!0, !1), this;
      }; var C = g('core.SimpleTimeline', function (t) {
        O.call(this, 0, t), this.autoRemoveChildren = this.smoothChildTiming = !0;
      });

 n = C.prototype = new O, n.constructor = C, n.kill()._gc = !1, n._first = n._last = n._recent = null, n._sortChildren = !1, n.add = n.insert = function (t, e) {
        var i, s;

 if (t._startTime = Number(e || 0) + t._delay, t._paused && this !== t._timeline && (t._pauseTime = t._startTime + (this.rawTime() - t._startTime) / t._timeScale), t.timeline && t.timeline._remove(t, !0), t.timeline = t._timeline = this, t._gc && t._enabled(!0, !0), i = this._last, this._sortChildren) {
          for (s = t._startTime; i && i._startTime > s;) {
            i = i._prev;
          }
        }

 return i ? (t._next = i._next, i._next = t) : (t._next = this._first, this._first = t), t._next ? t._next._prev = t : this._last = t, t._prev = i, this._recent = t, this._timeline && this._uncache(!0), this;
      }, n._remove = function (t, e) {
        return t.timeline === this && (e || t._enabled(!1, !0), t._prev ? t._prev._next = t._next : this._first === t && (this._first = t._next), t._next ? t._next._prev = t._prev : this._last === t && (this._last = t._prev), t._next = t._prev = t.timeline = null, t === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this;
      }, n.render = function (t, e, i) {
        var s, r = this._first;

 for (this._totalTime = this._time = this._rawPrevTime = t; r;) {
          s = r._next, (r._active || t >= r._startTime && !r._paused) && (r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i)), r = s;
        }
      }, n.rawTime = function () {
        return o || a.wake(), this._totalTime;
      }; var D = g('TweenLite', function (e, i, s) {
          if (O.call(this, i, s), this.render = D.prototype.render, e == null) {
            throw 'Cannot tween a null target.';
          } this.target = e = typeof e != 'string' ? e : D.selector(e) || e; var r, n, a, o = e.jquery || e.length && e !== t && e[0] && (e[0] === t || e[0].nodeType && e[0].style && !e.nodeType), h = this.vars.overwrite;

 if (this._overwrite = h = h == null ? Y[D.defaultOverwrite] : typeof h == 'number' ? h >> 0 : Y[h], (o || e instanceof Array || e.push && f(e)) && typeof e[0] != 'number') {
            for (this._targets = a = u(e), this._propLookup = [], this._siblings = [], r = 0; a.length > r; r++) {
              n = a[r], n ? typeof n != 'string' ? n.length && n !== t && n[0] && (n[0] === t || n[0].nodeType && n[0].style && !n.nodeType) ? (a.splice(r--, 1), this._targets = a = a.concat(u(n))) : (this._siblings[r] = G(n, this, !1), h === 1 && this._siblings[r].length > 1 && Z(n, this, null, 1, this._siblings[r])) : (n = a[r--] = D.selector(n), typeof n == 'string' && a.splice(r + 1, 1)) : a.splice(r--, 1);
            }
          } else {
            this._propLookup = {}, this._siblings = G(e, this, !1), h === 1 && this._siblings.length > 1 && Z(e, this, null, 1, this._siblings);
          }(this.vars.immediateRender || i === 0 && this._delay === 0 && this.vars.immediateRender !== !1) && (this._time = -_, this.render(-this._delay));
        }, !0), M = function (e) {
          return e && e.length && e !== t && e[0] && (e[0] === t || e[0].nodeType && e[0].style && !e.nodeType);
        }, z = function (t, e) {
          var i, s = {};

 for (i in t) {
            B[i] || i in e && i !== 'transform' && i !== 'x' && i !== 'y' && i !== 'width' && i !== 'height' && i !== 'className' && i !== 'border' || !(!E[i] || E[i] && E[i]._autoCSS) || (s[i] = t[i], delete t[i]);
          }t.css = s;
        };

 n = D.prototype = new O, n.constructor = D, n.kill()._gc = !1, n.ratio = 0, n._firstPT = n._targets = n._overwrittenProps = n._startAt = null, n._notifyPluginsOfEnabled = n._lazy = !1, D.version = '1.17.0', D.defaultEase = n._ease = new T(null, null, 1, 1), D.defaultOverwrite = 'auto', D.ticker = a, D.autoSleep = 120, D.lagSmoothing = function (t, e) {
        a.lagSmoothing(t, e);
      }, D.selector = t.$ || t.jQuery || function (e) {
        var i = t.$ || t.jQuery;

 return i ? (D.selector = i, i(e)) : typeof document == 'undefined' ? e : document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById(e.charAt(0) === '#' ? e.substr(1) : e);
      }; var I = [], F = {}, N = D._internals = { isArray: f,
isSelector: M,
lazyTweens: I }, E = D._plugins = {}, L = N.tweenLookup = {}, X = 0, B = N.reservedProps = {
ease: 1,
delay: 1,
overwrite: 1,
onComplete: 1,
onCompleteParams: 1,
onCompleteScope: 1,
useFrames: 1,
runBackwards: 1,
startAt: 1,
onUpdate: 1,
onUpdateParams: 1,
onUpdateScope: 1,
onStart: 1,
onStartParams: 1,
onStartScope: 1,
onReverseComplete: 1,
onReverseCompleteParams: 1,
onReverseCompleteScope: 1,
onRepeat: 1,
onRepeatParams: 1,
onRepeatScope: 1,
easeParams: 1,
yoyo: 1,
immediateRender: 1,
repeat: 1,
repeatDelay: 1,
data: 1,
paused: 1,
reversed: 1,
autoCSS: 1,
lazy: 1,
onOverwrite: 1,
callbackScope: 1
}, Y = {
none: 0,
all: 1,
auto: 2,
concurrent: 3,
allOnStart: 4,
preexisting: 5,
'true': 1,
'false': 0
}, j = O._rootFramesTimeline = new C, U = O._rootTimeline = new C, q = 30, V = N.lazyRender = function () {
        var t, e = I.length;

 for (F = {}; --e > -1;) {
          t = I[e], t && t._lazy !== !1 && (t.render(t._lazy[0], t._lazy[1], !0), t._lazy = !1);
        }I.length = 0;
      };

 U._startTime = a.time, j._startTime = a.frame, U._active = j._active = !0, setTimeout(V, 1), O._updateRoot = D.render = function () {
        var t, e, i;

 if (I.length && V(), U.render((a.time - U._startTime) * U._timeScale, !1, !1), j.render((a.frame - j._startTime) * j._timeScale, !1, !1), I.length && V(), a.frame >= q) {
          q = a.frame + (parseInt(D.autoSleep, 10) || 120); for (i in L) {
            for (e = L[i].tweens, t = e.length; --t > -1;) {
              e[t]._gc && e.splice(t, 1);
            }e.length === 0 && delete L[i];
          } if (i = U._first, (!i || i._paused) && D.autoSleep && !j._first && a._listeners.tick.length === 1) {
            for (;i && i._paused;) {
              i = i._next;
            }i || a.sleep();
          }
        }
      }, a.addEventListener('tick', O._updateRoot); var G = function (t, e, i) {
          var s, r, n = t._gsTweenID;

 if (L[n || (t._gsTweenID = n = 't' + X++)] || (L[n] = { target: t,
tweens: [] }), e && (s = L[n].tweens, s[r = s.length] = e, i)) {
            for (;--r > -1;) {
              s[r] === e && s.splice(r, 1);
            }
          }

 return L[n].tweens;
        }, W = function (t, e, i, s) {
          var r, n, a = t.vars.onOverwrite;

 return a && (r = a(t, e, i, s)), a = D.onOverwrite, a && (n = a(t, e, i, s)), r !== !1 && n !== !1;
        }, Z = function (t, e, i, s, r) {
          var n, a, o, h;

 if (s === 1 || s >= 4) {
            for (h = r.length, n = 0; h > n; n++) {
              if ((o = r[n]) !== e) {
                o._gc || o._kill(null, t, e) && (a = !0);
              } else if (s === 5) {
                break;
              }
            }

 return a;
          } var l, u = e._startTime + _, c = [], f = 0, p = e._duration === 0;

 for (n = r.length; --n > -1;) {
            (o = r[n]) === e || o._gc || o._paused || (o._timeline !== e._timeline ? (l = l || Q(e, 0, p), Q(o, l, p) === 0 && (c[f++] = o)) : u >= o._startTime && o._startTime + o.totalDuration() / o._timeScale > u && ((p || !o._initted) && u - o._startTime <= 2e-10 || (c[f++] = o)));
          } for (n = f; --n > -1;) {
            if (o = c[n], s === 2 && o._kill(i, t, e) && (a = !0), s !== 2 || !o._firstPT && o._initted) {
              if (s !== 2 && !W(o, e)) {
                continue;
              } o._enabled(!1, !1) && (a = !0);
            }
          }

 return a;
        }, Q = function (t, e, i) {
          for (var s = t._timeline, r = s._timeScale, n = t._startTime; s._timeline;) {
            if (n += s._startTime, r *= s._timeScale, s._paused) {
              return -100;
            } s = s._timeline;
          }

 return n /= r, n > e ? n - e : i && n === e || !t._initted && 2 * _ > n - e ? _ : (n += t.totalDuration() / t._timeScale / r) > e + _ ? 0 : n - e - _;
        };

 n._init = function () {
        var t, e, i, s, r, n = this.vars, a = this._overwrittenProps, o = this._duration, h = !!n.immediateRender, l = n.ease;

 if (n.startAt) {
          this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), r = {}; for (s in n.startAt) {
            r[s] = n.startAt[s];
          } if (r.overwrite = !1, r.immediateRender = !0, r.lazy = h && n.lazy !== !1, r.startAt = r.delay = null, this._startAt = D.to(this.target, 0, r), h) {
            if (this._time > 0) {
              this._startAt = null;
            } else if (o !== 0) {
              return;
            }
          }
        } else if (n.runBackwards && o !== 0) {
          if (this._startAt) {
            this._startAt.render(-1, !0), this._startAt.kill(), this._startAt = null;
          } else {
            this._time !== 0 && (h = !1), i = {}; for (s in n) {
              B[s] && s !== 'autoCSS' || (i[s] = n[s]);
            } if (i.overwrite = 0, i.data = 'isFromStart', i.lazy = h && n.lazy !== !1, i.immediateRender = h, this._startAt = D.to(this.target, 0, i), h) {
              if (this._time === 0) {
                return;
              }
            } else {
              this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null);
            }
          }
        } if (this._ease = l = l ? l instanceof T ? l : typeof l == 'function' ? new T(l, n.easeParams) : x[l] || D.defaultEase : D.defaultEase, n.easeParams instanceof Array && l.config && (this._ease = l.config.apply(l, n.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets) {
          for (t = this._targets.length; --t > -1;) {
            this._initProps(this._targets[t], this._propLookup[t] = {}, this._siblings[t], a ? a[t] : null) && (e = !0);
          }
        } else {
          e = this._initProps(this.target, this._propLookup, this._siblings, a);
        } if (e && D._onPluginEvent('_onInitAllProps', this), a && (this._firstPT || typeof this.target != 'function' && this._enabled(!1, !1)), n.runBackwards) {
          for (i = this._firstPT; i;) {
            i.s += i.c, i.c = -i.c, i = i._next;
          }
        } this._onUpdate = n.onUpdate, this._initted = !0;
      }, n._initProps = function (e, i, s, r) {
        var n, a, o, h, l, _;

 if (e == null) {
          return !1;
        } F[e._gsTweenID] && V(), this.vars.css || e.style && e !== t && e.nodeType && E.css && this.vars.autoCSS !== !1 && z(this.vars, e); for (n in this.vars) {
          if (_ = this.vars[n], B[n]) {
            _ && (_ instanceof Array || _.push && f(_)) && _.join('').indexOf('{self}') !== -1 && (this.vars[n] = _ = this._swapSelfInParams(_, this));
          } else if (E[n] && (h = new E[n])._onInitTween(e, this.vars[n], this)) {
            for (this._firstPT = l = {
_next: this._firstPT,
t: h,
p: 'setRatio',
s: 0,
c: 1,
f: !0,
n: n,
pg: !0,
pr: h._priority
}, a = h._overwriteProps.length; --a > -1;) {
              i[h._overwriteProps[a]] = this._firstPT;
            }(h._priority || h._onInitAllProps) && (o = !0), (h._onDisable || h._onEnable) && (this._notifyPluginsOfEnabled = !0);
          } else {
            this._firstPT = i[n] = l = {
_next: this._firstPT,
t: e,
p: n,
f: typeof e[n] == 'function',
n: n,
pg: !1,
pr: 0
}, l.s = l.f ? e[n.indexOf('set') || typeof e['get' + n.substr(3)] != 'function' ? n : 'get' + n.substr(3)]() : parseFloat(e[n]), l.c = typeof _ == 'string' && _.charAt(1) === '=' ? parseInt(_.charAt(0) + '1', 10) * Number(_.substr(2)) : Number(_) - l.s || 0;
          }l && l._next && (l._next._prev = l);
        }

 return r && this._kill(r, e) ? this._initProps(e, i, s, r) : this._overwrite > 1 && this._firstPT && s.length > 1 && Z(e, this, i, this._overwrite, s) ? (this._kill(i, e), this._initProps(e, i, s, r)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (F[e._gsTweenID] = !0), o);
      }, n.render = function (t, e, i) {
        var s, r, n, a, o = this._time, h = this._duration, l = this._rawPrevTime;

 if (t >= h) {
          this._totalTime = this._time = h, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (s = !0, r = 'onComplete', i = i || this._timeline.autoRemoveChildren), h === 0 && (this._initted || !this.vars.lazy || i) && (this._startTime === this._timeline._duration && (t = 0), (t === 0 || l < 0 || l === _ && this.data !== 'isPause') && l !== t && (i = !0, l > _ && (r = 'onReverseComplete')), this._rawPrevTime = a = !e || t || l === t ? t : _);
        } else if (t < 1e-7) {
          this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (o !== 0 || h === 0 && l > 0) && (r = 'onReverseComplete', s = this._reversed), t < 0 && (this._active = !1, h === 0 && (this._initted || !this.vars.lazy || i) && (l >= 0 && (l !== _ || this.data !== 'isPause') && (i = !0), this._rawPrevTime = a = !e || t || l === t ? t : _)), this._initted || (i = !0);
        } else if (this._totalTime = this._time = t, this._easeType) {
          var u = t / h, c = this._easeType, f = this._easePower;

 (c === 1 || c === 3 && u >= .5) && (u = 1 - u), c === 3 && (u *= 2), f === 1 ? u *= u : f === 2 ? u *= u * u : f === 3 ? u *= u * u * u : f === 4 && (u *= u * u * u * u), this.ratio = c === 1 ? 1 - u : c === 2 ? u : t / h < .5 ? u / 2 : 1 - u / 2;
        } else {
          this.ratio = this._ease.getRatio(t / h);
        } if (this._time !== o || i) {
          if (!this._initted) {
            if (this._init(), !this._initted || this._gc) {
              return;
            } if (!i && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) {
              return this._time = this._totalTime = o, this._rawPrevTime = l, I.push(this), this._lazy = [t, e], void 0;
            } this._time && !s ? this.ratio = this._ease.getRatio(this._time / h) : s && this._ease._calcEnd && (this.ratio = this._ease.getRatio(this._time === 0 ? 0 : 1));
          } for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== o && t >= 0 && (this._active = !0), o === 0 && (this._startAt && (t >= 0 ? this._startAt.render(t, e, i) : r || (r = '_dummyGS')), this.vars.onStart && (this._time !== 0 || h === 0) && (e || this._callback('onStart'))), n = this._firstPT; n;) {
            n.f ? n.t[n.p](n.c * this.ratio + n.s) : n.t[n.p] = n.c * this.ratio + n.s, n = n._next;
          } this._onUpdate && (t < 0 && this._startAt && t !== -1e-4 && this._startAt.render(t, e, i), e || (this._time !== o || s) && this._callback('onUpdate')), r && (!this._gc || i) && (t < 0 && this._startAt && !this._onUpdate && t !== -1e-4 && this._startAt.render(t, e, i), s && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[r] && this._callback(r), h === 0 && this._rawPrevTime === _ && a !== _ && (this._rawPrevTime = 0));
        }
      }, n._kill = function (t, e, i) {
        if (t === 'all' && (t = null), t == null && (e == null || e === this.target)) {
          return this._lazy = !1, this._enabled(!1, !1);
        } e = typeof e != 'string' ? e || this._targets || this.target : D.selector(e) || e; var s, r, n, a, o, h, l, _, u, c = i && this._time && i._startTime === this._startTime && this._timeline === i._timeline;

 if ((f(e) || M(e)) && typeof e[0] != 'number') {
          for (s = e.length; --s > -1;) {
            this._kill(t, e[s], i) && (h = !0);
          }
        } else {
          if (this._targets) {
            for (s = this._targets.length; --s > -1;) {
              if (e === this._targets[s]) {
                o = this._propLookup[s] || {}, this._overwrittenProps = this._overwrittenProps || [], r = this._overwrittenProps[s] = t ? this._overwrittenProps[s] || {} : 'all'; break;
              }
            }
          } else {
            if (e !== this.target) {
              return !1;
            } o = this._propLookup, r = this._overwrittenProps = t ? this._overwrittenProps || {} : 'all';
          } if (o) {
            if (l = t || o, _ = t !== r && r !== 'all' && t !== o && (typeof t != 'object' || !t._tempKill), i && (D.onOverwrite || this.vars.onOverwrite)) {
              for (n in l) {
                o[n] && (u || (u = []), u.push(n));
              } if ((u || !t) && !W(this, i, e, u)) {
                return !1;
              }
            } for (n in l) {
              (a = o[n]) && (c && (a.f ? a.t[a.p](a.s) : a.t[a.p] = a.s, h = !0), a.pg && a.t._kill(l) && (h = !0), a.pg && a.t._overwriteProps.length !== 0 || (a._prev ? a._prev._next = a._next : a === this._firstPT && (this._firstPT = a._next), a._next && (a._next._prev = a._prev), a._next = a._prev = null), delete o[n]), _ && (r[n] = 1);
            }!this._firstPT && this._initted && this._enabled(!1, !1);
          }
        }

 return h;
      }, n.invalidate = function () {
        return this._notifyPluginsOfEnabled && D._onPluginEvent('_onDisable', this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], O.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -_, this.render(-this._delay)), this;
      }, n._enabled = function (t, e) {
        if (o || a.wake(), t && this._gc) {
          var i, s = this._targets;

 if (s) {
            for (i = s.length; --i > -1;) {
              this._siblings[i] = G(s[i], this, !0);
            }
          } else {
            this._siblings = G(this.target, this, !0);
          }
        }

 return O.prototype._enabled.call(this, t, e), this._notifyPluginsOfEnabled && this._firstPT ? D._onPluginEvent(t ? '_onEnable' : '_onDisable', this) : !1;
      }, D.to = function (t, e, i) {
        return new D(t, e, i);
      }, D.from = function (t, e, i) {
        return i.runBackwards = !0, i.immediateRender = i.immediateRender != 0, new D(t, e, i);
      }, D.fromTo = function (t, e, i, s) {
        return s.startAt = i, s.immediateRender = s.immediateRender != 0 && i.immediateRender != 0, new D(t, e, s);
      }, D.delayedCall = function (t, e, i, s, r) {
        return new D(e, 0, {
delay: t,
onComplete: e,
onCompleteParams: i,
callbackScope: s,
onReverseComplete: e,
onReverseCompleteParams: i,
immediateRender: !1,
lazy: !1,
useFrames: r,
overwrite: 0
});
      }, D.set = function (t, e) {
        return new D(t, 0, e);
      }, D.getTweensOf = function (t, e) {
        if (t == null) {
          return [];
        } t = typeof t != 'string' ? t : D.selector(t) || t; var i, s, r, n;

 if ((f(t) || M(t)) && typeof t[0] != 'number') {
          for (i = t.length, s = []; --i > -1;) {
            s = s.concat(D.getTweensOf(t[i], e));
          } for (i = s.length; --i > -1;) {
            for (n = s[i], r = i; --r > -1;) {
              n === s[r] && s.splice(i, 1);
            }
          }
        } else {
          for (s = G(t).concat(), i = s.length; --i > -1;) {
            (s[i]._gc || e && !s[i].isActive()) && s.splice(i, 1);
          }
        }

 return s;
      }, D.killTweensOf = D.killDelayedCallsTo = function (t, e, i) {
        typeof e == 'object' && (i = e, e = !1); for (var s = D.getTweensOf(t, e), r = s.length; --r > -1;) {
          s[r]._kill(i, t);
        }
      }; var $ = g('plugins.TweenPlugin', function (t, e) {
        this._overwriteProps = (t || '').split(','), this._propName = this._overwriteProps[0], this._priority = e || 0, this._super = $.prototype;
      }, !0);

 if (n = $.prototype, $.version = '1.10.1', $.API = 2, n._firstPT = null, n._addTween = function (t, e, i, s, r, n) {
        var a, o;

 return s != null && (a = typeof s == 'number' || s.charAt(1) !== '=' ? Number(s) - Number(i) : parseInt(s.charAt(0) + '1', 10) * Number(s.substr(2))) ? (this._firstPT = o = {
_next: this._firstPT,
t: t,
p: e,
s: i,
c: a,
f: typeof t[e] == 'function',
n: r || e,
r: n
}, o._next && (o._next._prev = o), o) : void 0;
      }, n.setRatio = function (t) {
        for (var e, i = this._firstPT, s = 1e-6; i;) {
          e = i.c * t + i.s, i.r ? e = Math.round(e) : s > e && e > -s && (e = 0), i.f ? i.t[i.p](e) : i.t[i.p] = e, i = i._next;
        }
      }, n._kill = function (t) {
        var e, i = this._overwriteProps, s = this._firstPT;

 if (t[this._propName] != null) {
          this._overwriteProps = [];
        } else {
          for (e = i.length; --e > -1;) {
            t[i[e]] != null && i.splice(e, 1);
          }
        } for (;s;) {
          t[s.n] != null && (s._next && (s._next._prev = s._prev), s._prev ? (s._prev._next = s._next, s._prev = null) : this._firstPT === s && (this._firstPT = s._next)), s = s._next;
        }

 return !1;
      }, n._roundProps = function (t, e) {
        for (var i = this._firstPT; i;) {
          (t[this._propName] || i.n != null && t[i.n.split(this._propName + '_').join('')]) && (i.r = e), i = i._next;
        }
      }, D._onPluginEvent = function (t, e) {
        var i, s, r, n, a, o = e._firstPT;

 if (t === '_onInitAllProps') {
          for (;o;) {
            for (a = o._next, s = r; s && s.pr > o.pr;) {
              s = s._next;
            }(o._prev = s ? s._prev : n) ? o._prev._next = o : r = o, (o._next = s) ? s._prev = o : n = o, o = a;
          }o = e._firstPT = r;
        } for (;o;) {
          o.pg && typeof o.t[t] == 'function' && o.t[t]() && (i = !0), o = o._next;
        }

 return i;
      }, $.activate = function (t) {
        for (var e = t.length; --e > -1;) {
          t[e].API === $.API && (E[(new t[e])._propName] = t[e]);
        }

 return !0;
      }, d.plugin = function (t) {
        if (!(t && t.propName && t.init && t.API)) {
          throw 'illegal plugin definition.';
        } var e, i = t.propName, s = t.priority || 0, r = t.overwriteProps, n = {
init: '_onInitTween',
set: 'setRatio',
kill: '_kill',
round: '_roundProps',
initAll: '_onInitAllProps'
}, a = g('plugins.' + i.charAt(0).toUpperCase() + i.substr(1) + 'Plugin', function () {
            $.call(this, i, s), this._overwriteProps = r || [];
          }, t.global === !0), o = a.prototype = new $(i);

 o.constructor = a, a.API = t.API; for (e in n) {
          typeof t[e] == 'function' && (o[n[e]] = t[e]);
        }

 return a.version = t.version, $.activate([a]), a;
      }, s = t._gsQueue) {
        for (r = 0; s.length > r; r++) {
          s[r]();
        } for (n in p) {
          p[n].func || t.console.log('GSAP encountered missing dependency: com.greensock.' + n);
        }
      }o = !1;
    }
  }(typeof module != 'undefined' && module.exports && typeof global != 'undefined' ? global : this || window, 'TweenMax');
})();
// //////////////////////////////

// //////////////////////////////
// jquery.preload.min.js
// //////////////////////////////
(function () {
/**
 * jQuery.Preload - Multifunctional preloader
 * Copyright (c) 2008 Ariel Flesler - aflesler(at)gmail(dot)com
 * Dual licensed under MIT and GPL.
 * Date: 3/25/2009
 * @author Ariel Flesler
 * @version 1.0.8
 */
  (function ($) {
    var h = $.preload = function (c, d) {
      if (c.split) {
        c = $(c);
      }d = $.extend({}, h.defaults, d); var f = $.map(c, function (a) {
          if (!a) {
            return;
          } if (a.split) {
            return d.base + a + d.ext;
          } var b = a.src || a.href;

 if (typeof d.placeholder == 'string' && a.src) {
            a.src = d.placeholder;
          } if (b && d.find) {
            b = b.replace(d.find, d.replace);
          }

 return b || null;
        }), data = {
loaded: 0,
failed: 0,
next: 0,
done: 0,
total: f.length
};

 if (!data.total) {
        return finish();
      } var g = $(Array(d.threshold + 1).join('<img/>')).load(handler).error(handler).bind('abort', handler).each(fetch);

 function handler(e) {
        data.element = this; data.found = e.type == 'load'; data.image = this.src; data.index = this.index; var a = data.original = c[this.index];

 data[data.found ? 'loaded' : 'failed']++; data.done++; if (d.enforceCache) {
          h.cache.push($('<img/>').attr('src', data.image)[0]);
        } if (d.placeholder && a.src) {
          a.src = data.found ? data.image : d.notFound || a.src;
        } if (d.onComplete) {
          d.onComplete(data);
        } if (data.done < data.total) {
          fetch(0, this);
        } else {
          if (g && g.unbind) {
            g.unbind('load').unbind('error').unbind('abort');
          }g = null; finish();
        }
      } function fetch(i, a, b) {
        if (a.attachEvent && data.next && data.next % h.gap == 0 && !b) {
          setTimeout(function () {
            fetch(i, a, 1);
          }, 0);

 return !1;
        } if (data.next == data.total) {
          return !1;
        } a.index = data.next; a.src = f[data.next++]; if (d.onRequest) {
          data.index = a.index; data.element = a; data.image = a.src; data.original = c[data.next - 1]; d.onRequest(data);
        }
      } function finish() {
        if (d.onFinish) {
          d.onFinish(data);
        }
      }
    };

 h.gap = 14; h.cache = []; h.defaults = {
threshold: 2,
base: '',
ext: '',
replace: ''
}; $.fn.preload = function (a) {
      h(this, a);

 return this;
    };
  })(jQuery);
})();
// //////////////////////////////

// //////////////////////////////
// jquery.touchSwipe.min.js
// //////////////////////////////
(function () {
  (function (a) {
    a.fn.swipe = function (b) {
      if (!this) {
        return false;
      } var c = {
fingers: 1,
threshold: 75,
swipe: null,
swipeLeft: null,
swipeRight: null,
swipeUp: null,
swipeDown: null,
swipeStatus: null,
click: null,
triggerOnTouchEnd: true,
allowPageScroll: 'auto'
}; var d = 'left'; var e = 'right'; var f = 'up'; var g = 'down'; var h = 'none'; var i = 'horizontal'; var j = 'vertical'; var k = 'auto'; var l = 'start'; var m = 'move'; var n = 'end'; var o = 'cancel'; var p = 'start';

 if (b.allowPageScroll == undefined && (b.swipe != undefined || b.swipeStatus != undefined)) {
        b.allowPageScroll = h;
      } if (b) {
        a.extend(c, b);
      }

 return this.each(function () {
        function D() {
          var a = C();

 if (a <= 45 && a >= 0) {
            return d;
          } else if (a <= 360 && a >= 315) {
            return d;
          } else if (a >= 135 && a <= 225) {
            return e;
          } else if (a > 45 && a < 135) {
            return g;
          } else {
            return f;
          }
        } function C() {
          var a = s.x - t.x; var b = t.y - s.y; var c = Math.atan2(b, a); var d = Math.round(c * 180 / Math.PI);

 if (d < 0) {
            d = 360 - Math.abs(d);
          }

 return d;
        } function B() {
          return Math.round(Math.sqrt((t.x - s.x)**2 + (t.y - s.y)**2));
        } function A(a, b) {
          if (c.allowPageScroll == h) {
            a.preventDefault();
          } else {
            var l = c.allowPageScroll == k;

 switch (b) {
              case d: if (c.swipeLeft && l || !l && c.allowPageScroll != i) {
                a.preventDefault();
              } break; case e: if (c.swipeRight && l || !l && c.allowPageScroll != i) {
                a.preventDefault();
              } break; case f: if (c.swipeUp && l || !l && c.allowPageScroll != j) {
                a.preventDefault();
              } break; case g: if (c.swipeDown && l || !l && c.allowPageScroll != j) {
                a.preventDefault();
              } break;
            }
          }
        } function z(a, h) {
          if (c.swipeStatus) {
            c.swipeStatus.call(b, a, h, direction || null, distance || 0);
          } if (h == o) {
            if (c.click && r == 1 && (isNaN(distance) || distance == 0)) {
              c.click.call(b, a, a.target);
            }
          } if (h == n) {
            if (c.swipe) {
              c.swipe.call(b, a, direction, distance);
            } switch (direction) {
              case d: if (c.swipeLeft) {
                c.swipeLeft.call(b, a, direction, distance);
              } break; case e: if (c.swipeRight) {
                c.swipeRight.call(b, a, direction, distance);
              } break; case f: if (c.swipeUp) {
                c.swipeUp.call(b, a, direction, distance);
              } break; case g: if (c.swipeDown) {
                c.swipeDown.call(b, a, direction, distance);
              } break;
            }
          }
        } function y(a) {
          r = 0; s.x = 0; s.y = 0; t.x = 0; t.y = 0; u.x = 0; u.y = 0;
        } function x(a) {
          a.preventDefault(); distance = B(); direction = D(); if (c.triggerOnTouchEnd) {
            p = n; if (r == c.fingers && t.x != 0) {
              if (distance >= c.threshold) {
                z(a, p); y(a);
              } else {
                p = o; z(a, p); y(a);
              }
            } else {
              p = o; z(a, p); y(a);
            }
          } else if (p == m) {
            p = o; z(a, p); y(a);
          }
        } function w(a) {
          if (p == n || p == o) {
            return;
          } t.x = a.touches[0].pageX; t.y = a.touches[0].pageY; direction = D(); r = a.touches.length; p = m; A(a, direction); if (r == c.fingers) {
            distance = B(); if (c.swipeStatus) {
              z(a, p, direction, distance);
            } if (!c.triggerOnTouchEnd) {
              if (distance >= c.threshold) {
                p = n; z(a, p); y(a);
              }
            }
          } else {
            p = o; z(a, p); y(a);
          }
        } function v(a) {
          p = l; r = a.touches.length; distance = 0; direction = null; if (r == c.fingers) {
            s.x = t.x = a.touches[0].pageX; s.y = t.y = a.touches[0].pageY; if (c.swipeStatus) {
              z(a, p);
            }
          } else {
            y(a);
          }
        } var b = a(this); var q = null; var r = 0; var s = { x: 0,
y: 0 }; var t = { x: 0,
y: 0 }; var u = { x: 0,
y: 0 };

 try {
          this.addEventListener('touchstart', v, false); this.addEventListener('touchmove', w, false); this.addEventListener('touchend', x, false); this.addEventListener('touchcancel', y, false);
        } catch (E) {}
      });
    };
  })(jQuery);
})();
// //////////////////////////////

// //////////////////////////////
// fastclick.min.js
// //////////////////////////////
(function () {
  (function () {
    function e(a, b) {
      function c(a, b) {
        return function () {
          return a.apply(b, arguments);
        };
      } var d;

 b = b || {}; this.trackingClick = !1; this.trackingClickStart = 0; this.targetElement = null; this.lastTouchIdentifier = this.touchStartY = this.touchStartX = 0; this.touchBoundary = b.touchBoundary || 10; this.layer = a; this.tapDelay = b.tapDelay || 200; this.tapTimeout = b.tapTimeout || 700; if (!e.notNeeded(a)) {
        for (var f = 'onMouse onClick onTouchStart onTouchMove onTouchEnd onTouchCancel'.split(' '), h = 0, k = f.length; h < k; h++) {
          this[f[h]] = c(
this[f[h]],
            this
);
        } g && (a.addEventListener('mouseover', this.onMouse, !0), a.addEventListener('mousedown', this.onMouse, !0), a.addEventListener('mouseup', this.onMouse, !0)); a.addEventListener('click', this.onClick, !0); a.addEventListener('touchstart', this.onTouchStart, !1); a.addEventListener('touchmove', this.onTouchMove, !1); a.addEventListener('touchend', this.onTouchEnd, !1); a.addEventListener('touchcancel', this.onTouchCancel, !1); Event.prototype.stopImmediatePropagation || (a.removeEventListener = function (b, c, d) {
          var e = Node.prototype.removeEventListener;

          b === 'click' ? e.call(a, b, c.hijacked || c, d) : e.call(a, b, c, d);
        }, a.addEventListener = function (b, c, d) {
          var e = Node.prototype.addEventListener;

 b === 'click' ? e.call(a, b, c.hijacked || (c.hijacked = function (a) {
            a.propagationStopped || c(a);
          }), d) : e.call(a, b, c, d);
        }); typeof a.onclick === 'function' && (d = a.onclick, a.addEventListener('click', function (a) {
          d(a);
        }, !1), a.onclick = null);
      }
    } var k = navigator.userAgent.indexOf('Windows Phone') >= 0, g = navigator.userAgent.indexOf('Android') > 0 && !k, f = /iP(ad|hone|od)/.test(navigator.userAgent) && !k, l =
f && /OS 4_\d(_\d)?/.test(navigator.userAgent), m = f && /OS [6-7]_\d/.test(navigator.userAgent), n = navigator.userAgent.indexOf('BB10') > 0;

 e.prototype.needsClick = function (a) {
      switch (a.nodeName.toLowerCase()) {
        case 'button': case 'select': case 'textarea': if (a.disabled) {
          return !0;
        } break; case 'input': if (f && a.type === 'file' || a.disabled) {
          return !0;
        } break; case 'label': case 'iframe': case 'video': return !0;
      }

 return /\bneedsclick\b/.test(a.className);
    }; e.prototype.needsFocus = function (a) {
      switch (a.nodeName.toLowerCase()) {
        case 'textarea': return !0;
        case 'select': return !g; case 'input': switch (a.type) {
          case 'button': case 'checkbox': case 'file': case 'image': case 'radio': case 'submit': return !1;
        }

 return !a.disabled && !a.readOnly; default: return /\bneedsfocus\b/.test(a.className);
      }
    }; e.prototype.sendClick = function (a, b) {
      var c, d;

 document.activeElement && document.activeElement !== a && document.activeElement.blur(); d = b.changedTouches[0]; c = document.createEvent('MouseEvents'); c.initMouseEvent(
this.determineEventType(a), 
!0, 
!0, 
window, 
1, 
d.screenX, 
d.screenY, 
d.clientX, 
d.clientY,
        !1, 
!1, 
!1, 
!1, 
0, 
null
); c.forwardedTouchEvent = !0; a.dispatchEvent(c);
    }; e.prototype.determineEventType = function (a) {
      return g && a.tagName.toLowerCase() === 'select' ? 'mousedown' : 'click';
    }; e.prototype.focus = function (a) {
      var b;

 f && a.setSelectionRange && a.type.indexOf('date') !== 0 && a.type !== 'time' && a.type !== 'month' ? (b = a.value.length, a.setSelectionRange(b, b)) : a.focus();
    }; e.prototype.updateScrollParent = function (a) {
      var b, c;

 b = a.fastClickScrollParent; if (!b || !b.contains(a)) {
        c = a; do {
          if (c.scrollHeight > c.offsetHeight) {
            b = c; a.fastClickScrollParent =
c; break;
          }c = c.parentElement;
        } while (c);
      }b && (b.fastClickLastScrollTop = b.scrollTop);
    }; e.prototype.getTargetElementFromEventTarget = function (a) {
      return a.nodeType === Node.TEXT_NODE ? a.parentNode : a;
    }; e.prototype.onTouchStart = function (a) {
      var b, c, d;

 if (a.targetTouches.length > 1) {
        return !0;
      } b = this.getTargetElementFromEventTarget(a.target); c = a.targetTouches[0]; if (f) {
        d = window.getSelection(); if (d.rangeCount && !d.isCollapsed) {
          return !0;
        } if (!l) {
          if (c.identifier && c.identifier === this.lastTouchIdentifier) {
            return a.preventDefault(), !1;
          }
          this.lastTouchIdentifier = c.identifier; this.updateScrollParent(b);
        }
      } this.trackingClick = !0; this.trackingClickStart = a.timeStamp; this.targetElement = b; this.touchStartX = c.pageX; this.touchStartY = c.pageY; a.timeStamp - this.lastClickTime < this.tapDelay && a.preventDefault();

 return !0;
    }; e.prototype.touchHasMoved = function (a) {
      a = a.changedTouches[0]; var b = this.touchBoundary;

 return Math.abs(a.pageX - this.touchStartX) > b || Math.abs(a.pageY - this.touchStartY) > b ? !0 : !1;
    }; e.prototype.onTouchMove = function (a) {
      if (!this.trackingClick) {
        return !0;
      }
      if (this.targetElement !== this.getTargetElementFromEventTarget(a.target) || this.touchHasMoved(a)) {
        this.trackingClick = !1, this.targetElement = null;
      }

 return !0;
    }; e.prototype.findControl = function (a) {
      return void 0 !== a.control ? a.control : a.htmlFor ? document.getElementById(a.htmlFor) : a.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
    }; e.prototype.onTouchEnd = function (a) {
      var b, c, d = this.targetElement;

 if (!this.trackingClick) {
        return !0;
      } if (a.timeStamp - this.lastClickTime <
this.tapDelay) {
        return this.cancelNextClick = !0;
      } if (a.timeStamp - this.trackingClickStart > this.tapTimeout) {
        return !0;
      } this.cancelNextClick = !1; this.lastClickTime = a.timeStamp; b = this.trackingClickStart; this.trackingClick = !1; this.trackingClickStart = 0; m && (c = a.changedTouches[0], d = document.elementFromPoint(c.pageX - window.pageXOffset, c.pageY - window.pageYOffset) || d, d.fastClickScrollParent = this.targetElement.fastClickScrollParent); c = d.tagName.toLowerCase(); if (c === 'label') {
        if (b = this.findControl(d)) {
          this.focus(d); if (g) {
            return !1;
          }
          d = b;
        }
      } else if (this.needsFocus(d)) {
        if (a.timeStamp - b > 100 || f && window.top !== window && c === 'input') {
          return this.targetElement = null, !1;
        } this.focus(d); this.sendClick(d, a); f && c === 'select' || (this.targetElement = null, a.preventDefault());

 return !1;
      } if (f && !l && (b = d.fastClickScrollParent) && b.fastClickLastScrollTop !== b.scrollTop) {
        return !0;
      } this.needsClick(d) || (a.preventDefault(), this.sendClick(d, a));

 return !1;
    }; e.prototype.onTouchCancel = function () {
      this.trackingClick = !1; this.targetElement = null;
    }; e.prototype.onMouse = function (a) {
      return this.targetElement &&
!a.forwardedTouchEvent && a.cancelable ? !this.needsClick(this.targetElement) || this.cancelNextClick ? (a.stopImmediatePropagation ? a.stopImmediatePropagation() : a.propagationStopped = !0, a.stopPropagation(), a.preventDefault(), !1) : !0 : !0;
    }; e.prototype.onClick = function (a) {
      if (this.trackingClick) {
        return this.targetElement = null, this.trackingClick = !1, !0;
      } if (a.target.type === 'submit' && a.detail === 0) {
        return !0;
      } a = this.onMouse(a); a || (this.targetElement = null);

 return a;
    }; e.prototype.destroy = function () {
      var a = this.layer;

 g && (a.removeEventListener(
'mouseover',
        this.onMouse,
!0
), a.removeEventListener('mousedown', this.onMouse, !0), a.removeEventListener('mouseup', this.onMouse, !0)); a.removeEventListener('click', this.onClick, !0); a.removeEventListener('touchstart', this.onTouchStart, !1); a.removeEventListener('touchmove', this.onTouchMove, !1); a.removeEventListener('touchend', this.onTouchEnd, !1); a.removeEventListener('touchcancel', this.onTouchCancel, !1);
    }; e.notNeeded = function (a) {
      var b, c;

 if (typeof window.ontouchstart === 'undefined') {
        return !0;
      } if (c = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) ||
[, 0])[1]) {
        if (g) {
          if ((b = document.querySelector('meta[name=viewport]')) && (b.content.indexOf('user-scalable=no') !== -1 || c > 31 && document.documentElement.scrollWidth <= window.outerWidth)) {
            return !0;
          }
        } else {
          return !0;
        }
      }

 return n && (b = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/), b[1] >= 10 && b[2] >= 3 && (b = document.querySelector('meta[name=viewport]')) && (b.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) || a.style.msTouchAction === 'none' || a.style.touchAction === 'manipulation' ||
+(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1] >= 27 && (b = document.querySelector('meta[name=viewport]')) && (b.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth) ? !0 : a.style.touchAction === 'none' || a.style.touchAction === 'manipulation' ? !0 : !1;
    }; e.attach = function (a, b) {
      return new e(a, b);
    }; typeof define === 'function' && typeof define.amd === 'object' && define.amd ? define(function () {
      return e;
    }) : typeof module !== 'undefined' && module.exports ? (module.exports = e.attach,
    module.exports.FastClick = e) : window.FastClick = e;
  })();
})();
// //////////////////////////////

// //////////////////////////////
// spin.min.js
// //////////////////////////////
(function () {
// fgnass.github.com/spin.js#v2.0.1
  !function (a, b) {
    typeof exports == 'object' ? module.exports = b() : typeof define == 'function' && define.amd ? define(b) : a.Spinner = b();
  }(this, function () {
    'use strict';

 function a(a, b) {
      var c, d = document.createElement(a || 'div');

 for (c in b) {
        d[c] = b[c];
      }

 return d;
    } function b(a) {
      for (var b = 1, c = arguments.length; c > b; b++) {
        a.appendChild(arguments[b]);
      }

 return a;
    } function c(a, b, c, d) {
      var e = ['opacity', b, ~~(100 * a), c, d].join('-'), f = .01 + c / d * 100, g = Math.max(1 - (1 - a) / b * (100 - f), a), h = j.substring(0, j.indexOf('Animation')).toLowerCase(), i = h && '-' + h + '-' || '';

 return l[e] || (m.insertRule('@' + i + 'keyframes ' + e + '{0%{opacity:' + g + '}' + f + '%{opacity:' + a + '}' + (f + .01) + '%{opacity:1}' + (f + b) % 100 + '%{opacity:' + a + '}100%{opacity:' + g + '}}', m.cssRules.length), l[e] = 1), e;
    } function d(a, b) {
      var c, d, e = a.style;

 for (b = b.charAt(0).toUpperCase() + b.slice(1), d = 0; d < k.length; d++) {
        if (c = k[d] + b, void 0 !== e[c]) {
          return c;
        }
      }

 return void 0 !== e[b] ? b : void 0;
    } function e(a, b) {
      for (var c in b) {
        a.style[d(a, c) || c] = b[c];
      }

 return a;
    } function f(a) {
      for (var b = 1; b < arguments.length; b++) {
        var c = arguments[b];

 for (var d in c) {
          void 0 === a[d] && (a[d] = c[d]);
        }
      }

 return a;
    } function g(a, b) {
      return typeof a == 'string' ? a : a[b % a.length];
    } function h(a) {
      this.opts = f(a || {}, h.defaults, n);
    } function i() {
      function c(b, c) {
        return a('<' + b + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', c);
      }m.addRule('.spin-vml', 'behavior:url(#default#VML)'), h.prototype.lines = function (a, d) {
        function f() {
          return e(c('group', { coordsize: k + ' ' + k,
coordorigin: -j + ' ' + -j }), { width: k,
height: k });
        } function h(a, h, i) {
          b(m, b(e(f(), { rotation: 360 / d.lines * a + 'deg',
left: ~~h }), b(e(c('roundrect', { arcsize: d.corners }), {
width: j,
height: d.width,
left: d.radius,
top: -d.width >> 1,
filter: i
}), c('fill', { color: g(d.color, a),
opacity: d.opacity }), c('stroke', { opacity: 0 }))));
        } var i, j = d.length + d.width, k = 2 * j, l = 2 * -(d.width + d.length) + 'px', m = e(f(), { position: 'absolute',
top: l,
left: l });

 if (d.shadow) {
          for (i = 1; i <= d.lines; i++) {
            h(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)');
          }
        } for (i = 1; i <= d.lines; i++) {
          h(i);
        }

 return b(a, m);
      }, h.prototype.opacity = function (a, b, c, d) {
        var e = a.firstChild;

 d = d.shadow && d.lines || 0, e && b + d < e.childNodes.length && (e = e.childNodes[b + d], e = e && e.firstChild, e = e && e.firstChild, e && (e.opacity = c));
      };
    } var j, k = ['webkit', 'Moz', 'ms', 'O'], l = {}, m = function () {
        var c = a('style', { type: 'text/css' });

 return b(document.getElementsByTagName('head')[0], c), c.sheet || c.styleSheet;
      }(), n = {
lines: 12,
length: 7,
width: 5,
radius: 10,
rotate: 0,
corners: 1,
color: '#000',
direction: 1,
speed: 1,
trail: 100,
opacity: .25,
fps: 20,
zIndex: 2e9,
className: 'spinner',
top: '50%',
left: '50%',
position: 'absolute'
};

 h.defaults = {}, f(h.prototype, {
spin: function (b) {
      this.stop(); { var c = this, d = c.opts, f = c.el = e(a(0, { className: d.className }), { position: d.position,
width: 0,
zIndex: d.zIndex });

 d.radius + d.length + d.width } if (e(f, { left: d.left,
top: d.top }), b && b.insertBefore(f, b.firstChild || null), f.setAttribute('role', 'progressbar'), c.lines(f, c.opts), !j) {
        var g, h = 0, i = (d.lines - 1) * (1 - d.direction) / 2, k = d.fps, l = k / d.speed, m = (1 - d.opacity) / (l * d.trail / 100), n = l / d.lines;

 !function o() {
          h++; for (var a = 0; a < d.lines; a++) {
            g = Math.max(1 - (h + (d.lines - a) * n) % l * m, d.opacity), c.opacity(f, a * d.direction + i, g, d);
          }c.timeout = c.el && setTimeout(o, ~~(1e3 / k));
        }();
      }

 return c;
    },
stop: function () {
      var a = this.el;

 return a && (clearTimeout(this.timeout), a.parentNode && a.parentNode.removeChild(a), this.el = void 0), this;
    },
lines: function (d, f) {
      function h(b, c) {
        return e(a(), {
position: 'absolute',
width: f.length + f.width + 'px',
height: f.width + 'px',
background: b,
boxShadow: c,
transformOrigin: 'left',
transform: 'rotate(' + ~~(360 / f.lines * k + f.rotate) + 'deg) translate(' + f.radius + 'px,0)',
borderRadius: (f.corners * f.width >> 1) + 'px'
});
      } for (var i, k = 0, l = (f.lines - 1) * (1 - f.direction) / 2; k < f.lines; k++) {
        i = e(a(), {
position: 'absolute',
top: 1 + ~(f.width / 2) + 'px',
transform: f.hwaccel ? 'translate3d(0,0,0)' : '',
opacity: f.opacity,
animation: j && c(f.opacity, f.trail, l + k * f.direction, f.lines) + ' ' + 1 / f.speed + 's linear infinite'
}), f.shadow && b(i, e(h('#000', '0 0 4px #000'), { top: '2px' })), b(d, b(i, h(g(f.color, k), '0 0 1px rgba(0,0,0,.1)')));
      }

 return d;
    },
opacity: function (a, b, c) {
      b < a.childNodes.length && (a.childNodes[b].style.opacity = c);
    }
}); var o = e(a('group'), { behavior: 'url(#default#VML)' });

 return !d(o, 'transform') && o.adj ? i() : j = d(o, 'animation'), h;
  });
})();
// //////////////////////////////

// //////////////////////////////
// ext.js
// //////////////////////////////
// (function () {
{
/**
*  console.log - Fallback for Firefox and IE
*/
  /*
if (typeof console !== 'object') {
	var console = { log: function(x) {
		if (window.location.search === '?debug') alert(x);
	} };
}
*/

  /**
* string.lpad - String left padding method
* Credit: http://sajjadhossain.com/2008/10/31/javascript-string-trimming-and-padding/
*/
  String.prototype.lpad = function (padString, length) {
    var str = this;

    while (str.length < length) {
      str = padString + str;
    }

    return str;
  };

  /**
* string.rpad - String right padding method
* Credit: http://sajjadhossain.com/2008/10/31/javascript-string-trimming-and-padding/
*/
  String.prototype.rpad = function (padString, length) {
    var str = this;

    while (str.length < length) {
      str = str + padString;
    }

    return str;
  };

  /**
* timeFormat - Format seconds into 00:00 format
*/
  function timeFormat(num) {
    num = num.toFixed(0);
    var seconds = num % 60;
    var minutes = parseInt(num / 60);

    return minutes.toString().lpad('0', 2) + ' : ' + seconds.toString().lpad('0', 2);
  }

  // Get size of object
  // example: Object.size(myObject)
  Object.size = function (obj) {
    var size = 0, key;

    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        size++;
      }
    }

    return size;
  };

  // Drop a cookie with a name, value stored in it, and duration in days it should last
  function setCookie(name, value, days) {
    if (days) {
      var date = new Date();

      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = '; expires=' + date.toGMTString();
    } else {
      var expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  // Gets a cookie by name
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }

    return null;
  }

  // Deletes a cookie by name
  function deleteCookie(name) {
    setCookie(name, '', -1);
  }

  // Simple timer class 
  function Timer() {
    var d = new Date();

    this.current_time = this.start_time = d.getTime();
    this.now = function () {
      this.current_time = d.getTime() / 1000;
      var now_time = Math.round((this.start_time - new Date().getTime()) / 1000);

      return now_time;
    };
  }

  /*
 * Source : http://sroucheray.org/blog/2009/11/array-sort-should-not-be-used-to-shuffle-an-array/
 * Add a shuffle function to Array object prototype
 * Usage : 
 *  var tmpArray = ["a", "b", "c", "d", "e"];
 *  tmpArray.shuffle();
 */
  Array.prototype.shuffle = function () {
    var i = this.length, j, temp;

    if (i == 0) {
      return;
    }
    while (--i) {
      j = Math.floor(Math.random() * (i + 1));
      temp = this[i];
      this[i] = this[j];
      this[j] = temp;
    }
  };
}
// })();
// //////////////////////////////

// //////////////////////////////
// jquery.ext.js
// //////////////////////////////
(function () {
  var EXT_ROLLOVERS = [];

  (function ($) {
    'use strict';

    /**
	Avoid opacity issues using animateSafe (somewhat intelligent)
	
	@method animateSafe
	@param {Object} properties A set of properties that will be passed to $.animate
	@param {Integer} [duration = 400] Sets the duration of the animation
	@param {String} [easing] Sets the type of easing that will be passed to $.animate
	@param {Function} [complete] Sets the function to be called when everything is complete
	@return {Object} jQuery Object
	@chainable
	**/
    $.fn.animateSafe = function (properties, duration, easing, complete) {
      var delay = 400;

      if (typeof this[0] !== 'object') {
        return;
      }
      // Non-native opacity support
      if (typeof properties.opacity !== 'undefined' && !$.support.opacity) {
        // Fade In: Show immediately
        if (properties.opacity > 0) {
          this.show(0).css('filter', '0');

          // Fade Out: Hide after delay
        } else {
          // Delay
          if (typeof duration === 'number') {
            delay = duration;
          } else if (typeof duration === 'object' && typeof duration.duration === 'number') {
            delay = duration.duration;
          }

          var $this = this;

          setTimeout(function () {
            $this.hide(0);
          }, delay);
        }

        delete properties.opacity;
      }

      return this.animate(properties, duration, easing, complete);
    };

    /**
	Simple cascading fading function
		$('div.sections, div.content').cascade({duration: 500, delay: 1000}, callback);
		
	For executing in absolute order
		$(['div.sections', 'div.content']).cascade({duration: 500, delay: 1000}, callback);
	
	@method cascade
	@param {Object} [options] A set of options to control cascading
		@param {Integer} [duration = 600] Sets the duration of fade
		@param {Integer} [initialDelay = 0] Sets delay before fade begins
		@param {Integer} [delay = 500] Sets delay between Elements being faded
		@param {Function} [callback = @param callback] Sets function to called after last element is faded
		@param {String} [type = fadeIn] Sets the type of fade that will be used
		@param {Function} [step = undefined] Sets a function to be called for each element after its done faded
		@param {Boolean} [stop = false] If 'true' will remove any setTimouts for the element and stop animations and return
	@param {Function} [callback] Sets the function to be called when everything is complete
	@return {Object} jQuery Object
	@chainable
	**/
    $.fn.cascade = function (options, callback) {
      // Begins Transition into Effects
      // *must use function because of callback scope issue where it passes a reference instead of a copy
      function transition($element, options, delay, callback) {
        // setTimeout must be used due to a jQuery bug // fadeout wont work properly without it in IE
        $element.data('cascade').push(setTimeout(function () {
          // Types of Effect
          switch (options['type']) {
            case 'fadeOut':
            case 'fadeOutSafe':
              $element.fadeOutSafe(options['duration'], callback);
              break;

            case 'fadeIn':
            case 'fadeInSafe':
              $element.fadeInSafe(options['duration'], callback);
              break;
          }
        }, delay));
      }

      var size = this.length - 1;
      var default_options = {
        'duration': 600,
        'initialDelay': 0,
        'delay': 500,
        'callback': callback,
        'type': 'fadeIn',
        'step': undefined,
        'stop': false
      };

      var o = $.extend({}, default_options, options);

      // Merge Step function and Callback
      if (typeof o['step'] === 'function') {
        var temp_callback = o['callback'];

        o['callback'] = function () {
          o['step'].apply(this);
          if (typeof temp_callback === 'function') {
            temp_callback.apply(this);
          }
        };
      }

      // Iterate over selected elements
      return this.each(function (n, value) {
        var selector, delay;

        // Check if Absolute order
        selector = typeof value === 'string' ? $(value) : $(this);

        // Check against invalid Selectors			
        if (typeof selector[0] !== 'object') {
          return;
        }

        // Stop animations and remove timeouts
        if (o['stop']) {
          // Check for preempted use of stop 
          if (!selector.data('cascade')) {
            return;
          }

          $.each(selector.data('cascade'), function (i, value) {
            clearTimeout(value);
          });
          selector.data('cascade', []);
          selector.stop(true, true);

          return;
        }

        // Create an array for timeouts if does not exist already
        if (!selector.data('cascade')) {
          selector.data('cascade', []);
        }

        // Set delay
        delay = o['delay'] * n + o['initialDelay'];

        // Last element executes callback
        if (n === size) {
          transition(selector, o, delay, o['callback']);
        } else {
          transition(selector, o, delay, o['step']);
        }
      });
    };

    // Similar to cascade but very basic and different behavior
    // All elements fadein/out simultaneusly with different fade durations instead of delays between fadein/out calls
    $.fn.flow = function (options) {
      var default_options = {
        initialDelay: 1,
        base: 500,
        rate: 50,
        action: 'fadeIn',
        callback: function () {}
      };

      var o = $.extend({}, default_options, options);

      return this.each(function (n, value) {
        // Check if Absolute order
        var selector = typeof value === 'string' ? $(value) : $(this),
            len = selector.length;

        if (o['action'] === 'fadeIn') {
          if (n + 1 === len) {
            setTimeout(function () {
              selector.fadeInSafe(o['base'] + o['rate'] * (n + 1), o.callback);
            }, o['initialDelay']);
          } else {
            setTimeout(function () {
              selector.fadeInSafe(o['base'] + o['rate'] * (n + 1));
            }, o['initialDelay']);
          }
        } else {
          if (n + 1 === len) {
            setTimeout(function () {
              selector.fadeOutSafe(o['base'] + o['rate'] * (n + 1), o.callback);
            }, o['initialDelay']);
          } else {
            setTimeout(function () {
              selector.fadeOutSafe(o['base'] + o['rate'] * (n + 1));
            }, o['initialDelay']);
          }
        }
      });
    };

    /**
	center - center object on screen
	
	@method center
	@return {Object} jQuery Object
	**/
    $.fn.center = function () {
      return this.each(function () {
        var top = ($(window).height() - this.outerHeight()) / 2;
        var left = ($(window).width() - this.outerWidth()) / 2;

        this.css({
 'position': 'fixed',
'margin': 0,
'top': (top > 0 ? top : 0) + 'px',
'left': (left > 0 ? left : 0) + 'px' 
});
      });
    };

    /**
	createMask - create a mask to insert before an object

	@method createMask
	@param {Object} [options] A set of options to control createMask
		@param {String} [id = ''] Sets ID that will be assigned to the mask element
		@param {String} [class = ''] Sets the CLASS that will be assigned to the mask element
		@param {String} [z-index = 'auto'] Sets the z-index for this element
		@param {String} [parent = ''] Sets parent element of this element
		@param {Object} [css = ''] Sets CSS that will be assigned to the mask
	@return {Object} Returns the Mask element
	**/
    $.fn.createMask = function (options) {
      var defaults = {
        'id': '',
        'class': '',
        'z-index': 'auto',
        'parent': '',
        'css': '',
        'onClick': function () {}
      };

      // Merge options in with defaults
      $.extend(defaults, options);

      if (defaults['class'] !== '') {
        defaults['class'] = ' ' + defaults['class'];
      }

      // Create new mask element
      var new_mask = $('<div class="dynamic_mask' + defaults['class'] + '" id="' + defaults['id'] + '"></div>');

      new_mask.click(defaults.onClick);

      // Positioning parent passed in or not
      if (defaults['parent'] !== '') {
        // Add it before the current element
        $(defaults['parent']).before(new_mask);
      } else {
        this.before(new_mask);
      }

      if (defaults['css'] !== '') {
        new_mask.css(defaults['css']);
      }

      this.css('z-index', defaults['z-index']);

      // Add custom class with the same z-index as selector
      new_mask.css('z-index', parseInt(this.css('z-index'), 10) - 1);

      // Save mask to data of selector
      return this.data('mask', new_mask);
    };

    // 

    /**
	Simple crossfade function for two elements
		$('div.current').crossfade({ 'target' : $('div.new'), 'duration' : 1000);
	
	For different durations, fade in at 1000 and fade out at 500
		Usage $('div.current').crossfade({ 'target' : $('div.new'), 'fadeIn' : 1000, 'fadeOut' : 500);
	
	@method crossFade
	@param {Object} [options] A set of options to control crossFade
		@param {Object} [target = ''] Sets the element that will be faded in
		@param {Integer} [duration = ''] If not omitted, duration of both elements in the crossfade will be set to this
		@param {Integer} [delay = 0] Sets delay before fade begins on target only
		@param {Function} [callback = @param callback] A function to be called when everything is complete
		@param {Boolean} [reveal = false] If 'true' target will not fade in, but a reveal effect will be used
		@param {Integer} [fadeIn = 1000] Sets the duration of the fade in for target
		@param {Integer} [fadeOut = 1000] Sets the duration of the fade out for element
	@param {Function} [callback] Sets the function to be called when everything is complete
	@return {Object} jQuery Object
	@chainable
	**/
    $.fn.crossFade = function (options, callback) {
      var default_options = {
        'target': '',
        'duration': '',
        'delay': 0,
        'callback': callback,
        'reveal': false,
        'fadeIn': 1000,
        'fadeOut': 1000
      };

      var o = $.extend({}, default_options, options);
      var callback_delay = 0;

      // Checks
      if (o['target'] === '') {
        return this;
      }
      if (o['duration'] !== '') {
        o['fadeOut'] = o['fadeIn'] = o['duration'];
      }
      if (o['reveal']) {
        o['fadeIn'] = 0;
      }

      // Fade in target element
      $(o['target']).delay(o['delay']).fadeInSafe(o['fadeIn']);

      // Fade out selected element
      this.fadeOutSafe(o['fadeOut']);

      // Callback
      if (typeof o['callback'] === 'function') {
        callback_delay += o['fadeOut'] > (o['fadeIn'] + o['delay']) ? o['fadeOut'] : o['fadeIn'] + o['delay'];
        setTimeout(function () {
          o['callback']();
        }, callback_delay);
      }

      // Return jQuery selection
      return this;
    };

    /**
	fadeInSafe - Calls show() instead of fadeIn() if native opacity is not supported
	
	@method fadeInSafe
	@param {Integer} duration Sets the duration of the fade
	@param {Function} [complete] Sets the function to be called when everything is complete
	@return {Object} jQuery Object
	@chainable
	**/
    $.fn.fadeInSafe = function (duration, callback) {
      if ($.support.opacity) {
        return this.fadeIn(duration, callback);
      } else {
        return this.delay(duration).show(0, callback);
      }
    };

    /**
	fadeOutSafe - Calls hide() instead of fadeOut() if native opacity is not supported
	
	@method fadeOutSafe
	@param {Integer} duration Sets the duration of the fade
	@param {Function} [complete] Sets the function to be called when everything is complete
	@return {Object} jQuery Object
	@chainable
	**/
    $.fn.fadeOutSafe = function (duration, callback) {
      if ($.support.opacity) {
        return this.fadeOut(duration, callback);
      } else {
        return this.delay(duration).hide(0, callback);
      }
    };

    /**
	Checks if an element is in view based on a %'age of it viewable
	
	Example Usage:
		if ($('#target').inView(50)) $('#target').fadeOut(); // Fadeout target if out of view

	@method inView
	@param {Double} percentage
	@return {Boolean} returns 'true' if element is in view, otherwise returns false
	**/
    /* $.fn.inView = function (percentage) {
		
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();
		var elemTop = this.offset().top;
		var elemBottom = elemTop + this.height();
		
		var topInView = elemTop <= docViewBottom && elemTop >= docViewTop;
		var bottomInView = elemBottom >= docViewTop && elemBottom <= docViewBottom;
		if (topInView || bottomInView) {
			if (typeof percentage === 'number') {
				// Top portion of element visible
				if (topInView) {
					if (((docViewBottom - elemTop) / (elemBottom - elemTop)) * 100 >= percentage) return true; else return false;
				// Bottom portion of element visible
				} else {
					if (((elemBottom - docViewTop) / (elemBottom - elemTop)) * 100 >= percentage) return true; else return false;
				}
			} else {
				return true;
			}
		} else {
			// Not in view
			return false;
		}
	};*/

    $.fn.inView = function (percentage) {
      var _window = $(window).height() + $(window).scrollTop();
      var _object = this.height() + this.offset().top;

      // Object completely above or below view fold
      if (this.offset().top > _window) {
        return false;
      }
      if (_object < $(window).scrollTop()) {
        return false;
      }
      // Object in view and view %'age calculated off the larger of the two values
      if (_window > _object) {
        return (_object / _window) >= (percentage / 100) ? true : false;
      } else {
        return (_window / _object) >= (percentage / 100) ? true : false;
      }
    };

    /**
	Shuffle - shuffle the children of a selected element
		$(ul#main_list).shuffle()
	
	@method shuffle
	@param {String} [f = ''] Sets the type of filter that will be used to determine elements that should be shuffled
	**/
    $.fn.shuffle = function (f) {
      var filter = typeof f === 'undefined' ? '' : f;
      var selector = this;
      var len = this.children().length - 1;

      this.children(filter).each(function () {
        var rand = Math.floor(Math.random() * len);

        selector.children(':eq(' + rand + ')').after($(this).clone(true));
        $(this).remove();
      });
    };

    /**
	Complex rollover behaviors through simple interface
	
	Example Usage:
	Basic - $('#target').rollover('#popup'); // Default behavior : fade in popup with a 250 duration
	Custom - $('#target').rollover({onEnterHook : function() { $('#popup').show(); }); // popup shows immediately on mouseover
	
	@method rollover
	@param {String} [target]
	@param {Object} [c] A set of options to control rollover
		@param {Object} [target = '']
		@param {Function} [onEnter]
		@param {Function} [onEnterHook]
		@param {Function} [onLeave]
		@param {Function} [onLeaveHook]
		@param {Function} [timeout] 
		@param {Integer} [time = 500]
		@param {String} [group = 'global']
		@param {String} [children = '']
	**/
    $.fn.rollover = function (target, c) {
      // Rollover helpers ( mainly used for timeout variable storage )
      var rollover_variables = {};

      if (typeof target !== 'string') {
        c = target;
      }
      // Default actions
      var config = {
        onEnter: function () {
          jQuery(target).stop(true, true).fadeInSafe(250, false);
        },
        onEnterHook: function () {},
        onLeave: function () {
          jQuery(target).stop(true, true).fadeOutSafe(250, false);
        },
        onLeaveHook: function () {},
        timeout: function () {},
        time: 500,
        initialDelay: 1,
        leaveDelay: 1,
        toggleClass: '',
        click: false,
        group: 'global',
        children: ''
      };

      // Merge custom config into defaults
      jQuery.extend(config, c);

      var preserve = this;

      // Mouseleave trigger function
      this.bind('close', function (e, triggered) {
        if (config.children === '' || typeof triggered !== 'undefined') {
          rollover_variables['leaveDelay'] = setTimeout(function () {
            config.onLeaveHook();
            config.onLeave();
            preserve.removeClass(config.toggleClass);
          }, config.leaveDelay);
        } else {
          // If we have children extend a grace period before closing
          rollover_variables['grace'] = setTimeout(function () {
            config.onLeave();
            config.onLeaveHook();
            preserve.removeClass(config.toggleClass);
          }, 150);
          // If we naturally mouseout of this object for a set amount of time we trigger a callback
          rollover_variables[config.group] = setTimeout(config.timeout, config.time);
        }
      });
      // If click is true bind the onEnter/onEnterHook/toggleClass
      if (config.click === true) {
        this.click(function () {
          // Add toggle class
          jQuery(this).addClass(config.toggleClass);
          config.onEnterHook();
          // Trigger on enter func
          config.onEnter();

          return false;
        });
      }
      // Mouse Enter
      this.mouseenter(function () {
        // Force close other rollover states in this group
        jQuery.each(EXT_ROLLOVERS, function (key, val) {
          if (typeof val[config.group] !== 'undefined') {
            if (val[config.group] !== preserve) {
              jQuery(val[config.group]).trigger('close', true);
            }
          }
        });
        clearTimeout(rollover_variables[config.group]);
        clearTimeout(rollover_variables['grace']);
        clearTimeout(rollover_variables['leaveDelay']);

        // Trigger onEnter after "initialDelay" amount of time
        var subelement = jQuery(this);

        rollover_variables['initial'] = setTimeout(function () {
          // Add toggle class
          subelement.addClass(config.toggleClass);
          config.onEnterHook();
          // Trigger on enter func
          config.onEnter();
        }, config.initialDelay);

        // Mouse Leave
      }).mouseleave(function () {
        clearTimeout(rollover_variables['initial']);
        preserve.trigger('close');
      });
      // Children elements will stop the rollover from disappearing if they are moused over
      if (config.children !== '') {
        jQuery(config.children).mouseenter(function () {
          clearTimeout(rollover_variables[config.group]);
          clearTimeout(rollover_variables['grace']);
        }).mouseleave(function () {
          /* config.onLeaveHook();
				config.onLeave();*/
          // rollover_variables[config.group] = setTimeout(config.timeout, config.time);
        });
      }
      // Add to master rollover list with grouping
      var obj = {};

      obj[config.group] = this;
      EXT_ROLLOVERS.push(obj);

      return this;
    };

    // Simple way to have mouseovers become click events on mobile devices with less hassle
    $.fn.interact = function (c) {
      var config = {
        enter: function () {}, // what should happen on click/mouseenter
        leave: function () {}, // what should happen on subsequent click/mouseleave
        mobile: false, // a passed in boolean to represent if we a re a mobile device or not
        unique: false // jquery selected collection of bound objects that will have leave() called on them if they are not the target
      };

      var o = $.extend({}, config, c);

      $(this).each(function (key, val) {
        var self = $(val);

        // Execute the enter call immediately
        if (typeof c === 'undefined') {
          self.data('mobile') ? self.click() : self.mouseenter();

          return false;
        }

        if (o.mobile) {
          self.click(function () {
            if ($(this).hasClass('active_ext')) {
              $(this).removeClass('active_ext');
              o.leave.apply(self);
            } else {
              $(this).addClass('active_ext');
              o.enter.apply(self);
              if (typeof o.unique === 'object') {
                o.unique.not(self).each(function (key, val) {
                  o.leave.apply($(val));
                });
              }
            }

            return false;
          }).data('mobile', true);
        } else {
          self.mouseenter(function () {
            o.enter.apply(self);
          }).mouseleave(function () {
            o.leave.apply(self);
          });
        }

        return this;
      });
    };

    // Object has a parent matching p selector
    $.fn.hasParent = function (p) {
      return this.parents(p).length > 0 ? true : false;
    };

    // Add class if one does not exist and return success or not
    $.fn.addUniqueClass = function (c) {
      if (this.hasClass(c)) {
        return false;
      }
      this.addClass(c);

      return true;
    };
  })(jQuery);
})();
// //////////////////////////////

// //////////////////////////////
// el.lib.js
// //////////////////////////////
(function () {
  if (typeof el == 'undefined' || typeof el.productView == 'undefined' || typeof el.productView.quickshopById == 'undefined') {
    var el = {
      productView: {
        quickshopById: function () {
          console.log('el.productView.quickshopById()', arguments);
        }
      }
    };
  }

  // MPP START //
  var total_products = 0;
  var mpp_data = {
    'product_count': 1,
    'product_data': '',
    'product_list': '',
    'product_columns': 1,
    'product_rows': 1,
    'current_margin': 0,
    'current_width': 0,
    'product': {
      'height': 320,
      'width': 322
    },
    'callback': ''
  };

  function mpp_calculate_columns(e, firstrun) {
    // Not on estee dev so forget MPP
    if (jQuery('#main_container').length < 1) {
      return false;
    }

    var speed = 1000;

    mpp_data.current_width = jQuery('#main_container').width();

    for (var i = 5; i > 0; i--) {
      if ((i * mpp_data.product.width) < mpp_data.current_width) {
        //				mpp_data.product_rows = Math.ceil(mpp_data.product_count / i);
        mpp_data.product_rows = Math.ceil(total_products / i);

        if (!firstrun) {
          speed = 10;
        }

        mpp_data.product_columns = i * mpp_data.product.width;
        mpp_data.current_margin = (mpp_data.current_width - mpp_data.product_columns) / 2;

        if (firstrun) {
          speed = mpp_data.product_rows * 250;
          // console.log("SPEED : " + speed);
          jQuery('#main_container ul#mpp_product_list').css({ 'width': mpp_data.product_columns,
'margin-left': mpp_data.current_margin });
          jQuery('#main_container ul#mpp_product_list').animate({ 'height': (mpp_data.product_rows * mpp_data.product.height) + 'px' }, speed, function () {
            mpp_init();
          });
        } else {
          jQuery('#main_container ul#mpp_product_list').css({ 'width': mpp_data.product_columns,
'height': (mpp_data.product_rows * mpp_data.product.height) + 'px',
'margin-left': mpp_data.current_margin });
        }
        break;
      }
    }
  }

  // Determine product note via MISC_FLAG property
  function mpp_determine_flag(flag) {
    switch (flag) {
      case 1:
        return 'NEW!';
        break;
      case 2:
        return 'LIMITED EDITION';
        break;
      default:
        return '';
        break;
    }
  }

  // Determine price range of product
  function mpp_determine_price_range(skus) {
    // Sort SKU array by price
    if (skus.length > 1) {
      skus.sort(function (a, b) {
        return a.PRICE - b.PRICE;
      });

      // Check if min = max
      if (skus[0].formattedPrice !== skus[skus.length - 1].formattedPrice) {
        return skus[0].formattedPrice + ' - ' + skus[skus.length - 1].formattedPrice;
      }
    }

    // One item no range
    return skus[0].formattedPrice;
  }

  // Build products
  function mpp_build_products(data) {
    // Grab all product data
    mpp_data.product_data = data[0].result.value.categories[0].products;
    mpp_data.product_list = jQuery('ul#mpp_product_list');

    var product_template = jQuery('.mpp_product.template').hide().clone(true, true).removeClass('template').show();
    var images_all = [];

    // Build individual products
    jQuery.each(mpp_data.product_data, function (key, val) {
      mpp_data.product_count += 1;
      total_products += 1;
      // Clone template
      var product = product_template.clone(true, true);

      // Set main background image
      product.find('img.product_image').attr('src', val.MEDIUM_IMAGE);
      images_all.push(val.MEDIUM_IMAGE);

      // Set product note
      product.find('.mpp_product_note').text(mpp_determine_flag(val.MISC_FLAG));
      // Set product category/line
      product.find('.mpp_product_title_line strong').html(val.PROD_RGN_NAME);
      // Set product name
      product.find('.mpp_product_title_name').html(val.PROD_RGN_SUBHEADING);
      // Set product cost
      product.find('.mpp_product_cost').text(mpp_determine_price_range(val.skus));
      // Build product rating
      if (val.AVERAGE_RATING !== null) {
        product.find('.mpp_product_rating')
          .find('.stars span').addClass('rating_' + val.AVERAGE_RATING.toFixed(1).split('.').join('_'))
          .attr('title', val.AVERAGE_RATING.toFixed(1) + ' Stars')
          .text(val.AVERAGE_RATING.toFixed(1));
        product.find('.mpp_product_rating').find('.mpp_product_rating_reviews').text('(' + val.TOTAL_REVIEW_COUNT + ')');
      }

      // Set product links
      var url = '/product/' + val.PARENT_CAT_ID.replace('CAT', '') + '/' + val.PROD_BASE_ID + '/';

      if (typeof val.skus[0] !== 'undefined') {
        url += val.skus[0].SKU_BASE_ID + '/';
      }
      product.find('a').attr('href', url);
      product.find('a.mpp_product_shopnow').attr('href', val.url);
      product.hide();
      // Add product to list
      mpp_data.product_list.append(product);
    });

    mpp_preload_images(images_all);
  }
  /*
function mpp_setup(mpp_category, callback) {
	// Main query call
	var query = [{
		"method":"prodcat",
		"params":[{
			"categories":[
				mpp_category
			],
			"category_fields":[
				"products",
			],
			"sku_fields":[
				"SKU_BASE_ID",
				"PRICE",
				"formattedPrice"
			],
			"product_fields":[
				"skus",
				"PARENT_CAT_ID",
				"PROD_BASE_ID",
				"PROD_RGN_NAME",
				"PROD_RGN_SUBHEADING",
				"MEDIUM_IMAGE",

				"url",
				'MISC_FLAG',
				'TOTAL_REVIEW_COUNT',
				'AVERAGE_RATING'
			]
		}],
		"id":1
	}];

	// Pull product data in
	formatted_query = JSON.stringify(query);
	// extra formatting hullabaloo for estee browser definitions of JSON.stringify
	if (formatted_query.indexOf('\\') > -1) {
		formatted_query = formatted_query.replace(/\\/g, '');
		formatted_query = formatted_query.replace(/ /g, '');
		formatted_query = formatted_query.replace(/\"\[/g, '[');
		//formatted_query = formatted_query.replace(/\]\"/g, ']');
	}
	jQuery.getJSON('/rpc/response.tmpl?JSONRPC='+formatted_query, mpp_build_products);

	if (typeof callback == 'function') {
		mpp_data.callback = callback;
	}
}
*/

  // preload
  function mpp_preload_images(images_all) {
    if (!jQuery('body').hasClass('app')) {
      jQuery.preload(images_all, {
        'base': '',
        'onRequest': function () {},
        'onComplete': function () {},
        'enforceCache': true,
        'onFinish': function () {
          mpp_calculate_columns(null, true);
        }
      });

      // Preload fallback
      setTimeout(function () {
        mpp_calculate_columns(null, true);
      }, 5000);
    }
  }

  // initialize
  function mpp_init() {
    // console.log('init');
    jQuery('a.product').each(function () {
      var self = this;

      jQuery(this).quicklook({
        product_mouseIn: function () {
          var title = self.title;
          var price = decodeURIComponent(self.hash).split('price=').pop();

          jQuery('#quicklook').find('p').html(title + '<br>' + price);
        },
        quicklook_mouseIn: function () {
          clearTimeout(jQuery('#quicklook').data('quicklook_timeout'));
        }
      });
    });

    jQuery('img.loader').fadeOut(100, function () {
      mpp_data.product_list.find('> *').not('.template').cascade({
        duration: 500,
        delay: 150,
        callback: function () {
          if (typeof mpp_data.callback == 'function') {
            // console.log('callback!');
            tempfunction = mpp_data.callback;
            mpp_data.callback = null;
            tempfunction();
          } else {
            // console.log('load boutique!');
          }
          //				mpp_data.product.height = jQuery("#mpp_product_list li").eq(2).outerHeight();
          //				mpp_data.product.width = jQuery("#mpp_product_list li").eq(2).outerWidth();
        }
      });
    });
    window.onresize = mpp_calculate_columns;
  }
  // MPP END //

  // Check if we're online and set status accordingly
  function check_status() {
    if (!window.navigator.bindLine) {
      jQuery('body').addClass('offline');
    } else {
    }

    if ('standalone' in window.navigator) {
      if (window.navigator.standalone == true) {
        jQuery('body').removeClass('dev').addClass('standalone');
      }
    }
  }
  function load_cached_boutique() {
    jQuery.event.trigger('load_cached_boutique');
  }

  function preload_boutique() {
    jQuery.event.trigger('preload_boutique');
  }

  // jQuery On Ready in no conflict mode
  jQuery(function ($) {
    // App hash?
    var pathArray = window.location.pathname.split('#');

    if (pathArray.length > 1) {
      if (pathArray[1] == 'app') {
        $('body').load('/js/add2home.js');
      }
    }
    /*
	var standalone_status = false;

	// Standalone mode?
	if (window.navigator.standalone == true) {
		standalone_status = false;
	}

	if (!standalone_status) {
		$('body').addClass("offline_toggles");
	}
*/

    // Move title to data attribute to prevent tooltips
    $('a.product').not('.buttonless').each(function () {
      if (typeof this.title !== 'undefined') {
        $(this).data('title', this.title).removeAttr('title');
      }
    });

    // Product Links into Quick Look/*
    if (!($('#quicklook').length > 0)) {
      $('a.product')
        .click(function (e) {
          e.preventDefault();

          /* Assumes the following URL structure:
				["http:",
				"",
				"example.com",
				"product",
				"6370",		// Category UD
				"4595",		// Product ID
				"ABCD",		// SKU ID (Optional)
				""]
			*/

          var pathname = this.pathname;

          if (pathname.charAt(0) != '/') {
            pathname = '/' + pathname;
          }
          var parts = pathname.split('/');
          var ql_cat = parts[2] ? 'CAT' + parts[2] : '';
          var ql_prod = parts[3] ? 'PROD' + parts[3] : '';
          var ql_sku = parts[4] ? 'SKU' + parts[4] : null;

          el.productView.quickshopById(ql_cat, ql_prod, [], undefined, ql_sku);
        })
        .not('.buttonless').each(function () {
          var product = $(this);
          var width = product.width();
          var height = product.height();
          var left = 0;
          var top = 0;

          if (width < 88) {
            width = 88;
            left = (width - product.width()) / 2;
          }
          if (height < 22) {
            height = 22;
            top = (height - product.height()) / 2;
          }
          product.append('<span class="quicklook" style="width: ' + width + 'px; height: ' + height + 'px; left: -' + left + 'px; top: -' + top + 'px;">Quick Look</span>');
        });
    }

    $.fn.quicklooks = function (args) {
      // boutique name
      var product_mouseIn = typeof args.product_mouseIn === 'function' ? args.product_mouseIn : function () {
        return true;
      };
      var product_mouseOut = typeof args.product_mouseOut === 'function' ? args.product_mouseOut : function () {
        return true;
      };
      var self = this;
      var pathname = this.pathname;

      if (!($('#quicklook').length > 0)) {
        $('a.product').not('.buttonless').append('<span id="quicklook" class="product">Quick Look</span>');
      }

      var prev = false;

      // Mouse in of product
      this.mouseenter(function () {
        if (prev && prev.data('timeout')) {
          prev.mouseenter();

 return false;
        }

        // Build clone
        prev = $('#quicklook_list .template').hide().clone(true, true).removeClass('template');

        // Mouse in and out of our clone
        prev.mouseenter(function () {
          if (!prev || !prev[0]) {
            return;
          }
          clearTimeout(prev.data('timeout'));
          prev.data('timeout', false);
        }).mouseleave(function () {
          self.mouseleave();
        });

        // Set it up
        prev.find('p em').html(self.data('title'));
        var offsets = typeof self.attr('data-offset') === 'string' ? self.attr('data-offset') : '0 0';

        product_mouseIn.call(prev);
        // Add clone to master list
        $('#quicklook_list').prepend(prev);

        if (jQuery.ui) {
          prev.fadeInSafe(250).position({
            my: 'center center',
            at: 'center center',
            of: self,
            offset: offsets,
            collision: 'none'
          });
        } else {
          console.log('You must include jQuery UI in order to use this function ( .position )');
        }
        // Redefine quick look click
        prev.find('a').unbind('click').click(function () {
          self.click();

 return false;
        });

        // Mouse out of target
      }).mouseleave(function () {
        if (!prev) {
          return;
        }
        prev.data('timeout', setTimeout(function () {
          if (!prev || !prev[0]) {
            return;
          }
          prev.data('timeout', false);
          // Kill clone
          if (prev) {
            prev.fadeOutSafe(250, (function (p) {
              return function () {
                p.remove();
              };
            })(prev));
          }
        }, 200));
        product_mouseOut();
      }).click(function (e) {
        e.preventDefault();

        /* Assumes the following URL structure:
				["http:",
				"",
				"example.com",
				"product",
				"6370",		// Category UD
				"4595",		// Product ID
				"ABCD",		// SKU ID (Optional)
				""]
			*/

        var pathname = this.pathname;

        if (pathname.charAt(0) != '/') {
          pathname = '/' + pathname;
        }
        var parts = pathname.split('/');
        var ql_cat = parts[2] ? 'CAT' + parts[2] : '';
        var ql_prod = parts[3] ? 'PROD' + parts[3] : '';
        var ql_sku = parts[4] ? 'SKU' + parts[4] : null;

        el.productView.quickshopById(ql_cat, ql_prod, [], undefined, ql_sku);
      });

      // Setup quicklook data only once
      this.each(function (n) {
        if (n == 0) {
          $(this).quicklook_setup(args);
        }
      });

      return this;
    };

    // Quicklook plugin
    $.fn.quicklook = function (args) {
      // boutique name
      var product_mouseIn = typeof args.product_mouseIn === 'function' ? args.product_mouseIn : function () {
        return true;
      };
      var product_mouseOut = typeof args.product_mouseOut === 'function' ? args.product_mouseOut : function () {
        return true;
      };
      var self = this;
      var pathname = this.pathname;

      if (!($('#quicklook').length > 0)) {
        $('a.product').not('.buttonless').append('<span id="quicklook" class="product">Quick Look</span>');
      }

      // Mouse in of target
      this.mouseenter(function () {
        clearTimeout($('#quicklook').data('product_timeout'));
        $('#quicklook').addClass('active');
        $('#quicklook p em').html(self.data('title'));
        var offsets = typeof self.attr('data-offset') === 'string' ? self.attr('data-offset') : '0 0';

        product_mouseIn();
        if (jQuery.ui) {
          $('#quicklook').stop(true, true).fadeInSafe(500).position({
            my: 'center center',
            at: 'center center',
            of: self,
            offset: offsets,
            collision: 'none'
          });
        } else {
          console.log('You must include jQuery UI in order to use this function ( .position )');
        }

        // Redefine quick look click
        $('#quicklook a').unbind('click').click(function () {
          self.click();

 return false;
        });

        // Mouse out of target
      }).mouseleave(function () {
        $('#quicklook').removeClass('active');
        $('#quicklook').data('product_timeout', setTimeout(function () {
          if (!$('#quicklook').hasClass('active')) {
            $('#quicklook').fadeOutSafe(400);
          }
        }, 1000));
        product_mouseOut();
      }).click(function (e) {
        e.preventDefault();

        /* Assumes the following URL structure:
				["http:",
				"",
				"example.com",
				"product",
				"6370",		// Category UD
				"4595",		// Product ID
				"ABCD",		// SKU ID (Optional)
				""]
			*/

        var pathname = this.pathname;

        if (pathname.charAt(0) != '/') {
          pathname = '/' + pathname;
        }
        var parts = pathname.split('/');
        var ql_cat = parts[2] ? 'CAT' + parts[2] : '';
        var ql_prod = parts[3] ? 'PROD' + parts[3] : '';
        var ql_sku = parts[4] ? 'SKU' + parts[4] : null;

        el.productView.quickshopById(ql_cat, ql_prod, [], undefined, ql_sku);
      });

      // Setup quicklook data only once
      this.each(function (n) {
        if (n == 0) {
          $(this).quicklook_setup(args);
        }
      });

      return this;
    };

    $.fn.quicklook_setup = function (args) {
      var quicklook_mouseIn = typeof args.quicklook_mouseIn === 'function' ? args.quicklook_mouseIn : function () {
        return true;
      };
      var quicklook_mouseOut = typeof args.quicklook_mouseOut === 'function' ? args.quicklook_mouseOut : function () {
        return true;
      };

      $('#quicklook').mouseenter(function () {
        clearTimeout($(this).data('product_timeout'));
        setTimeout(function () {
          $('#quicklook').addClass('active');
        }, 100);
        quicklook_mouseIn();
      }).mouseleave(function () {
        // setTimeout(function() {$('#quicklook').removeClass('active');}, 250);
        $('#quicklook').removeClass('active');
        $('#quicklook').data('product_timeout', setTimeout(function () {
          if (!$('#quicklook').hasClass('active')) {
            $('#quicklook').fadeOutSafe(150);
          }
        }, 1000));
        quicklook_mouseOut();
      });
    };
  });
})();
// //////////////////////////////

// //////////////////////////////
// includes/html5media/html5media.min.js
// //////////////////////////////
(function () {
  (function () {
    function k(a) {
      if (!a || typeof a != 'object') {
        return a;
      } var b = new a.constructor, e;

 for (e in a) {
        a.hasOwnProperty(e) && (b[e] = k(a[e]));
      }

 return b;
    } function j(a, b) {
      if (a) {
        var e, d = 0, c = a.length;

 if (c === void 0) {
          for (e in a) {
            if (b.call(a[e], e, a[e]) === !1) {
              break;
            }
          }
        } else {
          for (e = a[0]; d < c && b.call(e, d, e) !== !1; e = a[++d]) {

          }
        }

 return a;
      }
    } function n(a, b, e) {
      if (typeof b != 'object') {
        return a;
      } a && b && j(b, function (d, b) {
        if (!e || typeof b != 'function') {
          a[d] = b;
        }
      });

 return a;
    } function r(a) {
      var b = a.indexOf('.');

 if (b != -1) {
        var e = a.slice(0, b) || '*', d = a.slice(b +
1, a.length), c = [];

 j(document.getElementsByTagName(e), function () {
          this.className && this.className.indexOf(d) != -1 && c.push(this);
        });

 return c;
      }
    } function i(a) {
      a = a || window.event; a.preventDefault ? (a.stopPropagation(), a.preventDefault()) : (a.returnValue = !1, a.cancelBubble = !0);

 return !1;
    } function o(a, b, e) {
      a[b] = a[b] || []; a[b].push(e);
    } function t() {
      return '_' + ('' + Math.random()).slice(2, 10);
    } function m(a, p, e) {
      var d = this, h = null, m = !1, l, v, f = [], q = {}, s = {}, u, y, x, z, A, r;

 n(d, {
id: function () {
        return u;
      },
isLoaded: function () {
        return h !==
null && h.fp_play !== void 0 && !m;
      },
getParent: function () {
        return a;
      },
hide: function (b) {
        if (b) {
          a.style.height = '0px';
        } if (d.isLoaded()) {
          h.style.height = '0px';
        }

 return d;
      },
show: function () {
        a.style.height = r + 'px'; if (d.isLoaded()) {
          h.style.height = A + 'px';
        }

 return d;
      },
isHidden: function () {
        return d.isLoaded() && parseInt(h.style.height, 10) === 0;
      },
load: function (b) {
        if (!d.isLoaded() && d._fireEvent('onBeforeLoad') !== !1) {
          var f = 0;

 j(c, function () {
            this.unload(function () {
              if (++f == c.length) {
                if ((l = a.innerHTML) && !flashembed.isSupported(p.version)) {
                  a.innerHTML =
'';
                } if (b) {
                  b.cached = !0, o(s, 'onLoad', b);
                }flashembed(a, p, { config: e });
              }
            });
          });
        }

 return d;
      },
unload: function (b) {
        if (this.isFullscreen() && /WebKit/i.test(navigator.userAgent)) {
          return b && b(!1), d;
        } if (l.replace(/\s/g, '') !== '') {
          if (d._fireEvent('onBeforeUnload') === !1) {
            return b && b(!1), d;
          } m = !0; try {
            h && (h.fp_close(), d._fireEvent('onUnload'));
          } catch (f) {}setTimeout(function () {
            h = null; a.innerHTML = l; m = !1; b && b(!0);
          }, 50);
        } else {
          b && b(!1);
        }

 return d;
      },
getClip: function (a) {
        a === void 0 && (a = z);

 return f[a];
      },
getCommonClip: function () {
        return v;
      },
getPlaylist: function () {
        return f;
      },
      getPlugin: function (a) {
        var f = q[a];

 if (!f && d.isLoaded()) {
          var e = d._api().fp_getPlugin(a);

 e && (f = new b(a, e, d), q[a] = f);
        }

 return f;
      },
getScreen: function () {
        return d.getPlugin('screen');
      },
getControls: function () {
        return d.getPlugin('controls')._fireEvent('onUpdate');
      },
getLogo: function () {
        try {
          return d.getPlugin('logo')._fireEvent('onUpdate');
        } catch (a) {}
      },
getPlay: function () {
        return d.getPlugin('play')._fireEvent('onUpdate');
      },
getConfig: function (a) {
        return a ? k(e) : e;
      },
getFlashParams: function () {
        return p;
      },
loadPlugin: function (
a,
        f, 
e, 
c
) {
        typeof e == 'function' && (c = e, e = {}); var p = c ? t() : '_';

 d._api().fp_loadPlugin(a, f, e, p); f = {}; f[p] = c; c = new b(a, null, d, f);

 return q[a] = c;
      },
getState: function () {
        return d.isLoaded() ? h.fp_getState() : -1;
      },
play: function (a, b) {
        var f = function () {
          a !== void 0 ? d._api().fp_play(a, b) : d._api().fp_play();
        };

 d.isLoaded() ? f() : m ? setTimeout(function () {
          d.play(a, b);
        }, 50) : d.load(function () {
          f();
        });

 return d;
      },
getVersion: function () {
        if (d.isLoaded()) {
          var a = h.fp_getVersion();

 a.push('flowplayer.js 3.2.6');

 return a;
        }

 return 'flowplayer.js 3.2.6';
      },
      _api: function () {
        if (!d.isLoaded()) {
          throw 'Flowplayer ' + d.id() + ' not loaded when calling an API method';
        }

 return h;
      },
setClip: function (a) {
        d.setPlaylist([a]);

 return d;
      },
getIndex: function () {
        return x;
      },
_swfHeight: function () {
        return h.clientHeight;
      }
}); j('Click*,Load*,Unload*,Keypress*,Volume*,Mute*,Unmute*,PlaylistReplace,ClipAdd,Fullscreen*,FullscreenExit,Error,MouseOver,MouseOut'.split(','), function () {
        var a = 'on' + this;

 if (a.indexOf('*') != -1) {
          var a = a.slice(0, a.length - 1), b = 'onBefore' + a.slice(2);

 d[b] = function (a) {
            o(
s,
              b,
a
);

 return d;
          };
        }d[a] = function (b) {
          o(s, a, b);

 return d;
        };
      }); j('pause,resume,mute,unmute,stop,toggle,seek,getStatus,getVolume,setVolume,getTime,isPaused,isPlaying,startBuffering,stopBuffering,isFullscreen,toggleFullscreen,reset,close,setPlaylist,addClip,playFeed,setKeyboardShortcutsEnabled,isKeyboardShortcutsEnabled'.split(','), function () {
        var a = this;

 d[a] = function (b, f) {
          if (!d.isLoaded()) {
            return d;
          } var e = null, e = b !== void 0 && f !== void 0 ? h['fp_' + a](b, f) : b === void 0 ? h['fp_' + a]() : h['fp_' + a](b);

 return e === 'undefined' ||
e === void 0 ? d : e;
        };
      }); d._fireEvent = function (a) {
        typeof a == 'string' && (a = [a]); var b = a[0], c = a[1], p = a[2], u = a[3], i = 0;

 e.debug && console.log('$f.fireEvent', [].slice.call(a)); !d.isLoaded() && b == 'onLoad' && c == 'player' && (h = h || document.getElementById(y), A = d._swfHeight(), j(f, function () {
          this._fireEvent('onLoad');
        }), j(q, function (a, b) {
          b._fireEvent('onUpdate');
        }), v._fireEvent('onLoad')); if (!(b == 'onLoad' && c != 'player')) {
          if (b == 'onError' && (typeof c == 'string' || typeof c == 'number' && typeof p == 'number')) {
            c = p, p = u;
          } if (b == 'onContextMenu') {
            j(
e.contextMenu[c],
              function (a, b) {
                b.call(d);
              }
);
          } else if (b == 'onPluginEvent' || b == 'onBeforePluginEvent') {
            if (u = q[c.name || c]) {
              return u._fireEvent('onUpdate', c), u._fireEvent(p, a.slice(3));
            }
          } else {
            if (b == 'onPlaylistReplace') {
              f = []; var m = 0;

 j(c, function () {
                f.push(new g(this, m++, d));
              });
            } if (b == 'onClipAdd') {
              if (c.isInStream) {
                return;
              } c = new g(c, p, d); f.splice(p, 0, c); for (i = p + 1; i < f.length; i++) {
                f[i].index++;
              }
            } var l = !0;

 if (typeof c == 'number' && c < f.length && (z = c, (a = f[c]) && (l = a._fireEvent(b, p, u)), !a || l !== !1)) {
              l = v._fireEvent(b, p, u, a);
            }j(s[b], function () {
              l = this.call(
d,
                c,
p
); this.cached && s[b].splice(i, 1); if (l === !1) {
                return !1;
              } i++;
            });

 return l;
          }
        }
      }; if (typeof a == 'string') {
        var w = document.getElementById(a);

 if (!w) {
          throw 'Flowplayer cannot access element: ' + a;
        } a = w;
      }(function () {
        function h(a) {
          var b = d.hasiPadSupport && d.hasiPadSupport();

 if (/iPad|iPhone|iPod/i.test(navigator.userAgent) && !/.flv$/i.test(f[0].url) && !b) {
            return !0;
          } !d.isLoaded() && d._fireEvent('onBeforeClick') !== !1 && d.load();

 return i(a);
        }$f(a) ? ($f(a).getParent().innerHTML = '', x = $f(a).getIndex(), c[x] = d) : (c.push(d), x = c.length - 1);
        r = parseInt(a.style.height, 10) || a.clientHeight; u = a.id || 'fp' + t(); y = p.id || u + '_api'; p.id = y; e.playerId = u; typeof e == 'string' && (e = { clip: { url: e } }); if (typeof e.clip == 'string') {
          e.clip = { url: e.clip };
        }e.clip = e.clip || {}; if (a.getAttribute('href', 2) && !e.clip.url) {
          e.clip.url = a.getAttribute('href', 2);
        }v = new g(e.clip, -1, d); e.playlist = e.playlist || [e.clip]; var m = 0;

 j(e.playlist, function () {
          var a = this;

 typeof a == 'object' && a.length && (a = { url: '' + a }); j(e.clip, function (b, f) {
            f !== void 0 && a[b] === void 0 && typeof f != 'function' && (a[b] = f);
          });
          e.playlist[m] = a; a = new g(a, m, d); f.push(a); m++;
        }); j(e, function (a, b) {
          if (typeof b == 'function') {
            if (v[a]) {
              v[a](b);
            } else {
              o(s, a, b);
            } delete e[a];
          }
        }); j(e.plugins, function (a, f) {
          f && (q[a] = new b(a, f, d));
        }); if (!e.plugins || e.plugins.controls === void 0) {
          q.controls = new b('controls', null, d);
        }q.canvas = new b('canvas', null, d); l = a.innerHTML; setTimeout(function () {
          l.replace(/\s/g, '') !== '' ? a.addEventListener ? a.addEventListener('click', h, !1) : a.attachEvent && a.attachEvent('onclick', h) : (a.addEventListener && a.addEventListener(
'click', 
i,
            !1
), d.load());
        }, 0);
      })();
    } function l(a) {
      this.length = a.length; this.each = function (b) {
        j(a, b);
      }; this.size = function () {
        return a.length;
      };
    } var g = function (a, b, e) {
        var c = this, h = {}, i = {};

 c.index = b; typeof a == 'string' && (a = { url: a }); n(this, a, !0); j('Begin*,Start,Pause*,Resume*,Seek*,Stop*,Finish*,LastSecond,Update,BufferFull,BufferEmpty,BufferStop'.split(','), function () {
          var a = 'on' + this;

 if (a.indexOf('*') != -1) {
            var a = a.slice(0, a.length - 1), f = 'onBefore' + a.slice(2);

 c[f] = function (a) {
              o(i, f, a);

 return c;
            };
          }c[a] = function (b) {
            o(i, a, b);

            return c;
          }; b == -1 && (c[f] && (e[f] = c[f]), c[a] && (e[a] = c[a]));
        }); n(this, {
onCuepoint: function (a, f) {
          if (arguments.length == 1) {
            return h.embedded = [null, a], c;
          } typeof a == 'number' && (a = [a]); var q = t();

 h[q] = [a, f]; e.isLoaded() && e._api().fp_addCuepoints(a, b, q);

 return c;
        },
update: function (a) {
          n(c, a); e.isLoaded() && e._api().fp_updateClip(a, b); var f = e.getConfig();

 n(b == -1 ? f.clip : f.playlist[b], a, !0);
        },
_fireEvent: function (a, f, q, s) {
          if (a == 'onLoad') {
            return j(h, function (a, f) {
              f[0] && e._api().fp_addCuepoints(f[0], b, a);
            }), !1;
          } s = s || c; if (a == 'onCuepoint') {
            var u =
h[f];

 if (u) {
              return u[1].call(e, s, q);
            }
          } if (f && 'onBeforeBegin,onMetaData,onStart,onUpdate,onResume'.indexOf(a) != -1 && (n(s, f), f.metaData)) {
            s.duration ? s.fullDuration = f.metaData.duration : s.duration = f.metaData.duration;
          } var g = !0;

 j(i[a], function () {
            g = this.call(e, s, f, q);
          });

 return g;
        }
}); if (a.onCuepoint) {
          var g = a.onCuepoint;

 c.onCuepoint.apply(c, typeof g == 'function' ? [g] : g); delete a.onCuepoint;
        }j(a, function (b, f) {
          typeof f == 'function' && (o(i, b, f), delete a[b]);
        }); if (b == -1) {
          e.onCuepoint = this.onCuepoint;
        }
      }, b = function (a, b, c, d) {
        var h =
this, g = {}, i = !1;

 d && n(g, d); j(b, function (a, c) {
          typeof c == 'function' && (g[a] = c, delete b[a]);
        }); n(this, {
animate: function (d, f, q) {
          if (!d) {
            return h;
          } typeof f == 'function' && (q = f, f = 500); if (typeof d == 'string') {
            var s = d, d = {};

 d[s] = f; f = 500;
          } if (q) {
            var i = t();

 g[i] = q;
          }f === void 0 && (f = 500); b = c._api().fp_animate(a, d, f, i);

 return h;
        },
css: function (d, f) {
          if (f !== void 0) {
            var q = {};

 q[d] = f; d = q;
          }b = c._api().fp_css(a, d); n(h, b);

 return h;
        },
show: function () {
          this.display = 'block'; c._api().fp_showPlugin(a);

 return h;
        },
hide: function () {
          this.display = 'none';
            c._api().fp_hidePlugin(a);

 return h;
        },
toggle: function () {
          this.display = c._api().fp_togglePlugin(a);

 return h;
        },
fadeTo: function (b, f, d) {
          typeof f == 'function' && (d = f, f = 500); if (d) {
            var p = t();

 g[p] = d;
          } this.display = c._api().fp_fadeTo(a, b, f, p); this.opacity = b;

 return h;
        },
fadeIn: function (a, b) {
          return h.fadeTo(1, a, b);
        },
fadeOut: function (a, b) {
          return h.fadeTo(0, a, b);
        },
getName: function () {
          return a;
        },
getPlayer: function () {
          return c;
        },
_fireEvent: function (b, f) {
          if (b == 'onUpdate') {
            var d = c._api().fp_getPlugin(a);

 if (!d) {
              return;
            } n(h, d); delete h.methods;
              i || (j(d.methods, function () {
              var b = '' + this;

 h[b] = function () {
                var f = [].slice.call(arguments), f = c._api().fp_invoke(a, b, f);

 return f === 'undefined' || f === void 0 ? h : f;
              };
            }), i = !0);
          }

 return (d = g[b]) ? (d = d.apply(h, f), b.slice(0, 1) == '_' && delete g[b], d) : h;
        }
});
      }, c = [];

 window.flowplayer = window.$f = function () {
      var a = null, b = arguments[0];

 if (!arguments.length) {
        return j(c, function () {
          if (this.isLoaded()) {
            return a = this, !1;
          }
        }), a || c[0];
      } if (arguments.length == 1) {
        if (typeof b == 'number') {
          return c[b];
        } else {
          if (b == '*') {
            return new l(c);
          } j(c, function () {
            if (this.id() ==
b.id || this.id() == b || this.getParent() == b) {
              return a = this, !1;
            }
          });

 return a;
        }
      } if (arguments.length > 1) {
        var e = arguments[1], d = arguments.length == 3 ? arguments[2] : {};

 typeof e == 'string' && (e = { src: e }); e = n({
bgcolor: '#000000',
version: [9, 0],
expressInstall: 'http://static.flowplayer.org/swf/expressinstall.swf',
cachebusting: !1
}, e); if (typeof b == 'string') {
          if (b.indexOf('.') != -1) {
            var h = [];

 j(r(b), function () {
              h.push(new m(this, k(e), k(d)));
            });

 return new l(h);
          } else {
            var g = document.getElementById(b);

 return new m(g !== null ? g : b, e, d);
          }
        } else if (b) {
          return new m(
b,
            e,
d
);
        }
      }

 return null;
    }; n(window.$f, {
fireEvent: function () {
      var a = [].slice.call(arguments), b = $f(a[0]);

 return b ? b._fireEvent(a.slice(1)) : null;
    },
addPlugin: function (a, b) {
      m.prototype[a] = b;

 return $f;
    },
each: j,
extend: n
}); if (typeof jQuery == 'function') {
      jQuery.fn.flowplayer = function (a, b) {
        if (!arguments.length || typeof arguments[0] == 'number') {
          var c = [];

 this.each(function () {
            var a = $f(this);

 a && c.push(a);
          });

 return arguments.length ? c[arguments[0]] : new l(c);
        }

 return this.each(function () {
          $f(this, k(a), b ? k(b) : {});
        });
      };
    }
  })();
  (function () {
    function k() {
      if (g.done) {
        return !1;
      } var b = document;

 if (b && b.getElementsByTagName && b.getElementById && b.body) {
        clearInterval(g.timer); g.timer = null; for (b = 0; b < g.ready.length; b++) {
          g.ready[b].call();
        }g.ready = null; g.done = !0;
      }
    } function j(b, c) {
      if (c) {
        for (key in c) {
          c.hasOwnProperty(key) && (b[key] = c[key]);
        }
      }

 return b;
    } function n(b) {
      switch (r(b)) {
        case 'string': return b = b.replace(RegExp('(["\\\\])', 'g'), '\\$1'), b = b.replace(/^\s?(\d+)%/, '$1pct'), '"' + b + '"'; case 'array': return '[' + i(b, function (a) {
          return n(a);
        }).join(',') +
']'; case 'function': return '"function()"'; case 'object': var c = [], a;

 for (a in b) {
          b.hasOwnProperty(a) && c.push('"' + a + '":' + n(b[a]));
        }

 return '{' + c.join(',') + '}';
      }

 return String(b).replace(/\s/g, ' ').replace(/\'/g, '"');
    } function r(b) {
      if (b === null || b === void 0) {
        return !1;
      } var c = typeof b;

 return c == 'object' && b.push ? 'array' : c;
    } function i(b, c) {
      var a = [], g;

 for (g in b) {
        b.hasOwnProperty(g) && (a[g] = c(b[g]));
      }

 return a;
    } function o(b, c) {
      var a = j({}, b), g = document.all, e = '<object width="' + a.width + '" height="' + a.height + '"';

 if (g && !a.id) {
        a.id =
'_' + ('' + Math.random()).substring(9);
      }a.id && (e += ' id="' + a.id + '"'); a.cachebusting && (a.src += (a.src.indexOf('?') != -1 ? '&' : '?') + Math.random()); e += a.w3c || !g ? ' data="' + a.src + '" type="application/x-shockwave-flash"' : ' classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"'; e += '>'; if (a.w3c || g) {
        e += '<param name="movie" value="' + a.src + '" />';
      }a.width = a.height = a.id = a.w3c = a.src = null; for (var d in a) {
        a[d] !== null && (e += '<param name="' + d + '" value="' + a[d] + '" />');
      }a = ''; if (c) {
        for (var h in c) {
          c[h] !== null && (a += h + '=' + (typeof c[h] ==
'object' ? n(c[h]) : c[h]) + '&');
        }a = a.substring(0, a.length - 1); e += '<param name="flashvars" value=\'' + a + "' />";
      }e += '</object>';

 return e;
    } function t(b, c, a) {
      var g = flashembed.getVersion();

 j(this, {
getContainer: function () {
        return b;
      },
getConf: function () {
        return c;
      },
getVersion: function () {
        return g;
      },
getFlashvars: function () {
        return a;
      },
getApi: function () {
        return b.firstChild;
      },
getHTML: function () {
        return o(c, a);
      }
}); var e = c.version, d = c.expressInstall, h = !e || flashembed.isSupported(e);

 if (h) {
        c.onFail = c.version = c.expressInstall = null, b.innerHTML =
o(c, a);
      } else if (e && d && flashembed.isSupported([6, 65])) {
        j(c, { src: d }), a = { MMredirectURL: location.href,
MMplayerType: 'PlugIn',
MMdoctitle: document.title }, b.innerHTML = o(c, a);
      } else if (b.innerHTML.replace(/\s/g, '') === '' && (b.innerHTML = '<h2>Flash version ' + e + ' or greater is required</h2><h3>' + (g[0] > 0 ? 'Your version is ' + g : 'You have no flash plugin installed') + '</h3>' + (b.tagName == 'A' ? '<p>Click here to download latest version</p>' : "<p>Download latest version from <a href='http://www.adobe.com/go/getflashplayer'>here</a></p>"),
      b.tagName == 'A')) {
        b.onclick = function () {
          location.href = 'http://www.adobe.com/go/getflashplayer';
        };
      } if (!h && c.onFail && (e = c.onFail.call(this), typeof e == 'string')) {
        b.innerHTML = e;
      }document.all && (window[c.id] = document.getElementById(c.id));
    } var m = typeof jQuery == 'function', l = {
width: '100%',
height: '100%',
allowfullscreen: !0,
allowscriptaccess: 'always',
quality: 'high',
version: null,
onFail: null,
expressInstall: null,
w3c: !1,
cachebusting: !1
};

 if (m) {
      jQuery.tools = jQuery.tools || {}, jQuery.tools.flashembed = { version: '1.0.4',
conf: l };
    }
    var g = m ? jQuery : function (b) {
      if (g.done) {
        return b();
      } g.timer ? g.ready.push(b) : (g.ready = [b], g.timer = setInterval(k, 13));
    };

 window.attachEvent && window.attachEvent('onbeforeunload', function () {
      __flash_unloadHandler = function () {}; __flash_savedUnloadHandler = function () {};
    }); window.flashembed = function (b, c, a) {
      if (typeof b == 'string') {
        var i = document.getElementById(b);

 if (i) {
          b = i;
        } else {
          g(function () {
            flashembed(b, c, a);
          });

 return;
        }
      } if (b) {
        return typeof c == 'string' && (c = { src: c }), i = j({}, l), j(i, c), new t(b, i, a);
      }
    }; j(window.flashembed, {
getVersion: function () {
      var b =
[0, 0];

 if (navigator.plugins && typeof navigator.plugins['Shockwave Flash'] == 'object') {
        var c = navigator.plugins['Shockwave Flash'].description;

 typeof c != 'undefined' && (c = c.replace(/^.*\s+(\S+\s+\S+$)/, '$1'), b = parseInt(c.replace(/^(.*)\..*$/, '$1'), 10), c = /r/.test(c) ? parseInt(c.replace(/^.*r(.*)$/, '$1'), 10) : 0, b = [b, c]);
      } else if (window.ActiveXObject) {
        try {
          c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.7');
        } catch (a) {
          try {
            c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.6'), b = [6, 0], c.AllowScriptAccess = 'always';
          } catch (g) {
            if (b[0] ==
6) {
              return b;
            }
          } try {
            c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
          } catch (e) {}
        } typeof c == 'object' && (c = c.GetVariable('$version'), typeof c != 'undefined' && (c = c.replace(/^\S+\s+(.*)$/, '$1').split(','), b = [parseInt(c[0], 10), parseInt(c[2], 10)]));
      }

 return b;
    },
isSupported: function (b) {
      var c = flashembed.getVersion();

 return c[0] > b[0] || c[0] == b[0] && c[1] >= b[1];
    },
domReady: g,
asString: n,
getHTML: o
}); if (m) {
      jQuery.fn.flashembed = function (b, c) {
        var a = null;

 this.each(function () {
          a = flashembed(this, b, c);
        });

 return b.api === !1 ? this : a;
      };
    }
  })(); (function () {
    function k() {
      if (!m && (m = !0, l)) {
        for (var g = 0; g < l.length; g++) {
          l[g].call(window, []);
        }l = [];
      }
    } function j(g) {
      var b = window.onload;

 window.onload = typeof window.onload != 'function' ? g : function () {
        b && b(); g();
      };
    } function n() {
      if (!t) {
        t = !0; document.addEventListener && !o.opera && document.addEventListener('DOMContentLoaded', k, !1); o.msie && window == top && function () {
          if (!m) {
            try {
              document.documentElement.doScroll('left');
            } catch (b) {
              setTimeout(arguments.callee, 0);

 return;
            }k();
          }
        }(); o.opera && document.addEventListener(
'DOMContentLoaded',
          function () {
            if (!m) {
              for (var b = 0; b < document.styleSheets.length; b++) {
                if (document.styleSheets[b].disabled) {
                  setTimeout(arguments.callee, 0);

 return;
                }
              }k();
            }
          },
!1
); if (o.safari) {
          var g;

 (function () {
            if (!m) {
              if (document.readyState != 'loaded' && document.readyState != 'complete') {
                setTimeout(arguments.callee, 0);
              } else {
                if (g === void 0) {
                  for (var b = document.getElementsByTagName('link'), c = 0; c < b.length; c++) {
                    b[c].getAttribute('rel') == 'stylesheet' && g++;
                  }b = document.getElementsByTagName('style'); g += b.length;
                }document.styleSheets.length != g ? setTimeout(
arguments.callee,
                  0
) : k();
              }
            }
          })();
        }j(k);
      }
    } var r = window.DomReady = {}, i = navigator.userAgent.toLowerCase(), o = {
version: (i.match(/.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [])[1],
safari: /webkit/.test(i),
opera: /opera/.test(i),
msie: /msie/.test(i) && !/opera/.test(i),
mozilla: /mozilla/.test(i) && !/(compatible|webkit)/.test(i)
}, t = !1, m = !1, l = [];

 r.ready = function (g) {
      n(); m ? g.call(window, []) : l.push(function () {
        return g.call(window, []);
      });
    }; n();
  })(); (function (k, j) {
    function n(b, c) {
      return b.canPlayType(c) || a && c.search('mp4') > -1;
    } function r(b) {
      for (var c = j.getElementsByTagName(b), d = [], e = 0; e < c.length; e++) {
        d.push(c[e]);
      } for (e = 0; e < d.length; e++) {
        var c = d[e], g = !0;

 if (c.canPlayType) {
          if (c.src) {
            n(c, t(b, c.src)) && (g = !1);
          } else {
            for (var h = c.getElementsByTagName('source'), l = 0; l < h.length; l++) {
              var m = h[l];

 if (n(c, t(b, m.src, m.type))) {
                g = !1; break;
              }
            }
          }
        }g || i.forceFallback(b, c) ? i.createFallback(b, c) : a && c.addEventListener('click', function () {
          this.play();
        }, !1);
      }
    } function i() {
      r('video');
      r('audio');
    } function o(a) {
      return a.split('/').slice(0, -1).join('/') + '/';
    } function t(a, b, c) {
      return c || B[a][b.split('.').slice(-1)[0]] || d[a];
    } function m(a, b) {
      var c = a.getAttribute(b);

 return c == !0 || typeof c == 'string';
    } function l(a) {
      return a.substr(0, 1) == '/' ? C + a : a.substr(0, 1) == '.' || !a.match(/^\s*\w+:\/\//) ? v + a : a;
    } function g(a, b, c) {
      var d = a.getAttribute(b);

 if (d) {
        return d + 'px';
      } if (a.currentStyle) {
        a = a.currentStyle[b];
      } else if (k.getComputedStyle) {
        a = j.defaultView.getComputedStyle(a, null).getPropertyValue(b);
      } else {
        return c;
      }

      return a == 'auto' ? c : a;
    } function b(a) {
      return a.match(/\s*([\w-]+\/[\w-]+)(;|\s|$)/)[1];
    } function c(a, c) {
      return b(a) == b(c);
    }j.createElement('video').canPlayType || (j.createElement('audio'), j.createElement('source')); var a = k.navigator.userAgent.toLowerCase().match(/android 2\.[12]/) !== null, p = k.navigator.userAgent.toLowerCase().match(/opera/) !== null;

 i.forceFallback = function () {
      return !1;
    }; var e = function () {
      for (var a = j.getElementsByTagName('script'), b = 0; b < a.length; b++) {
        var c = a[b];

 if (c.src.match(/html5media(\.min|)\.js/)) {
          return o(c.src);
        }
      }

 return '';
    }();

    i.flowplayerSwf = e + 'flowplayer.swf'; i.flowplayerAudioSwf = e + 'flowplayer.audio.swf'; i.flowplayerControlsSwf = e + 'flowplayer.controls.swf'; i.expressInstallSwf = e + 'expressInstall.swf'; var d = { video: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
audio: 'audio/mpeg;' }, h = ['video/mp4; codecs="avc1.42E01E, mp4a.40.2"', 'audio/x-m4a;', 'audio/mpeg;'], B = {
video: {
ogg: 'video/ogg; codecs="theora, vorbis"',
ogv: 'video/ogg; codecs="theora, vorbis"',
avi: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
mp4: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
          mkv: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
h264: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
264: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
avc: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
m4v: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
'3gp': 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
'3gpp': 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
'3g2': 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
mpg: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
mpeg: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
webm: 'video/webm;'
},
        audio: {
ogg: 'audio/ogg; codecs="vorbis"',
oga: 'audio/ogg; codecs="vorbis"',
aac: 'audio/x-m4a;',
m4a: 'audio/x-m4a;',
mp3: 'audio/mpeg;',
wav: 'audio/wav; codecs="1"'
}
}, C = k.location.protocol + '//' + k.location.host, v = String(k.location), v = o(function () {
        for (var a = j.getElementsByTagName('base'), b = 0; b < a.length; b++) {
          var c = a[0];

 if (c.href) {
            return c.href;
          }
        }

 return String(k.location);
      }());

 i.configureFlowplayer = function (a, b) {
      return b;
    }; i.createFallback = function (a, b) {
      var d = m(b, 'controls'), e = b.getAttribute('poster') || '', n = b.getAttribute('src') ||
'';

 if (!n) {
        for (var k = b.getElementsByTagName('source'), o = 0; o < k.length; o++) {
          var r = k[o], v = r.getAttribute('src');

 if (v) {
            for (var w = 0; w < h.length; w++) {
              if (c(h[w], t(a, v, r.getAttribute('type')))) {
                n = v; break;
              }
            }
          } if (n) {
            break;
          }
        }
      } if (n) {
        k = j.createElement('span'); k.id = b.id; k.style.cssText = b.style.cssText; k.className = b.className; k.title = b.title; k.style.display = 'block'; k.style.width = g(b, 'width', '300px'); k.style.height = a == 'audio' ? '26px' : g(b, 'height', '200px'); b.parentNode.replaceChild(k, b); r = (b.getAttribute('preload') || '').toLowerCase();
        o = []; e && o.push({ url: l(e) }); n && o.push({
url: l(n),
autoPlay: m(b, 'autoplay'),
autoBuffering: m(b, 'autobuffer') || m(b, 'preload') && (r == '' || r == 'auto'),
onBeforeFinish: function () {
          return !m(b, 'loop');
        }
}); e = { controls: d && {
url: l(i.flowplayerControlsSwf),
opacity: 0.8,
backgroundColor: '#181818',
backgroundGradient: 'none',
fullscreen: a == 'video',
autoHide: a == 'video' && {
fullscreenOnly: !1,
enabled: !0,
hideStyle: 'fade',
mouseOutDelay: 0
} || { enabled: !1 }
} || null }; if (p && e.controls) {
          e.controls.autoHide.enabled = !1;
        } if (a == 'audio') {
          e.audio = { url: l(i.flowplayerAudioSwf) };
          if (!d) {
            e.controls = { url: l(i.flowplayerControlsSwf),
display: 'none' }, k.style.height = 0;
          }o[o.length - 1].autoBuffering = !1;
        }d = {
play: null,
playlist: o,
clip: { scaling: 'fit',
fadeInSpeed: 0,
fadeOutSpeed: 0 },
canvas: { backgroundGradient: 'none',
backgroundColor: '#000000' },
plugins: e
}; d = i.configureFlowplayer(b, d); flowplayer(k, { src: l(i.flowplayerSwf),
expressInstall: l(i.expressInstallSwf),
wmode: 'opaque' }, d);
      }
    }; DomReady.ready(i); k.html5media = i;
  })(this, document);
})();
// //////////////////////////////

// //////////////////////////////
// jquery.player.html5media.min.js
// //////////////////////////////
(function () {
/**
* $.fn.html5mediaplayer
*
* Plugin for wrapping html5media.js
*
* @version v1.0.001, 2013-1-14
* @author Fredi Quirino <fred@firefallpro.com>, Scott Park <scott@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2013 Firefall Pro, LLC
*
* Todo:
*	- Ability to take a list of sources
*	- identify which methods need arguments and which only need a callback
*	- Separate test for Flowplayer instead of per-method tests
*/
  (function (c) {
    var l = {
'default': 'height width controls poster preload class mediagroup loop autoplay'.split(' '),
url_html5media: 'includes/html5media/html5media.min.js',
url_swfobject: '//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js',
flash: !1,
debug: !1,
script_path: null,
plugin_name: 'player.html5media'
}, h = {}, f = {
_log: function () {
      if (c.fn.html5mediaplayer.debug) {
        var a = !c.support.opacity, d = arguments, b = '';

 a && typeof arguments[0] === 'string' && typeof arguments[1] === 'string' ? b = arguments[0] + ' ' + arguments[1] :
          a && typeof arguments[0] === 'string' && (b = arguments[0]); console.log(l.plugin_name, a ? b : d);
      }
    },
_script_path: function (a) {
      if (a.script_path === null) {
        return a = c('script[src*="' + a.plugin_name + '"]'), a.length === 0 ? '/' : a[0].src;
      } var d = document.createElement('a');

 d.href = a.script_path;

 return d.href;
    },
_base_path: function (a) {
      return a.substr(0, a.lastIndexOf('/'));
    },
_dependency: function (a, d, b) {
      var e = c('body');

 c.each(a, function (a, b) {
        typeof g[a] === 'undefined' && (g[a] = 0); g[a] === 2 || b.test() ? (f._log(a + ' is already loaded'), g[a] = 2,
        typeof b.callback !== 'undefined' && b.callback()) : (b.url === null && (b.url = f._base_path(d.script_path) + '/' + a), f._log('load script at ' + b.url), e.queue('player', function (d) {
          g[a] === 0 ? (f._log('Loading ' + a), g[a] = 1, g[a + '_promise'] = c.ajax({
cached: !0,
dataType: 'script',
error: function () {
            c.error('Failed to load dependency: ' + b.url);
          },
success: function () {
            f._log(a + ' loaded'); g[a] = 2; typeof b.callback !== 'undefined' && b.callback(); b.async || d();
          },
url: b.url
})) : (f._log(a + 'has already been started'), g[a + '_promise'].done(function () {
            f._log(a +
' was added to .done()'); typeof b.callback !== 'undefined' && b.callback();
          })); b.async && d();
        }));
      }); typeof b !== 'undefined' && e.queue('player', function (a) {
        f._log('Queue is complete'); b(); a();
      }); e.dequeue('player');
    },
_configure_html5media: function (a) {
      if (typeof window.html5media === 'undefined') {
        c.error('_configure_html5media: Called before html5media loaded');
      } else {
        f._log('Configuring html5media'); var d = a.url_html5media, d = d.slice(0, d.lastIndexOf('/') + 1);

 html5media.flowplayerSwf = d + 'flowplayer.swf'; html5media.flowplayerControlsSwf =
d + 'flowplayer.controls.swf'; html5media.flowplayerAudioSwf = d + 'flowplayer.audio.swf'; html5media.configureFlowplayer = function (a, d) {
          return c.extend(d, {
debug: !1,
onVolume: function () {
            c(this.getParent()).trigger('volumechange', arguments);
          },
onMute: function () {
            c(this.getParent()).trigger('volumechange', arguments);
          },
onUnmute: function () {
            c(this.getParent()).trigger('volumechange', arguments);
          },
onError: function () {
            c(this.getParent()).trigger('error', arguments);
          },
onBegin: function () {
            c(this.getParent()).trigger('loadstart');
          },
          onLoad: function () {
            c(this.getParent()).trigger('loadstart');
          },
onFinish: function () {
            this.getTime() !== 0 && c(this.getParent()).trigger('ended');
          },
onMetaData: function () {
            c(this.getParent()).trigger('loadedmetadata');
          },
onPause: function () {
            c(this.getParent()).trigger('pause');
          },
onResume: function () {
            this.getTime() !== 0 && c(this.getParent()).trigger('play');
          },
onBeforeSeek: function () {
            c(this.getParent()).trigger('seeking');
          },
onSeek: function () {
            c(this.getParent()).trigger('seeked');
          },
onStart: function () {
            this.getStatus().bufferEnd !== 0 &&
c(this.getParent()).trigger('playing');
          },
clip: {
autoBuffering: !0,
bufferLength: 3,
autoPlay: !0,
metaData: !1
},
onBeforeLoad: function () {
            c(this.getParent()).trigger('onbeforeload');
          },
onBufferFull: function () {
            c(this.getParent()).trigger('bufferfull');
          }
});
        }; html5media.forceFallback = function () {
          return a.flash;
        };
      }

 return this;
    },
init: function (a, d, b) {
      var e = this;

 g.inited = 1; h = c.extend({}, l, d); h.debug && (c.fn.html5mediaplayer.debug = !0); h.url_html5media === l.url_html5media && (h.url_html5media = f._base_path(f._base_path(f._script_path(h))) +
'/' + h.url_html5media); f._log('script_path is ', h.script_path); f._log('url is ', h.url_html5media); f._dependency({
'html5media.min.js': {
url: h.url_html5media,
async: !1,
test: function () {
        return typeof window.html5media !== 'undefined';
      },
callback: function () {
        f._configure_html5media(h);
      }
},
'swfobject.js': {
url: h.url_swfobject,
async: !0,
test: function () {
        return typeof swfobject !== 'undefined';
      }
}
}, h, function () {
        g.inited = 2; b.call(e);
      });

 return this;
    },
player: function (a, d, b) {
      var e = document.createElement('a'), k, n, g = c(document.createElement('video')),
          l = {}, m = document.createElement('source');

 if (typeof a !== 'string') {
        return c.error('No video URL specified'), this;
      } e.href = a; if (!1 === f.videoplayer_mime(e.pathname)) {
        return c.error('Unsupported video type'), this;
      } f._log('Creating Player for ' + e.href); k = e.pathname.charAt(0) === '/' ? e.pathname : '/' + e.pathname; k = k.split('.'); n = k.pop(); k = (e.protocol === ':' ? '' : e.protocol) + '//' + e.hostname + k.join('.') + '.'; var p = c.extend({}, h, d);

 c.each(h['default'], function (a, b) {
        typeof p[b] !== 'undefined' && (l[b] = p[b]);
      }); l.id = 'player_' +
(new Date).getTime(); g.attr(l); m.src = k + n; m.type = f.videoplayer_mime(e.pathname); g.append(m); typeof h.types === 'string' && (a = h.types.split(','), c.each(a, function (a, b) {
        b = c.trim(b); n !== b && typeof f.videoplayer_mime(b) !== 'undefined' && (m = document.createElement('source'), m.src = k + b, m.type = f.videoplayer_mime(b), g.append(m));
      })); typeof h.poster === 'string' && (a = document.createElement('img'), a.src = h.poster, a.alt = 'No video playback available', g.append(a)); g.bind(
'init loadstart progress suspend abort error emptied stalled loadedmetadata loadeddata canplay canplaythrough playing waiting seeking seeked ended durationchange timeupdate play pause ratechange volumechange readystatechange',
        function (a, b) {
          f._log('event', a.type, b); c(this).parent().trigger(a.type + '.player', b);
        }
); this.append(g); this.data('player', { type: 'html5media' }); html5media(); this.trigger('init.player'); f._log('player initialized'); typeof b !== 'undefined' && b.call(this);

 return this;
    },
videoplayer_mime: function (a) {
      return {
mp4: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
webm: 'video/webm; codecs="vp8, vorbis"',
ogg: 'video/ogg; codecs="theora, vorbis"',
ogv: 'video/ogg; codecs="theora, vorbis"',
'theora.ogg': 'video/ogg; codecs="theora, vorbis"',
        'theora.ogv': 'video/ogg; codecs="theora, vorbis"'
}[a.split('.').pop()];
    },
play: function (a, d, b) {
      a = this.children()[0]; typeof $f() !== 'undefined' && $f(a) !== null ? $f(a).play() : typeof a.play !== 'undefined' && a.play(); typeof b !== 'undefined' && b.call(this);

 return this;
    },
pause: function (a, d, b) {
      a = this.children()[0]; typeof $f() !== 'undefined' && $f(a) !== null ? $f(a).pause() : typeof a.pause !== 'undefined' && a.pause(); typeof b !== 'undefined' && b.call(this);

 return this;
    },
stop: function (a, d, b) {
      a = this.children()[0]; typeof $f() !== 'undefined' &&
$f(a) !== null ? $f(a).stop() : typeof a.currentTime !== 'undefined' && a.readyState !== 0 && (a.pause(), a.currentTime = 0); typeof b !== 'undefined' && b.call(this);

 return this;
    },
destroy: function (a, d, b) {
      var c = this.children()[0];

 f.stop.call(this, a, d, function () {
        typeof $f() !== 'undefined' && $f(c) !== null ? ($f(c).close(), swfobject.removeSWF(this.find('span > object').attr('id'))) : this.find('video, source').attr('src', '#'); this.removeClass('video').removeData('player').empty(); f._log('destroyed'); typeof b !== 'undefined' && b.call(this);
      });

      return this;
    },
mute: function (a, c, b) {
      a = this.children()[0]; typeof $f() !== 'undefined' && $f(a) !== null ? $f(a).mute() : a.muted = !a.muted; typeof b !== 'undefined' && b.call(this);

 return this;
    },
seekTo: function (a, c, b) {
      c = this.children()[0]; if (typeof $f() !== 'undefined' && $f(c) !== null) {
        var e = f.duration.call(this);

 a = a > e ? e : a; a = a < 0 ? 0 : a; $f(c).seek(a);
      } else {
        c.readyState !== 0 && (a = a > c.duration ? c.duration : a, a = a < 0 ? 0 : a, e = c.buffered.length, e = typeof e === 'number' && e ? c.buffered.end(e - 1) : 0, c.currentTime = a < e ? a : e);
      } typeof b !== 'undefined' &&
b.call(this);

 return this;
    },
duration: function () {
      var a = this.children()[0];

 return typeof $f() !== 'undefined' && $f(a) !== null ? $f(a).getClip().fullDuration : a.duration;
    },
current_time: function () {
      var a = this.children()[0];

 return typeof $f() !== 'undefined' && $f(a) !== null ? $f(a).getTime() : a.currentTime;
    },
isPaused: function () {
      var a = this.children()[0];

 return typeof $f() !== 'undefined' && $f(a) !== null ? $f(a).isPaused() : a.paused;
    },
full_screen: function () {
      var a = this.children()[0];

 typeof $f() !== 'undefined' && $f(a) !== null && $f(a).toggleFullscreen();

      return this;
    }
};

 c.fn.html5mediaplayer = function () {
      for (var a = 'init', d, b = {}, e, h, g = 0; g < arguments.length; g++) {
        switch (typeof arguments[g]) {
          case 'function': e = arguments[g]; break; case 'object': b = arguments[g]; break; case 'undefined': break; default: f[arguments[g]] ? a = arguments[g] : d = arguments[g];
        }
      }f._log(a); c.fn.html5mediaplayer.dependencies.inited === 0 ? h = f.init.call(this, null, b, function () {
        a !== 'init' && this.html5mediaplayer(a, d, b, e);
      }) : c.each(this, function () {
        h = f[a].call(c(this), d, b, e);
      });

 return h;
    }; var g = c.fn.html5mediaplayer.dependencies =
{ inited: 0 };

 c.fn.html5mediaplayer.debug = !1;
  })(jQuery);
})();
// //////////////////////////////

// //////////////////////////////
// jquery.player.youtube.min.js
// //////////////////////////////
// (function () {
/**
* $.fn.youtubeplayer
*
* Plugin for Youtube's 3 different players, iframe, chromeless, and flash
*
*
* @version v1.0.001, 2012-11-30
* @author Fredi Quirino <fred@firefallpro.com>, Scott Park <scott@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2012 Firefall Pro, LLC
*/
/*
 http://www.firefallpro.com/license.txt
 @copyright Copyright (c) 2012 Firefall Pro, LLC
*/
(function (d) {
  var l = {
debug: 1,
width: 425,
height: 355,
initialVideo: '',
playerType: 'iframe',
html5: null,
preferredQuality: 'default',
wmode: 'transparent',
url_swfobject: '//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js',
url_iframe: '//www.youtube.com/iframe_api',
script_path: null,
plugin_name: 'player.youtube',
autohide: 2,
autoplay: 0,
cc_load_policy: 0,
color: 'red',
controls: 1,
disablekb: 0,
end: 0,
fs: 1,
iv_load_policy: 1,
list: '',
listType: '',
loop: 0,
modestbranding: 1,
origin: '',
playlist: '',
rel: 1,
showinfo: 1,
start: 0,
theme: 'dark'
},
      f = {
_log: function () {
      if (d.fn.youtubeplayer.debug) {
        var a = !d.support.opacity, b = arguments, c = '';

 a && typeof arguments[0] === 'string' && typeof arguments[1] === 'string' ? c = arguments[0] + ' ' + arguments[1] : a && typeof arguments[0] === 'string' && (c = arguments[0]); console.log(l.plugin_name, a ? c : b);
      }
    },
_script_path: function (a) {
      if (a.script_path === null) {
        return a = d('script[src*="' + a.plugin_name + '"]'), a.length === 0 ? '/' : a[0].src;
      } var b = document.createElement('a');

 b.href = a.script_path;

 return b.href;
    },
_base_path: function (a) {
      return a.substr(
0,
          a.lastIndexOf('/')
);
    },
_dependency: function (a, b, c) {
      var g = d('body');

 d.each(a, function (a, c) {
        typeof k[a] === 'undefined' && (k[a] = 0); k[a] === 2 || c.test() ? (f._log(a + ' is already loaded'), k[a] = 2, typeof c.callback !== 'undefined' && c.callback()) : (c.url === null && (c.url = f._base_path(b.script_path) + '/' + a), f._log('load script at ' + c.url), g.queue('player', function (b) {
          k[a] === 0 ? (f._log('Loading ' + a), k[a] = 1, k[a + '_promise'] = d.ajax({
cached: !0,
dataType: 'script',
error: function () {
            d.error('Failed to load dependency: ' + c.url);
          },
success: function () {
            f._log(a +
' loaded'); k[a] = 2; typeof c.callback !== 'undefined' && c.callback(); c.async || b();
          },
url: c.url
})) : (f._log(a + 'has already been started'), k[a + '_promise'].done(function () {
            f._log(a + ' loaded'); typeof c.callback !== 'undefined' && c.callback();
          })); c.async && b();
        }));
      }); typeof c !== 'undefined' && g.queue('player', function (a) {
        f._log('Queue is complete'); c(); a();
      }); g.dequeue('player');
    },
init: function (a, b) {
      a.debug && (d.fn.youtubeplayer.debug = !0); var c = d.extend({}, l, a), g = this;

 this.each(function () {
        var a = d(this);

 if (typeof a.data('player') !== 'undefined') {
          f._log('skipping init'),
            typeof b !== 'undefined' && (g = b.call(a));
        } else {
          var h = {
'swfobject.js': {
url: c.url_swfobject,
async: !0,
test: function () {
            return typeof swfobject !== 'undefined';
          }
},
iframe_api: {
url: c.url_iframe,
async: !0,
test: function () {
            return typeof YT !== 'undefined';
          }
}
};

 c.playerType !== 'iframe' ? (delete h.iframe_api, h['swfobject.js'].callback = function () {
            typeof b !== 'undefined' && b.call(a);
          }) : (delete h['swfobject.js'], h.iframe_api.callback = function () {
            k.iframeInited || typeof YT.Player === 'undefined' || (k.iframeInited = !0); typeof b !== 'undefined' &&
b.call(a);
          }); c.script_path = f._script_path(c); f._log('script_path is', c.script_path); f._dependency(h, c); g = a;
        }
      });

 return g;
    },
initPlayer: function (a, b, c, g) {
      var e = d(this), h = d.extend({}, l, c);

 if (typeof e.data('player') !== 'undefined') {
        return f._log('Element has initialized player'), h = d.extend({}, d.fn.youtubeplayer.player[e.data('player').id].options, c), d.fn.youtubeplayer.player[e.data('player').id].options = h, a !== 'init' && a !== 'initPlayer' ? f[a].call(e, d.fn.youtubeplayer.player[h.player_ID], b, g) : e;
      } f._log('Element has uninitialized player');
        c = !1; !d.fn.youtubeplayer.parse_youtube_id(h.initialVideo) && typeof b === 'string' && d.fn.youtubeplayer.parse_youtube_id(b) ? (h.initialVideo = d.fn.youtubeplayer.parse_youtube_id(b), b = '') : d.fn.youtubeplayer.parse_youtube_id(h.initialVideo) || h.playerType === 'chromeless' ? h.initialVideo = d.fn.youtubeplayer.parse_youtube_id(h.initialVideo) : c = !0; typeof a === 'destroy' && (c = !0); c ? f._log('Element has no valid video ID or invalid method, will load dependencies', h) : (h.player_ID = 'youtubeplayer_' + d.fn.youtubeplayer.current_ID++,
        c = document.createElement('div'), c.id = h.player_ID, e.append(c).data('player', { type: 'youtube',
id: h.player_ID }), d.fn.youtubeplayer.player[h.player_ID] = { options: h }, h.playerType !== 'iframe' ? (f._log('Element has Flash Player'), f.createFlashPlayer.call(d(this), h)) : (f._log('Element has Iframe Player'), e.queue('player', function (a) {
        f.createIframePlayer.call(e, h, a);
      }), k.iframeInited && e.dequeue('player')), a !== 'init' && a !== 'initPlayer' && (f._log(a + ' is being queued'), e.queue('player', function (c) {
        f._log(a + ' queued method is being triggered');
          f[a].call(e, d.fn.youtubeplayer.player[h.player_ID], b, g); c();
      })));
    },
load: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } var g = a.youtubeplayer;

 b = d.fn.youtubeplayer.parse_youtube_id(b); if (!b) {
        return this;
      } g.loadVideoById(b, a.options.start, a.options.preferredQuality); a.options.initialVideo = b; typeof c !== 'undefined' && c.call(this);

 return this;
    },
cue: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } var g = a.youtubeplayer;

 b = d.fn.youtubeplayer.parse_youtube_id(b); if (!b) {
        return this;
      }
        g.cueVideoById(b, a.options.start, a.options.preferredQuality); a.options.initialVideo = b; typeof c !== 'undefined' && c.call(this);

 return this;
    },
play: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } var g = a.youtubeplayer, e = g.getPlayerState();

 typeof b === 'string' && b.length && f.load(a, b, c); if (e === 3 || e === 1) {
        return this;
      } g.playVideo(); typeof c !== 'undefined' && c.call(this);

 return this;
    },
pause: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } a = a.youtubeplayer; var g = a.getPlayerState();

      if (g !== 1 && g !== 2) {
        return this;
      } typeof b !== 'undefined' && b !== null && (b = b ? !0 : !1); f._log('Pause Value Before Change', b, g); b || g === 1 && !1 !== b ? a.pauseVideo() : (!b || g === 2 && !0 !== b) && a.playVideo(); f._log('Pause Value After Change', b, a.getPlayerState()); typeof c !== 'undefined' && c.call(this);

 return this;
    },
stop: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } a.youtubeplayer.stopVideo(); typeof c !== 'undefined' && c.call(this);

 return this;
    },
volume: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      }
        a = a.youtubeplayer; var g = a.getVolume();

 f._log('Volume Value Before Change', b, g); typeof b !== 'undefined' && b !== null && (b = parseInt(b, 10), b < 0 && (b = 0), b > 100 && (b = 100), a.setVolume(b)); f._log('Volume Value After Change', b, a.getVolume()); typeof c !== 'undefined' && c.call(this);

 return g;
    },
mute: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } a = a.youtubeplayer; var g = a.getPlayerState();

 if (g !== 1 && g !== 2) {
        return this;
      } g = a.isMuted(); typeof b !== 'undefined' && b !== null && (b = b ? !0 : !1); f._log(
'Mute Value Before Change',
          b,
g
); b || !g && !1 !== b ? a.mute() : (!1 === b || g) && a.unMute(); f._log('Mute Value After Change', b, a.isMuted()); typeof c !== 'undefined' && c.call(this);

 return this;
    },
seek: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } var g = a.youtubeplayer.getCurrentTime(), e = a.youtubeplayer.getPlayerState();

 if (e !== 1 && e !== 2) {
        return this;
      } f._log('Seek Value Before Change', b, g); typeof b !== 'undefined' && b !== null && (b = parseInt(b, 10), a.youtubeplayer.seekTo(b)); f._log('Seek Value Before Change', b, a.youtubeplayer.getCurrentTime());
        f._log('callback', typeof c); typeof c !== 'undefined' && c.call(this);

 return g;
    },
destroy: function (a, b, c) {
      if (typeof a.youtubeplayer === 'undefined') {
        return this;
      } a.youtubeplayer.stopVideo(); a.options.playerType !== 'iframe' && swfobject.removeSWF(a.options.player_ID); this.removeClass('video').removeData('player').children('#' + a.options.player_ID).attr('src', '#'); this.empty(); d.fn.youtubeplayer.player[a.options.player_ID] = null; typeof c !== 'undefined' && c.call(this);

 return this;
    },
info: function (a, b, c) {
      if (typeof a.youtubeplayer ===
'undefined') {
        return this;
      } switch (b) {
        case 'currentTime': a = a.youtubeplayer.getCurrentTime(); break; case 'duration': a = a.youtubeplayer.getDuration(); break; case 'loaded': a = a.youtubeplayer.getVideoLoadedFraction(); break; case 'state': a = a.youtubeplayer.getPlayerState(); break; case 'muted': a = a.youtubeplayer.isMuted(); break; default: a = {
currentTime: a.youtubeplayer.getCurrentTime(),
duration: a.youtubeplayer.getDuration(),
loaded: a.youtubeplayer.getVideoLoadedFraction(),
state: a.youtubeplayer.getPlayerState(),
            muted: a.youtubeplayer.isMuted()
};
      }f._log('Info requested', b, a); typeof c !== 'undefined' && c.call(this);

 return a;
    },
supportsHTML5: function () {
      f._log('Support function triggered');

 return !!document.createElement('video').canPlayType;
    },
createIframePlayer: function (a, b) {
      f._log('Creating IFRAME player', a); var c = this;

 new YT.Player(a.player_ID, {
height: a.height,
width: a.width,
videoId: a.initialVideo,
playerVars: {
autohide: a.autohide,
autoplay: a.autoplay,
color: a.color,
cc_load_policy: a.cc_load_policy,
controls: a.controls,
          disablekb: a.disablekb,
end: a.end,
wmode: a.wmode,
fs: a.fs,
list: a.list,
listType: a.listType,
html5: a.html5,
iv_load_policy: a.iv_load_policy,
loop: a.loop,
modestbranding: a.modestbranding,
origin: a.origin,
playlist: a.playlist,
rel: a.rel,
showinfo: a.showinfo,
start: a.start,
theme: a.theme
},
events: {
onReady: function (g) {
        f._log('onReady : Iframe'); var e = a.player_ID;

 d.fn.youtubeplayer.player[e].youtubeplayer = g.target; d('#' + e).bind('playing, unstarted, ended, pause, buffering, cued, ready, qualitychange', function (a, b) {
          f._log(
'event',
              a.type,
b
); d(this).parent().trigger(a.type + '.player', b);
        }); c.queue('player', function (a) {
          d(this).trigger('ready.player'); a();
        }); typeof b !== 'undefined' && b();
      },
onStateChange: function (b) {
        f.onStateChange.call(c, a.player_ID, b);
      },
onPlaybackQualityChange: function (b) {
        f.onPlaybackQualityChange.call(c, a.player_ID, b);
      },
onError: function (b) {
        f.onError.call(c, a.player_ID, b);
      }
}
}); this.trigger('init.player');
    },
onStateChange: function (a, b) {
      f._log('onStateChange : Iframe and Flash'); switch (typeof b === 'object' ? b.data : b) {
        case -1: d('#' +
a).trigger('unstarted'); break; case 0: d('#' + a).trigger('ended'); break; case 1: d('#' + a).trigger('playing'); break; case 2: d('#' + a).trigger('pause'); break; case 3: d('#' + a).trigger('buffering'); break; case 5: d('#' + a).trigger('cued');
      }
    },
onPlaybackQualityChange: function (a, b) {
      f._log('onPlaybackQualityChange: Iframe and Flash', b); var c = typeof b === 'object' ? b.data : b;

 d('#' + a).trigger('qualitychanged', [c]);
    },
onError: function (a, b) {
      f._log('onError: Iframe and Flash', arguments); d('#' + a).trigger('error', [b]);
    },
createFlashPlayer: function (a) {
      f._log(
'Creating Flash player',
          a
); var b = { allowScriptAccess: 'always',
allowFullScreen: a.fs,
wmode: a.wmode }, c = { id: a.player_ID }, g = 'http://www.youtube.com', e = { enablejsapi: '1',
version: '3' };

 a.loop && a.playlist === '' && (a.playlist = a.initialVideo); a.playerType === 'chromeless' ? (g += '/apiplayer?', e.video_id = a.initialVideo, e.autoplay = a.autoplay, e.cc_load_policy = a.cc_load_policy, e.end = a.end, e.iv_load_policy = a.iv_load_policy, e.disablekb = a.disablekb, e.loop = a.loop, e.list = a.list, e.listType = a.listType, e.playlist = a.playlist, e.start = a.start, e.playerapiid =
a.player_ID) : (g += '/v/' + a.initialVideo, e.autohide = a.autohide, e.autoplay = a.autoplay, e.cc_load_policy = a.cc_load_policy, e.color = a.color, e.controls = a.controls, e.disablekb = a.disablekb, e.end = a.end, e.fs = a.fs, e.iv_load_policy = a.iv_load_policy, e.loop = a.loop, e.list = a.list, e.listType = a.listType, e.modestbranding = a.modestbranding, e.playerapiid = a.player_ID, e.playlist = a.playlist, e.rel = a.rel, e.showinfo = a.showinfo, e.start = a.start, e.theme = a.theme); g += '?' + d.param(e); f._log('URL', g); this.trigger('init.player'); swfobject.embedSWF(
g,
          a.player_ID,
a.width,
a.height,
'8',
null,
null,
b,
c
);
    },
onYouTubePlayerReady: function (a) {
      var b = d('#' + a)[0], c = d(b).parent();

 d(b).bind('playing, unstarted, ended, pause, buffering, cued, ready, qualitychange', function (a, b) {
        f._log('event', a.type, b); d(this).parent().trigger(a.type + '.player', b);
      }); d.fn.youtubeplayer.player[a].youtubeplayer = b; d.fn.youtubeplayer.callbacks.onStateChange['player_' + a] = function (b) {
        f.onStateChange.call(c, a, b);
      }; d.fn.youtubeplayer.callbacks.onPlaybackQualityChange['player_' + a] = function (b) {
        f.onPlaybackQualityChange.call(
c,
            a,
b
);
      }; d.fn.youtubeplayer.callbacks.onError['player_' + a] = function (b) {
        f.onError.call(c, a, b);
      }; b.addEventListener('onStateChange', '$.fn.youtubeplayer.callbacks.onStateChange.player_' + a); b.addEventListener('onPlaybackQualityChange', '$.fn.youtubeplayer.callbacks.onPlaybackQualityChange.player_' + a); b.addEventListener('onError', '$.fn.youtubeplayer.callbacks.onError.player_' + a); c.queue('player', function (a) {
        d(this).trigger('ready.player'); a();
      }); c.dequeue('player');
    }
};

 d.fn.youtubeplayer = function () {
    for (var a =
'init', b, c = {}, d, e = 0; e < arguments.length; e++) {
      switch (typeof arguments[e]) {
        case 'function': d = arguments[e]; break; case 'object': c = arguments[e]; break; case 'undefined': break; default: f[arguments[e]] ? a = arguments[e] : b = arguments[e];
      }
    }f._log(a); for (var h in c) {
      c.hasOwnProperty(h) && (typeof c[h] === 'boolean' && (c[h] = Number(c[h])), typeof c[h] !== typeof l[h] && l[h] !== null && (c[h] = l[h]));
    }

 return f.init.call(this, c, function () {
      return f.initPlayer.call(this, a, b, c, d);
    });
  }; d.fn.youtubeplayer.current_ID = 0; d.fn.youtubeplayer.player =
{}; var k = d.fn.youtubeplayer.dependency = { iframeInited: !1 };

 d.fn.youtubeplayer.debug = !1; d.fn.youtubeplayer.callbacks = {
onYouTubePlayerReady: f.onYouTubePlayerReady,
onStateChange: {},
onPlaybackQualityChange: {},
onError: {}
}; d.fn.youtubeplayer.supportsHTML5 = f.supportsHTML5(); d.fn.youtubeplayer.parse_youtube_id = function (a) {
    var b, c;

 if (typeof a !== 'string') {
      return !1;
    } if ((b = a.indexOf('youtu.be/')) !== -1) {
      b += 9;
    } else if ((b = a.indexOf('v=')) !== -1) {
      b += 2;
    } else {
      return a.length === 11 ? a : !1;
    }

 return (c = a.indexOf('&', b)) !== -1 ? a.substring(
b,
      c
) : a.substring(b);
  };
})(jQuery); function onYouTubeIframeAPIReady() {
  jQuery.fn.youtubeplayer.debug && console.log('Iframe API Ready'); jQuery.fn.youtubeplayer.dependency.iframeInited || (jQuery.fn.youtubeplayer.dependency.iframeInited = !0); jQuery.each(jQuery.fn.youtubeplayer.player, function () {
    this.options.playerType === 'iframe' && jQuery('#' + this.options.player_ID).parent().dequeue('player');
  });
}
function onYouTubePlayerReady(d) {
  jQuery.fn.youtubeplayer.debug && console.log('Flash API Ready ', d); jQuery.fn.youtubeplayer.callbacks.onYouTubePlayerReady(d);
}
// })();
// //////////////////////////////

// //////////////////////////////
// jquery.player.min.js
// //////////////////////////////
(function () {
/**
* $.fn.player
*
* jQuery unified player plugin
*
* @version v1.0.001, 2013-1-14
* @author Fredi Quirino <fred@firefallpro.com>, Scott Park <scott@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2013 Firefall Pro, LLC
*/
  (function (c) {
    var k = {
url_html5mediaplayer: null,
url_youtubeplayer: null,
defaults: {},
debug: !1,
flash: !1,
script_path: null,
plugin_name: 'jquery.player'
}, b = {
_log: function () {
      if (c.fn.player.debug) {
        var b = !c.support.opacity, f = arguments, g = '';

 b && typeof arguments[0] === 'string' && typeof arguments[1] === 'string' ? g = arguments[0] + ' ' + arguments[1] : b && typeof arguments[0] === 'string' && (g = arguments[0]); console.log(k.plugin_name, b ? g : f);
      }
    },
_script_path: function (b) {
      if (b.script_path === null) {
        return b = c('script[src*="' + b.plugin_name +
'"]'), b.length === 0 ? '/' : b[0].src;
      } var f = document.createElement('a');

 f.href = b.script_path;

 return f.href;
    },
_base_path: function (b) {
      return b.substr(0, b.lastIndexOf('/'));
    },
_dependency: function (l, f, g) {
      var d = c('body');

 c.each(l, function (a, e) {
        typeof h[a] === 'undefined' && (h[a] = 0); h[a] === 2 || e.test() ? (b._log(a + ' is already loaded'), h[a] = 2, typeof e.callback !== 'undefined' && e.callback()) : (e.url === null && (e.url = b._base_path(f.script_path) + '/' + a), b._log('load script at ' + e.url), d.queue('player', function (d) {
          h[a] === 0 ? (b._log('Loading ' +
a), h[a] = 1, h[a + '_promise'] = c.ajax({
cached: !0,
dataType: 'script',
error: function () {
            c.error('Failed to load dependency: ' + e.url);
          },
success: function () {
            b._log(a + ' loaded'); h[a] = 2; typeof e.callback !== 'undefined' && e.callback(); e.async || d();
          },
url: e.url
})) : (b._log(a + 'has already been started'), h[a + '_promise'].done(function () {
            b._log(a + ' loaded'); typeof e.callback !== 'undefined' && e.callback();
          })); e.async && d();
        }));
      }); typeof g !== 'undefined' && d.queue('player', function (c) {
        b._log('Queue is complete'); g(); c();
      }); d.dequeue('player');
    },
    init: function (h, f, g) {
      var d = c.extend(!0, {}, k, f);

 d.debug && (c.fn.player.debug = !0); var a = this;

 this.each(function () {
        b._log('Initializing scope'); var e = {}, g = c(this), f = {};

 e.youtube = c('a.video[href*="youtube.com/"], a[href*="youtu.be/"]', g).addClass('video_youtube'); e.html5media = c('a.video[href*=".mp4"], a[href*=".webm"], a[href*=".ogg"], a[href*=".ogv"], a[href*=".theora.ogg"], a[href*="theora.ogv"]', g).addClass('video_html5media'); c.isEmptyObject(d.defaults) || (e.youtube.data(d.defaults), e.html5media.data(d.defaults));
        f = {
'jquery.player.youtube.min.js': {
url: d.url_youtubeplayer,
async: !1,
test: function () {
          return typeof c.fn.youtubeplayer !== 'undefined';
        }
},
'jquery.player.html5media.min.js': {
url: d.url_html5mediaplayer,
async: !1,
test: function () {
          return typeof c.fn.html5mediaplayer !== 'undefined';
        }
}
}; e.youtube.length === 0 && delete f['jquery.player.youtube.min.js']; e.html5media.length === 0 && delete f['jquery.player.html5media.min.js']; d.script_path = b._script_path(d); b._log('script_path is', d.script_path); b._dependency(f, d); e.youtube.bind(
'click',
          function (a) {
            a.preventDefault(); a = c(this.hash); b._log('Youtube link clicked ' + this.href); var e = this.protocol + this.host + this.pathname + this.search;

 typeof a.data('player') === 'undefined' ? (b._log('Initializing new player', c(this).data()), a.youtubeplayer(e, c.extend({}, c(this).data(), d)).addClass('video')) : (b._log('Existing player available'), a.youtubeplayer('cue', e), c(this).data('autoplay') && a.youtubeplayer('play'), a.trigger('init.player'));
          }
); e.html5media.bind('click', function (a) {
          a.preventDefault(); a = c(this.hash);
          b._log('html5media link clicked ' + this.href); typeof a.data('player') !== 'undefined' && (b._log('Existing player found'), a.html5mediaplayer('destroy')); b._log('Initializing new player', c(this).data()); a.html5mediaplayer('player', this.href, c.extend(c(this).data(), d)).addClass('video');
        }); a = g;
      }); typeof g !== 'undefined' && g.call(this);

 return a;
    }
};

 c.fn.player = function () {
      for (var c, f = {}, g, d = 0; d < arguments.length; d++) {
        switch (typeof arguments[d]) {
          case 'function': g = arguments[d]; break; case 'object': f = arguments[d]; break;
          case 'undefined': break; default: b[arguments[d]] && (c = arguments[d]);
        }
      } var a;

 b[c] ? (b._log(c), a = b[c].call(this, void 0, f, g)) : typeof this.data('player') !== 'undefined' && this.data('player').type === 'html5media' ? a = this.html5mediaplayer.apply(this, arguments) : typeof this.data('player') !== 'undefined' && this.data('player').type === 'youtube' && (a = this.youtubeplayer.apply(this, arguments));

 return a;
    }; var h = c.fn.player.dependencies = {};

 c.fn.player.debug = !1;
  })(jQuery);
})();
// //////////////////////////////

// //////////////////////////////
// jquery.propoScript.js
// //////////////////////////////
(function () {
/**
*	jQuery plugin to create and apply pseudo-responsiveness (scaling) to non-responsive webpage designs
*	@version 0.0.3
*	@author Aric Ng
* 	
*	Added non-propoContainer parent override
*/

  /**
* jQuery.
* @external "$"
 * @see {@link http://jquery.com/ | jQuery}
*/

  /**
* The jQuery plugin namespace.
* @external "$.fn"
 * @see {@link http://learn.jquery.com/plugins/|jQuery Plugins}
*/

  // Resize event handling for propoScript 
  var $ = jQuery;

  jQuery(function ($) {
    $(window).on('resize propoResize', function () {
      // Resize root propoContainers only
      $('.propoContainer.root').each(function () {
        var $this = $(this),
            max_width = $this.data('max_width'),
            max_height = $this.data('max_height'),
            scale;

        // Needs at least a max-width or a max-height
        if (max_width === undefined && max_height === undefined) {
          return;
        }

        // Use max-width first, then defer to max-height if undefined
        scale = max_width !== undefined ? $this.width() / max_width : $this.height() / max_height;
        $this.css(max_width !== undefined ? 'height' : 'width', $this.data(max_width !== undefined ? 'max_height' : 'max_width') * scale + 'px');
      });

      // Resize propoText elements
      $('.propoText').each(function () {
        var $this = $(this),
            $parent = $($this.parents('.propoContainer')[0]),
            max_width = $parent.data('max_width'),
            max_height = $parent.data('max_height'),
            scale,
            css_data = {};

        if (max_width === undefined && max_height === undefined) {
          return;
        }

        scale = max_width !== undefined ? $parent.width() / max_width : max_height !== undefined ? $parent.height() / max_height : false;

        if (!scale) {
          return;
        }

        if ($this.data('font_size')) {
          css_data.fontSize = $this.data('font_size') * scale;
        }

        if ($this.data('letter_spacing')) {
          css_data.letterSpacing = $this.data('letter_spacing') * scale;
        }

        $this.css(css_data);
      });

      $('.propoOverride').each(function () {
        var $this = $(this),
            $parent = $this.data('propoOverrideParent'),
            parent_max_width = $parent.data('max_width'),
            parent_max_height = $parent.data('max_height'),
            positions = $this.data('propoPositions'),
            max_width = $this.data('propoMaxWidth'),
            max_height = $this.data('propoMaxHeight'),
            scale,
            css_properties = {};

        scale = parent_max_width !== undefined ? $parent.width() / parent_max_width : parent_max_height !== undefined ? $parent.height() / parent_max_height : false;

        if (!scale) {
          return;
        }

        // Add adjusted positions
        for (var position in positions) {
          if (positions.hasOwnProperty(position)) {
            css_properties[position] = positions[position] * scale;
          }
        }

        // Add widths
        if (max_width !== undefined) {
          css_properties.width = max_width * scale;
        }

        // Add height
        if (max_height !== undefined) {
          css_properties.height = max_height * scale;
        }
        $this.css(css_properties);
      });
    });
  });

  /**
* Helper function that processes all propo-classes. Classes are processed in this order, propoContainer (must be first!), propoElement, and propoText.
* @name processPropoItems
* @function external:"$".processPropoItems
* @param {object} options - Contains options
* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
*	@param {boolean} [options.overrideNonPropoOffsetParents=false] - PropoElement related, Allows pixel resizing and px positioning when needed (when propoContainer isn't the offset parent)
*/
  $.processPropoItems = function (options) {
    var debug = options.debug !== undefined ? window.console ? options.debug : false : false,
        overrideNonPropoOffsetParents = options.overrideNonPropoOffsetParents !== undefined ? options.overrideNonPropoOffsetParents : false;

    $('head').append('<style>.propoProcessing {display:none;}\n .propoElement {position: absolute;}\n .propoContainer {position: relative;}</style>');

    /* BEGIN: propoContainers */
    if (debug) {
      console.log('<<<<<< processPropoItems: processPropoContainer: Start >>>>>>');
    }
    $('.propoContainer').each(function () {
      var $this = $(this);

      $this.processPropoContainer(options);
    });

    if (debug) {
      console.log('<<<<<< processPropoItems: processPropoContainer: End >>>>>>');
    }
    /* END: propoContainers */

    /* BEGIN: propoElements */
    if (debug) {
      console.log('<<<<<< processPropoItems: processPropoElement: Start >>>>>>');
    }
    $('.propoElement').each(function () {
      var $this = $(this);

      $this.processPropoElement(options);
    });
    if (debug) {
      console.log('<<<<<< processPropoItems: processPropoElement: End >>>>>>');
    }
    /* END: propoElements */

    /* BEGIN: propoTexts */
    if (debug) {
      console.log('<<<<<< processPropoItems: processPropoText: Start >>>>>>');
    }
    $('.propoText').each(function () {
      var $this = $(this);

      $this.processPropoText(options);
    });
    if (debug) {
      console.log('<<<<<< processPropoItems: processPropoText: End >>>>>>');
    }

    if (debug && overrideNonPropoOffsetParents) {
      console.log('<<<<<< processPropoItems: OVERRIDE: INIT Resizing >>>>>>');
      $(window).trigger('propoResize');
    }
    /* END: propoTexts */
  };

  /**
* Processes an element with the propoContainer class. PropoContainers that do not reside in another propoContainer will be treated as 'root' containers
* that will be affected by resize events. This function will not handle sizing or positioning, the target element should use propoElement and processPropoElement().
* @name processPropoContainer
* @function external:"$.fn".processPropoContainer
* @param {object} options - Contains options
* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
*/
  // Note: propoContainers needs hard values for height 
  // If it's a root propoContainer, it will scale based on how it's squished by its parent, otherwise scaling and positioning should be deferred to propoElement 
  $.fn.processPropoContainer = function (options) {
    var $this = $(this),
        debug = options.debug !== undefined ? window.console ? options.debug : false : false,
        $parent = $this.offsetParent(),
        css_max_width,
        css_max_height,
        max_width,
        max_height,
        regex_percent = /[0-9]+%{1}/,
        regex_px = /[0-9]+(px){1}/;

    if (debug) {
      console.log('<<< processPropoContainer: Start: For id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
    }

    // Must have propoContainer class to process
    if (!$this.hasClass('propoContainer')) {
      if (debug) {
        console.log('processPropoContainer: Failed');
      }

      return;
    }

    // Clear data and if root, clear css values
    if ($this.hasClass('propoContainerReady')) {
      $this.removeData(['max_width', 'max_height']);
      if ($this.hasClass('root')) {
        $this.css({
          width: '',
          height: ''
        });
        $this.removeClass('root');
      }
      $this.removeClass('propoContainerReady');
    }

    // Get cleaned max-sizes
    css_max_width = $this.css('max-width');
    css_max_height = $this.css('max-height');

    /*
	Percentage values are not valid proportional scaling values
	*/
    if (regex_px.test(css_max_width)) {
      max_width = parseInt(css_max_width.replace('px', ''));
    } else if (regex_percent.test(css_max_width)) {
      max_width = false;
    }

    if (regex_px.test(css_max_height)) {
      max_height = parseInt(css_max_height.replace('px', ''));
    } else if (regex_percent.test(css_max_height)) {
      max_height = false;
    }

    /*
	propoContainer must have a max-width or max-height set in the CSS, otherwise there's
	nothing to proportionally scale off of 
	*/

    if (!max_width && !max_height) {
      if (debug) {
        console.log('processPropoContainer: missing both max-width and max-height px values: element not a valid propoContainer');
      }

      return;
    }

    // Used for propoElements to calculate sizing and positioning
    $this.data('max_width', max_width);
    $this.data('max_height', max_height);

    // This will be a root propoContainer which will size all other propoContainers after it, provided that they're propoElements(!), unless otherwise.
    if ($parent.is('html, body') || !$parent.hasClass('propoContainer')) {
      if (debug) {
        console.log('processPropoContainer: root container detected');
      }

      $this.addClass('root');
      $this.css(max_width ? 'width' : 'height', '100%');

      if (max_width) {
        $this.css('height', max_height * $this.width() / max_width + 'px');
      }
    }

    $this.addClass('propoContainerReady');

    if (debug) {
      console.log('<<< processPropoContainer: End: For id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
    }
  };

  /**
* Processes elements with the propoElement class. If max-width or max-height is found in the CSS, it will be treated as a scaling element. Without positioning values, the propoElement will use relative positioning instead; provided
that the element has the necessary CSS for scaling it will still scale.
* @name processPropoElement
* @function external:"$.fn".processPropoElement
* @param {object} options - Contains options
* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
*	@param {boolean} [options.overrideNonPropoOffsetParents=false] - PropoElement related, allows pixel resizing and px positioning when needed (when propoContainer isn't the offset parent), percentage positioning used otherwise
*/
  $.fn.processPropoElement = function (options) {
    var $this = $(this),
        debug = options.debug !== undefined ? window.console ? options.debug : false : false,
        overrideNonPropoOffsetParents = options.overrideNonPropoOffsetParents !== undefined ? options.overrideNonPropoOffsetParents : false,
        override_applied = false,
        $parent = $this.offsetParent(),
        positions = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        raw_positions = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        css_max_width,
        css_max_height,
        max_width,
        max_height,
        auto_count = 0,
        /*
	 Check for browser types; different browsers make jQuery return different position values depending on element being hidden or not, or % positioning as px.
	 */
        is_safari = navigator.userAgent.indexOf('Safari') > -1,
        // is_firefox = navigator.userAgent.indexOf('Firefox') > -1,
        is_ie = navigator.userAgent.indexOf('Trident') > -1,
        regex_percent = /[0-9]+%{1}/,
        regex_px = /[0-9]+(px){1}/;

    if (debug) {
      console.log('<<< processPropoElement: Start: For id:', $this.attr('id'), 'class:', $this.attr('class'), 'for propoContainer with id:', $parent.attr('id'), 'class:', $parent.attr('id'), '>>>');
    }

    if ((!($parent.hasClass('propoContainer') && $parent.hasClass('propoContainerReady')) && !overrideNonPropoOffsetParents) || !$this.hasClass('propoElement')) {
      if (debug) {
        console.log('processPropoElement: Failed: ', !$parent.hasClass('propoContainer') ? 'offset parent missing propoContainer class' : '', !$this.hasClass('propoElement') ? 'missing propoElement class' : '');
      }

      return;
    }
    // If overrideNonPropoOffsetParents, search for the nearest propoContainer and append propoOverride to the propoElement
    else if (!(($parent.hasClass('propoContainer') && $parent.hasClass('propoContainerReady')) && overrideNonPropoOffsetParents)) {
      if (debug) {
        console.log('processPropoElement: OVERRIDE: ', !$parent.hasClass('propoContainer') ? 'offset parent missing propoContainer class' : '', !$this.hasClass('propoElement') ? 'missing propoElement class' : '', 'using nearest propoContainer instead');
      }
      $parent = $($this.parents('.propoContainer')[0]);
      $this.data('propoOverrideParent', $parent);

      if (debug) {
        console.log('processPropoElement: OVERRIDE: Parent with max-width:', $parent.data('max_width'), 'and max-height:', $parent.data('max_height'));
      }
      override_applied = true;
    }

    /* BEGIN: Positioning */
    // Clear old positioning if this element was already processed
    if ($this.hasClass('propoElementReady')) {
      $this.css({
        left: '',
        top: '',
        right: '',
        bottom: '',
        width: '',
        height: ''
      });

      $this.removeClass('propoElementReady');
    }

    /*
	Hide element in Chrome/Firefox to acquire stylesheet positioning values,
	i.e., and safari return weird values if hidden
	*/
    if (!is_ie && !is_safari) {
      $this.addClass('propoProcessing');
    }

    /*
	Get current positions and calculate each percentage position
	Note: Right and Bottom will take priority over top. Overridden positions or 'unused' positions will result in "auto" 
	so that artifact positions values do not affect in-line positions generated by this script
	*/
    for (var position in positions) {
      if (positions.hasOwnProperty(position)) {
        var current_position = $this.css(position),
            position_horizontal = position == 'left' || position == 'right' ? true : false,
            position_vertical = position == 'top' || position == 'bottom' ? true : false,
            parent_size = $parent.data(position_horizontal ? 'max_width' : position_vertical ? 'max_height' : 'error');

        /*
				Safari returns all position values as px; which leads to problems when handling % positioning. One of the things that can be done is to detect decimals...
				This will convert from percent to px position based on parent max-(sizes)
			*/
        if (is_safari) {
          var float_value = parseFloat($this.css(position).replace('px', '')),
              calculated_percentage;

          if ($this.css(position) !== 'auto' && float_value % 1 !== 0) {
            calculated_percentage = float_value / (position_horizontal ? $parent.width() : $parent.height());
            current_position = calculated_percentage * parent_size + 'px';
            if (parent_size === undefined) {
              delete positions[position];
              continue;
            }

            if (debug) {
              console.log('processPropoElement: Safari:', position, ':', float_value, calculated_percentage, current_position, parent_size);
            }
          }
        }

        /*
			 Check if percentage or "auto". Mark % positions as percentages 
			 such that % positions are skipped over (in favor of the stylesheet value)
			 */
        if (regex_percent.test(current_position)) {
          if (debug) {
            console.log('processPropoElement: % value found for position:', position, current_position);
          }

          // Precedence! For bottom and right values
          if (position == 'bottom') {
            positions.top = 'auto';
          }
          if (position == 'right') {
            positions.left = 'auto';
          }

          delete positions[position];
          delete raw_positions[position];
          // console.log('deleted', 'position');
          continue;
        }
        /*
				Check if px value, convert into int
				create a percentage value to position to offset parent
			*/
        else if (regex_px.test(current_position)) {
          if (debug) {
            console.log('processPropoElement: px value found for position:', position, current_position);
          }

          // Precedence! For bottom and right values
          if (position == 'bottom') {
            positions.top = 'auto';
          }
          if (position == 'right') {
            positions.left = 'auto';
          }

          current_position = parseInt(current_position.replace('px', ''));
          raw_positions[position] = current_position;
          if ((position_horizontal && $parent.data('max_width') !== undefined) || (position_vertical && $parent.data('max_height') !== undefined)) {
            current_position = (current_position / parent_size) * 100 + '%';
          } // Change later
          else {
            delete positions[position];
            continue;
          }
        } else {
          auto_count++;
          if (current_position != 'auto') {
            if (debug) {
              console.log('processPropoElement: rejected value for position:', position, 'with value: ', current_position);
            }
            current_position = 'auto';
          } else {
            if (debug) {
              console.log('processPropoElement: no value for position:', position, 'with value: ', current_position);
            }
            delete positions[position];
            delete raw_positions[position];
            continue;
          }
        }

        positions[position] = current_position;
      }
    }

    $this.removeClass('propoProcessing');

    if (debug) {
      console.log(positions);
    }

    // Set CSS values
    if (auto_count == 4) {
      if (debug) {
        console.log('processPropoElement: No position css entered: Assuming non-absolute element');
      }
      $this.css({ position: 'relative' });
    }
    $this.css(positions);
    $this.data('propoPositions', raw_positions);
    /*
	for(var position in positions)
	{
		if(positions.hasOwnProperty(position) && !position.is_percent)
		{
			var current_position = positions[position];
			$this.css(position, current_position.is_percent ? current_position.val : current_position.percent);
		}
	}*/

    /* END: Positioning */

    /* BEGIN: Sizing */
    css_max_width = $this.css('max-width');
    css_max_height = $this.css('max-height');

    if (css_max_width != 'none') {
      // Parent must have a max-width set for width scaling to happen
      if (regex_px.test(css_max_width) && $parent.data('max_width')) {
        max_width = (parseInt(css_max_width.replace('px', '')) / $parent.data('max_width')) * 100 + '%';
        $this.css('width', max_width);
        $this.data('propoMaxWidth', parseInt(css_max_width.replace('px', '')));
      }
    }

    if (css_max_height != 'none') {
      // Parent must have a max-height set for width scaling to happen
      if (regex_px.test(css_max_height) && $parent.data('max_height')) {
        max_height = (parseInt(css_max_height.replace('px', '')) / $parent.data('max_height')) * 100 + '%';
        $this.css('height', max_height);
        $this.data('propoMaxHeight', parseInt(css_max_height.replace('px', '')));
      }
    }
    /* END: Sizing */

    // Mark element as processed
    $this.addClass('propoElementReady');
    if (overrideNonPropoOffsetParents && override_applied) {
      $this.addClass('propoOverride');
      $this.css({
        left: '',
        top: '',
        right: '',
        bottom: '',
        width: '',
        height: ''
      });
    }
    if (debug) {
      console.log('<<< processPropoElement: End: For id:', $this.attr('id'), 'class:', $this.attr('class'), 'for propoContainer with id:', $parent.attr('id'), 'class:', $parent.attr('id'), '>>>');
    }
  };

  /**
* Sets text within an element to resize. CSS values font-size (px), line-height, and letter-spacing are set for scaling.
* @name processPropoText
* @function external:"$.fn".processPropoText
* @param {object} options - Contains options
* 	@param {boolean} [options.debug=false] - Enables debug messages if true, will be false if console does not exist.
*/
  $.fn.processPropoText = function (options) {
    var $this = $(this),
        debug = options.debug !== undefined ? window.console ? options.debug : false : false,
        $parent = $this.closest('.propoContainer.propoContainerReady'),
        css_font_size,
        css_line_height,
        css_letter_spacing,
        font_size = false,
        line_height = false,
        letter_spacing = false,
        parent_scale,
        regex_px = /[0-9]+(px){1}/;

    if (debug) {
      console.log('<<< processPropoText: Start: for id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
    }

    // Must have propoText class and a propoContainer parent
    if (!$this.hasClass('propoText') || $parent.length === 0) {
      if (debug) {
        console.log('processPropoText: failed');
      }

      return;
    }
    // Clear any existing font size values and data set by the script
    if ($this.hasClass('propoTextReady')) {
      $this.css({
        fontSize: '',
        letterSpacing: '',
        lineHeight: ''
      });
      $this.removeData([
        'font_size',
        'line_height',
        'letter_spacing'
      ]);
      $this.removeClass('propoTextReady');
    }

    // Scaling uses parent width first, before checking height
    parent_scale = $parent.data('max_width') ? $parent.width() / $parent.data('max_width') : $parent.data('max-height') ? $parent.height() / $parent.data : 1;

    css_font_size = $this.css('font-size');
    css_line_height = $this.css('line-height');
    css_letter_spacing = $this.css('letter-spacing');

    var css_data = {};

    font_size = parseInt(css_font_size.replace('px', ''));
    $this.data('font_size', font_size);
    css_data.fontSize = font_size * parent_scale + 'px';

    // Do not allow non-numeric values to be scaled
    if (css_line_height != 'normal') {
      // convert to a easy-to-use-multiplier
      if (regex_px.test(css_line_height)) {
        line_height = parseFloat(css_line_height.replace('px', ''));
      }
      // else if(regex_percent.test(css_line_height))
      //	line_height = parseFloat(css_line_height.replace('%', ''))/100*font_size;

      if (line_height % 1 !== 0 || (regex_px.test(css_line_height) && line_height % font_size !== 0) || line_height % font_size === 0) {
        line_height = line_height / font_size;
      }

      $this.data('line_height', line_height);
      css_data.lineHeight = line_height;
    }
    // Do not allow non-numeric values to be scaled;
    if (css_letter_spacing != 'normal') {
      letter_spacing = parseInt(css_letter_spacing.replace('px', ''));
      $this.data('letter_spacing', letter_spacing);
      css_data.letterSpacing = letter_spacing * parent_scale + 'px';
    }

    $this.css(css_data);

    if (debug) {
      console.log('<<< processPropoText: End: for id:', $this.attr('id'), 'class:', $this.attr('class'), '>>>');
    }
  };

  // packages.js
  (function () {
    jQuery(function (k) {
      var p = k('#holiday-2015_container .ytplayer'), l = 3E3, m = window.location.search.indexOf('debug=true') !== -1 ? !0 : !1, l = navigator.userAgent.toLowerCase().indexOf('trident/7') !== -1 ? 4E3 : l;

 window.Holiday_Package = function () {
        var q = navigator.userAgent.toLowerCase().indexOf('msie 7') !== -1 || navigator.userAgent.toLowerCase().indexOf('msie 8') !== -1 ? !0 : !1, n = navigator.userAgent.match(/iPad/i) !== null;

 n && k('body').addClass('custom_controls_ipad'); p.bind('init.player', function () {
          var b = k(this);

 fullScreenApi.supportsFullScreen &&
b.siblings('controls-mask').find('.full_btn').show(); q && setTimeout(function () {
            b.trigger('timeupdate.player', !0);
          }, l);
        }); (function () {
          'user strict';

 var b = {
supportsFullScreen: !1,
isFullScreen: function () {
              return !1;
            },
requestFullScreen: function () {},
cancelFullScreen: function () {},
fullScreenEventName: '-',
prefix: ''
}, a = ['webkit', 'moz', 'o', 'ms'];

 if (typeof document.exitFullscreen != 'undefined') {
            b.supportsFullScreen = !0;
          } else if (typeof document.cancelFullScreen != 'undefined') {
            b.supportsFullScreen = !0;
          } else {
            for (var g = 0, e = a.length; g <
e; g++) {
              if (b.prefix = a[g], typeof document[b.prefix + 'CancelFullScreen'] != 'undefined') {
                b.supportsFullScreen = !0; break;
              }
            }
          }b.supportsFullScreen && (b.fullScreenEventName = b.prefix + 'fullscreenchange', b.isFullScreen = function () {
            switch (this.prefix) {
              case '': return document.fullScreen; case 'webkit': return document.webkitIsFullScreen; default: return document[this.prefix + 'FullScreen'];
            }
          }, b.requestFullScreen = function (a) {
            return this.prefix === '' ? a.requestFullScreen() : a[this.prefix + 'RequestFullScreen']();
          }, b.cancelFullScreen =
function () {
  return this.prefix === '' ? document.cancelFullScreen() : document[this.prefix + 'CancelFullScreen']();
}); window.fullScreenApi = b;
        })();

 return {
Video: function (b) {
          var a = k(b || '#video_01'), g, e, f, h;

 a.length ? typeof a.data('custom_init') === 'undefined' && (this.init = !0, a.data('custom_init', !0), g = a.siblings('.controls-mask'), e = g.find('.controls'), f = e.find('.scrubber'), h = f.find('.inner_scrubber'), fullScreenApi.supportsFullScreen ? e.find('.full_btn').show() : e.find('.full_btn').hide(), e.find('.bg').addClass('active').css({ opacity: '0' }),
          a.bind('clear_timer', function () {
            if (typeof a.data('player') === 'undefined') {
              m && console.log('custom-controls: no player data set');
            } else {
              if (a.data('player').type && a.data('player').type === 'html5media') {
                if (typeof $f() === 'undefined') {
                  return !1;
                }
              } else if (typeof a.data('timer') === 'undefined') {
                return !1;
              } for (var d in a.data('timer')) {
                clearInterval(a.data('timer')[d]);
              }a.removeData('timer');
            }
          }).bind('timeupdate.player', function (d, b) {
            if (typeof a.data('player') !== 'undefined' && a.data('player').type === 'html5media') {
              if (a.html5mediaplayer('isPaused')) {
                return !1;
              }
            } else if (a.player('info', 'state') !==
1) {
              return !1;
            } if (n) {
              return !1;
            } var c, e;

 typeof a.data('player') !== 'undefined' && a.data('player').type === 'html5media' ? (c = a.html5mediaplayer('current_time'), e = a.html5mediaplayer('duration')) : (c = a.player('info', 'currentTime'), e = a.player('info', 'duration')); if (typeof $f() === 'undefined' && a.data('player').type === 'html5media' || !b) {
              c /= e, c = Math.floor(f.width() * c), h.css('width', c);
            } else {
              if (typeof a.data('timer') !== 'undefined') {
                return !1;
              } c = []; c.push(setInterval(function () {
                var d = -1, b = 0;

 return function () {
                  var c;

                  c = a.data('player').type === 'html5media' ? a.html5mediaplayer('current_time') : a.player('info', 'currentTime'); a.trigger('timeupdate.player'); c >= e || d === c && b >= 2 ? a.trigger('clear_timer') : (b = d === c ? ++b : 0, d = c);
                };
              }(), 250)); a.data('timer', c);
            }
          }).bind('ended.player', function () {
            e.find('.play_btn').removeClass('active'); h.css('width', '100%');
          }).bind('playing.player, play.player', function () {
            e.find('.play_btn').removeClass('active'); typeof $f() === 'undefined' && a.data('player').type === 'html5media' || a.trigger(
'timeupdate.player',
              !0
);
          }).bind('pause.player', function () {
            e.find('.play_btn').addClass('active');
          }), e.bind('mousedown', function (d) {
            d.stopPropagation(); var b, c;

 k(this); c = f.offset(); d.pageX < c.left || d.pageX > c.left + f.width() || (b = h.width(), a.data('player').type === 'html5media' ? a.html5mediaplayer('pause') : a.player('pause'), typeof $f() === 'undefined' && h.width(d.pageX - c.left), g.one('mouseup', a, function () {
              h.width(b);
            }));
          }).bind('mouseup', function (d) {
            d.stopPropagation(); var b, c;

 b = f.offset(); g.unbind('mouseup'); d.pageX < b.left || d.pageX >
b.left + f.width() || (d = d.pageX - f.offset().left, b = d / f.width(), c = a.data('player').type === 'html5media' ? a.html5mediaplayer('duration') : a.player('info', 'duration'), b *= c, typeof $f() !== 'undefined' && (b = d = 0), h.width(d), a.trigger('clear_timer'), a.data('player').type === 'html5media' ? a.html5mediaplayer('seekTo', b, function () {
              a.html5mediaplayer('play', function () {
                a.trigger('timeupdate.player', !0);
              });
            }) : a.player('seek', b, function () {
              setTimeout(function () {
                a.player('play'); a.trigger('timeupdate.player', !0);
              }, 500);
            }));
          }).find('.play_btn').bind(
'click',
            function (b) {
              b.preventDefault(); b = k(this); typeof a.data('player') !== 'undefined' && a.data('player').type === 'html5media' ? a.html5mediaplayer('isPaused') ? (a.html5mediaplayer('play'), b.removeClass('active'), a.trigger('timeupdate.player', !0)) : (a.html5mediaplayer('pause'), b.addClass('active'), a.trigger('clear_timer')) : a.player('info', 'state') !== 1 ? (a.player('play'), b.removeClass('active'), a.trigger('timeupdate.player', !0)) : a.player('info', 'state') === 1 && (a.player('pause'), b.addClass('active'), a.trigger('clear_timer'));
            }
).siblings('.full_btn').bind(
'click',
            function (b) {
              b.preventDefault(); a.data('player').type === 'html5media' ? typeof $f() === 'undefined' && fullScreenApi.requestFullScreen(a.find('.video')[0]) : (fullScreenApi.requestFullScreen(a.find('iframe')[0]), fullScreenApi.requestFullScreen(a[0]));
            }
)) : m && console.log('custom-controls: video element found.');
        }
};
      }();
    });
  })();
})();
// //////////////////////////////

// //////////////////////////////
// packages.js
// //////////////////////////////
(function () {
  jQuery(function (k) {
    var p = k('#holiday-2015_container .ytplayer'), l = 3E3, m = window.location.search.indexOf('debug=true') !== -1 ? !0 : !1, l = navigator.userAgent.toLowerCase().indexOf('trident/7') !== -1 ? 4E3 : l;

 window.Holiday_Package = function () {
      var q = navigator.userAgent.toLowerCase().indexOf('msie 7') !== -1 || navigator.userAgent.toLowerCase().indexOf('msie 8') !== -1 ? !0 : !1, n = navigator.userAgent.match(/iPad/i) !== null;

 n && k('body').addClass('custom_controls_ipad'); p.bind('init.player', function () {
        var b = k(this);

 fullScreenApi.supportsFullScreen &&
b.siblings('controls-mask').find('.full_btn').show(); q && setTimeout(function () {
          b.trigger('timeupdate.player', !0);
        }, l);
      }); (function () {
        'user strict';

 var b = {
supportsFullScreen: !1,
isFullScreen: function () {
            return !1;
          },
requestFullScreen: function () {},
cancelFullScreen: function () {},
fullScreenEventName: '-',
prefix: ''
}, a = ['webkit', 'moz', 'o', 'ms'];

 if (typeof document.exitFullscreen != 'undefined') {
          b.supportsFullScreen = !0;
        } else if (typeof document.cancelFullScreen != 'undefined') {
          b.supportsFullScreen = !0;
        } else {
          for (var g = 0, e = a.length; g <
e; g++) {
            if (b.prefix = a[g], typeof document[b.prefix + 'CancelFullScreen'] != 'undefined') {
              b.supportsFullScreen = !0; break;
            }
          }
        }b.supportsFullScreen && (b.fullScreenEventName = b.prefix + 'fullscreenchange', b.isFullScreen = function () {
          switch (this.prefix) {
            case '': return document.fullScreen; case 'webkit': return document.webkitIsFullScreen; default: return document[this.prefix + 'FullScreen'];
          }
        }, b.requestFullScreen = function (a) {
          return this.prefix === '' ? a.requestFullScreen() : a[this.prefix + 'RequestFullScreen']();
        }, b.cancelFullScreen =
function () {
  return this.prefix === '' ? document.cancelFullScreen() : document[this.prefix + 'CancelFullScreen']();
}); window.fullScreenApi = b;
      })();

 return {
Video: function (b) {
        var a = k(b || '#video_01'), g, e, f, h;

 a.length ? typeof a.data('custom_init') === 'undefined' && (this.init = !0, a.data('custom_init', !0), g = a.siblings('.controls-mask'), e = g.find('.controls'), f = e.find('.scrubber'), h = f.find('.inner_scrubber'), fullScreenApi.supportsFullScreen ? e.find('.full_btn').show() : e.find('.full_btn').hide(), e.find('.bg').addClass('active').css({ opacity: '0' }),
        a.bind('clear_timer', function () {
          if (typeof a.data('player') === 'undefined') {
            m && console.log('custom-controls: no player data set');
          } else {
            if (a.data('player').type && a.data('player').type === 'html5media') {
              if (typeof $f() === 'undefined') {
                return !1;
              }
            } else if (typeof a.data('timer') === 'undefined') {
              return !1;
            } for (var d in a.data('timer')) {
              clearInterval(a.data('timer')[d]);
            }a.removeData('timer');
          }
        }).bind('timeupdate.player', function (d, b) {
          if (typeof a.data('player') !== 'undefined' && a.data('player').type === 'html5media') {
            if (a.html5mediaplayer('isPaused')) {
              return !1;
            }
          } else if (a.player('info', 'state') !==
1) {
            return !1;
          } if (n) {
            return !1;
          } var c, e;

 typeof a.data('player') !== 'undefined' && a.data('player').type === 'html5media' ? (c = a.html5mediaplayer('current_time'), e = a.html5mediaplayer('duration')) : (c = a.player('info', 'currentTime'), e = a.player('info', 'duration')); if (typeof $f() === 'undefined' && a.data('player').type === 'html5media' || !b) {
            c /= e, c = Math.floor(f.width() * c), h.css('width', c);
          } else {
            if (typeof a.data('timer') !== 'undefined') {
              return !1;
            } c = []; c.push(setInterval(function () {
              var d = -1, b = 0;

 return function () {
                var c;

                c = a.data('player').type === 'html5media' ? a.html5mediaplayer('current_time') : a.player('info', 'currentTime'); a.trigger('timeupdate.player'); c >= e || d === c && b >= 2 ? a.trigger('clear_timer') : (b = d === c ? ++b : 0, d = c);
              };
            }(), 250)); a.data('timer', c);
          }
        }).bind('ended.player', function () {
          e.find('.play_btn').removeClass('active'); h.css('width', '100%');
        }).bind('playing.player, play.player', function () {
          e.find('.play_btn').removeClass('active'); typeof $f() === 'undefined' && a.data('player').type === 'html5media' || a.trigger(
'timeupdate.player',
            !0
);
        }).bind('pause.player', function () {
          e.find('.play_btn').addClass('active');
        }), e.bind('mousedown', function (d) {
          d.stopPropagation(); var b, c;

 k(this); c = f.offset(); d.pageX < c.left || d.pageX > c.left + f.width() || (b = h.width(), a.data('player').type === 'html5media' ? a.html5mediaplayer('pause') : a.player('pause'), typeof $f() === 'undefined' && h.width(d.pageX - c.left), g.one('mouseup', a, function () {
            h.width(b);
          }));
        }).bind('mouseup', function (d) {
          d.stopPropagation(); var b, c;

 b = f.offset(); g.unbind('mouseup'); d.pageX < b.left || d.pageX >
b.left + f.width() || (d = d.pageX - f.offset().left, b = d / f.width(), c = a.data('player').type === 'html5media' ? a.html5mediaplayer('duration') : a.player('info', 'duration'), b *= c, typeof $f() !== 'undefined' && (b = d = 0), h.width(d), a.trigger('clear_timer'), a.data('player').type === 'html5media' ? a.html5mediaplayer('seekTo', b, function () {
            a.html5mediaplayer('play', function () {
              a.trigger('timeupdate.player', !0);
            });
          }) : a.player('seek', b, function () {
            setTimeout(function () {
              a.player('play'); a.trigger('timeupdate.player', !0);
            }, 500);
          }));
        }).find('.play_btn').bind(
'click',
          function (b) {
            b.preventDefault(); b = k(this); typeof a.data('player') !== 'undefined' && a.data('player').type === 'html5media' ? a.html5mediaplayer('isPaused') ? (a.html5mediaplayer('play'), b.removeClass('active'), a.trigger('timeupdate.player', !0)) : (a.html5mediaplayer('pause'), b.addClass('active'), a.trigger('clear_timer')) : a.player('info', 'state') !== 1 ? (a.player('play'), b.removeClass('active'), a.trigger('timeupdate.player', !0)) : a.player('info', 'state') === 1 && (a.player('pause'), b.addClass('active'), a.trigger('clear_timer'));
          }
).siblings('.full_btn').bind(
'click',
          function (b) {
            b.preventDefault(); a.data('player').type === 'html5media' ? typeof $f() === 'undefined' && fullScreenApi.requestFullScreen(a.find('.video')[0]) : (fullScreenApi.requestFullScreen(a.find('iframe')[0]), fullScreenApi.requestFullScreen(a[0]));
          }
)) : m && console.log('custom-controls: video element found.');
      }
};
    }();
  });
})();
// //////////////////////////////

// //////////////////////////////
// mpp_filtering
// //////////////////////////////
(function ($) {
  //
  //    METHOD OVERVIEW
  //
  //      init:
  //            Move filter tab to correct position
  //            Move filter panel to correct position
  //            Event handlers 
  //
  //      adjustMppProductHeights:
  //            Look at the height of all the visible products in each row
  //            and make them all the same height (using tallest in row as a guide)
  //
  //      populateConcernedArr:
  //            Create array of all filter possibilities based on product list (dry, oily, daywear, etc)
  //
  //      filterProducts:
  //            Based on selected filters, decide which products to display
  //
  //      createZeroProductFilterMatrix:
  //            Create a [filter1][filter2] matrix that returns TRUE if there are ZERO products with both those filters
  //
  //      greyOutZeroResultFilters:
  //            Based on chosen filters, decide which filters, if selected, would result in zero products, 
  //            and grey out those filters
  //
  //      getClassFromFilterLineItem:
  //            Given a filter line item DOM element, get its filter class, e.g., dry, normal_combination, etc
  //
  //      setVisibleItemCount:
  //            Display number of visible products
  //
  //      createSecondColumnForAttributesIfNeeded:
  //            If an attribute has too many filters in a single column, move the extra filters to a second column
  //
  //      adjustColumnWidths:
  //            Based on the number of attributes and the number of columns in each attribute,
  //            adjust the width of those attributes and the columns in them.
  //
  //      adjustMppProductGrid:
  //            The current grid adds a special class to those products in the middle of a row,
  //            which works unless they're not in the middle of a row anymore. This function
  //            sees what's in the middle, and gives that product a special class.
  //

  site.mpp_filter = {
    isIE: $('html').data('useragent').indexOf('MSIE') > -1,
    zeroProductFilterMatrix: {},
    lastFilterClicked: { 'name': '',
'selected': true },

    //
    //    TERMS:
    //      Attribute: category of filter option. 
    //        Examples: Skin Type, Skin Concern, Collection
    //    
    //      Filter option: specific option within an attribute
    //        Examples: 
    //          "Dry" and "Normal" filter options in the Skin Type attribute
    //          "DayWear" and "Hydrationist" filter options in Collection attribute

    //    Use OR within an attribute (like Skin Type)
    //        So users can choose "Dry" "Normal" and "Oily"
    //        and that INCREASES the number of visible products
    //
    //    Use AND between attributes
    //        If a user chooses, say, "Dry" and "Normal" skin types, then
    //        certain filter options in other attributes (like Skin Concern or Collections)
    //        will grey out.
    //      

    maxNumberFiltersPerColumn: 7,

    lastAttributeWhereUserClickedAFilter: false,

    //
    //    Use this array to set which categories display the filter
    //
    allowedCatBaseIdsForFilter: [
      688, //  Moisturizers
      689 //  Serum
      // 685,  //  Eye Care
      // 637,  //  Mascara
      // 684,  //  Cleanser/Toner
      // 649,   //  Lipstick
      // 647,   // Lip gloss
      // 636,   // Eye Shadow
      // 643   // Foundation
    ], // use integers, not strings

    showSkinTypes: [688],
    showCollections: [688, 689, 685, 637, 684, 649, 643],
    showBenefits: [637, 684],
    showConcerns: [688, 689, 685],
    showFinishes: [643],
    showIntensity: [643],
    showCoverage: [643],
    thisCatId: null,
    concernArr: [],
    init: function () {
      // 
      //    Make sure 
      //      1.  filter exists on the page and 
      //      2.  the current MPP should show it
      //
      // thisCatId = page_data['custom-mpp'].categories[0].CAT_BASE_ID;
      // if ($("#mpp__filter").length === 0 || $.inArray(thisCatId, site.mpp_filter.allowedCatBaseIdsForFilter) === -1) {
      // return false;
      // }

      var $mppFilter = $('#mpp__filter');
      var $mppFilterTab = $('#mpp__filter-tab');
      var widthFilter = $mppFilter.outerWidth();
      var filterPos = $mppFilter.position();
      var filterTop = $mppFilter.css('top');
      var heightFilterTab = $mppFilterTab.outerHeight();
      var $allSections = $('#mpp__filter .mpp__filter-section');
      var newFilterTop;
      var widthFilterTab;

      //
      //    Sapce out products in MPP grid
      //
      site.mpp_filter.adjustMppProductGrid();

      // 
      //  Move "Filter By" next to "Moisturizers" headline
      //
      $($mppFilterTab).detach().prependTo('.mpp.js-mpp-wrapper');

      //
      //  Move filter panel just above product grid
      //  and make it visible
      //
      $mppFilter.detach().insertBefore('.mpp__product-grid');

      //
      // Find out which filter items should be shown
      //
      // site.mpp_filter.populateConcernedArr();      
      // site.mpp_filter.setVisibleItemCount();

      // show appropriate filters and hide the others 
      // $('.mpp__filter-content li.mpp__filter-item').addClass('js-inactive');
      // for(var i = 0; i < site.mpp_filter.concernArr.length; i++){
      // $('.mpp__filter-content li.mpp__filter-item.'+site.mpp_filter.concernArr[i]).removeClass('js-inactive');
      // }

      //  add hidden class to items who aren't available for this MPP's "default state" 
      //  (i.e., when no filters are currently engaged)
      // $('.mpp__filter-content li.mpp__filter-item.js-inactive').addClass('hidden'); 

      site.mpp_filter.zeroProductFilterMatrix = site.mpp_filter.createZeroProductFilterMatrix();

      // 
      //    Remove attributes without options in them
      //
      //      Examples of attributes: Skin Type, Finish, Collection
      //
      //      In every attribute (i.e., ".mpp__filter-section"), see if there are any non-"js-inactive" filter items
      //      If they're all js-inactive, hide the attribute
      //
      $.each($allSections, function (index) {
        var numActiveFilters = $(this).find("li:not('.js-inactive')").size();

        if (numActiveFilters === 0) {
          $(this).remove();
        }
      });

      //
      //    Decide if any attributes have too many filters, and they need a second column
      //
      site.mpp_filter.createSecondColumnForAttributesIfNeeded();

      site.mpp_filter.adjustColumnWidths();

      //
      //  Move filter panel just above product grid and make it visible
      //
      $mppFilter.detach().insertBefore('.mpp__product-grid');

      // //////////////////////////////
      //                            //
      //  EVENT HANDLERS            //
      //                            //
      // //////////////////////////////

      //
      //    Click filter options
      //
      $('#mpp__filter li.mpp__filter-item a').click(function (e) {
        e.preventDefault();

        site.mpp_filter.scrollToTopOfFilter();

        //
        //  Ignore the click if the user's clicked on a greyed-out filter option
        //
        if ($(this).parents('.zero-results').size() > 0) {
          return false;
        }

        //
        //    Remember which filter was clicked on most recently and
        //    See if filter is about to be displayed as "selected"
        //
        var isSelected = !$(this).find('.filter-item-checkbox.active').size();

        site.mpp_filter.lastFilterClicked = {
          'name': site.mpp_filter.getClassFromFilterLineItem($(this).closest('li.mpp__filter-item')),
          'selected': isSelected
        };

        //
        //    For analytics
        //
        //      Should create something like this: "Skincare|Moisturizers|Skin Concern|Loss of Firmness"
        //
        if (tms_page_data && tms_page_data['tms_page_info'] && tms_page_data['tms_page_info']['page_name']) {
          var pageNameArr = tms_page_data['tms_page_info']['page_name']['pageID'].split(' | ');
          var hierarchy1 = pageNameArr[2];
          var hierarchy2 = pageNameArr[4];
          var hierarchy3 = categoryName = $(this).closest('.mpp__filter-section').find('h2').text();
          var filterName = $(this).find('.filter-name').text();

          $(this).trigger('MPP:FILTERCLICK', [hierarchy1 + '|' + hierarchy2 + '|MPP Filter-' + hierarchy3 + '|' + filterName]);
        }

        //
        //  See which attribute the user clicked inside
        //
        $thisAttribute = $(this).closest('.mpp__filter-section');
        site.mpp_filter.lastAttributeWhereUserClickedAFilter = $('.mpp__filter-section').index($thisAttribute);

        // Make filter and checkbox active
        $(this)
          .toggleClass('active')
          .find('.filter-item-checkbox').toggleClass('active');

        site.mpp_filter.filterProducts();
        site.mpp_filter.greyOutZeroResultFilters();
        site.mpp_filter.adjustMppProductHeights(); // make sure all visible products in a row have same height
        site.mpp_filter.adjustMppProductGrid();
        site.mpp_filter.setVisibleItemCount();

        //
        //  Update "Clear all" button, if necessary
        //
        var $clearAll = $mppFilter.find('.clear-all');

        if ($mppFilter.find('li.mpp__filter-item a.active').size() === 0) {
          $clearAll.removeClass('filter-selected');
        } else {
          if (!$clearAll.hasClass('filter-selected')) {
            $clearAll.addClass('filter-selected');
          }
        }
      });

      //
      //    Click Filter tab
      //
      $mppFilterTab.click(function (evt) {
        site.mpp_filter.scrollToTopOfFilter();

        if ($mppFilter.css('display') == 'none') {
          $mppFilter.slideDown();
          $mppFilterTab.find('.plus').fadeOut('fast', function () {
            $mppFilterTab.find('.minus').fadeIn('fast').css('display', 'inline-block');
          });
        } else {
          $mppFilter.slideUp();
          $mppFilterTab.find('.minus').fadeOut('fast', function () {
            $mppFilterTab.find('.plus').fadeIn('fast').css('display', 'inline-block');
          });
        }
      });

      //  
      //    Hover over "Clear All"
      //
      //      We're using a class instead of ":hover" in CSS
      //      because ":hover" causes a problem in iPad
      //
      $('#mpp__filter-footer .clear-all').hover(function () {
        $(this).addClass('hover');
      }, function () {
        $(this).removeClass('hover');
      });

      //
      //  Click "Clear All"
      //
      //    Click all active (selected) filters, which should unselect them
      //
      $('#mpp__filter-footer .clear-all').click(function () {
        var $activeLinks = $('li.mpp__filter-item a.active');

        $activeLinks.each(function () {
          $(this).trigger('click');
        });
        $(this).removeClass('hover'); // fixing iPad bug where "hover" gets added back
      });
    },

    //
    //  Look at the height of all the visible products in each row
    //  and make them all the same height (using tallest in row as a guide)
    //
    adjustMppProductHeights: function () {
      var numProductsInRow = 3;
      var $visibleProducts = $('.mpp__product-grid li.mpp__product').not('.hidden');
      var numVisibleProducts = $visibleProducts.size();
      var maxRowHeight = 0;
      var counter = 0;
      var productHeight;

      // loop over all visible products
      for (i = 0; i < numVisibleProducts; i++) {
        productHeight = $visibleProducts.eq(i).css('height');
        productHeight = Number(productHeight.replace('px', ''));

        if (productHeight > maxRowHeight) {
          maxRowHeight = productHeight;

          if (counter === 1) {
            $visibleProducts.eq(i - 1).css('height', maxRowHeight + 'px');
          } else if (counter === 2) {
            $visibleProducts.eq(i - 1).css('height', maxRowHeight + 'px');
            $visibleProducts.eq(i - 2).css('height', maxRowHeight + 'px');
          }
        } else {
          $visibleProducts.eq(i).css('height', maxRowHeight + 'px');
        }
        counter++;
        if (counter === numProductsInRow) {
          counter = 0;
          maxRowHeight = 0;
        }
      }
    },

    populateConcernedArr: function () {
      var allSkinTypes = [];
      var skintypes = [];

      //
      //   Loop over all visible products in the MPP list
      //
      $('ul.mpp__product-grid li.mpp__product[data-productid]').not('.hidden').each(function (j, prodBox) {
        //
        //   Get product data from page_data
        //
        var prodId = $(prodBox).attr('data-productid');
        var product = $(page_data['catalog-mpp'].categories[0].products).filter(function () {
          return this.PRODUCT_ID === prodId;
        })[0];

        if (typeof product == 'undefined') {
          return true;
        }

        //
        // Add SKIN CONCERN
        //
        //    These appear as comma-separated strings, like "Lines and Wrinkles,Uneven Skintone,Blemishes,Enlarged Pores"
        //
        if (product.ATTRIBUTE_CONCERN !== null && product.ATTRIBUTE_CONCERN !== 'undefined' && $.inArray(thisCatId, site.mpp_filter.showConcerns) > -1) {
          skinConcerns = product.ATTRIBUTE_CONCERN.split(',');

          $.each(skinConcerns, function (index, value) {
            skinConcernFormatted = value.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
            $(prodBox).addClass(skinConcernFormatted);
            if ($.inArray(skinConcernFormatted, site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(skinConcernFormatted);
            }
          });
        }

        //
        // Add SKIN TYPES
        //
        //    These appear as comma-separated strings, like "Normal/Combination, Dry, Oily"
        //
        if (product.ATTRIBUTE_SKINTYPE !== null && $.inArray(thisCatId, site.mpp_filter.showSkinTypes) > -1) {
          skintypes = product.ATTRIBUTE_SKINTYPE.split(',');

          $.each(skintypes, function (index, value) {
            skinTypeFormatted = value.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
            $(prodBox).addClass(skinTypeFormatted);
            if ($.inArray(skinTypeFormatted, site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(skinTypeFormatted);
            }
          });
        }

        //
        // Add BENEFITS
        //
        if (product.ATTRIBUTE_BENEFIT !== null && $.inArray(thisCatId, site.mpp_filter.showBenefits) > -1) {
          var arr = product.ATTRIBUTE_BENEFIT.split(',');

          $.each(arr, function (index, value) {
            var val = value.replace(/^\s+|\s+$/g, ''); // trim() that works with IE8

            val = val.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
            $(prodBox).addClass(val);
            if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(val);
            }
          });
        }

        // 
        //  Add COLOR FAMILY
        //
        for (i = 0; i < product.skus.length; i++) {
          if (product.skus[i].ATTRIBUTE_COLOR_FAMILY !== null) {
            val = $.trim(product.skus[i].ATTRIBUTE_COLOR_FAMILY).toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');

            // fix color mappings
            switch (val) {
              case 'natural_browns':
                val = 'naturals_browns';
                break;
              case 'violets_blues':
                val = 'violets_blues';
                break;
              case 'violets__blues':
                val = 'violets_blues';
                break;
              case 'violets___blues':
                val = 'violets_blues';
                break;
              case 'violets__berries':
                val = 'violets_blues';
                break;
              case 'violets___berries':
                val = 'violets_blues';
                break;
            }

            $(prodBox).addClass(val);
            if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(val);
            }
          }
        }

        //
        //    Add FINISH
        //
        var thisProductFinishes = [];

        productSkusLength = product.skus.length;
        if (productSkusLength > 0) {
          for (i = 0; i < productSkusLength; i++) {
            // Make sure SKU's skin type is in the list for this category
            if ($.inArray(thisCatId, site.mpp_filter.showFinishes) !== -1) {
              thisProductFinishes.push(product.skus[i].FINISH);
            }
          }
        }
        // remove duplicate entries from skin type array
        thisProductFinishes = $(thisProductFinishes).filter(function (itm, i, a) {
          return i = $.inArray(itm, a);
        });
        len = thisProductFinishes.length;
        for (i = 0; i < len; i++) {
          if ($.inArray(thisProductFinishes[i], site.mpp_filter.concernArr) == -1) {
            site.mpp_filter.concernArr.push(thisProductFinishes[i]);
          }
        }

        //
        //    Add INTENSITY
        //
        var thisProductIntensity = [];

        productSkusLength = product.skus.length;
        if (productSkusLength > 0 && $.inArray(thisCatId, site.mpp_filter.showIntensity) !== -1) {
          for (i = 0; i < productSkusLength; i++) {
            val = $.trim(product.skus[i].INTENSITY).toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
            thisProductIntensity.push(val + '_intensity');
          }
        }
        // remove duplicate entries from intensity array
        thisProductIntensity = $(thisProductIntensity).filter(function (itm, i, a) {
          return i = $.inArray(itm, a);
        });
        len = thisProductIntensity.length;
        for (i = 0; i < len; i++) {
          if ($.inArray(thisProductIntensity[i], site.mpp_filter.concernArr) == -1) {
            $(prodBox).addClass(thisProductIntensity[i]);
            site.mpp_filter.concernArr.push(thisProductIntensity[i]);
          }
        }

        //
        //    Add COVERAGE
        //
        if (product.ATTRIBUTE_COVERAGE !== null && $.inArray(thisCatId, site.mpp_filter.showCoverage) > -1) {
          arr = product.ATTRIBUTE_COVERAGE.split(',');
          $.each(arr, function (index, value) {
            val = value.replace(/^\s+|\s+$/g, ''); // trim() that works with IE8
            val = val.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
            $(prodBox).addClass(val);
            if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(val);
            }
          });
        }

        //  
        //    Add COLLECTION
        //
        if (product.ATTRIBUTE_COLLECTION !== null && $.inArray(thisCatId, site.mpp_filter.showCollections) > -1) {
          val = product.ATTRIBUTE_COLLECTION.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');

          // fix collection mappings
          switch (val) {
            case 'pure_color_envy_shine':
              val = 'pure_color';
              break;
            case 'pure_color_envy':
              val = 'pure_color';
              break;
          }

          $(prodBox).addClass(val);
          if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
            site.mpp_filter.concernArr.push(val);
          }
        }
      });
    },
    // end showConcernedArr

    //
    //    FILTER PRODUCTS
    //
    //      Okay, this gets a little complicated. Hang on.
    //
    //      STEP ONE.
    //      Within each attribute, e.g., Skin Type, Skin Concern, Collection,
    //      users can select multiple options, and those are treated as OR.
    //
    //      Example:
    //        In the Skin Type attribute, a user selects "Dry", "Oily", and "Normal".
    //        All products that have EITHER "Dry" OR "Oily" OR "Normal" are shown.
    //        So every time a user selects an option within the same attribute, the number
    //        of products increases.
    //
    //      So in the first step, we look at all the attributes (there can be different numbers 
    //      and different kinds of attributes). Each attribute gets its own set of products.
    //      That is, we pretend that only that attribute exists, and create a selector that 
    //      would display only the user-selected products.
    //
    //      Clear as mud? Check out the example.
    //
    //      Example:
    //        There are three attributes: Skin Care, Skin Concern, and Collection.
    //        The user has selected a few filters in each attribute.
    //        In the Skin Care attribute, the user has selected "Dry" and "Normal".
    //        The code ignores the existance of other two attributes and creates a selector
    //        that shows all the "Dry" and "Normal" products:
    //          "li.mpp__product.dry, li.mpp__product.normal"
    //            (in real life skin types are done with 'type-'+number, so the real selector would be:
    //            "li.mpp__product.type-2, li.mpp__product.type-3")
    //
    //          selector[0] = "li.mpp__product.type-2, li.mpp__product.type-3"
    //          selector[1] = "li.mpp__product.wrinkles, li.mpp__product.redness"
    //          selector[2] = "li.mpp__product.daywear, li.mpp__product.nutritious"
    //
    //
    //      STEP TWO.
    //
    //      prods = $(selector[0]).filter(selector[1]).filter(selector[2])
    //
    //      
    filterProducts: function () {
      //
      //  Find out number of attributes
      //
      var numAttributes = $('.mpp__filter-section').size();
      var selector;
      var prods = [];
      var className;
      var selectedFilters = [];
      var $currentAttribute;
      var currentFilter;

      //
      //    Find out which filters in this attribute have been selected
      //      and put them in "activeParams"
      //
      for (var i = 0; i < numAttributes; i++) {
        selectedFilters = [];
        $currentAttribute = $('.mpp__filter-section').eq(i);

        $currentAttribute.find('li.mpp__filter-item a.active').each(function () {
          selectedFilters.push($(this).parent().attr('class'));
        });

        //
        //    Create product set based on the selected filters
        //
        for (var j = 0; j < selectedFilters.length; j++) {
          selector = 'li.mpp__product.na';

          currentFilter = selectedFilters[j]; // this will be something like "mpp__filter-item type-3"

          for (var k = 1; k < currentFilter.split(' ').length; k++) {
            className = currentFilter.split(' ')[k];
            if (typeof className != 'undefined') {
              className = className.replace(/^\s+|\s+$/g, ''); // trim() for IE8
              if (className.length > 0) {
                selector += ', li.mpp__product.' + className;
              }
            }
          }

          //
          //    Based on the selector, build the set of products that should be displayed
          //
          var newProds = $(selector);

          if (typeof prods[i] === 'undefined') {
            prods[i] = newProds;
          } else {
            prods[i] = $.merge(prods[i], newProds);
          }

          //
          //    If there are no selected filters, then show all the products
          //
          if (selectedFilters[j].length === 0) {
            $('li.mpp__product').removeClass('hidden');
          }
        }
      }

      //
      //    At this point, we have X sets of products, one set for every attribute.
      //    It's time to filter those in order to create a final set of filtered products
      //
      var $prodsToShow = $('.mpp__product');

      $.each(prods, function (index, prodSet) {
        if (typeof prodSet !== 'undefined') {
          $prodsToShow = $prodsToShow.filter(prodSet);
        }
      });

      $('li.mpp__product').addClass('hidden');
      $prodsToShow.removeClass('hidden');
    },

    //
    //    Create a matrix that says whether the intersection of two filter classes,
    //    e.g., "Dry" and "Blemishes" result in zero products or not.
    //
    //    Examples:
    //      matrix["dry"]["blemishes"] = true                           : this means there are zero products
    //      matrix["normal_combination"]["enlarged_pores"] = false      : this means there one or more products
    //
    createZeroProductFilterMatrix: function () {
      var matrix = {};
      var $visibleProducts = $('.mpp__product');
      var numFilters = site.mpp_filter.concernArr.length;

      for (var i = 0; i < numFilters; i++) {
        var filter1 = site.mpp_filter.concernArr[i];

        matrix[filter1] = {};

        for (var j = 0; j < numFilters; j++) {
          var filter2 = site.mpp_filter.concernArr[j];

          // default value, assumes no products
          //
          matrix[filter1][filter2] = true;

          //  Loop over all products
          //  See if there are any products that share the classes (i.e., filters) we're looking at
          //
          $.each($visibleProducts, function (index, value) {
            if ($(value).hasClass(filter1) && $(value).hasClass(filter2)) {
              matrix[filter1][filter2] = false; // this means that there's at least one product with both those filters

              return false; // we have our answer, and it's time to look at the next filter
            }
          });
        }
      }

      return matrix;
    }, // end createZeroProductFilterMatrix

    greyOutZeroResultFilters: function () {
      var $filtersInAttribute;
      var $filtersToExamine;
      var filterClassName;

      var $activeFiltersInLoopAttribute;

      var thisFilterClassArr;
      var thisFilterClass;
      var activeFilterClass;

      var $loopAttributes;

      var hasZero;

      var thisAttributeIsAllTrue;
      var anyAttributeIsAllTrue;

      var selectedFilter = site.mpp_filter.lastFilterClicked.name;

      var $attributes = $('#mpp__filter .mpp__filter-section');
      var $currentAttribute = $('.mpp__filter-section').has('li.mpp__filter-item.' + selectedFilter);
      var currentAttributeIndex = $('.mpp__filter-section').index($currentAttribute);
      var $attributesExceptCurrent = $('.mpp__filter-section').not(':eq(' + currentAttributeIndex + ')');
      var numSelectedFiltersInCurrentAttribute = $currentAttribute.find('li.mpp__filter-item a.active').size();

      var $normalFiltersToExamine = $('#mpp__filter li.mpp__filter-item').not('.js-inactive, .zero-results, :has(a.active)');

      var $greyedOutFilters = $('#mpp__filter li.mpp__filter-item.zero-results');
      var greyedOutFilterClass;
      var greyedOutFilterAttr;

      //
      //  SCENARIO 1: USER SELECTS FIRST FILTER IN AN ATTRIBUTE
      //
      //      Skin Types
      //      ---------------
      //      [x] Dry                       <-- selected
      //      [ ] Normal/Combination
      //      [ ] Oily
      //
      //  IF 
      //    this is the only selected filter in the attribute
      //      AND
      //    this filter is selected (instead of deselected)
      //  THEN
      //    grey out filters (not in current attribute) with zero products
      //
      //  COMPLICATION:
      //    -   You have to look at other attributes as a whole. That is, if the combined active (selected) filters
      //        in an attribute all result in zero products for a given non-active filter, then that filter
      //        must be greyed out. 
      //
      if (numSelectedFiltersInCurrentAttribute === 1 && site.mpp_filter.lastFilterClicked.selected) {
        //
        //  v2: 
        //        if all the active filters in an attribute have a [][] results of true,
        //        that means that attribute's selection keep that grey-out filter greyed out
        //        because attributes act as AND (i.e., subtractive)

        //
        //    For all NORMAL filters NOT in current attribute
        //
        $filtersToExamine = $attributesExceptCurrent.find('.mpp__filter-item').not('.js-inactive, .zero-results, :has(a.active)');

        //
        //      For each non-greyed-out filter, look at the active filters in the other attributes
        //
        $.each($filtersToExamine, function (filterIndex, filterValue) {
          filterClassName = site.mpp_filter.getClassFromFilterLineItem($(filterValue));
          $loopAttributes = $('.mpp__filter-section').not(':has(li.mpp__filter-item.' + filterClassName + ')');

          //
          //    Loop over all attributes not containing the current filter class
          //
          $.each($loopAttributes, function (loopAttributeIndex, loopAttributeValue) {
            thisAttributeIsAllTrue = true;
            $activeFiltersInLoopAttribute = $(loopAttributeValue).find('.mpp__filter-item:has(a.active)');

            if ($activeFiltersInLoopAttribute.size() === 0) {
              thisAttributeIsAllTrue = false;
            } else {
              //
              //  Loop over those active filters
              //
              $.each($activeFiltersInLoopAttribute, function (activeFilterIndex, activeFilterValue) {
                activeFilterClass = site.mpp_filter.getClassFromFilterLineItem($(activeFilterValue));
                hasZero = site.mpp_filter.zeroProductFilterMatrix[filterClassName][activeFilterClass];
                if (!hasZero) {
                  thisAttributeIsAllTrue = false;

                  return false; // we don't need to look in this attribute any more
                }
              });
            }

            if (thisAttributeIsAllTrue) {
              $(filterValue).addClass('zero-results');
            }
          });
        });

      //
      //  SCENARIO 2: USER *DE*SELECTS ONLY FILTER IN AN ATTRIBUTE
      //
      //  IF 
      //    this was the only selected filter in the attribute
      //      AND
      //    this filter is deselected (instead of selected)
      //  THEN
      //    see if any greyed-out filters can be un-greyed-out (i.e., returned to normal)
      //
      //   The only thing that would cause a grey-out filter to remain greyed-out would be the action of 
      //    another active filter.
      //
      //      1. Loop over list of filters that COULD cause greying out (i.e., active ones).
      //      2. IF a filter (say, "double_wear") is selected, then it MIGHT be causing the greying out of, say, "blemishes".
      //      3. In order for a grey-out filter to remain grey-out, ALL ACTIVE filters must have no intersection
      //         with the grey-out filter.
      //          - that is:
      //          site.mpp_filter.zeroProductFilterMatrix[grey-out filter][active filter] = true
      //          for ALL ACTIVE FILTERS
      //          If even one active filter is "false" above, the greyed-out filter reverts to normal
      //
      //  Example:
      //
      //      Skin Types
      //      ---------------
      //      [ ] Dry                       <-- deselected
      //      [ ] Normal/Combination
      //      [ ] Oily
      //
      } else if (numSelectedFiltersInCurrentAttribute === 0 && !site.mpp_filter.lastFilterClicked.selected) {
        //
        //  loop over all grey-ed out filters
        //
        //    loop over all attributes except current one
        //  
        //      loop over all active filters in an attribute
        //
        //        if all the active filters in that attribute have a [][] results of true,
        //        that means that attribute's selection keep that grey-out filter greyed out
        //        because attributes act as AND (i.e., subtractive)
        //

        // $greyedOutFilters = $("#mpp__filter li.mpp__filter-item.zero-results");
        // $attributesExceptCurrent = $(".mpp__filter-section").not(":eq(" + currentAttributeIndex + ")");

        //
        //    Loop over all greyed-out filters
        //
        $.each($greyedOutFilters, function (greyedOutIndex, greyedOutValue) {
          greyedOutFilterClass = site.mpp_filter.getClassFromFilterLineItem($(greyedOutValue));
          anyAttributeIsAllTrue = false;

          $.each($('.mpp__filter-section'), function (attrIndex, attrValue) {
            // if the greyed-out attribute and the active filter are in the same attribute
            // they shouldn't be compared to each other 
            //
            greyedOutFilterAttr = $(greyedOutValue).closest('.mpp__filter-section');
            if (greyedOutFilterAttr.is($(attrValue))) {
              return true;
            }

            thisAttributeIsAllTrue = true;
            $activeFiltersInLoopAttribute = $(attrValue).find('.mpp__filter-item:has(a.active)');

            if ($activeFiltersInLoopAttribute.size() === 0) {
              thisAttributeIsAllTrue = false;
            } else {
              //
              //  Loop over those active filters
              //
              $.each($activeFiltersInLoopAttribute, function (activeFitlerIndex, activeFilterValue) {
                activeFilterClass = site.mpp_filter.getClassFromFilterLineItem($(activeFilterValue));
                hasZero = site.mpp_filter.zeroProductFilterMatrix[greyedOutFilterClass][activeFilterClass];

                if (!hasZero) {
                  thisAttributeIsAllTrue = false;

                  return false; // we don't need to look in this attribute any more
                }
              }); // end loop over active filters
            }

            if (thisAttributeIsAllTrue) {
              anyAttributeIsAllTrue = true;

              return true;
            }
          }); // end loop over attributes

          if (!anyAttributeIsAllTrue) {
            $(greyedOutValue).removeClass('zero-results');
          }
        });

      //
      //  SCENARIO 3:
      //    USER SELECTS SECOND OR MORE FILTER IN AN ATTRIBUTE
      //
      //    We now look for greyed-out options to UN-grey-out
      //    IN OTHER ATTRIBUTES
      //
      //  Example:
      //
      //      Skin Types
      //      ---------------
      //      [x] Dry                       
      //      [x] Normal/Combination      <-- selected
      //      [ ] Oily
      //
      } else if (numSelectedFiltersInCurrentAttribute >= 1 && site.mpp_filter.lastFilterClicked.selected) {
        // $greyedOutFilters = $("#mpp__filter li.mpp__filter-item.zero-results");
        selectedFilter = site.mpp_filter.lastFilterClicked.name;
        $currentAttribute = $('.mpp__filter-section').has('li.mpp__filter-item.' + selectedFilter);

        //
        //    Loop over all greyed-out filters
        //
        $.each($greyedOutFilters, function (index, value) {
          $loopAttribute = $(value).closest('.mpp__filter-section');
          if ($loopAttribute.is($currentAttribute)) {
            return true; // same as "continue" in loops
          }

          greyedOutFilterClass = site.mpp_filter.getClassFromFilterLineItem($(value));
          //
          //    If there's an intersection of the user-selected filter and the greyed-out filter,
          //    un-grey-out the filter.
          //
          if (!site.mpp_filter.zeroProductFilterMatrix[selectedFilter][greyedOutFilterClass]) {
            $(value).removeClass('zero-results');

            return true; // same as continue
          }
        });
        //
        //  SCENARIO 4:
        //    USER *DE*SELECTS SECOND OR MORE FILTER IN AN ATTRIBUTE
        //
        //    This might INCREASE the number of greyed-out options.
        //
        //    Method: Go over all non-greyed-out, non-selected filters (outside the current attribute) 
        //    and see if they should be greyed out.
        //
        //    For each non-greyed-out, non-selected filter (i.e., normal state):
        //    - compare that filter to all the active filters that aren't in that filter's own attribute
        //
        //
        //  Example:
        //
        //      Skin Types
        //      ---------------
        //      [x] Dry                       
        //      [ ] Normal/Combination      <-- deselected
        //      [ ] Oily
        //
      } else if (numSelectedFiltersInCurrentAttribute >= 0 && !site.mpp_filter.lastFilterClicked.selected) {
        //
        //    Loop over all non-greyed-out, non-selected filters outside current attribute
        //
        //      For each of those "normal" filters, loop over attributes outside of that normal filter's attribute
        //
        //        For each attribute, loop over all of that attribute's active filters
        //
        //           If 
        //            ALL of those attribute's active filters result in [normal][active] = true
        //           THEN 
        //            thisAttributeIsAllTrue = true
        //           ELSE
        //            thisAttributeIsAllTrue = false
        //
        //              Which means 
        //                anyAttributeIsAllTrue = false
        //
        //          If anyAttributeIsAllTrue,
        //            that means there's an attribute whose selections (i.e., active filters) whose existence will force a grey-out
        //            of the "normal" filter
        //
        //
        //
        //    

        $.each($normalFiltersToExamine, function (normalFilterIndex, normalFilterValue) {
          $normalFiltersAttribute = $(normalFilterValue).closest('.mpp__filter-section');
          anyAttributeIsAllTrue = false;
          normalFilterClass = site.mpp_filter.getClassFromFilterLineItem($(normalFilterValue));

          //
          //    Loop over all attributes
          //
          $.each($('.mpp__filter-section'), function (attrIndex, attrValue) {
            thisAttributeIsAllTrue = true;

            //
            //  If the loop's attribute is the same as the normalFilter's attribute, skip to the next attribute
            //
            if ($normalFiltersAttribute.is($(attrValue))) {
              return true; // continue to next loop value
            }

            $thisAttrActiveFilters = $(attrValue).find('.mpp__filter-item:has(a.active)');

            if ($thisAttrActiveFilters.size() === 0) {
              thisAttributeIsAllTrue = false;
            } else {
              $.each($thisAttrActiveFilters, function (activeFilterIndex, activeFilterValue) {
                //
                //    See if the [][] combination of the normalFilter and the activeFilter
                //
                activeFilterClass = site.mpp_filter.getClassFromFilterLineItem($(activeFilterValue));
                hasZero = site.mpp_filter.zeroProductFilterMatrix[normalFilterClass][activeFilterClass];
                if (!hasZero) {
                  thisAttributeIsAllTrue = false;

                  return false; // we don't need to look at this attribute any more
                }
              }); // end active filter loop
            }

            if (thisAttributeIsAllTrue) {
              anyAttributeIsAllTrue = true;

              return true;
            }
          }); // end attribute loop

          if (anyAttributeIsAllTrue) {
            $(normalFilterValue).addClass('zero-results');
          }
        });
      }
    },

    //
    //    Get a filter class like "dry" or "lines_and_wrinkles" from a DOM element
    //
    getClassFromFilterLineItem: function (filterElement) {
      var thisFilterClassArr = $(filterElement).attr('class').split(' ');

      thisFilterClassArr = $.grep(thisFilterClassArr, function (value) {
        return value != 'mpp__filter-item' && value != 'zero-results';
      });

      return thisFilterClassArr[0];
    },

    setVisibleItemCount: function () {
      var numProducts = $('.mpp__product-grid li.mpp__product').not('.hidden').size();

      $('#mpp__filter-footer .js-item-count').html(numProducts);

      //
      //    Correct grammar
      //
      if (numProducts === 1) {
        $('#mpp__filter-footer .js-product').show();
        $('#mpp__filter-footer .js-products').hide();
      } else {
        $('#mpp__filter-footer .js-products').show();
        $('#mpp__filter-footer .js-product').hide();
      }
    },

    scrollToTopOfFilter: function () {
      $('html, body').animate({ scrollTop: $('.mpp.js-mpp-wrapper').offset().top - 80 }, 'slow');
    },

    //
    //    Any of the attributes have too many filters in them.
    //      If so, create another column and move the extra filters there
    //
    createSecondColumnForAttributesIfNeeded: function () {
      var numFiltersInAttribute;
      var $allSections = $('#mpp__filter .mpp__filter-section');

      // if the window is too small, and there are already 3 attributes,
      //    do not create an extra column
      var filterWidth = $('#mpp__filter').width();
      var numAttributes = $('.mpp__filter-section').size();

      if (filterWidth <= 800 && numAttributes >= 3) {
        return false;
      }
      // console.log("*** filter width", filterWidth);

      $.each($allSections, function (attrIndex, attrValue) {
        numFiltersInAttribute = $(attrValue).find('li.mpp__filter-item:not(.hidden)').size();

        if (numFiltersInAttribute > site.mpp_filter.maxNumberFiltersPerColumn) {
          //
          //  Create second column for attribute
          //
          newList = document.createElement('ul');
          $(newList).addClass('added-column');
          $(attrValue).append(newList);
          startFilterNum = site.mpp_filter.maxNumberFiltersPerColumn;
          $theFilters = $(attrValue).find('li.mpp__filter-item:not(.hidden)').slice(startFilterNum, numFiltersInAttribute);
          $theFilters.detach().appendTo($(newList));
        }
      });
    },

    adjustMppProductGrid: function () {
      var $visibleProducts = $('.mpp__product-grid li.mpp__product').not('.hidden');

      //
      //  1. Remove all classes that determine side margins
      //
      $('.mpp__product-grid li.mpp__product').removeClass('nth-child-3np2 middle left');

      //
      //    2.  Add "middle" and "left" classes to layout new product list correctly
      //
      $.each($visibleProducts, function (prodIndex, prodValue) {
        //
        //  prodIndex % 3 will be 0 , 1, 2, so 1 will be the middle product
        //
        if (prodIndex % 3 === 1) {
          $(prodValue).addClass('middle');
        } else if (prodIndex % 3 === 0) {
          $(prodValue).addClass('left');
        }
      });
    },

    //
    //    Based on the number of attributes and the number of columns in each attribute,
    //    adjust the width of those attributes and the columns in them.
    //
    adjustColumnWidths: function () {
      //
      //    Reset $allSections because we've just removed the empty ones
      //
      $allSections = $('#mpp__filter .mpp__filter-section');
      numAllSections = $allSections.size();
      $allSectionsUL = $('#mpp__filter .mpp__filter-section ul');
      numAllSectionsUL = $allSectionsUL.size();

      if (numAllSections === numAllSectionsUL) {
        if (numAllSections >= 4) {
          $allSections.addClass('four-columns');
        } else {
          $allSections.addClass('three-columns');
        }
      } else if (numAllSections < numAllSectionsUL) {
        if (numAllSectionsUL >= 4) {
          $allSections.addClass('four-columns');
          $allSectionsUL.addClass('four-columns');
        } else {
          $allSections.addClass('three-columns');
          $allSectionsUL.addClass('three-columns'); // this is the default size, even if there are only 1 or 2 columns
        }

        // if a section has 2 ULs, add "double-" to that section's class
        //  so it's wide enough to accommodate both ULs
        //
        $.each($allSections, function (sectionIndex, sectionValue) {
          if ($(sectionValue).find('ul').size() == 2) {
            if ($(sectionValue).hasClass('four-columns')) {
              $(sectionValue).removeClass('four-columns').addClass('double-four-columns');
            } else {
              $(sectionValue).removeClass('three-columns').addClass('double-three-columns');
            }
          }
        });
      }
    }
  };
  //
  //    END site.mpp_filter

  Drupal.behaviors.mpp_filter = {
    attach: function (context, settings) {
      /*
      var doABtesting = true;
      if (doABtesting)
      {
        var evarData = "";

				if (sessionStorage.splitTest == null)
				{
					if (Math.random() >= 0.5) 
					{
            evarData = "MPP Filter Test | Version A | MPP Filters Hidden"
            $('#mpp__filter-tab').addClass('hidden');
            sessionStorage.splitTest = true;

          } 
          else 
          {
            evarData = "MPP Filter Test | Version B | MPP Filters Shown"
            site.mpp_filter.init(); 
            sessionStorage.splitTest = false;
          }

				}
				else if (sessionStorage.splitTest == "false")
				{
					evarData = "MPP Filter Test | Version B | MPP Filters Shown"
          site.mpp_filter.init(); 

				}
				
				else if (sessionStorage.splitTest == "true")
				{
					  evarData = "MPP Filter Test | Version A | MPP Filters Hidden"
            $('#mpp__filter-tab').addClass('hidden');
				}
      }
      
      $(window).load(function(){
        $(window).trigger('event24', { "evar32": evarData}); 
      });
      */

    } // close attach property
  }; // close Drupal.behaviors.mpp_filter
})(jQuery);
// //////////////////////////////

// //////////////
// boutique.js
// //////////////

/* global TimelineMax:true, TweenMax:true, Power3:true, Power0:true, Power1:true, Power2:true, Project_E_Package:true, fullScreenApi:true, Spinner:true, Sector:true, Viewport:true, FastClick:true*/
jQuery(function ($) {
  'use strict';

  var debug = true, // window.location.search.indexOf('debug=true') !== -1 ? true : false,
      debug_lvl = debug && window.location.search.indexOf('debug_lvl') !== -1 ? window.location.search.charAt(window.location.search.indexOf('debug_lvl=') + 'debug_lvl='.length) : 0,
      is_mobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()),
      $window = $(window),
      $body = $('body'),
      ie_version = false,
      is_ie = function (v) { // check if IE
        var allowed = {
              8: 'trident/4.0',
              9: 'trident/5.0',
              10: 'trident/6.0',
              11: 'trident/7.0',
              12: 'trident/8.0'// temp
            },
            agent = window.navigator.userAgent.toLowerCase();

      if (v === 'any') {
          if (agent.indexOf('msie') !== -1 && agent.indexOf('trident/') !== -1) {
            var version = 1;

          for (var key in allowed) {
              if (!allowed.hasOwnProperty(key)) {
              continue;
            }
              if (agent.indexOf(allowed[key]) === -1) {
              continue;
            }
              version = key;
              break;
            }

          return version;
          }

        return false;
        }
        if (typeof allowed[v] === 'undefined') {
        return false;
      }

      return agent.indexOf(allowed[v]) !== -1 ? true : false;
      },
      boutique = {
        deeplink: function () { // Takes the window's hash and grabs the appropriately defined target and feeds it to the section
          if (debug) {
          console.log('deeplink fn', window.location.hash);
        }

        if (window.location.hash.length !== 0) {
            var target_section = window.location.hash.split('/')[1];
            var $target = $('#section-' + target_section);

          if (!$target.length || typeof $target.data('section') === 'undefined') {
            return false;
          }

          if (debug) {
            console.log($target.data('section'), window.location.hash.split('/')[2]);
          }

          $target.data('section').deeplink(window.location.hash.split('/')[2]);

          return true;
          }

        return false;
        },
        set_deeplink: (function () { // Set the deeplink target if its new and don't disturb search history
          var current = '#!/landing';

        return function (hash) {
            if (hash === current) {
            return false;
          }

          current = hash;
            location.replace(hash);
          };
        }())
      },
      spinner,
      image = {
        'document': [],
        'css': [],
        'unique': [],
        'valid': [],
        'invalid': []
      };

  ie_version = is_ie('any');

  if (is_ie('any')) {
    $body.addClass('ie');
  }

  is_mobile = debug && $body.hasClass('device-mobile') ? true : is_mobile;

  if (!is_mobile) {
    $body.addClass('desktop');
  }

  var is_ipad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;

  // FastClick.attach(document.body);

  // dom
  var $site_container = $('#holiday-2015_container'),
      $section_container = $site_container.find('.content_container'),
      $sections = $section_container.find('.section'),
      $side_wrapper = $site_container.find('.holiday-2015_side-nav-wrapper'),
      $video_container = $('.video_container'),
      $close_btn = $video_container.find('.close_btn'),
      $video = $('#video_1'),
      $mpp_grid = $('.mpp__product-grid'),
      $mpp_sort = $('.mpp__product-sort'),
      $load_more = $('#holiday-2015_load-more');

  var $original_products = null;

  // ///////////
 	// QuickShop
 	// ///////////
  (function () {
    var product_ids = [],
        quickshops = $('#holiday-2015_container .rollover .quickshop.button');

    if (!quickshops.length) {
      if (debug) {
        console.log('QUICKSHOP FAILED: targets not found');
      }

      return;
    }

    // Build list of product ids
    // NOTE: each quickshop <a> should have a data-productID="PROD###" where ### is the specific product ID
    // If not it will attempt to parse the product url ex url : /product/12883/6600/Product-Catalog/Makeup/Accessories/Brushes/Concealer-Brush
    quickshops.each(function () {
      if ($(this).data('product')) {
        product_ids.push($(this).data('product'));
      } else {
        var pathname = this.pathname;

        if (pathname.charAt(0) != '/') {
          pathname = '/' + pathname;
        }
        product_ids.push('PROD' + pathname.split('/')[3]);
      }
    });

    // Run the fetch for all required fields for quickshop
    generic.jsonrpc.fetch({
      method: 'prodcat',
      params: [
{
        products: product_ids,
        'sku_fields': [
          'HEX_VALUE_STRING',
          'INVENTORY_STATUS',
          'LARGE_IMAGE',
          'MEDIUM_IMAGE',
          'PRICE',
          'PRODUCT_ID',
          'PRODUCT_SIZE',
          'SHADENAME',
          'SKU_BASE_ID',
          'SKU_ID',
          'XL_IMAGE',
          'formattedPrice'
        ],
        product_fields: [
          'ATTRIBUTE_DESC_1',
          'ATTRIBUTE_DESC_2',
          'ATTRIBUTE_LABEL_1',
          'ATTRIBUTE_LABEL_2',
          'PRODUCT_DETAILS_MOBILE',
          'DEFAULT_CAT_ID',
          'DISPLAY_STATUS',
          'FAMILY_CODE',
          'MPP_DESC_1',
          'MPP_DESC_2',
          'PRODUCT_ID',
          'PROD_RGN_NAME',
          'PROD_RGN_SUBHEADING',
          'RATING_IMAGE',
          'SHORT_DESC',
          'TOTAL_REVIEW_COUNT',
          'priceRange',
          'shaded',
          'sized',
          'skus',
          'url'
        ]
      }
],
      onSuccess: function (results) {
        var product_results = results.getValue().products;

        // Simple 1:1 bind of product data to buttons
        quickshops.each(function (index) {
          $(this).unbind('click').click(function (e) {
            e.preventDefault();
            // Launch the quickshop
            site.quickshop(product_results[index]);
          });
        });
      },
      onFail: function (error) {
        if (debug) {
          console.log('QUICKSHOP FAILURE: ', error);
        }
      }
    });
  }());

  // ///////////
 	// CMS Prehandler
 	// ///////////
 	(function () {
 		// pull the mpp part out of the section
    var $mpp = $sections.find('.mpp');

    if (!$mpp.length) {
      if (debug) {
        console.log('cms prehandler: mpp not found');
      }
    } else if (!is_mobile || is_ipad) {
      if (debug) {
        console.log('cms prehandler: mpp is now after propocontainer section');
      }

      $sections.after($mpp);
    }

 		var $tiles = $sections.find('.image_container');

 		if (!$tiles.length) {
      if (debug) {
        console.log('cms prehandler: no tiles found');
      }

      return true;
    }
    // var lowest_tile = 0;
    $tiles.each(function (i) {
      var $tile = $(this),
          position;

      if ($tile.hasClass('video')) {
        $tile.find('.rollover').remove();
        $tile.find('a.button').addClass('video-link');
      } else {
        $tile.find('.video_type').remove();
      }

      // if ($tile.hasClass('link')) {}
      if ($tile.hasClass('image')) {
        $tile.find('.rollover').remove();
      }

      // help determine the new max-height of section by using the lowest tile
      // if (!is_mobile) {
      // position = $tile.offset().top + $tile.height();
      // lowest_tile = position > lowest_tile ? position : lowest_tile;
      // }
    });
    // lowest_tile = lowest_tile - $sections.offset().top;
    // if (debug) console.log('cms prehandler: lowest positioned tile', lowest_tile, $sections.css('max-height'));
    // $sections.css('max-height', lowest_tile);
  })();

  // //////////////////
  // Mobile
  // for mobile only
  // //////////////////
  if (is_mobile && !is_ipad) {
    (function () {
      var $landing = $('#holiday-2015_carousel-landing'),
          $carousel = $('.mobile-carousel-formatter.holiday-2015_section .slick-carousel'),
          $pagination = $carousel.find('.slick-dots');

      var carousel_timer = false,
          carousel_delay = 4000;

      var methods = {
        start_carousel: function () {
          if (debug) {
            console.log('start carousel');
          }
          if (carousel_timer !== false) {
            clearTimeout(carousel_timer);
          }
          carousel_timer = setTimeout(function () {
            if (debug) {
              console.log('start carousel: timer up');
            }

            methods.start_carousel();

            if (!$pagination.find('li').last().hasClass('slick-active')) {
              if (debug) {
                console.log('start carousel: next');
              }
              $carousel.slickNext();

              return;
            }

            $pagination.find('li:first-child button').click();
          }, carousel_delay);
        },
        stop_carousel: function () {
          if (debug) {
            console.log('stop carousel');
          }
          clearTimeout(carousel_timer);
        },
        add_anchor: function ($tile, $anchors) {
          var current_url = '';

          current_url += window.location.protocol + '//';
          current_url += window.location.hostname + '/';
          current_url += window.location.pathname.replace(/\/$/, '').replace(/^\//, '');

          $anchors.each(function () {
            var $this = $(this);
            var href = this.href;
            var hash = this.hash;
            var $target;
            var target_url = '';

            if (debug) {
              console.log('check href on tile', href, hash, current_url);
            }

            // href only has an anchor
            if (!href && hash) {
              if (debug) {
                console.log('add_anchor: href only has anchor');
              }
              $target = $(hash);

              // href has url and an anchor	
            } else if (href && hash) {
              if (debug) {
                console.log('add_anchor: href has url and anchor');
              }

              target_url += this.protocol + '//';
              target_url += this.hostname + '/';
              target_url += this.pathname.replace(/\/$/, '').replace(/^\//, '');

              // log
              if (debug) {
                console.log('target url', target_url);
              }

              if (current_url !== target_url) {
                if (debug) {
                  console.log('target and current url do not match');
                }

                return true;
              }

              $target = $(hash);
            } else {
              if (debug) {
                console.log('add_anchor: skipping');
              }

              return true;
            }

            if (!$target || !$target.length) {
              if (debug) {
                console.log('add_anchor: target not found or not set', $target);
              }

              return true;
            }

            $this.bind('click', function (e) {
              e.preventDefault();
              if (debug) {
                console.log('add_anchor: tile with anchor clicked');
              }
              $('html, body').animate({ scrollTop: $target.offset().top }, 800);
            });
          });
        },
        // add rollover animation
        add_rollover: function ($tile, $target) {
          TweenMax.set($target, { opacity: 0,
display: 'block' });

          // bind mouse enter and mouse leave actions on to the tile
          $tile
            .bind('mouseenter', function () {
              TweenMax.killTweensOf($target);
              TweenMax.fromTo($target, 0.5, { opacity: 0 }, { opacity: 1 });
            })
            .bind('mouseleave', function () {
              TweenMax.killTweensOf($target);
              TweenMax.fromTo($target, 0.5, { opacity: 1 }, { opacity: 0 });
            });
        },
        // add video functionality on tile click
        add_video: function ($tile) {
          var $video_anchor = $tile.find('.video');

          // proxy click on the video anchor when clicking on the tile
          $tile.find('a').not($video_anchor).bind('click', function (e) {
            e.preventDefault();
            $video_anchor.click();
          });
        },
        // add dropdown functionality to a tile 
        add_dropdown: function ($tile) {
          var $dropdown = $tile.find('.dropdown'),
              $parent = $tile.parents('.propoContainer'),
              $content = $dropdown.find('h3, ul'),
              current_h = 0,
              new_h = 0,
              max_height;

          // max_height = parseInt($tile.css('max-height'), 10);
          // max_height = isNaN(max_height) ? 0 : max_height;
          $tile.css('max-height', 'none');

          if (!$parent.length) {
            if (debug) {
              console.log('add_dropdown: no parent found');
            }

            return;
          }

          $dropdown.addClass('close');
          $content.css('opacity', 0);

          // $tile.find('.button').css('position', 'relative');
          // $dropdown.css({ 'position' : 'relative', 'top' : 0 });

          $window.bind('resize', function () {
            // isn't visible
            // if (!$tile.hasClass('complete')) {
            // if (debug) console.log('add_dropdown: resize: not visible');
            // return;
            // }

            // is trying to open
            if ($dropdown.hasClass('will_open') && !$dropdown.hasClass('open')) {
              if (debug) {
                console.log('add_dropdown: resize: abort o');
              }

              return;
            }
            // is trying to close
            if ($dropdown.hasClass('will_close') && !$dropdown.hasClass('close')) {
              if (debug) {
                console.log('add_dropdown: resize: abort c');
              }

              return;
            }

            var max_height = $tile.height();

            if (max_height === 0) {
              if (debug) {
                console.log('add_dropdown: resize: height is zero');
              }

              return;
            }

            // re-calculate
            // assumes its closed
            if ($dropdown.hasClass('close')) {
              if (debug) {
                console.log('add_dropdown: resize: close calculate');
              }
              // new_height = (default_height / default_width) * $tile.width();
              // new_height = new_height * 0.4464751958;
              // $tile.height(new_height);
              max_height = $tile.height();
              if (debug) {
                console.log('resize', max_height);
              }
              $tile.find('.button').css('max-height', max_height);

              // assumes its open
            } else if ($dropdown.hasClass('open')) {
              if (debug) {
                console.log('add_dropdown: resize: open calculate');
              }
              max_height = max_height * 0.4913793103;// $tile.height()
              if (debug) {
                console.log('resize', max_height);
              }
              $tile.find('.button').css('max-height', max_height);

              current_h = $tile.height() - $dropdown.height();
            }
          }).trigger('resize');

          $tile
            .bind('open_dropdown', function () {
              if (debug) {
                console.log('open_dropdown:');
              }
              current_h = $dropdown.hasClass('close') ? $tile.height() : current_h;
              $dropdown.show();// .css('opacity', 1)
              $content.css('opacity', 1);
              new_h = current_h + $dropdown.height();
              if (debug) {
                console.log('open_dropdown: log', current_h, new_h);
              }

              // no percentage
              var max_height = new_h * 0.4913793103;

              $tile.find('.button').css('max-height', max_height);
              if (debug) {
                console.log('open_dropdown: log', max_height);
              }

              // new_h = (new_h / $parent.height() * 100) + '%';
              if (debug) {
                console.log('open_dropdown: log', new_h);
              }

              $content.css('opacity', 0);
              $content.stop(true, true).animate({ 'opacity': 1 }, 400);
              $tile.stop(true, true).animate({ 'height': new_h }, function () {
                if (debug) {
                  console.log('open_dropdown: complete');
                }
                $dropdown.removeClass('close').addClass('open');
              });
            })
            .bind('close_dropdown', function () {
              if (debug) {
                console.log('close_dropdown:');
              }
              if (debug) {
                console.log('close_dropdown: log', current_h);
              }

              $content.stop(true, true).animate({ 'opacity': 0 }, 400);
              $tile.stop(true, true).animate({ 'height': current_h }, function () { // (current_h / $parent.height() * 100) + '%'
                if (debug) {
                  console.log('close_dropdown: complete');
                }
                $dropdown.removeClass('open').addClass('close');
              });
            });

          if (!is_mobile) {
            $tile.bind('mouseenter', function () {
              if (debug) {
                console.log('dropdown: enter');
              }
              $dropdown.removeClass('will_close').addClass('will_open');
              $tile.trigger('open_dropdown');
            })
              .bind('mouseleave', function () {
                if (debug) {
                  console.log('dropdown: leave');
                }
                $dropdown.removeClass('will_open').addClass('will_close');
                $tile.trigger('close_dropdown');
              });
          } else {
            $tile.find('a.button')
              .bind('click', function (e) {
                e.preventDefault();
                if (debug) {
                  console.log('dropdown: click');
                }
                if ($dropdown.hasClass('will_open')) {
                  if (debug) {
                    console.log('dropdown: will close');
                  }
                  $dropdown.removeClass('will_open').addClass('will_close');
                  $tile.trigger('close_dropdown');

                  return;
                }
                if (debug) {
                  console.log('dropdown: will open');
                }
                $dropdown.removeClass('will_close').addClass('will_open');
                $tile.trigger('open_dropdown');
              });
          }
          $tile.find('li a').bind('click', function (e) {
            if (debug) {
              console.log('dropdown: li link clicked');
            }
          });
        },
        open_dropdown: function ($dropdown, height) {
          $dropdown.stop(true, true).animate({ 'height': height }, function () {
            if (debug) {
              console.log('open_dropdown: complete');
            }
            $dropdown.css('opacity', 1);
          });
        }
      };

      // //////////////
      // landing
      // //////////////
      /*
			if ($landing.length) {
				(function () {
					//var $carousel = $landing.find('.carousel');
					// Setup Carousel
					$carousel.carousel({
						increment: '100%', 
						offset: '0%', 
						duration: 0.5,
						key_next: 39,
						key_prev: 37,
						click_next: $('.carousel_controls .left'),
						click_prev: $('.carousel_controls .right'),
						$dot_container: $('.dot_nav_container'),
						$dot_template: $('.dot.template')
					});
	
					// Setup Autoplay
					window.setInterval(function(){
						$carousel.carouselNext();
					}, 5000);
	
					// Setup Carousel Swipe
					$carousel.swipe({
						swipeLeft: function(){
							$carousel.carouselNext();
						},
						swipeRight: function(){
							$carousel.carouselPrev();
						},
						excludedElements:['button', 'input', 'select', 'textarea', '.noSwipe']
					});
	
					$carousel.find('.slide a').bind('click', function () {
						var href = this.href;
						if (!href || href === '#') {
							return false;
						}
					});
					
				})();
			}
			*/
      if ($carousel.length && $pagination.length) {
        $pagination.find('li button')
          .bind('click', function () {
            methods.stop_carousel();
            methods.start_carousel();
          });
        methods.start_carousel();
      }

      // //////////////
      // MMP
      // //////////////
      if ($site_container.hasClass('mobile-mpp-full-page')) {
        (function () {
          // dropdown
          var $target = $site_container.find('.holiday-dropdown');

          if ($target.length) {
            if (debug) {
              console.log('mmp: dropdown found');
            }

            if (is_mobile && !is_ipad) {
              $target.removeClass('propoContainer propoElement');
              $target.find('.propoContainer').removeClass('propoContainer');
              $target.find('.propoElement').removeClass('propoElement');
              $target.find('.propoText').removeClass('propoText');
            }

            methods.add_dropdown($target);
          }
          // header
          $target = $site_container.find('.holiday-header');
          if ($target.length) {
            if (debug) {
              console.log('mmp: header found');
            }
            $target.fadeOut(0).fadeIn(1000);
          }
        })();
      }

      $.processPropoItems({ debug: true,
overrideNonPropoOffsetParents: true });
    })();

    return;
  }

  var methods = {
    add_anchor: function ($tile, $anchors) {
      var current_url = '';

      current_url += window.location.protocol + '//';
      current_url += window.location.hostname + '/';
      current_url += window.location.pathname.replace(/\/$/, '').replace(/^\//, '');

      $anchors.each(function () {
        var $this = $(this);
        var href = this.href;
        var hash = this.hash;
        var $target;
        var target_url = '';

        if (debug) {
          console.log('check href on tile', href, hash, current_url);
        }

        // href only has an anchor
        if (!href && hash) {
          if (debug) {
            console.log('add_anchor: href only has anchor');
          }
          $target = $(hash);

          // href has url and an anchor	
        } else if (href && hash) {
          if (debug) {
            console.log('add_anchor: href has url and anchor');
          }

          target_url += this.protocol + '//';
          target_url += this.hostname + '/';
          target_url += this.pathname.replace(/\/$/, '').replace(/^\//, '');

          // log
          if (debug) {
            console.log('target url', target_url);
          }

          if (current_url !== target_url) {
            if (debug) {
              console.log('target and current url do not match');
            }

            return true;
          }

          $target = $(hash);
        } else {
          if (debug) {
            console.log('add_anchor: skipping');
          }

          return true;
        }

        if (!$target || !$target.length) {
          if (debug) {
            console.log('add_anchor: target not found or not set', $target);
          }

          return true;
        }

        $this.bind('click', function (e) {
          e.preventDefault();
          if (debug) {
            console.log('add_anchor: tile with anchor clicked');
          }
          $('html, body').animate({ scrollTop: $target.offset().top }, 800);
        });
      });
    },
    // add rollover animation
    add_rollover: function ($tile, $target) {
      TweenMax.set($target, { opacity: 0,
display: 'block' });

      // bind mouse enter and mouse leave actions on to the tile
      $tile
        .bind('mouseenter', function () {
          TweenMax.killTweensOf($target);
          TweenMax.fromTo($target, 0.5, { opacity: 0 }, { opacity: 1 });
        })
        .bind('mouseleave', function () {
          TweenMax.killTweensOf($target);
          TweenMax.fromTo($target, 0.5, { opacity: 1 }, { opacity: 0 });
        });
    },
    // add video functionality on tile click
    add_video: function ($tile) {
      var $video_anchor = $tile.find('.video');

      // proxy click on the video anchor when clicking on the tile
      $tile.find('a').not($video_anchor).bind('click', function (e) {
        e.preventDefault();
        $video_anchor.click();
      });
    },
    // add dropdown functionality to a tile 
    add_dropdown: function ($tile) {
      var $dropdown = $tile.find('.dropdown'),
          $parent = $tile.parents('.propoContainer'),
          $content = $dropdown.find('h3, ul'),
          current_h = 0,
          new_h = 0,
          max_height;

      // max_height = parseInt($tile.css('max-height'), 10);
      // max_height = isNaN(max_height) ? 0 : max_height;
      $tile.css('max-height', 'none');

      if (!$parent.length) {
        if (debug) {
          console.log('add_dropdown: no parent found');
        }

        return;
      }

      $dropdown.addClass('close');
      $content.css('opacity', 0);

      // $tile.find('.button').css('position', 'relative');
      // $dropdown.css({ 'position' : 'relative', 'top' : 0 });

      $window.bind('resize', function () {
        // isn't visible
        // if (!$tile.hasClass('complete')) {
        // if (debug) console.log('add_dropdown: resize: not visible');
        // return;
        // }

        // is trying to open
        if ($dropdown.hasClass('will_open') && !$dropdown.hasClass('open')) {
          if (debug) {
            console.log('add_dropdown: resize: abort o');
          }

          return;
        }
        // is trying to close
        if ($dropdown.hasClass('will_close') && !$dropdown.hasClass('close')) {
          if (debug) {
            console.log('add_dropdown: resize: abort c');
          }

          return;
        }

        var max_height = $tile.height();

        if (max_height === 0) {
          if (debug) {
            console.log('add_dropdown: resize: height is zero');
          }

          return;
        }

        // re-calculate
        // assumes its closed
        if ($dropdown.hasClass('close')) {
          if (debug) {
            console.log('add_dropdown: resize: close calculate');
          }
          // new_height = (default_height / default_width) * $tile.width();
          // new_height = new_height * 0.4464751958;
          // $tile.height(new_height);
          max_height = $tile.height();
          if (debug) {
            console.log('resize', max_height);
          }
          $tile.find('.button').css('max-height', max_height);

          // assumes its open
        } else if ($dropdown.hasClass('open')) {
          if (debug) {
            console.log('add_dropdown: resize: open calculate');
          }
          max_height = max_height * 0.4913793103;// $tile.height()
          if (debug) {
            console.log('resize', max_height);
          }
          $tile.find('.button').css('max-height', max_height);

          current_h = $tile.height() - $dropdown.height();
        }
      }).trigger('resize');

      $tile
        .bind('open_dropdown', function () {
          if (debug) {
            console.log('open_dropdown:');
          }
          current_h = $dropdown.hasClass('close') ? $tile.height() : current_h;
          $dropdown.show();// .css('opacity', 1)
          $content.css('opacity', 1);
          new_h = current_h + $dropdown.height();
          if (debug) {
            console.log('open_dropdown: log', current_h, new_h);
          }

          // no percentage
          var max_height = new_h * 0.4913793103;

          $tile.find('.button').css('max-height', max_height);
          if (debug) {
            console.log('open_dropdown: log', max_height);
          }

          // new_h = (new_h / $parent.height() * 100) + '%';
          if (debug) {
            console.log('open_dropdown: log', new_h);
          }

          $content.css('opacity', 0);
          $content.stop(true, true).animate({ 'opacity': 1 }, 400);
          $tile.stop(true, true).animate({ 'height': new_h }, function () {
            if (debug) {
              console.log('open_dropdown: complete');
            }
            $dropdown.removeClass('close').addClass('open');
          });
        })
        .bind('close_dropdown', function () {
          if (debug) {
            console.log('close_dropdown:');
          }
          if (debug) {
            console.log('close_dropdown: log', current_h);
          }

          $content.stop(true, true).animate({ 'opacity': 0 }, 400);
          $tile.stop(true, true).animate({ 'height': current_h }, function () { // (current_h / $parent.height() * 100) + '%'
            if (debug) {
              console.log('close_dropdown: complete');
            }
            $dropdown.removeClass('open').addClass('close');
          });
        });

      if (!is_mobile) {
        $tile.bind('mouseenter', function () {
          if (debug) {
            console.log('dropdown: enter');
          }
          $dropdown.removeClass('will_close').addClass('will_open');
          $tile.trigger('open_dropdown');
        })
          .bind('mouseleave', function () {
            if (debug) {
              console.log('dropdown: leave');
            }
            $dropdown.removeClass('will_open').addClass('will_close');
            $tile.trigger('close_dropdown');
          });
        $tile.children('a').bind('click', function (e) {
          e.preventDefault();
        });
      } else {
        $tile.find('a.button')
          .bind('click', function (e) {
            e.preventDefault();
            if (debug) {
              console.log('dropdown: click');
            }
            if ($dropdown.hasClass('will_open')) {
              if (debug) {
                console.log('dropdown: will close');
              }
              $dropdown.removeClass('will_open').addClass('will_close');
              $tile.trigger('close_dropdown');

              return;
            }
            if (debug) {
              console.log('dropdown: will open');
            }
            $dropdown.removeClass('will_close').addClass('will_open');
            $tile.trigger('open_dropdown');
          });
      }

      // if not mobile, carry out filtering. 
      $tile.find('li a').bind('click', function (e) {
        if (!$('body').hasClass('device-mobile')) {
          e.preventDefault();
          if (debug) {
            console.log('dropdown: li link clicked');
          }
          var $parent, $product_target, sort_name, product_list;

          $parent = $(this).parent();
          if ($parent.hasClass('active')) {
            if (debug) {
              console.log('dropdown: already active');
            }

            return;
          }

          $parent.addClass('active').siblings().removeClass('active');

          sort_name = typeof $parent.data('slot_name') === 'undefined' ? false : $parent.data('slot_name');
          if (sort_name === false) {
            if (debug) {
              console.log('dropdown: no sort name found', $parent, $parent.data());
            }

            return;
          }

          $product_target = $('#' + sort_name);
          if (!$product_target.length) {
            if (debug) {
              console.log('dropdown: product container not found');
            }

            return;
          }

          product_list = $product_target.text();
          product_list = $.trim(product_list).toLowerCase();
          if (!product_list) {
            if (debug) {
              console.log('dropdown: no product list found');
            }

            return;
          }

          if (debug) {
            console.log('dropdown: product list', product_list);
          }

          product_list = product_list.split(',');

          if ($original_products === null) {
            if (debug) {
              console.log('dropdown: original products not set');
            }

            return;
          }

          var $new_set = $original_products.filter(function () {
            var $li = $(this);

            if (typeof $li.data('product-id') === 'undefined') {
              return false;
            }
            var product_id = $li.data('product-id').toLowerCase();
            var match = false;

            for (var i = 0; i < product_list.length; i++) {
              if (product_id === $.trim(product_list[i])) {
                match = true;
                break;
              }
            }

            return match;
          }).removeClass('row-hidden').css('display', '');

          $mpp_grid.empty().append($new_set);

          methods.set_products($new_set);

          // run grid adjust function here
          if (!window.site || !window.site.mpp_filter) {
            if (debug) {
              console.log('dropdown: site or mpp_filter not set');
            }

            return;
          }
          if (typeof window.site.mpp_filter.adjustMppProductGrid !== 'function') {
            if (debug) {
              console.log('dropdown: adjustMppProductGrid not set or not a function');
            }

            return;
          }

          window.site.mpp_filter.adjustMppProductGrid();

          var $target = $('.mpp__product-sort-container');

          if (!$target.length) {
            if (debug) {
              console.log('dropdown: mpp container not found');
            }

            return;
          }

          $('html, body').animate({ scrollTop: $target.offset().top }, 800);

          /*
					$mpp_grid.find('li').each(function () {
						var $li = $(this);
						if (typeof $li.data('product-id') === 'undefined') {
							return true;
						}
						var product_id = $li.data('product-id').toLowerCase();
						var match = false;
						for (var i = 0; i < product_list.length; i++) {
							if (product_id === $.trim(product_list[i])) {
								match = true;
								break;
							}
						}
					
						if (!match) {
							$li.removeClass('hidden');
							return true;
						}
					
						$li.addClass('hidden');
						//data-product-id
					});
					*/
        }
      });
    },
    open_dropdown: function ($dropdown, height) {
      $dropdown.stop(true, true).animate({ 'height': height }, function () {
        if (debug) {
          console.log('open_dropdown: complete');
        }
        $dropdown.css('opacity', 1);
      });
    },
    set_products: function ($products) {
      var default_visible_rows = 2,
          default_boundry_index = 3;

      $products.each(function (i) {
        var $product = $(this);

        if (debug) {
          console.log('set_products: log', $product, i);
        }

        // flag the initial products that are at the left edge
        if (i % default_boundry_index === 0) {
          $product.addClass('left');
        }
        // flag all products that are not in the initial rows
        if (i >= default_boundry_index * default_visible_rows) {
          $product.addClass('row-hidden');
        }
      });

      if (!$products.filter('.row-hidden').length) {
        $load_more.addClass('disabled');
      } else {
        $load_more.removeClass('disabled');
      }
    }
  };

  // store original set of products
  if (!$mpp_grid.length) {
    if (debug) {
      console.log('mpp grid not found');
    }
  } else {
    methods.set_products($mpp_grid.find('li.mpp__product'));
    $original_products = $mpp_grid.find('li.mpp__product').clone(true, true);
  }

  // Clear all title attributes
  $('a').attr('title', '');

  $('#wishlist_popup_overlay, #wishlist_popup_container').show().css('opacity', 0);
  // $.processPropoItems({debug: true, overrideNonPropoOffsetParents: true});
  // $('#wishlist_popup_overlay, #wishlist_popup_container').css('opacity', 1).fadeOut(0);
  // $mpp_grid.addClass('enable-row-hidden');

  // help determine the new max-height of section by using the lowest tile
  // /////
  var lowest_tile = 0;
  var $tiles = $sections.find('.image_container');

  if (!$tiles.length) {
    if (debug) {
      console.log('event: preload: no tiles found');
    }
  } else if (!is_mobile) {
    if (debug) {
      console.log('event: preload: log', $tiles);
    }
    $tiles.each(function (i) {
      var $tile = $(this), position;

      position = parseInt($tile.css('max-height'), 10);
      position = isNaN(position) ? 0 : position;
      position = $tile.offset().top + position;// $tile.height();
      lowest_tile = position > lowest_tile ? position : lowest_tile;

      if (debug) {
        console.log('event: preload: log', position, $tile.height(), $tile.find('.button img').height());
      }
    });
    lowest_tile = lowest_tile - $sections.offset().top;
    if (debug) {
      console.log('event: preload: lowest positioned tile', lowest_tile, $sections.css('max-height'));
    }
    $sections.css('max-height', lowest_tile);
  }
  // /////

  $.processPropoItems({ debug: true,
overrideNonPropoOffsetParents: true });
  $('#wishlist_popup_overlay, #wishlist_popup_container').css('opacity', 1).fadeOut(0);
  $mpp_grid.addClass('enable-row-hidden');

  // ///////////
  // events
  // ///////////
  $close_btn.bind('click', function (e) {
    e.preventDefault();
    if (debug) {
      console.log('modal: close video');
    }

    var callback = function () {
      // stop player, firefox requires destroying it
      $video.trigger('clear_timer');
      $video.player('destroy');
      // for australia
      $body.removeClass('vopen');
      $video_container.removeClass('open');
    };

    if (ie_version) {
      $video_container.css('display', 'none');
      callback();
    } else {
      TweenMax.to($video_container, 0.5, {
 opacity: 0,
display: 'none',
ease: Power1.easeIn,
onComplete: callback 
});
    }
    // boutique.set_deeplink('#!/1');
  });
  $video.bind('ended', function () {
    $close_btn.click();
  })[0].ended = function () {
    $close_btn.click();
  };

  // temp
  // if (debug) console.log('log: vid:', $section_container.find('a.video-link'));
  // if (debug) console.log('log: vid:', $section_container);

  $section_container.find('a.video-link').bind('click', function (e) {
    e.preventDefault();
    if (debug) {
      console.log('video anchor clicked');
    }

    if (is_ipad) {
      $video_container.find('.controls-mask').height('30%').find('.controls').hide();
    }

    if (!$video.length) {
      if (debug) {
        console.log(' $video not found');
      }

      return;
    }

    var $this = $(this);

    // hide the words
    $video_container.addClass('open');
    var callback = function () {
      $video_container.find('.controls').css('left', ($window.width() - $video_container.find('.scrubber').width() - 62) / 2);
      // boutique.set_deeplink('#!/1/video');

      // for australia
      $body.addClass('vopen');
      $this.parent().find('a.video').click();
      TweenMax.from($video_container.find('#video_1'), 1, { opacity: 0,
delay: 0 });

      // temp
      if (debug) {
        console.log('log: vid:', $this.parent().find('a.video'));
      }
      if (debug) {
        console.log('log: vid:', $video_container.find('#video_1'));
      }
    };

    if (ie_version) {
      $video_container.css('display', 'block');
      callback();
    } else {
      TweenMax.set($video_container, { right: $window.width() * -1,
opacity: 1,
display: 'block' });
      TweenMax.fromTo($video_container, 0.5, { opacity: 0,
display: 'block' }, { opacity: 1,
ease: Power1.easeIn,
onComplete: callback });
      TweenMax.from($video_container.find('.controls-mask'), 0.5, { opacity: 0,
delay: 0.2 });
    }

    // initialize the custom controllers
    if (typeof $video.data('custom_init') !== 'undefined') {
      // hard reset the scrubber for firefox
      $video_container.find('.inner_scrubber').css('width', 0);
    } else {
      // Initiate Video
      Holiday_Package.Video('#' + $video[0].id);
    }
  });
  $window.bind('resize', function () {
    $window.scroll();
  });

  $site_container.bind('preload', function () {
    if (debug) {
      console.log('event: preload');
    }
    if ($site_container.hasClass('loaded')) {
      if (debug) {
        console.log('event: preload: already loaded');
      }

      return;
    }

    // Determine global image path
    var global_image_path = $('#image_path')[0].src;

    global_image_path = global_image_path.slice(0, global_image_path.lastIndexOf('/'));

    // truncate list to only those we assume are for holiday
    var preload_image_list = [];

    for (var i = 0; i < image.unique.length; i++) {
      var img_url = image.unique[i].toLowerCase();

      // simple assumption that it isn't holiday related
      if (img_url.indexOf('boutiques/holiday') === -1) {
        continue;
      }
      // push to new list
      preload_image_list.push(img_url);
    }

    if (debug) {
      console.log('event: preload: image list', preload_image_list);
    }

    $.preload.gap = 10;
    // Begin preloader using the images array
    $.preload(preload_image_list, {
      // 'base': global_image_path + '/',
      'enforceCache': false,
      'onFinish': function () {
        if (debug) {
          console.log('event: preload: complete');
        }

        $site_container.addClass('loaded');
        spinner.stop();
        $('#loader, #image_path').hide();

        $sections.show().trigger('load_section');
        $window.scroll();
      }
 		});
 	});

 	$load_more.bind('click', function (e) {
 		e.preventDefault();
 		if (debug) {
      console.log('event: load more');
    }
 		if ($mpp_grid.hasClass('transition')) {
 			if (debug) {
        console.log('event: load more: busy');
      }

 			return;
 		}

 		$mpp_grid.addClass('transition');
 		$mpp_grid.find('.row-hidden').fadeIn(800, function () {
 			$mpp_grid.removeClass('transition');// enable-row-hidden
 			$load_more.addClass('disabled');
 		});
 	});

 	// bind to Normal Sorter
 	$mpp_sort.bind('click', function (e) {
 		e.preventDefault();
 		var $dropdown = $('.selectBox-dropdown-menu');

 		if (!$dropdown.length) {
 			if (debug) {
        console.log('event: mpp sort: dropdown not found');
      }

 			return;
 		}
 		if (!$mpp_sort.hasClass('init')) {
 			if (debug) {
        console.log('event: mpp sort: will setup');
      }

	 		$dropdown.find('a').bind('click', function () {
	 			// setTimeout(function () {
		 			methods.set_products($mpp_grid.find('li.mpp__product').removeClass('row-hidden').css('display', ''));
		 			window.site.mpp_filter.adjustMppProductGrid();
		 		// }, 200);
	 		});
	 		$mpp_sort.addClass('init');
	 	}
 	});

 	// Wish List
  $('.button_like a.button').click(function (e) {
    e.preventDefault();
    $('#wishlist_popup_overlay, #wishlist_popup_container').fadeIn('500');
    $window.scrollTop(0);
  });
  // Popup for WishList
  $('#wishlist_popup_wrapper a.close, #wishlist_popup_overlay').click(function (e) {
    e.preventDefault();
    $('#wishlist_popup_overlay, #wishlist_popup_container').fadeOut();
  });

  // show tiles on scroll
  $window.scroll(function () {
    if (debug) {
      console.log('scroll:');
    }
    if (!$site_container.hasClass('loaded')) {
      if (debug) {
        console.log('scroll: not loaded yet');
      }

      return;
    }
    $.each($sections, function () {
      var $this = $(this);
      var $tiles = $this.find('.image_container').filter(function () {
        var $tile = $(this);
        var result = window.Viewport.inViewport($tile);

        if (!result || typeof result.visible === 'undefined' || typeof result.direction === 'undefined') {
          if (debug) {
            console.log('error: result object not available', result);
          }

          return;
        }
        // if (debug) console.log($tile, result);

        if ($tile.hasClass('animated')) {
          return false;
        }
        if (result.visible === 1 || (result.direction === 1 && result.visible > 0.6) || (result.direction === -1 && result.visible > 0.3)) {
          return true;
        }
      });

      // if (debug) console.log('allowed', $tiles);
      if ($tiles.length) {
        TweenMax.staggerFromTo($tiles.addClass('animated'), 1, { opacity: 0 }, {
 opacity: 1,
ease: Power2.easeIn,
onComplete: function () {
          $(this.target).addClass('complete');
        }
}, 0.3);
      }
    });
  });

  // ///////////
  // pre-loader generator
  // ///////////
  (function () {
    Array.prototype.getUnique = function () {
      'use strict';

      var u = {}, a = [];

      for (var i = 0, l = this.length; i < l; ++i) {
        if (u.hasOwnProperty(this[i])) {
          continue;
        }
        a.push(this[i]);
        u[this[i]] = 1;
      }

      return a;
    };
    function parse_css_images(css, url) {
      var matches = [];
      var images = [];
      var image;

      // Validate Input
      if (typeof css !== 'string') {
        return false;
      }
      if (typeof url !== 'string') {
        return false;
      }

      // Parse CSS for images
      matches = css.match(/url\(["']?(.*\.(png|jpeg|jpg|gif))["']?\)/gi);
      if (typeof matches !== 'object' || matches === null) {
        return false;
      }

      // Normalize file paths
      for (var i = 0; i < matches.length; i++) {
        // Validate input
        if (typeof matches[i] !== 'string') {
          continue;
        }

        // Isolate file
        matches[i] = new RegExp(/url\(["']?(.*\.(png|jpeg|jpg|gif))["']?\)/gi).exec(matches[i]);

        // Complete path
        image = complete_path(matches[i][1], url);
        if (typeof image === 'string') {
          images.push(image);
        }
      }

      return images;
    }
    function complete_path(url, url_document) {
      var path = [];
      var dir_traversal = [];
      var a = document.createElement('a');

      // Validate Input
      if (typeof url !== 'string') {
        return false;
      }
      if (typeof url_document !== 'string') {
        return false;
      }

      a.href = url_document;

      // Full Path
      if (url.charAt(0) === '/') {
        return a.protocol + '//' + a.hostname + url;
      }

      // Absolute path
      if (url.indexOf('://') !== -1) {
        return url;
      }

      // Relative Path
      path = a.pathname.split('/');

      // Remove document from path
      if (path[path.length - 1] !== '') {
        path[path.length - 1] = '';
      }
      path.pop();

      // Directory depth
      dir_traversal = url.match(/\.\.\//g);
      if (typeof dir_traversal === 'object' && dir_traversal !== null) {
        // Traverse up
        for (var i = 0; i < dir_traversal.length; i++) {
          if (dir_traversal[i] === '../') {
            path.pop();
          }
        }
        url = url.replace(/\.\.\//g, '');
      }

      return a.protocol + '//' + a.hostname + path.join('/') + '/' + url;
    }

    if (debug) {
      console.log('preload-generator: will fetch images');
    }

    var $source;
    var stylesheet_count = 0;
    var image_count = 0;

    $('img').each(function () {
      image.document.push(this.src);
    });
    // CSS - External
    /*
		$source = $('link[rel=stylesheet]');
		stylesheet_count = $source.length;
		if (debug) console.log('Checking ' + stylesheet_count + ' external stylesheets');
		$source.each(function () {
			$.get(this.href, function (data) {
				if (debug) console.log('Checking: ' + this.url.split('/').pop());
			
				// Parse Images
				var images = [];
				images = parse_css_images(data, this.url);
				if (typeof images === 'object') {
					image.css = image.css.concat(images);
				}
			
				stylesheet_count--;
				if (stylesheet_count === 0) {
					image.unique = image.document.concat(image.css);
					image.unique = image.unique.getUnique();
					image_count = image.unique.length;
					$.each(image.unique, function (key, url) {
						$.ajax({
							'type' : 'HEAD',
							'url' : url,
							'success' : function () { image.valid.push(url); },
							'error' : function () { image.invalid.push(url); },
							'complete' : function () {
								image_count--;
								if (image_count === 0) {
									if (debug) console.log('preload-generator: complete');
									if (debug) console.log(image);
									if (debug) console.log('invalid images', image.invalid);
									$site_container.trigger('preload');
								}
							}
						});
					});
				}
			});
		});
		*/
    // FOR CMS HOLIDAY
    // CSS - Style Attribute
    $source = $('body [style]');
    if (debug) {
      console.log('Checking ' + $source.length + ' style attributes');
    }
    $source.each(function () {
      // Parse Images
      var images = [];

      images = parse_css_images($(this).attr('style'), window.location.href);
      if (typeof images === 'object') {
        image.css = image.css.concat(images);
      }
    });

    image.unique = image.document.concat(image.css);
    image.unique = image.unique.getUnique();
    image_count = image.unique.length;
    /*
		$.each(image.unique, function (key, url) {
			$.ajax({
				'type' : 'HEAD',
				'url' : url,
				'success' : function () { image.valid.push(url); },
				'error' : function () { image.invalid.push(url); },
				'complete' : function () {
					image_count--;
					if (image_count === 0) {
						if (debug) console.log('preload-generator: complete');
						if (debug) console.log(image);
						if (debug) console.log('invalid images', image.invalid);
						$site_container.trigger('preload');
					}
				}
			});
		});
		*/
  })();

  // maybe wrap this in an init function, and call it after the preloader
  // /////////////////////////

  // ///////////
  // side menu
  // ///////////
  (function () {
    var $side_nav = $side_wrapper.find('.holiday-2015_side-nav'),
        $primary = $side_wrapper.find('.holiday-2015-primary_nav'),
        $secondary = $side_nav.find('.holiday-2015-secondary_nav'),
        $menu_items = $primary.find('li'),
        $categories = $secondary.find('li');

    var speed = 0.5;
    var min_width = 80;

    $side_wrapper
      .bind('open', function () {
        if ($side_wrapper.hasClass('open')) {
          if (debug) {
            console.log('sidenav: open: already open');
          }

          return;
        }
        if ($side_wrapper.hasClass('transition')) {
          if (debug) {
            console.log('sidenav: open: currently unavailable');
          }

          return;
        }
        $side_wrapper.addClass('transition');

        var container_offet = $side_wrapper.width();

        container_offet = container_offet < min_width ? min_width : container_offet;
        container_offet = $side_wrapper.find('.holiday-2015_side-nav').width() - container_offet;
        container_offet = container_offet / $window.width() * 100;
        // -215
        TweenMax.to($side_nav, speed, {
 right: '-287.5%',
onComplete: function () {
          if (debug) {
            console.log('sidenav: open: complete');
          }

          $side_wrapper.removeClass('transition').addClass('open');
        }
});
        TweenMax.to($section_container, speed, { left: '+=' + container_offet + '%' });// 15.4454023
        // 0.154454023
      })
      .bind('close', function () {
        if (!$side_wrapper.hasClass('open')) {
          if (debug) {
            console.log('sidenav: close: already close');
          }

          return;
        }
        if ($side_wrapper.hasClass('transition')) {
          if (debug) {
            console.log('sidenav: close: currently unavailable');
          }

          return;
        }
        var container_offet = $side_wrapper.width();

        container_offet = container_offet < min_width ? min_width : container_offet;
        container_offet = $side_wrapper.find('.holiday-2015_side-nav').width() - container_offet;
        container_offet = container_offet / $window.width() * 100;

        $side_wrapper.addClass('transition');
        TweenMax.to($side_nav, speed, {
 right: 0,
onComplete: function () {
          if (debug) {
            console.log('sidenav: close: complete');
          }

          $side_wrapper.removeClass('transition open');
          $menu_items.filter('.button_shop').fadeIn();
        }
});
        TweenMax.to($section_container, speed, { left: '-=' + container_offet + '%' });// 15.4454023
      });

    $menu_items.filter('.button_shop')
      .bind('click', function (e) {
        e.preventDefault();
        if (debug) {
          console.log('sidenav: shop btn: click');
        }
        if ($side_wrapper.hasClass('open')) {
          if (debug) {
            console.log('sidenav: shop btn: already open');
          }

          return;
        }
        if ($side_wrapper.hasClass('transition')) {
          if (debug) {
            console.log('sidenav: shop btn: currently unavailable');
          }

          return;
        }
        var $shop = $(this);

        $shop.fadeOut();

        $shop.siblings('.button_close').fadeIn();
        $side_wrapper.trigger('open');
      });
    $menu_items.filter('.button_close')
      .bind('click', function (e) {
        e.preventDefault();
        if (debug) {
          console.log('sidenav: close btn: click');
        }
        if (!$side_wrapper.hasClass('open')) {
          if (debug) {
            console.log('sidenav: close btn: already closed');
          }

          return;
        }
        if ($side_wrapper.hasClass('transition')) {
          if (debug) {
            console.log('sidenav: close btn: currently unavailable');
          }

          return;
        }
        var $close = $(this);

        $close.fadeOut();
        $side_wrapper.trigger('close');
      });
  })();
  // ///////////

  // ///////////
  // Tiles
  // ///////////
  // iterate through all tiles inside all sections
  $sections.each(function () {
    if (debug) {
      console.log('section: ' + this.id);
    }

    var $section = $(this);
    var $tiles = $section.find('.image_container');

    if (!$tiles.length) {
      if (debug) {
        console.log('no tiles found');
      }

      return true;
    }

    // iterate through all tiles
    $tiles.each(function () {
      var $tile = $(this);

      // internal anchor
      var $anchors = $tile.find('a').not('[href="#"]');

      if ($anchors.length) {
        methods.add_anchor($tile, $anchors);
      }

      // tile needs rollover animation
      var $rollover = $tile.find('.rollover');

      if ($rollover.length) {
        // if (debug) console.log('will add rollover', this);
        methods.add_rollover($tile, $rollover);
      }

      // tile has video
      // if ($tile.find('.video').length) {
      // methods.add_video($tile);
      // }

      // tile has a dropdown menu
      if ($tile.hasClass('holiday-dropdown')) {
        // if (debug) console.log('will add dropdown', this);
        methods.add_dropdown($tile);
      }

      // create initial fade-in animation
      // save tween within the tile
      $tile.css('opacity', 0);
      // var tween = TweenMax.from($tile, 0.6, { opacity : 0, paused : true, ease: Power2.easeIn });
      // $tile.data('tween', tween);
    });
  });
  $window.scroll();
  // ///////////

  // ///////////
  // Gifts for
  // ///////////
  if ($site_container.hasClass('holiday-banner-only')) {
    (function () {
      if (debug) {
        console.log('will do gifts-for');
      }

      var $section = $sections.first();
      var $target = $section.find('.image_wrapper');
      var load_tl = new TimelineMax({ paused: true });

      if (!$section.length || !$target.length) {
        if (debug) {
          console.log('gifts-for element not found', $section, $target);
        }

        return;
      }
      load_tl.from($target, 1, { opacity: 0,
ease: Power1.easeIn });
      $section.bind('load_section', function () {
        load_tl.play();
      });
    })();
  }

  // /////////////////////////

  // Player Init
  $site_container.player('init', {
    'defaults': {
      'width': 1366,
      'height': 800,
      'controls': is_ipad ? true : false,
      'autohide': 1,
      'modestbranding': 0,
      'autoplay': true,
      'html5': 1,
      'playerType': ie_version ? 'flash' : 'iframe',
      'preferredQuality': 'hd720'// highres
    },
    'debug': true// debug && debug_lvl > 3 ? true : false
  });

  // spinner
  var opts = {
    lines: 17, // The number of lines to draw
    length: 0, // The length of each line
    width: 5, // The line thickness
    radius: 26, // The radius of the inner circle
    corners: 1, // Corner roundness (0..1)
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: '#000', // #rgb or #rrggbb or array of colors
    speed: 1, // Rounds per second
    trail: 30, // Afterglow percentage
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    className: 'spinner', // The CSS class to assign to the spinner
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    top: '50%', // Top position relative to parent
    left: '50%' // Left position relative to parent
  };
  var $loader = $('#loader').show();

  spinner = new Spinner(opts).spin($loader[0]);
  $sections.hide();

  $site_container.trigger('preload');
  // /////////////////////////////////////////////////////////
});

window.Viewport = (function () {
  var _window = $(window),
      height = _window.height(),
      vtop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0),
      vbottom = vtop + height;

  // Returns the vertical percentage (0.0 - 1.0) that an object is in the viewport by.
  // Note: this is NOT the percentage of the object thats in view but rather the percentage of the view the object occupies vertically
  // If object is fully within the viewport ( even if only a slim percentage of the viewport ) it will return 1
  function inViewport($element) {
    var etop = $element.offset().top,
        ebottom = etop + $element.height();

    // console.log('dev:', $element.height());
    // Out of view entirely
    if ((ebottom < vtop) || (etop > vbottom)) {
      return { visible: 0,
direction: 0 };
      // Takes up entire viewport ( and stretches outside of it)	
    } else if ((etop <= vtop) && (ebottom > vbottom)) {
      return { visible: 1,
direction: 0,
position: (vbottom - etop) / $element.height() };

      // Fully inside viewport but not taking up the entirety of it
    } else if (etop >= vtop && ebottom < vbottom) {
      return { visible: 1,
direction: 0 };

      // Transitioning out/in of view towards the top of the page
    } else if ((etop < vtop) && (ebottom < vbottom)) {
      // return {visible: (ebottom - vtop) / ( vbottom - vtop), direction: -1};
      return { visible: (ebottom - vtop) / $element.height(),
direction: -1 };

      // Transitioning out/in of view towards the bottom of the page
    } else if ((etop > vtop && etop < vbottom) && (ebottom > vbottom)) {
      // return {visible: (vbottom - etop) / ( vbottom - vtop), direction: 1};
      return { visible: (vbottom - etop) / $element.height(),
direction: 1 };
    }
  }

  // Returns the vertical percentage of the elements top in relation to the viewport top ( 0 if vertically below )
  function fromTopofViewport($element) {
    var etop = $element.offset().top,
        ebottom = etop + $element.height();

    // Below viewport's bottom
    if (etop > vbottom) {
      return 0;
      // Calc percentage from viewport top
    } else {
      return (vbottom - etop) / (vbottom - vtop);
    }
  }

  // Bind ourselves to scroll and resize and set values accordingly
  _window.scroll(function () {
    vtop = _window.scrollTop();
    // vtop = top;
    vbottom = vtop + height;
  });
  _window.resize(function () {
    height = _window.height();
  });

  // Return interface
  return {
    inViewport: inViewport,
    fromTopofViewport: fromTopofViewport
  };
}());
// //////////////////////////////
